/**
 * Lithuanian Translations
 * Lithuanian translations for DQFleet
 */

export const translationsLt: Record<string, any> = {
  reportGenerator: {
    title: 'Ataskaitų generatorius',
    intro: 'Pasirinkite klientui suteiktą duomenų modelį, laukus ir išsaugokite šabloną. Siunčiama Excel, su atskiru lapu kiekvienam skirtukui, kuriame yra kelios eilutės.',
    organization: 'Organizacija',
    templates: 'Šablonai',
    noTemplates: 'Šiai organizacijai šablonų nėra.',
    newTemplate: 'Naujas šablonas',
    name: 'Pavadinimas',
    model: 'Duomenų modelis',
    noModels: 'Klientas neturi duomenų modelių. Priskirkite juos viršutiniame mazge.',
    fields: {
      title: 'Laukai',
      registrationNumber: 'Valst. nr.',
      brand: 'Markė',
      model: 'Modelis',
      year: 'Metai',
      color: 'Spalva',
      systemStatus: 'Sistemos būsena',
      fuelType: 'Kuras',
      engine: 'Variklis',
      transmission: 'Pavarų dėžė',
      horsepower: 'Galia',
      vehicleType: 'Transporto tipas',
      category: 'Kategorija',
      usageStatus: 'Būsena',
      ownership: 'Nuosavybė',
      vin: 'VIN',
      replacesVehicle: 'Pakeičia transportą',
      flinkey: 'Flinkey',
      registeredDate: 'Registruota',
      manufacturedDate: 'Pagaminta',
      stolen: 'Pavogta',
      emergencyVehicle: 'Skubios pagalbos transportas',
      drivingBan: 'Draudimas vairuoti',
      parentGroup: 'Pagrindinė grupė',
      group: 'Grupė',
      referenceNumber: 'Nuoroda',
      costCenter: 'Kaštų centras',
      businessResponsibility: 'Verslo atsakomybė',
      assignedUser: 'Priskirtas vairuotojas',
      leasingCompany: 'Lizingo bendrovė',
      rentStart: 'Sutarties pradžia',
      rentEnd: 'Sutarties pabaiga',
      monthlyCost: 'Mėnesio kaina',
      kmCap: 'Km limitas',
      odometer: 'Dabartinis odometras',
      initialOdometer: 'Pradinis odometras',
      drivenKm: 'Nuvažiuota',
      nextInspection: 'Kita apžiūra',
      imei: 'IMEI',
      lastSeen: 'Paskutinį kartą prisijungta',
      distanceKm: 'Nuvažiuoti km',
      tripCount: 'Kelionių skaičius',
      agreementNo: 'Sutarties nr.',
      contractNo: 'Kontrakto nr.',
      termMonths: 'Terminas (mėn.)',
      leasingProduct: 'Lizingo produktas',
      basePrice: 'Pradinė kaina',
      bookValue: 'Buhalterinė vertė',
      residualValue: 'Garantuota likutinė vertė',
      extraKmCost: 'Kaina už papildomą km',
      taxCost: 'Mėnesio mokestis',
      malusCost: 'Mėnesio malus',
      insuranceCompany: 'Draudikas',
      insuranceAgreement: 'Draudimo sutartis',
      insuranceStart: 'Draudimas nuo',
      insuranceEnd: 'Draudimas iki',
      insuranceCost: 'Mėnesio draudimas',
      disposalType: 'Nurašymas',
      disposalSupplier: 'Pardavėjas',
      disposalDate: 'Nurašymo data',
      disposalAmount: 'Pardavimo suma',
      placementAddress: 'Stovėjimo adresas',
      placementPostal: 'Pašto kodas',
      placementCity: 'Miestas',
      batteryKwh: 'Baterijos talpa (kWh)',
      chargingEfficiency: 'Įkrovimo efektyvumas',
      homeAddress: 'Įkrovimas namuose',
      workAddress: 'Įkrovimas darbe',
      bookingDescription: 'Užsakymo aprašas',
      bookingRest: 'Poilsio laikas (min)',
      bookingEmailNote: 'Tekstas užsakymo laiške',
      notes: 'Pastaba',
      cardNumber: 'Kortelės nr.',
      cardName: 'Kortelės pavadinimas',
      fuelCompany: 'Degalų įmonė',
      cardFrom: 'Galioja nuo',
      cardTo: 'Galioja iki',
      cardActive: 'Aktyvi kortelė',
      serviceName: 'Serviso taškas',
      serviceStatus: 'Serviso būsena',
      serviceDueDate: 'Terminas',
      serviceDueKm: 'Terminas km',
      serviceBooked: 'Užsakyta',
      tireType: 'Padangų tipas',
      tireBrand: 'Padangų markė',
      tireSize: 'Dydis',
      tireStatus: 'Padangų būsena',
      tireStorage: 'Saugojimas',
      tireTread: 'Protektoriaus gylis (mm)',
      attachmentName: 'Priedas',
      attachmentCategory: 'Kategorija',
      attachmentDescription: 'Aprašas',
      attachmentDate: 'Pridėta',
      equipmentName: 'Įranga',
      equipmentNotes: 'Įrangos pastaba',
    },
    groups: {
      vehicle: 'Transportas',
      organization: 'Organizacija',
      economy: 'Ekonomika',
      contract: 'Ekonomika',
      placement: 'Vieta',
      charging: 'Įkrovimas',
      booking: 'Užsakymas',
      notes: 'Pastabos',
      current: 'Dabartinė būsena',
      period: 'Laikotarpis',
      fuelCards: 'Degalų kortelės',
      service: 'Servisas',
      tires: 'Padangos',
      attachments: 'Priedai',
      equipment: 'Transporto įranga',
    },
    activeOnly: 'Tik aktyvios transporto priemonės',
    dataWindow: 'Duomenų laikotarpis',
    snapshot: 'Dabartinė būsena',
    previousWeek: 'Praėjusi savaitė',
    previousMonth: 'Praėjęs kalendorinis mėnuo',
    previousQuarter: 'Praėjęs ketvirtis',
    previousTertial: 'Praėjęs tertialas',
    previousYear: 'Praėję kalendoriniai metai',
    schedule: 'Tvarkaraštis',
    manual: 'Tik rankinis paleidimas',
    monthly: 'Kiekvieną mėnesį',
    yearly: 'Kiekvienais metais',
    day: 'Diena',
    month: 'Mėnuo',
    scheduleHelp: 'Suplanuotos ataskaitos siunčiamos 06:15. Diena 1–28.',
    recipients: 'Gavėjai',
    noRecipients: 'Organizacijoje nėra naudotojų su el. paštu.',
    save: 'Išsaugoti šabloną',
    saved: 'Šablonas išsaugotas',
    deleted: 'Šablonas pašalintas',
    run: 'Atsisiųsti Excel',
    preview: 'Peržiūra',
    previewCount: 'Rodomos pirmos eilutės iš',
    cancel: 'Atšaukti',
    edit: 'Keisti',
    delete: 'Pašalinti',
    lockedField: 'Visada įtraukta',
    models: {
      vehicleFleet: 'Transporto ataskaita',
    },
  },
  common: {
    save: 'Išsaugoti',
    selectTime: 'Pasirinkite laiką',
    cancel: 'Atšaukti',
    delete: 'Ištrinti',
    edit: 'Redaguoti',
    create: 'Sukurti',
    add: 'Pridėti',
    remove: 'Pašalinti',
    module: 'Modulis',
    type: 'Tipas',
    description: 'Aprašymas',
    saveChanges: 'Išsaugoti pakeitimus',
    saving: 'Išsaugoma...',
    update: 'Atnaujinti',
    search: 'Ieškoti',
    clear: 'Aišku',
    filter: 'Filtruoti',
    allOrganizations: 'Visos organizacijos',
    allRoles: 'Visi vaidmenys',
    clearFilters: 'Išvalyti filtrai',
    refresh: 'Atnaujinti',
    loading: 'Įkeliama...',
    error: 'Klaida',
    success: 'Sėkmės',
    confirm: 'Patvirtinti',
    yes: 'Taip',
    no: 'Nr',
    close: 'Uždaryti',
    back: 'Atgal',
    pageErrorTitle: 'Puslapio nepavyko parodyti',
    pageErrorDescription: 'Įvyko netikėta klaida. Grįžkite į ankstesnį puslapį.',
    next: 'Kitas',
    previous: 'Ankstesnis',
    actions: 'Veiksmai',
    notes: 'Pastabos',
    open: 'Atidaryti',
    notFound: 'Nerasta',
    comingSoon: 'Netrukus',
    plannedFeatures: 'Planuojamos funkcijos',
    underDevelopment: 'Ši funkcija kuriama',
    status: 'Būsena',
    active: 'Aktyvus',
    inactive: 'Neaktyvus',
    activate: 'Suaktyvinti',
    deactivate: 'Išjungti',
    suspended: 'Sustabdytas',
    overview: 'Apžvalga',
    organizations: 'Organizacijos',
    vehicles: 'Transporto priemonės',
    vehicle: 'Transporto priemonė',
    trend: 'Tendencija',
    trips: 'Kelionės',
    distance: 'Atstumas',
    organization: 'Organizacija',
    fromDate: 'Nuo datos',
    toDate: 'Iki šiol',
    from: 'Nuo',
    to: 'Iki',
    startDate: 'Pradžios data',
    endDate: 'Pabaigos data',
    all: 'Visi',
    export: 'Eksportuoti',
    exportCsv: 'Eksportuoti į CSV',
    saveError: 'Nepavyko išsaugoti',
    deleteError: 'Nepavyko ištrinti',
    activateError: 'Nepavyko suaktyvinti',
    loadDataError: 'Nepavyko įkelti duomenų',
    updateStatusError: 'Nepavyko atnaujinti būsenos',
    changeLanguageError: 'Nepavyko pakeisti kalbos',
    copiedToClipboard: 'Nukopijuota į mainų sritį',
    day: 'Diena',
    week: 'Savaitė',
    month: 'Mėnuo',
    quarter: 'ketvirtis',
    selected: 'Pasirinkta',
    noResults: 'Rezultatų nerasta',
    selectOrganization: 'Pasirinkite organizaciją',
    searchOrSelect: 'Ieškoti arba pasirinkti',
    noData: 'Nėra duomenų',
    count: 'Skaičius',
    showing: 'Rodoma',
    of: 'iš',
    tryAgain: 'Bandykite dar kartą',
    confirmDelete: 'Ar tikrai norite tai ištrinti?',
    view: 'Rodyti',
    hide: 'Slėpti',
    unknown: 'Nežinoma',
    select: 'Pasirinkite...',
    selectLanguage: 'Pasirinkite kalbą',
  },
  nav: {
    dashboard: 'Prietaisų skydelis',
    fleet: 'Automobilių parkas',
    liveTracking: 'Tiesioginis žemėlapis',
    reports: 'Ataskaitos',
    statistics: 'Statistika',
    vehicles: 'Transporto priemonės',
    profile: 'Profilis',
    administration: 'Administravimas',
    sysAdmin: 'Sistemos administratorius',
    crm: 'CRM',
    logout: 'Atsijungti',
    organization: 'Organizacija',
  },
  auth: {
    login: 'Prisijungti',
    signup: 'Užsiregistruoti',
    email: 'El. paštas',
    password: 'Slaptažodis',
    forgotPassword: 'Pamiršote slaptažodį?',
    rememberMe: 'Prisimink mane',
    loginSuccess: 'Prisijungimas sėkmingas',
    loginError: 'Prisijungti nepavyko',
    logout: 'Atsijungti',
    otpTitle: 'Patvirtinimo kodas',
    otpDescription: 'Išsiuntėme patvirtinimo kodą',
    otpSent: 'Patvirtinimo kodas išsiųstas',
    otpVerified: 'Patvirtinimas sėkmingas',
    otpResent: 'Išsiųstas naujas patvirtinimo kodas',
    invalidOtp: 'Neteisingas patvirtinimo kodas',
    resend: 'Siųsti dar kartą',
    samlRequired: 'Šiai organizacijai reikalingas SAML autentifikavimas',
    authMethodChanged: 'Autentifikavimo metodas pasikeitė',
    ssoRedirect: 'Peradresuojama į prisijungimą naudojant organizacijos tapatybę...',
    ssoCompleting: 'Prisijungiama...',
    ssoCompleteError: 'Nepavyko užbaigti prisijungimo. Bandykite dar kartą.',
    checkingSso: 'Tikrinamas prisijungimo būdas...',
    ssoContinue: 'Tęsti į {org}',
    ssoDomainSignupBlocked: 'Jūsų organizacija naudoja SSO prisijungimą. Nekurkite paskyros – prisijunkite naudodami organizacijos tapatybę.',
    useSsoInstead: 'Prisijungti per SSO',
    ssoLogin: 'Vienkartinis prisijungimas',
    chooseLoginMethod: 'Pasirinkite prisijungimo būdą',
    loginWith: 'Prisijunkite su',
    loginWithSaml: 'Prisijunkite naudodami SAML',
    loginWithSiths: 'Prisijunkite naudodami SITHS',
    loginWithPassword: 'Prisijunkite su slaptažodžiu',
    backToLogin: 'Grįžti į prisijungimą',
    noOrganizationId: 'Jokia organizacija nenurodyta',
    samlError: 'SAML autentifikavimas nepavyko',
    samlErrorTitle: 'Prisijungti nepavyko',
    insufficientLoa: 'Nepakankamas šios paslaugos užtikrinimo lygis',
    retryLogin: 'Bandykite dar kartą',
    backToLanding: 'Atgal į pradžios puslapį',
    goToLogin: 'Eikite į prisijungimą',
    contactSupport: 'Jei problema išlieka, susisiekite su palaikymo komanda.',
  },
  resetPassword: {
    title: 'Iš naujo nustatyti slaptažodį',
    description: 'Įveskite savo el. pašto adresą ir mes atsiųsime nuorodą, kad iš naujo nustatytumėte slaptažodį.',
    emailSentTitle: 'El. laiškas išsiųstas',
    emailSentMessage: 'Jei vartotojas turi šį el. pašto adresą, bus išsiųstas el. laiškas iš naujo. Patikrinkite gautuosius ir vadovaukitės instrukcijomis, kad iš naujo nustatytumėte slaptažodį.',
    newPasswordLabel: 'Naujas slaptažodis',
    newPasswordPlaceholder: 'Įveskite naują slaptažodį',
    confirmPasswordLabel: 'Patvirtinkite slaptažodį',
    confirmPasswordPlaceholder: 'Patvirtinkite naują slaptažodį',
    sendButton: 'Siųsti Atstatyti nuorodą',
    resetButton: 'Iš naujo nustatyti slaptažodį',
    sending: 'Siunčiama...',
    resetting: 'Nustatoma iš naujo...',
    backToLogin: 'Atgal į prisijungimą',
    rememberPassword: 'Prisiminti slaptažodį?',
  },
  admin: {
    title: 'Administravimas',
    roles: 'Vaidmenų valdymas',
    organizations: 'Organizacijos valdymas',
    users: 'Vartotojų valdymas',
    deleteUserConfirm: 'Ar tikrai norite ištrinti šį naudotoją?',
    translations: 'Vertimai',
    imports: 'Importo generatorius',
    packages: 'Kainų paketai',
    sysAdmin: 'Sistemos administratorius',
    devices: 'Prietaisai',
    deviceManagement: 'Įrenginių valdymas',
    hardDeleteUserConfirm: 'Tai visiškai pašalina {{name}} ({{email}}) iš sistemos, kad SSO galėtų iš naujo sukurti paskyrą. Negalima anuliuoti.',
  },
  packages: {
    title: 'Kainų paketai',
    description: 'Tvarkykite sistemų ir modulių kainų paketus',
    createNew: 'Sukurti naują paketą',
    noPackages: 'Jokių paketų nesukurta',
    priceMonthly: 'Kaina mėnesiui',
    priceYearly: 'Kaina metams',
    includedModules: 'Įtraukti moduliai',
    maxUsers: 'Maksimalus vartotojų skaičius',
    maxVehicles: 'Max transporto priemonės',
    features: 'Papildomos funkcijos',
    isDefault: 'Numatytasis paketas',
    selectPackage: 'Pasirinkite paketą',
    currentPackage: 'Dabartinis paketas',
    totalMonthly: 'Bendra mėnesio kaina',
    modulePrices: 'Modulio kainos',
    modulePrice: 'Modulio kaina',
    setDefaultPrice: 'Nustatyti numatytąją kainą',
    addon: 'Priedas',
    demo: 'Demonstracinis',
    trial: 'Teismo procesas',
    included: 'Įtraukta',
    startDemo: 'Pradėti demonstraciją',
    startTrial: 'Pradėkite bandymą',
    upgrade: 'Atnaujinti',
    upgradeToFull: 'Atnaujinti iki pilno',
    daysRemaining: 'likusios dienos',
    trialDays: 'Bandymo dienos',
    trialPrice: 'Bandomoji kaina',
    addModule: 'Pridėti modulį',
    removeModule: 'Pašalinti modulį',
    moduleAdded: 'Modulis pridėtas',
    moduleRemoved: 'Modulis pašalintas',
    demoStarted: 'Demonstracija pradėta (30 dienų)',
    trialStarted: 'Prasidėjo teismo procesas',
    upgraded: 'Atnaujinta iki visiškos prenumeratos',
    syncFromPackage: 'Sinchronizuoti iš paketo',
    modulesSynced: 'Moduliai sinchronizuoti',
    packages: 'Paketai',
    modules: 'Moduliai',
    pricePerMonth: 'Kaina/mėn',
    pricePerYear: 'Kaina/metai',
    modulePricesDescription: 'Nustatykite numatytąją kiekvieno modulio kainą. Šios kainos naudojamos kaip papildomi moduliai, kai klientai nori pridėti modulių, kurie nėra jų paketo.',
    packagesCount: 'paketus',
    newPackage: 'Nauja pakuotė',
    systemsWithoutPackages: 'Sistemos be paketų',
    modulesWithoutPackages: 'Moduliai be paketų',
    noModulesFound: 'Modulių nerasta',
    noSystemsFound: 'Sistemų nerasta',
    noModulesForSystem: 'Šiai sistemai modulių nėra',
    noPacketsSelected: 'Nepasirinkta jokių paketų',
    addPacketsInSectionAbove: 'Pridėkite paketus aukščiau esančiame kainų paketų skyriuje, kad pamatytumėte galimus modulius.',
    systemsActive: 'sistemos aktyvios',
    enableModule: 'Įjungti modulį',
    disableModule: 'Išjungti modulį',
    enableAction: 'Įjungti',
    disableAction: 'Išjungti',
    noActionsForModule: 'Nėra galimų šio modulio funkcijų',
    moduleEnabledForCustomer: 'Modulis įjungtas klientui',
    moduleDisabledForCustomer: 'Modulis išjungtas klientui',
    moduleToggleError: 'Nepavyko pakeisti modulio',
    moduleActionsLoadError: 'Nepavyko įkelti modulio funkcijų',
    moduleActionEnabled: 'Funkcija įjungta',
    moduleActionDisabled: 'Funkcija išjungta',
    moduleActionToggleError: 'Nepavyko pakeisti funkcijos',
    defaultPackage: 'Numatytasis paketas naujiems klientams',
    extraFeatures: 'Papildomos funkcijos (po vieną eilutėje)',
    internalName: 'Vidinis pavadinimas',
    displayName: 'Rodomas vardas',
    descriptionPlaceholder: 'Trumpas pakuotės aprašymas',
    codeExample: 'pvz. standartinis',
    nameExample: 'pvz. Deque standartas',
    unlimited: 'Neribota',
    editPrice: 'Redaguoti kainą',
    createPackage: 'Sukurti paketą',
    editPackage: 'Redaguoti paketą',
    notSet: 'Nenustatyta',
    loadError: 'Nepavyko įkelti paketų',
    saveError: 'Nepavyko išsaugoti paketo',
    modulePriceSaved: 'Modulio kaina išsaugota',
    modulePriceError: 'Nepavyko išsaugoti modulio kainos',
    packageUpdated: 'Pakuotė atnaujinta',
    packageCreated: 'Paketas sukurtas',
    packageActivatedAndSynced: 'Paketas suaktyvintas ir moduliai sinchronizuoti',
    activateError: 'Nepavyko suaktyvinti paketo',
    addModuleError: 'Nepavyko pridėti modulio',
    confirmRemoveModule: 'Pašalinti modulį iš kliento?',
    removeModuleError: 'Nepavyko pašalinti modulio',
    upgradeError: 'Nepavyko atnaujinti',
    noPackagesAvailable: 'Nėra jokių paketų',
    selectModule: 'Pasirinkite modulį',
    fullFunctionFullPrice: 'Pilna funkcija, pilna kaina',
    demoDescription: '30 dienų, ribotas',
    trialDescription: 'Pilna funkcija, pritaikytas laikas',
    standard: 'Standartinis',
    free: 'Nemokama',
    perMonth: 'per mėnesį',
  },
  imports: {
    title: 'Importo generatorius',
    description: 'Kurti ir valdyti duomenų importavimą',
    createNew: 'Sukurti naują importą',
    noImports: 'Dar nesukurta jokių importo elementų',
    name: 'Importo pavadinimas',
    targetTable: 'Tikslinė lentelė',
    schedule: 'Tvarkaraštis',
    lastRun: 'Paskutinis bėgimas',
    status: 'Būsena',
    actions: 'Veiksmai',
    run: 'Vykdyti importavimą',
    edit: 'Redaguoti',
    delete: 'Ištrinti',
    fileLoaded: 'Failas įkeltas',
    missingFields: 'Prašome užpildyti visus privalomus laukus',
    saved: 'Importas išsaugotas',
    deleted: 'Importas ištrintas',
    loadError: 'Nepavyko įkelti importo',
    confirmDelete: 'Ar tikrai norite ištrinti šį importavimą?',
    step1: 'Pagrindiniai nustatymai',
    step2: 'Įkelti failą',
    step3: 'Žemėlapio laukai',
    step4: 'Nustatymai',
    sourceFields: 'Šaltinio laukai',
    targetFields: 'Tiksliniai laukai',
    fieldsMapped: 'pažymėti laukai',
    decimalSeparator: 'Dešimtainis skyriklis',
    csvDelimiter: 'CSV skyriklis',
    hasHeader: 'Pirmoji eilutė yra antraštė',
    duplicateAction: 'Ant dublikato',
    skipDuplicate: 'Praleisti (palikti esamą)',
    updateDuplicate: 'Atnaujinti esamą',
    errorAction: 'Dėl klaidos',
    skipErrors: 'Praleisti klaidingas eilutes',
    abortOnError: 'Nutraukti visą importavimą',
    loadForEditError: 'Nepavyko įkelti importo redaguoti',
    importSource: 'Importo šaltinis',
    importSourceNone: 'Nėra šaltinio',
    selectedSource: 'Pasirinktas šaltinis',
    lastFetchAt: 'Paskutinį kartą',
    lastFetchStatus: 'Sveikatos būklė',
    notFetchedYet: 'Niekada',
    sourceHealthSuccess: 'Sėkmingai',
    sourceHealthFailed: 'Nepavyko',
    sourceHealthUnknown: 'Nežinoma',
    sourcesStatusTitle: 'Šaltinio būsena',
    sourceSyncError: 'Sinchronizavimo klaida',
    sourcePreviewLoading: 'Įkeliamas naujausias failas iš šaltinio...',
    sourcePreviewLoaded: 'Šablonas įkeltas iš šaltinio',
    sourcePreviewNotFound: 'Nerasta pasirinkto šaltinio sinchronizuoto failo',
    sourcePreviewLoadError: 'Nepavyko įkelti šablono iš šaltinio',
    sourcePreviewReload: 'Iš naujo įkelti iš šaltinio',
    runLatestSource: 'Priverstinis paleidimas iš naujausio šaltinio failo',
    filesInSource: 'Failai šaltinyje',
    livePreviewNeedsSample: 'Neįkeltas joks šablono failas – grįžkite į 2 veiksmą ir iš naujo įkelkite iš šaltinio, kad pamatytumėte peržiūrą.',
    autoMappedFields: 'laukai buvo susieti automatiškai',
    importHistoryTitle: 'Importo istorija',
    allDefinitions: 'Visi apibrėžimai',
    historyUpdateBtn: 'Atnaujinti',
    historyLoadingText: 'Įkeliama istorija…',
    noRunsFound: 'Nerasta bėgimų',
    showDetails: 'Rodyti detales',
    loadRunError: 'Nepavyko įkelti paleisti',
    runDetailsTitle: 'Vairavimo detalės',
    runDetailsStatus: 'Būsena',
    runDetailsStarted: 'Prasidėjo',
    runDetailsEnded: 'Galutinis',
    runDetailsFile: 'Failas',
    runDetailsRows: 'Linijos',
    runDetailsErrors: 'Klaida',
    runDetailsAndMore: 'ir dar {n}',
    importingFile: 'Importuojama...',
    importThisFile: 'Importuoti šį failą',
    noFilesForSource: 'Šiame šaltinyje failų nerasta. Pirmiausia sinchronizuokite šaltinį.',
    loadingFiles: 'Įkeliami failai...',
    filesFromSourceTitle: 'Failai iš šaltinio',
    ftpImportTitle: 'FTP importavimas',
    ftpPathLabel: 'Kelias',
    ftpListBtn: 'Sąrašas',
    ftpLoadingText: 'Įkeliamas...',
    ftpNoFiles: 'Failai nerasta.',
    ftpOpen: 'Atidaryti',
    ftpRunImport: 'Vykdyti importavimą',
    importingProgress: 'Importuojama…',
    rowsSuffix: 'linijos',
    colsSuffix: 'anglies.',
    createFirstImport: 'Sukurkite pirmąjį importą',
    importUpdated: 'Importas atnaujintas',
    statusSuccess: 'Sėkmingai',
    statusFailed: 'Nepavyko',
    statusPartial: 'Iš dalies',
    statusRunning: 'Bėgimas',
    statusQueued: 'Eilėje',
    statusCancelled: 'Pertraukė',
    statusAll: 'Visi',
    colDefinition: 'Apibrėžimas',
    colFileSource: 'Failas / šaltinis',
    colStarted: 'Prasidėjo',
    colRows: 'Linijos',
    colErrors: 'Klaida',
    colAction: 'Išmatuoti',
    showingRuns: 'Rodoma {shown} iš {total}',
    noTransformsAdded: 'Nepridėta jokių transformacijų.',
    addTransform: 'Pridėti transformaciją',
    sourceLabel: 'Šaltinis',
    typeLabel: 'Tipas',
    paramsLabel: 'Parametrai (JSON)',
    moveUp: 'Judėti aukštyn',
    moveDown: 'Judėti žemyn',
    remove: 'Pašalinti',
    livePreview: 'Vertė išsaugota',
    runDetailsDuplicates: 'Pasikartojantys (praleisti)',
    downloadFailedRows: 'Atsisiųsti blogas eilutes (CSV)',
    downloadDuplicateRows: 'Atsisiųsti dublikatus (CSV)',
    artifactDownloadError: 'Nepavyko atsisiųsti failo',
    identifiedColumns: 'Identifikuoti stulpeliai:',
    changeFile: 'Keisti failą',
    supportedFormats: 'Palaikomi formatai: Excel, CSV, JSON, XML, TXT, DAT',
    schemaMappingError: 'Schemos patvirtinimas: atvaizdavimo klaidos',
    sourcePanelTitle: 'Šaltinio laukas (iš failo)',
    targetPanelTitle: 'Tikslinis laukas',
    examplePrefix: 'Pvz',
    fieldsMappedCount: '{n} laukai susieti',
    addMappingInStep3: 'Norėdami sukonfigūruoti transformacijas, atlikdami 3 veiksmą pridėkite bent vieną lauko susiejimą.',
    scheduleLabel: 'Planavimas',
    scheduleExecution: 'Vairavimas',
    scheduleManual: 'Tik rankiniu būdu',
    scheduleDaily: 'Kasdien',
    scheduleWeekly: 'Kas savaitę',
    scheduleMonthly: 'Kas mėnesį',
    scheduleTimeLabel: 'Laikas (HH:mm)',
    scheduleDayOfWeek: 'Savaitės diena (0 = sekmadienis … 6 = šeštadienis)',
    scheduleDayOfMonth: 'Mėnesio diena (1–31)',
    scheduleCronLabel: 'Cron (neprivaloma, pvz., 0 6 * * *)',
    fileSourcePathLabel: 'Failo šaltinis (kelias arba globa, pvz., /var/imports/fuel_*.dat)',
    stableFileTitle: 'Palaukite stabilaus failo',
    stableCheckInterval: 'Valdymo intervalas (ms)',
    stableStableFor: 'Stabilus (ms)',
    stableTimeout: 'Skirtasis laikas (ms, 0 = neribotas)',
    retryTitle: 'Jei įvyko klaida, bandykite dar kartą',
    retryMaxRetries: 'Maksimalus bandymas',
    retryInitialDelay: 'Pirmasis laukimo laikas (ms)',
    retryMaxDelay: 'Maksimalus laukimo laikas (ms)',
    retryBackoff: 'Atsitraukimo daugiklis',
    summaryTitle: 'Santrauka',
    summaryName: 'Vardas',
    summaryTargetTable: 'Tikslinė lentelė',
    summaryMappedFields: 'Žemėlapio laukai',
    summaryFileFormat: 'Failo formatas',
    summarySchedule: 'Planavimas',
    invalidJsonTransform: 'Netinkamas JSON transformacijos parametruose',
    duplicateActionLabel: 'Esant dublikatams',
    updateExisting: 'Atnaujinti esamą',
    errorActionLabel: 'Klaidos atveju',
    skipErroneousRows: 'Praleiskite neteisingas eilutes',
    abortEntireImport: 'Atšaukti visą importavimą',
    wizardTitleCreate: 'Sukurti naują importą',
    wizardTitleEdit: 'Redaguoti importus',
    wizardStepBasicInfo: 'Pagrindinė informacija',
    wizardStepLoadFile: 'Įkelti failą',
    wizardStepMapFields: 'Žemėlapio laukai',
    wizardStepTransforms: 'Transformuoja',
    wizardStepSettings: 'Nustatymai',
    wizardCancel: 'Atšaukti',
    wizardBack: 'Atgal',
    wizardNext: 'Kitas',
    wizardSave: 'Išsaugoti importą',
    descriptionPlaceholder: 'Pasirenkamas aprašas...',
    presetsLabel: 'Išankstiniai nustatymai (pasirinktinai)',
    clearPreset: 'Išvalyti išankstinį nustatymą',
    targetTableLabel: 'Tikslinė lentelė*',
    importNameLabel: 'Importo pavadinimas *',
    descriptionLabel: 'Aprašymas',
    step1Title: '1 veiksmas: pagrindiniai nustatymai',
    step2Title: '2 veiksmas: įkelkite šablono failą',
    step3Title: '3 veiksmas. Žemėlapio laukai',
    step4Title: '4 veiksmas: transformuoja pagal lauką',
    step5Title: '5 veiksmas: importuokite nustatymus',
    filenameFilterTitle: 'Failo vardo filtras',
    filenameFilterHint: 'Kurie failai iš šaltinio turėtų būti importuojami. Gaublys: *K02*, *K05*. Regex (prasideda ^): ^\\d = failo pavadinimas turi prasidėti skaičiumi (švediškai OKQ8). Tuščias = visi failai.',
    filenameFilterAdd: 'Pridėti modelius',
    decimalSeparatorLabel: 'Dešimtainis skyriklis',
    decimalComma: 'Kablelis (1 234,56)',
    decimalDot: 'Taškas (1 234,56)',
    csvSeparatorLabel: 'CSV skyriklis',
    csvSemicolon: 'kabliataškis (;)',
    csvComma: 'Kablelis (,)',
    csvTab: 'skirtuką',
    csvPipe: 'vamzdis (|)',
    excelSheetNameLabel: 'Excel lapo pavadinimas (neprivaloma)',
    excelSheetNamePlaceholder: 'Pavyzdžiui. 1 lapas',
    excelSheetIndexLabel: 'Excel lapo indeksas (pagrįstas 0)',
    excelSheetIndexHint: 'Jei nurodytas lapo pavadinimas, jis naudojamas prieš lapo rodyklę.',
    headerCellsTitle: 'Sąskaitos faktūros antraštė virš lentelės',
    headerCellsHint: 'Spustelėkite langelį eilutėse virš antraštės eilutės, kad susietumėte jį su tiksliniu lauku. Vertė pridedama prie kiekvienos importuotos eilutės.',
    headerCellsClickToMap: 'Spustelėkite norėdami pamatyti žemėlapį',
    headerCellsRemove: 'Pašalinti',
    headerCellsEditorTitle: 'Žemėlapio langelis',
    headerCellsEmpty: '(tuščia ląstelė)',
    headerCellsAsColumn: 'Virtualaus stulpelio pavadinimas',
    headerCellsTargetField: 'Tikslinis laukas',
    headerCellsNoTarget: '— Nėra tikslinio lauko —',
    headerCellsUseSplit: 'Padalinkite langelio reikšmę (pvz., kliento numeris + vardas)',
    headerCellsSplitPattern: 'Regex modelis',
    headerCellsSplitHint: 'Numatytasis: pirmieji skaitmenys → 1 dalis, likusieji → 2 dalis (kaip Qstar B3).',
    headerCellsPart1Column: '1 dalis (1 grupė)',
    headerCellsPart2Column: '2 dalis (2 grupė)',
    headerCellsReloadHint: 'Praleisti eilutes nustatytas, bet peržiūroje nėra sąskaitos faktūros antraštės. Iš naujo įkelkite failą / šaltinį, kad būtų galima susieti virš lentelės esančias eilutes.',
    runPendingSource: 'Importuoti visus laukiančius',
    runPendingSourceTitle: 'Importuokite visus dar neimportuotus šaltinio failus',
    pendingImportDone: 'Laukiama importavimo baigta',
    pendingImportFailed: 'Nepavyko importuoti laukiančių šaltinio failų',
    pendingImportRunning: 'Importuojami laukiantys failai…',
    pageTitle: 'Importo generatorius',
    pageDescription: 'Kurkite ir valdykite importuojamus duomenis be kodavimo',
    colName: 'Vardas',
    colDate: 'Data',
    colSize: 'Dydis',
    colTargetTable: 'Tikslinė lentelė',
    colSchedule: 'Tvarkaraštis',
    colLastRun: 'Paskutinis bėgimas',
    testImportTitle: 'Bandomasis importas ({n} eilutės)',
    loadingHistory: 'Įkeliama istorija...',
    cannotSave: 'Nepavyko išsaugoti',
    importComplete: 'Importavimas baigtas: {imported} importuotas, {updated} atnaujintas, {failed} nepavyko',
    testImportComplete: 'Bandomasis importavimas baigtas: išbandytos {processed} eilutės, {failed} nepavyko (duomenys neišsaugoti)',
    loadSourceFilesError: 'Nepavyko įkelti failų iš šaltinio',
    loadHistoryError: 'Nepavyko įkelti vairavimo istorijos',
    ftpListError: 'Nepavyko pateikti FTP failų sąrašo',
    ftpImportFailed: 'FTP importavimas nepavyko',
    importFailed: 'Importuoti nepavyko',
    latestSourceImportFailed: 'Nepavyko importuoti iš paskutinio šaltinio failo',
  },
  sysadmin: {
    loadSlowQueriesError: 'Nepavyko įkelti lėtų užklausų',
    clearLogError: 'Nepavyko išvalyti žurnalo',
    loadErrorLogError: 'Nepavyko įkelti klaidų žurnalo',
    loadAuditLogError: 'Nepavyko įkelti audito žurnalo',
  },
  tracking: {
    saveMapViewError: 'Nepavyko išsaugoti žemėlapio rodinio',
  },
  support: {
    updateTicketError: 'Nepavyko atnaujinti bilieto',
    sendReplyError: 'Nepavyko išsiųsti atsakymo',
    sendBroadcastError: 'Nepavyko išsiųsti transliacijos',
    deleteBroadcastError: 'Nepavyko ištrinti transliacijos',
    closeTicketError: 'Nepavyko uždaryti bilieto',
    sendMessageError: 'Nepavyko išsiųsti pranešimo',
  },
  deviceManagement: {
    title: 'Įrenginių valdymas',
    devices: 'Prietaisai',
    device: 'Įrenginys',
    imei: 'IMEI',
    iccid: 'ICCID',
    status: 'Būsena',
    vehicle: 'Transporto priemonė',
    organization: 'Organizacija',
    lastKnownVin: 'Paskutinis žinomas VIN',
    history: 'Istorija',
    actions: 'Veiksmai',
    details: 'Detalės',
    exportCsv: 'Eksportuoti CSV',
    exportEmpty: 'Nėra ką eksportuoti pagal pasirinktą filtrą',
    exportDone: 'Eksportuota {{count}} įrenginių',
    statusStock: 'Atsargos',
    statusCustomer: 'Pas klientą',
    statusVehicle: 'Transporto priemonėje',
    statusLost: 'Prarasta',
    statusDecommissioned: 'Išjungtas',
    toStock: 'Į atsargas',
    unmountKeep: 'Atjungti (palikti su klientu)',
    unmountStock: 'Atjungti (į sandėlį)',
    markLost: 'Pažymėti kaip prarastą',
    decommission: 'Eksploatacijos nutraukimas',
    assignOrganization: 'Priskirti organizaciją',
    selectOrganization: 'Pasirinkite organizaciją',
    organizationFollowsVehicle: 'Vykdo transporto priemonės paskirtį',
    importReturns: 'Importuoti grąžinimus',
    importTitle: 'Importuoti grąžintus įrenginius',
    importDescription: 'Įklijuokite IMEI numerius iš „Excel“ (po vieną eilutėje)',
    importSettings: 'Nustatymai',
    setToStock: 'Nustatykite būseną į ATJEKOS',
    disconnectVehicle: 'Atjunkite nuo transporto priemonės',
    deactivateSim: 'Išjunkite SIM kortelę „Jasper“.',
    validImeis: 'rasti galiojantys IMEI numeriai',
    importing: 'Importuojama...',
    successful: 'Sėkmingai',
    failed: 'Nepavyko',
    manualRequired: 'Reikalingas vadovas',
    needsAttention: 'Reikia dėmesio',
    changeHistory: 'Pakeitimų istorija',
    noHistory: 'Jokios istorijos',
    statusChanged: 'Statusas pakeistas',
    vehicleMounted: 'Montuojamas transporto priemonėje',
    vehicleUnmounted: 'Nemontuotas',
    vehicleTransferred: 'Perkelta į kitą transporto priemonę',
    vinDetected: 'Aptiktas VIN',
    vehicleCreated: 'Sukurta transporto priemonė',
    simActivated: 'SIM suaktyvinta',
    simSuspended: 'SIM kortelė sustabdyta',
    deviceCreated: 'Įrenginys sukurtas',
    deviceImported: 'Įrenginys importuotas',
    searchPlaceholder: 'Ieškokite IMEI (visą ar dalį, pvz. paskutinius 4), ICCID arba reg.no...',
    allStatuses: 'Visos būsenos',
    total: 'Iš viso',
    selectAllAvailable: 'Pasirinkite visus galimus',
    selected: 'pasirinktas',
    deselectAll: 'Panaikinkite visų pasirinkimą',
    importImeiToOrg: 'Importuoti IMEI → Organizacija',
    devicesAssigned: 'priskirtus įrenginius',
    deviceDetails: 'Išsami įrenginio informacija',
    noDevices: 'Nerasta jokių įrenginių',
    selectDevice: 'Norėdami peržiūrėti išsamią informaciją, pasirinkite įrenginį',
    confirmDecommission: 'Ar esi tikras? To negalima anuliuoti.',
    obsTitle: 'OBS sąrašas',
    obsHint: 'Įrenginiai, kuriuos reikia patikrinti, kai jie grįš.',
    obsOpenCount: '{count} atviri',
    obsEmpty: 'Nėra atvirų OBS įrašų.',
    obsBadge: 'STEBI',
    obsAdd: 'Pridėti į OBS sąrašą',
    obsAddSelected: 'Pridėti pasirinktą įrenginį į OBS sąrašą',
    obsNotePlaceholder: 'Ką testuoti, kai įrenginys grįš?',
    obsDefaultNote: 'Patikrinti stende, kai įrenginys grįš.',
    obsAdded: 'Pridėta į OBS sąrašą',
    obsMarkDone: 'Patikrinta / baigta',
    obsMarkedDone: 'OBS įrašas pažymėtas kaip baigtas',
    obsCancelled: 'OBS įrašas atšauktas',
    obsLoadError: 'Nepavyko įkelti OBS sąrašo',
    obsSaveError: 'Nepavyko išsaugoti OBS įrašo',
    obdModeTitle: 'OBD II funkcija',
    obdModeHint: 'Siunčia setparam į įrenginį per šliuzą (pateikiama eilėje neprisijungus). OBD = lengvasis automobilis, ELD = sunkioji transporto priemonė (J1939 / FMS), neOBD = EV / OEM (VIN automatinis / rankinis, web_connect). Anti-pavojaus signalas = neOBD + judėjimo sustabdymo delsa 5 s + uždegimo vidurkis išjungtas + akselerometro uždegimas (ID.x / vagystės signalas). OBD-Išjungti = tik 40000:0 (išjungti OBD II funkciją).',
    obdModeAuto: 'OBD (automatinis)',
    obdModeEld: 'GAISRO – Sunkiosios transporto priemonės',
    obdModeNonObd: 'Neatitinka OBD + OĮG',
    obdModeAntiAlarm: 'Anti-signalizacija',
    obdModeDisable: 'OBD – Išjungti',
    obdModeConfirmTitle: 'Siųsti komandą OBD',
    obdModeConfirmObdAuto: 'Įjungti OBD (automatiškai) {reg}? Siunčiamas setparam 40000:1. Jei automobilyje yra VIN, nustatytas VIN Rankinis (40005:1 + 40003), kitu atveju VIN Automatinis (40005:0). Tas pats, kaip P&P lengviesiems automobiliams / ICE.',
    obdModeConfirmEld: 'Įgalinti ELD (sunkiąją transporto priemonę) {reg}? Siunčiamas setparam 40000:2 (J1939/FMS). Naudokite tik sunkvežimiams/autobusams su FMS – ne lengviesiems automobiliams, hibridiniams ar EV.',
    obdModeConfirmNonObd: 'Įgalinti OBD nesuderinamą + OĮG aprūpinimą {reg}? Eilės setparam 40000:3, VIN auto/manual ir web_connect.',
    obdModeConfirmAntiAlarm: 'Siųsti prieš aliarmą į {reg}? Įtraukia į eilę setparam 40000:3;19002:5;50005:0;101:2 ir įtraukia įrenginį į sąrašą NeOBD.',
    obdModeConfirmDisable: 'Siųsti OBD-Disable į {reg}? Siunčiamas setparam 40000:0 ir automobilis išsaugomas problemų sąraše, kad FW/cfg atnaujinimo metu funkcija Išjungti būtų nustatyta iš naujo. Blokuojamas, jei įrenginys jau turi ELD (40000:2) – iš naujo nustato ekrano pavojaus signalus.',
    obdModeSuccess: 'Komanda OBD išsiųsta į įrenginį',
    obdModePartialFail: 'Komanda išsiųsta, bet įrenginys nereagavo į visus veiksmus (neprisijungus / skirtasis laikas?)',
    obdModeError: 'Nepavyko išsiųsti komandos OBD',
    obdDisableLastSent: 'Paskutinis išjungimas šiame įrenginyje: {when} ({status}) pagal {user}',
    obdDisableLogShow: 'Žiūrėti Išjungti žurnalą (paskutinis išsiuntimas)',
    obdDisableLogHide: 'Slėpti Išjungti žurnalą',
    obdDisableLogEmpty: 'Dar nėra užregistruotų išjungti laiškų.',
    obdDisableLogWhen: 'Kada',
    obdDisableLogDevice: 'Vienetas',
    obdDisableLogStatus: 'Būsena',
    obdDisableLogBy: 'Iš',
    obdBaselineTitle: 'OBD Plug & Play – pradinis lygis (FW + konfigūracija)',
    obdBaselineHelp: 'Prieš įjungdami P&P, įveskite tikslius FMM003 FOTA WEB failų pavadinimus. Automatinis paleidimas išjungtas, kol OBD_PROVISIONING_ENABLED=true .env.',
    obdBaselineRuntimeOn: 'P&P Global ON',
    obdBaselineRuntimeOff: 'P&P visuotinis IŠJUNGTAS (saugus režimas)',
    obdBaselineModels: 'Leidžiami modeliai',
    obdBaselineAllProfiles: 'visi profiliai',
    obdBaselineFw: 'Tikslinė programinė įranga (FOTA failo pavadinimas)',
    obdBaselineCfg: 'Grundconfig (FOTA failo pavadinimas)',
    obdBaselineNote: 'Pastaba',
    obdBaselineSaved: 'Bazinė padėtis išsaugota',
    obdBaselineLoadError: 'Nepavyko gauti bazinių linijų',
    obdBaselineSaveError: 'Nepavyko išsaugoti bazinės linijos',
    obdBaselineNeedFile: 'Įveskite bent programinės įrangos arba konfigūracijos failo pavadinimą',
    obdBaselineEmpty: 'Jokių bazinių linijų. Vykdykite perkėlimą 345 arba sukurkite eilutę FMM003.',
  },
  deviceAvlCapabilities: {
    title: 'AVL galimybės kiekvienam įrenginiui',
    description: 'Kokius AVL parametrus (id + pavadinimą) pateikia kiekvienas įrenginys / transporto priemonė. Viena eilutė kiekvienam IMEI+VIN. Spustelėkite IMEI, kad pamatytumėte pavadinimą ir aprašymą.',
    filterImei: 'Filtruoti pagal IMEI',
    filterRegNumber: 'Filtruoti pagal reg Nr.',
    filterAvlId: 'AVL ID (pvz., 13)',
    imei: 'IMEI',
    vin: 'VIN',
    regNumber: 'Reg Nr.',
    avlParameters: 'AVL parametrai',
    firstSeen: 'Pirmą kartą pamatytas',
    lastSeen: 'Paskutinį kartą matytas',
    noData: 'Dar nėra duomenų. Duomenys renkami, kai įrenginiai siunčia GPS taškus.',
    modalTitle: 'Įrenginio AVL parametrai',
    parameterCountOne: 'parametras',
    parameterCount: 'parametrus',
  },
  roles: {
    title: 'Vaidmenų valdymas',
    createRole: 'Sukurti naują vaidmenį',
    editRole: 'Redaguoti vaidmenį',
    viewRights: 'Žiūrėti teises',
    roleName: 'Vardas',
    roleCode: 'Kodas',
    roleDescription: 'Aprašymas',
    roleAdministrator: 'Vaidmens administratorius',
    roleAdministratorHelp: 'Parko vadovai gali perjungti vartotoją savo organizacijoje ir patikrinti teises. Pažymėkite, jei tą patį turi galėti daryti ir kitas vaidmuo.',
    permissions: 'Leidimai',
    systemRole: 'Sistemos vaidmuo',
    customRole: 'Pasirinktinis vaidmuo',
    allActions: 'Visi veiksmai',
    codePlaceholder: 'pvz. CUSTOM_ROLE',
    namePlaceholder: 'pvz. Pasirinktinis vaidmuo',
    descriptionPlaceholder: 'Vaidmenų aprašymas...',
    codeCannotChange: 'Kodo pakeisti negalima',
    rightsAndAccess: 'Teisės ir prieiga',
    loadingFeatures: 'Įkeliamos funkcijos...',
    noActionsAvailable: 'Nėra jokių veiksmų',
    noAccessToFeature: 'Nėra prieigos prie šios funkcijos',
    selectAll: 'Pasirinkite viską',
    deselectAll: 'Panaikinkite visų pasirinkimą',
    createRoleButton: 'Sukurti vaidmenį',
    updateRoleButton: 'Išsaugoti pakeitimus',
    roleCreated: 'Vaidmuo sukurtas!',
    roleUpdated: 'Vaidmuo atnaujintas!',
    createRoleError: 'Nepavyko sukurti vaidmens',
    updateRoleError: 'Nepavyko atnaujinti vaidmens',
    loadRoleError: 'Nepavyko įkelti vaidmens',
    systemRoleOnlyGlobalAdmin: 'Sistemos vaidmenis gali redaguoti tik visuotinis administratorius.',
    codeAndNameRequired: 'Būtinas kodas ir vardas',
    loadDataError: 'Nepavyko įkelti duomenų',
    systemRoleNote: '(Sistemos vaidmuo)',
    summary: 'Santrauka',
    permissionsCount: 'leidimai',
    noPermissionsSelected: 'Nepasirinkta jokių leidimų',
    actions: 'veiksmus',
    systemRoles: 'Sistemos vaidmenys',
    customerRoles: 'Klientui būdingi vaidmenys',
    visibleToAll: 'Matoma visiems klientams',
    visibleToOrganization: 'Matoma organizacijai ir palikuonims',
    showInactive: 'Rodyti neaktyvius vaidmenis',
    createAsSystemRole: 'Sukurti kaip sistemos vaidmenį',
    customerRoleHint: 'Vaidmuo bus sukurtas jūsų organizacijai ir palikuonims',
    roleActivated: 'Vaidmuo suaktyvintas!',
    roleDeactivated: 'Vaidmuo išjungtas!',
    toggleError: 'Nepavyko perjungti vaidmens būsenos',
    noRolesFound: 'Vaidmenų nerasta',
    menu: 'Meniu',
    systemTemplatesHint: 'Šablonai, kopijuojami naujiems klientams',
    templateStartingPoint: 'Pradinis taškas (šablonas)',
    selectTemplate: 'Pasirinkite šabloną...',
    templateRequired: 'Pasirinkite sistemos šabloną kaip pradžios tašką',
    templateHint: 'Pasirinkite sistemos šabloną. Tada galite koreguoti modulius ir funkcijas savo priskirtose paslaugose.',
    loadTemplateError: 'Nepavyko įkelti šablono leidimų',
    permissionCeilingExceeded: 'Teisė viršija kliento priskirtas paslaugas',
  },
  organizations: {
    title: 'Organizacijos valdymas',
    searchPlaceholder: 'Ieškoti organizacijos...',
    chart: 'Organizacijos schema',
    chartDescription: 'Peržiūrėkite ir redaguokite organizacijos hierarchiją grafiškai',
    managementDescription: 'Kurti ir valdyti organizacijas',
    createTopNode: 'Sukurkite viršutinį mazgą',
    createSubOrganization: 'Sukurti suborganizaciją',
    organizationName: 'Vardas',
    description: 'Aprašymas',
    parentOrganization: 'Tėvų organizacija',
    topNode: 'Viršutinis mazgas (nėra pirminio)',
    isTopNode: 'Viršutinis mazgas',
    isTopNodeHint: 'Aukščiausias mazgas neturi pagrindinės organizacijos ir yra hierarchijos viršuje.',
    authSettings: 'Autentifikavimo nustatymai',
    noOrganizations: 'Organizacijų dar nėra. Norėdami pradėti, sukurkite viršutinį mazgą.',
    deleteConfirm: 'Ar tikrai norite ištrinti šią organizaciją ir visas jos suborganizacijas?',
    editOrganization: 'Redaguoti organizaciją',
    addSub: 'Pridėti sub',
    deleteOrganization: 'Ištrinti',
    createButton: 'Sukurti',
    updateButton: 'Atnaujinti',
    customerLogo: 'Kliento logotipas',
    uploadLogo: 'Įkelti logotipą',
    removeLogo: 'Pašalinti logotipą',
    logoUploadSuccess: 'Logotipas įkeltas',
    logoDeleteSuccess: 'Logotipas pašalintas',
    organizationCreated: 'Organizacija sukurta!',
    organizationUpdated: 'Organizacija atnaujinta!',
    organizationDeleted: 'Organizacija ištrinta!',
    createError: 'Nepavyko sukurti organizacijos',
    updateError: 'Nepavyko atnaujinti organizacijos',
    deleteError: 'Nepavyko ištrinti organizacijos',
    loadHierarchyError: 'Nepavyko įkelti hierarchijos',
    loadChildrenError: 'Nepavyko įkelti poorganizacijų',
    nameRequired: 'Vardas yra būtinas',
    namePlaceholder: 'Organizacijos pavadinimas',
    descriptionPlaceholder: 'Aprašymas...',
    noParent: 'Nėra (sukurti kaip viršutinį mazgą)',
    status: 'Būsena',
    active: 'Aktyvus',
    suspended: 'Sustabdytas',
    inactive: 'Neaktyvus',
    loginParameters: 'Prisijungimo parametrai',
    authMethod: 'Autentifikavimo metodas',
    authMethodAppliesToUsers: 'Išsaugojus visi šio kliento naudotojai gauna tą patį prisijungimo būdą.',
    passwordAuth: 'Slaptažodis',
    twoFactorAuth: 'Dviejų faktorių autentifikavimas',
    samlAuth: 'SAML2',
    oidcAuth: '„OpenID Connect“ (pvz., „Entra ID“)',
    allowedDomains: 'Leidžiami domenai',
    allowedDomainsPlaceholder: 'pvz. acme.com, intranet.acme.com',
    allowedDomainsHint: 'Atskirkite kelis domenus kableliais',
    organizationIdentifier: 'Organizacijos identifikatorius',
    organizationIdentifierPlaceholder: 'pvz. acme',
    organizationIdentifierHint: 'Naudojamas identifikavimui naudojant užklausos parametrą (?org=)',
    additionalInfo: 'Papildoma informacija',
    address: 'Adresas',
    addressPlaceholder: 'pvz. Pagrindinė gatvė 1',
    postNr: 'Pašto kodas',
    postNrPlaceholder: 'pvz. 12345',
    town: 'Miestas',
    townPlaceholder: 'pvz. Stokholmas',
    orgNr: 'Organizacijos numeris',
    orgNrPlaceholder: 'pvz. 556123-4567',
    contact: 'Kontaktinis asmuo',
    contactPlaceholder: 'pvz. Anna Andersson',
    contacttel: 'Kontaktinis Telefonas',
    contacttelPlaceholder: 'pvz. +46-8-123456',
    email: 'El. paštas',
    emailPlaceholder: 'pvz. info@example.com',
    carRental: 'Automobilių nuomos įmonė',
    isBookingPool: 'Rezervacijų telkinys',
    isBookingPoolHint: 'Automobiliai su bendru įmonės automobiliu ir aktyvūs grupės ištekliai rodomi telkinyje. Automobiliai su vairuotoju arba rankiniu būdu atžymėti neįtraukiami.',
    costNo: 'Kainos numeris',
    costNoPlaceholder: 'pvz. KST-123',
    move: 'Judėti',
    moveOrganization: 'Perkelti organizaciją',
    moveOrganizationDescription: 'Perkelti organizaciją ir visas jos suborganizacijas į naują pirminę organizaciją. Visi nustatymai bus išsaugoti.',
    newParent: 'Nauja tėvų organizacija',
    selectParent: 'Pasirinkite pirminę organizaciją',
    moveButton: 'Judėti',
    organizationMoved: 'Organizacija persikėlė!',
    moveError: 'Nepavyko perkelti organizacijos',
    loadDataError: 'Nepavyko įkelti duomenų',
    loadError: 'Nepavyko įkelti organizacijų',
    importError: 'Nepavyko importuoti failo',
    fuelCompanies: {
      tabTitle: 'Kuro įmonės',
    },
    fuelAccounts: {
      loadError: 'Nepavyko įkelti degalų sąskaitų',
      saveError: 'Nepavyko išsaugoti degalų sąskaitų',
      saved: 'Išsaugota',
      fillAll: 'Pasirinkite kuro įmonę ir įveskite kliento numerį',
      alreadyAdded: 'Ta kuro įmonė jau pridėta',
      empty: 'Nėra susietų degalų sąskaitų. Žemiau pridėkite kuro įmones ir klientų numerius.',
      fuelCompany: 'Kuro įmonė',
      selectCompany: 'Pasirinkite kuro įmonę',
      customerNumber: 'Kliento numeris',
      customerNumberPlaceholder: 'pvz. 12345',
      add: 'Pridėti',
      savedWithLinks: 'Išsaugota. {{count}} kuro operacijos buvo susietos su organizacija.',
    },
    contactRoles: {
      title: 'Atsakingi / kontaktiniai vaidmenys',
      noAssignment: 'Nepriskirta',
      addCustomRole: 'Pridėti pasirinktinį vaidmenį',
      codeRequired: 'Būtinas kodas',
      codePlaceholder: 'pvz. regiono_vadybininkas',
      roleName: 'Vaidmens pavadinimas',
      description: 'Aprašymas',
      createRole: 'Sukurti vaidmenį',
      roleCreated: 'Sukurtas vaidmuo',
      roleDeleted: 'Vaidmuo ištrintas',
      confirmDeleteRole: 'Ištrinti šį vaidmenį?',
      attestationResponsible: 'Atestacija atsakinga',
      manager: 'Vadovas',
      localVehicleResponsible: 'Atsakingas vietinis automobilis',
      fleetManager: 'Flotilės vadovas',
      maintenanceResponsible: 'Atsakingas aptarnavimas',
      servicePersonnel: 'Aptarnaujantis personalas',
    },
    reminders: {
      tabTitle: 'Prenumeratos',
      title: 'Prenumeratos',
      intro: 'Taikoma visam kliento medžiui po šiuo viršutiniu mazgu. Išjungta paslauga nesukuria nei užduočių, nei pranešimų. Pranešimas valdo el. paštą ir push.',
      service: 'Paslauga',
      notify: 'Pranešimas',
      inspection: 'Techninė apžiūra',
      inspectionHelp: 'Priminimas, kai apžiūra per 40 dienų.',
      tax: 'Transporto priemonės mokestis',
      taxHelp: 'Priminimas, kai mokestį reikia sumokėti per 45 dienas.',
      leasing: 'Lizingo pabaiga',
      leasingHelp: 'Rodyti transporto priemones, kurių lizingas baigiasi per pasirinktą mėnesių skaičių. Numatyta 6.',
      monthsAhead: 'Mėnesiai į priekį',
    },
    emailSettings: {
      tabTitle: 'El. paštas',
      title: 'Siunčiamas el. paštas',
      intro: 'Rodo laiškus, kurie įeina į kliento modulius, ir paskyros laiškus. Pažymėta reiškia, kad laiškas siunčiamas. Taikoma visam kliento medžiui. Push ir SMS nekeičiami.',
      kinds: {
        bookingConfirmation: 'Rezervacijos patvirtinimas',
        bookingOverdue: 'Vėluojantis grąžinimas',
        bookingCancellation: 'Sistemos atšaukimas',
        bookingAssignment: 'Rezervacija tiekėjui',
        welcome: 'Pasveikinimo laiškas',
        passwordReset: 'Slaptažodžio atkūrimas',
        emailVerification: 'El. pašto patvirtinimas',
        drivingLog: 'Kelionės žurnalas',
        vehicleDue: 'Techninė apžiūra ir mokestis',
        service: 'Aptarnavimas',
        unplug: 'Atjungtas įrenginys',
        rentalReport: 'Nuomos ataskaita',
        travelPlanner: 'Kelionės planuotojas',
        scheduledReport: 'Suplanuotos ataskaitos',
        supportReply: 'Palaikymo atsakymas',
      },
      kindHelp: {
        bookingConfirmation: 'Patvirtinimas ir pakeitimai, įskaitant greitą rezervaciją.',
        bookingOverdue: 'Laiškas, kai grąžinimo laikas praėjo. Push vis tiek siunčiamas.',
        bookingCancellation: 'Laiškas, kai sistema atšaukia, nes nėra laisvo resurso.',
        bookingAssignment: 'Laiškas tiekėjui arba nuomos įmonei. Galioja gavėjo klientui.',
        welcome: 'Pasveikinimo laiškas su nuoroda slaptažodžiui.',
        passwordReset: 'Pamirštas slaptažodis. Atsakymas toks pat, bet laiškas nesiunčiamas.',
        emailVerification: 'Nuoroda el. paštui patvirtinti.',
        drivingLog: 'Priminimas, mėnesio ataskaita ir eksportas.',
        vehicleDue: 'Laiškas apie techninę apžiūrą ir mokestį.',
        service: 'Priminimas apie vėluojantį ar artėjantį aptarnavimą.',
        unplug: 'Įspėjimas, kai GPS įrenginys atjungiamas.',
        rentalReport: 'Nuomos ataskaita el. paštu.',
        travelPlanner: 'Maršrutas iš kelionės planuotojo.',
        scheduledReport: 'Suplanuotos ataskaitos iš ataskaitų generatoriaus.',
        supportReply: 'Patvirtinimas ir atsakymai į palaikymo užklausą.',
      },
    },
    reportModels: {
      tabTitle: 'Duomenų modeliai',
      title: 'Duomenų modeliai',
      intro: 'Pasirinkite, kuriuos ataskaitų modelius šis klientas gali naudoti. Taikoma visam kliento medžiui.',
      save: 'Išsaugoti modelius',
      saved: 'Duomenų modeliai išsaugoti',
      empty: 'Modelių dar nėra.',
    },
    supportForward: {
      tabTitle: 'Palaikymo užklausos',
      title: 'Palaikymo užklausų persiuntimas',
      intro: 'Kai ši organizacija gauna naują palaikymo užklausą, kopija siunčiama žemiau nurodytu adresu. Kitų organizacijų užklausos nesiunčiamos. Nieko nesiunčiama, kol persiuntimas neįjungtas.',
      enabled: 'Įjungti persiuntimą',
      enabledHelp: 'Turi būti pažymėta, kad kopija būtų išsiųsta.',
      email: 'El. pašto adresas',
      emailPlaceholder: 'pvz. support@klientas.lt',
      emailHelp: 'Pašto dėžutė, kuri gauna naujų užklausų kopijas tik šiai organizacijai.',
      partnerIntro: 'Kai platintojas arba klientas po juo gauna naują palaikymo užklausą, kopija siunčiama žemiau nurodytu adresu. Nieko nesiunčiama, kol persiuntimas neįjungtas.',
      partnerEmailHelp: 'Pašto dėžutė, kuri gauna naujų užklausų kopijas iš platintojo ir jo klientų.',
    },
    bookingSettings: 'Užsakymo nustatymai',
    defaultTimelineView: 'Laiko juosta kaip numatytasis rodinys klientų aptarnavime',
    defaultTimelineViewHelp: 'Sąrašas visada yra numatytasis. Pažymėkite, kad šiai organizacijai klientų aptarnavime pirmiausia būtų rodoma laiko juosta. Naudotojai visada gali patys pakeisti rodinį.',
    maxRecurringBookings: 'Maksimalus pasikartojančių užsakymų skaičius',
    maxRecurringBookingsHelp: 'Didžiausias būsimų užsakymų skaičius pasikartojančioje serijoje (pvz., tuo pačiu laiku kiekvieną savaitę). 0 arba tuščia = nėra apribojimų.',
    noBookingsBefore: 'Jokių užsakymų anksčiau',
    noBookingsAfter: 'Po to jokių užsakymų',
    noBookingsHelp: '0 arba tuščia = jokių apribojimų.',
    minLengthHours: 'Minimali trukmė (valandomis)',
    maxLengthHours: 'Maksimali trukmė (valandomis)',
    lengthHelp: '0 arba tuščia = jokių apribojimų.',
    bookableMonthsForward: 'Rezervuojami mėnesiai į priekį',
    bookableMonthsHelp: '0 arba tuščia = jokių apribojimų.',
    cancellationChargeHours: 'Atšaukimo mokestis (valandos iki starto)',
    cancellationChargeHelp: 'Jei klientas atšaukia užsakymą per šį laiką iki starto, užsakymas gali būti apmokestintas, tačiau transporto priemonė atleidžiama. 0 arba tuščia = tokios taisyklės nėra.',
    noShowReleaseMinutes: 'Nerodyti: atleidimo anga (minutės po pradžios)',
    noShowReleaseMinutesHelp: 'Jei transporto priemonė neišsiregistruojama per tiek minučių nuo užsakymo pradžios, lizdas atleidžiamas; už užsakymą vis tiek galima išrašyti sąskaitą faktūrą. 0 = išjungta. Naujos išdavimo vietos gauna šią reikšmę iš anksto (galima keisti kiekvienai vietai).',
    bookingPolicyHtml: 'Užsakymo politika',
    bookingPolicyHtmlHelp: 'Tekstas, kurį užsakovas turi atidaryti ir patvirtinti prieš užsakymą (be vairuotojo pažymėjimo). Palikite tuščią, jei politika neprivaloma.',
    selectOrganization: 'Pasirinkite organizaciją',
    customerTopNode: 'Kliento mazgas',
    organizationDeletedHard: 'Organizacija pašalinta visam laikui!',
    organizationDeletedSoft: 'Organizacija išjungta (švelnus ištrynimas), nes egzistuoja susietos transporto priemonės.',
    portalHostname: 'Portalo adresas',
    portalHostnamePlaceholder: 'klientas.deque.se',
    portalHostnameHint: 'https://kund.deque.se praleidžia slaptažodžio laukelį ir patenka tiesiai į kliento SSO. Programa lieka adresu app.deque.se. Išsaugojus adresą, A įrašas sukuriamas naudojant „Loopia“.',
    portalHostnameReadOnly: 'Adresą nustato Deque. Įveskite toliau pateiktą grąžinimo adresą į savo IDP.',
    portalIdpNotice: 'Klientas pats įveda OIDC grąžinimo adresą savo IdP (pavyzdžiui, Entra) ir pasilieka jau esančius adresus. Pakanka esamo SSO sertifikato.',
    portalOidcCallbackLabel: 'OIDC grąžinimo adresą pridėjo klientas',
    portalOidcCallbackPending: 'Kai organizacija išsaugoma, adresas tampa https://{{host}}/api/auth/oidc/{id}/callback',
    importModalTitle: 'Importo organizacijos',
    importModalSubtitle: 'Per',
    importDropzone: 'Nuvilkite Excel failą (.xlsx) čia arba spustelėkite, kad pasirinktumėte failą',
    importStart: 'Importuoti',
    importNoFile: 'Prieš importuodami pasirinkite failą',
    importFileError: 'Nepavyko perskaityti failo. Patikrinkite, ar tai galiojantis Excel failas.',
    importFileSelected: 'Pasirinktas failas',
    importPreviewTitle: 'Peržiūra',
    importPreviewCount: 'importuotinos eilutės',
    importPreviewScrollHint: 'Vienu metu rodoma iki 20 eilučių – slinkite, kad pamatytumėte daugiau',
    importColumnName: 'Vardas',
    importColumnParent: 'Tėvų organizacija',
    importColumnContact: 'Kontaktinis asmuo',
    importColumnPhone: 'Telefonas',
    importColumnEmail: 'paštas',
    importColumnCostNo: 'Kainos numeris',
    importCreated: 'sukurtos organizacijos',
    importErrors: 'negerai',
    importRowError: 'Eilutė',
    importOrganizations: 'Importo organizacijos',
    importOrganizationsTooltip: 'Importuoti suborganizacijas iš Excel',
    downloadTemplate: 'Atsisiųsti importavimo šabloną',
    downloadTemplateTooltip: 'Atsisiųsti organizacijos importavimo Excel šabloną',
    drivingLog: {
      tabTitle: 'Vairavimo žurnalo nustatymai',
      title: 'Vairavimo žurnalas',
      intro: 'Taikoma transporto priemonėms, susietoms su šia organizacija ir organizacijomis po ja. Pogrupis su savo nustatymais perima savo transporto priemones. Susiejant transporto priemonę su naudotoju naudojami aptarnavimo laikai, jei rankiniu būdu nenurodyta kitaip.',
      ownSettings: 'Savi vairavimo žurnalo nustatymai',
      ownSettingsHelp: 'Išsaugo šios organizacijos reikšmes. Jos taikomos transporto priemonėms, susietoms čia ir organizacijose po ja.',
      inheritedFrom: 'Rodomi {{name}} nustatymai. Pažymėkite, jei norite išsaugoti savus.',
      serviceHoursTitle: 'Standartinis darbo laikas (kitu privačiu laiku)',
      serviceStart: 'Paslaugos pradžia',
      serviceEnd: 'Paslaugos pabaiga',
      serviceHoursHelp: 'Pagal numatytuosius nustatymus taikoma visoms transporto priemonėms, kol kas nors nepakeičiama kiekvienai transporto priemonei arba prisijungiant.',
      cutOffEnabled: 'Įgalinti pateikimo pertraukos datą',
      cutOffEnabledHelp: 'Jei išjungta, sistemoje šiai viršūnei nenaudojama jokia mėnesio pertraukos data.',
      cutOffDay: 'Pertraukos data (mėnesio diena)',
      cutOffDayHelp: 'Pavyzdys: ne vėliau kaip kas mėnesį. Pasirinkite 1–28, kad išvengtumėte trumpo mėnesio.',
      reminderDays: 'Priminimas (dienos iki pertraukos datos)',
      reminderHelp: 'Dienų skaičius iki pertraukos datos, kai priminimas buvo išsiųstas. Push patenka į programą (vairuotojai ir naudotojai, turintys vairavimo įrašą). El. paštas siunčiamas persiuntimo adresu.',
      forwardingEmail: 'Numatytasis persiuntimo el. paštas',
      forwardingEmailPlaceholder: 'pvz. ekonomi@foretag.se; hr@foretag.se',
      forwardingEmailHelp: 'Naudojamas kaip iš anksto užpildytas persiuntimo tikslas, kai siunčiamas vairavimo įrašas. Keli adresai atskiriami kabliataškiais (;).',
      lockAfterSubmit: 'Užrakinti vairavimo žurnalą po pateikimo',
      lockAfterSubmitHelp: 'Užrakinamas redagavimas, kai vairavimo žurnalas pateikiamas rankiniu būdu ir kai baigiasi mėnesio ataskaitos galiojimo laikas. Priminimas (el. paštas/push) neužrakinamas.',
      odometerAdjustmentLock: 'Skaitiklio rodmenų blokavimas ataskaitiniu laikotarpiu',
      odometerAdjustmentLockHelp: 'Kai įjungta, 1–3 ir 26 mėnesių pabaigoje (apskaitos / atestavimo laikotarpis) skaitiklio rodmenų negalima reguliuoti rankiniu būdu. Išjungta pagal numatytuosius nustatymus.',
    },
    automaticService: 'Automatinis aptarnavimas',
    cabinetSettings: 'Kabineto nustatymai',
    cabinetHasCabinet: 'Klientas turi raktų spintelę',
    cabinetHasCabinetHelp: 'Įgalina viršutinio mazgo spinteles. Pirmą kartą atidarote spintelę su KeyWin integruotu SuperAdmin ir įkiškite kaiščius. Po to tik toje spintoje esantys čiaupai sinchronizuojami su kliento SuperAdmin ir kabineto LocalAdmin (KeyWin vartotojas, o ne žiniatinklio administratorius).',
    cabinetEnabled: 'Klientui suaktyvinta spintelė',
    cabinetDisabled: 'Kliento spintelė išjungta',
    cabinetEnableError: 'Nepavyko pakeisti spintelės nustatymų',
    cabinetSuperAdminPin: 'SuperAdmin PIN',
    cabinetSuperAdminPinHelp: '8 skaitmenys, unikalūs sistemoje. Klaviatūros PIN kodas sinchronizuojamas su „SuperAdmin“ vartotoju. Nepateikia prisijungimo prie interneto naudojant KeyWin. Pradinis čiaupų įdėjimas atliekamas naudojant įmontuotą SuperAdmin kodą, kuris visada gali atidaryti visas spinteles.',
    cabinetPinCopied: 'PIN nukopijuotas',
    cabinetGeneratePin: 'Sugeneruokite PIN kodą',
    cabinetPinSync: 'Išsaugoti KeyWin',
    cabinetPinSaved: 'SuperAdmin PIN išsaugotas KeyWin',
    cabinetPinGenerated: 'Naujas unikalus SuperAdmin PIN sukurtas ir išsaugotas KeyWin',
    cabinetPinInvalid: 'PIN kodą turi sudaryti tiksliai 8 skaitmenys',
    cabinetPinSaveError: 'Nepavyko išsaugoti SuperAdmin PIN kodo',
    cabinetWebAdmin: 'Prisijungimas prie interneto (KeyWin administratorius)',
    cabinetUsername: 'Vartotojo vardas',
    cabinetPassword: 'Slaptažodis',
    cabinetPasswordHelp: 'Naudojamas prisijungti prie KeyWin žiniatinklio sąsajos.',
    cabinetPasswordCopied: 'Slaptažodis nukopijuotas',
    cabinetRegeneratePassword: 'Sukurti naują slaptažodį',
    cabinetRegenerateConfirm: 'Ar norite sukurti naują žiniatinklio slaptažodį? Senasis nebegalioja.',
    cabinetRegenerateError: 'Nepavyko sugeneruoti naujo slaptažodžio',
    cabinetLinkedCabinets: 'Susietos spintelės',
    cabinetNoLinkedCabinets: 'Dar nėra susietų su klientu. Atlikite tai skiltyje Raktų valdymas.',
    cabinetSyncTags: 'Sinchronizavimo palietimai',
    cabinetSyncTagsHelp: 'Su „LocalAdmin“ ir viršutinio mazgo „SuperAdmin“ sujungia tik bakstelėjimus, kuriuos „KeyWin“ mato šioje spintoje. Ieškokite KeyWin skiltyje Vartotojai, o ne grupės.',
    cabinetSyncTagsSuccess: '{{count}} bakstelėjimai susieti su SuperAdmin ir LocalAdmin',
    cabinetSyncTagsEmpty: 'Spintelėje dar nėra bakstelėjimų. Atidarykite naudodami įtaisytąjį „SuperAdmin“, įkiškite kaiščius ir sinchronizuokite dar kartą.',
    cabinetSyncTagsError: 'Nepavyko sinchronizuoti smeigtukų',
    bookingRestMinutes: 'Poilsio laikas tarp užsakymų (minutės)',
    bookingRestMinutesHelp: 'Minimalus minučių skaičius pasibaigus užsakymui, kol tą pačią transporto priemonę galima vėl užsisakyti. 0 arba tuščia = poilsio laiko nėra.',
    bookingMinLeadTimeHours: 'Minimalus numatymas (valandomis)',
    bookingMinLeadTimeHoursHelp: 'Taikoma tik užklausoms, kurios siunčiamos automobilių nuomos įmonei. Užsakymas turi prasidėti bent prieš tiek valandų. 0 arba tuščia = jokių apribojimų.',
  },
  moduleSearch: {
    open: 'Ieškoti modulio',
    placeholder: 'Ieškoti modulio...',
    hint: 'Rašykite, kad ieškotumėte savo modulių',
    noResults: 'Joks modulis neatitinka',
  },

  manual: {
    title: 'Vartotojo vadovas',
    intro: 'Tokie pat skyriai kaip kairiajame meniu. Pasirinkite punktą ir skaitykite, ką modulis daro.',
    searchPlaceholder: 'Ieškoti vadove...',
    noDescription: 'Šiam moduliui aprašymo dar nėra.',
    mainMenu: 'Pagrindinis meniu',
    tools: 'Įrankiai',
    administration: 'Administravimas',
    path: 'Kelias',
    availableActions: 'Galimi veiksmai',
    noResults: 'Rezultatų nerasta',
    icons: 'Galimos piktogramos',
    iconsDescription: 'Čia yra visos piktogramos, kurias galite rasti Heroicons bibliotekoje. Galite pasirinkti bet kurią piktogramą, kurią naudosite sistemoje.',
    navigationIcons: 'Navigacijos piktogramos',
    arrowsIcons: 'Rodyklės piktogramos',
    actionsIcons: 'Veiksmų piktogramos',
    adminIcons: 'Administracinės piktogramos',
    communicationIcons: 'Bendravimo piktogramos',
    filesIcons: 'Failų piktogramos',
    statusIcons: 'Būsenos piktogramos',
    mediaIcons: 'Žiniasklaidos piktogramos',
    otherIcons: 'Kitos piktogramos',
    guides: {
      title: 'Vadovas ir procesai',
      deviceVehicleTitle: 'Įrenginio perjungimas į kitą automobilį',
      deviceVehicleIntro: 'Kas nutinka, kai GPS įrenginys perkeliamas iš vieno automobilio į kitą, ir kaip tai padaryti rankiniu būdu.',
      autoHeading: 'Kas nutinka automatiškai',
      autoSteps: [
        'Kai jis perkeliamas į kitą automobilį,',
        'Įrenginys atjungiamas nuo seno automobilio ir prijungiamas prie naujo automobilio.',
        'Jei tai visiškai naujas automobilis, jis automatiškai sukuriamas su teisinga informacija (markė, modelis, reg. Nr.).',
        'Jei sename automobilyje buvo vairuotojas, vairuotojas jį lydi į naują automobilį.',
        ' tvarkyklė.',
      ],
      manualHeading: 'Įrenginio keitimas rankiniu būdu',
      manualSteps: [
        'Eikite į Administravimas → Įrenginio valdymas.',
        'Ieškokite įrenginio ir pasirinkite prijungti jį prie naujo automobilio.',
        'Jei naujame automobilyje įrenginys jau yra, galite pasirinkti pakeisti įrenginių vietą arba atjungti senąjį.',
        'Patvirtinti – įrenginys perkeltas į naują automobilį ir atjungtas nuo senojo.',
        'Senas automobilis tampa laisvas, o naujas automobilis dabar rodo įrenginį.',
      ],
    },
  },
  icons: {
    fleet: 'Automobilių parkas',
    statistics: 'Statistika',
    trips: 'Kelionės',
    user: 'Vartotojas',
    manual: 'Vartotojo vadovas',
    search: 'Ieškoti',
    notification: 'Pranešimai',
    moon: 'Tamsusis režimas',
    sun: 'Šviesos režimas',
    arrowLeft: 'Atgal',
    eye: 'Rodyti',
    eyeSlash: 'Slėpti',
    settings: 'Nustatymai',
    database: 'Duomenų bazė',
    sync: 'Sinchronizuoti',
    userGroup: 'Vartotojų grupė',
  },
  translations: {
    title: 'Vertimai',
    key: 'Raktas',
    swedish: 'švedų',
    english: 'anglų kalba',
    editTranslation: 'Redaguoti vertimą',
    saveSuccess: 'Vertimas išsaugotas',
    saveError: 'Nepavyko išsaugoti vertimo',
    searchPlaceholder: 'Ieškokite rakto arba teksto...',
    noTranslations: 'Nerasta jokių vertimų',
    noMatchSearch: 'Jokie vertimai neatitiko paieškos',
    exportFiles: 'Eksportuoti į failus',
    exportNoteLabel: 'Pastaba',
    exportNote: 'Vertimai saugomi failuose (sv.ts, en.ts, de.ts ir lt.ts). Norėdami atsisiųsti atnaujintus failus, naudokite „Eksportuoti į failus“ arba redaguokite failus tiesiai kode.',
    total: 'Iš viso',
    filtered: 'filtruojamas iš',
    updatedNote: 'Vertimas atnaujintas! (Pastaba: failų pakeitimus reikia įrašyti rankiniu būdu)',
  },
  dashboard: {
    title: 'Prietaisų skydelis',
    activeVehicles: 'Aktyvios transporto priemonės',
    totalDistance: 'Bendras atstumas',
    averageSpeed: 'Vidutinis greitis',
    liveMap: 'Tiesioginis žemėlapis',
    liveTracking: 'Tiesioginis stebėjimas',
    mapComingSoon: 'OpenStreetMap integracija netrukus',
    addressUnavailable: 'Adreso nepavyko nuskaityti',
    edit: 'Redaguoti',
    editDashboard: 'Redaguoti prietaisų skydelį',
    save: 'Išsaugoti',
    cancel: 'Atšaukti',
    addWidget: 'Pridėti valdiklį',
    addWidgetHint: 'Pridedamas puslapio apačioje. Tada nuvilkite ten, kur norite.',
    addFirstWidget: 'Pridėkite savo pirmąjį valdiklį',
    emptyDashboard: 'Jūsų prietaisų skydelis tuščias',
    emptyDashboardDescription: 'Pridėkite valdiklių, kad tinkintumėte savo prietaisų skydelį. Galite pasirinkti iš daugybės valdiklių, rodančių informaciją apie jūsų transporto priemones ir organizaciją.',
    dragHere: 'Nuleiskite valdiklį čia',
    layoutSaved: 'Išdėstymas išsaugotas',
    layoutSaveFailed: 'Nepavyko išsaugoti maketo',
    widgetAdded: 'Valdiklis pridėtas',
    widgetRemoved: 'Valdiklis pašalintas',
    widgetNotAvailable: 'Valdiklis nepasiekiamas',
    saving: 'Išsaugoma...',
    favorites: 'Mėgstamiausi',
    reorderFavorites: 'Keisti mėgstamiausio tvarką',
    reorderFavoritesHint: 'vilkite, kad pakeistumėte tvarką',
    greetingMorning: 'Labas rytas, {{name}}.',
    greetingAfternoon: 'Laba diena, {{name}}.',
    greetingEvening: 'Labas vakaras, {{name}}.',
    greetingMorningPlain: 'Labas rytas.',
    greetingAfternoonPlain: 'Laba diena.',
    greetingEveningPlain: 'Labas vakaras.',
    widgetNoPermission: 'Neturite leidimo šiam valdikliui',
  },
  liveTracking: {
    title: 'Tiesioginis stebėjimas',
    description: 'Peržiūrėkite transporto priemones realiuoju laiku žemėlapyje su organizacijos medžio vaizdu',
    search: 'Ieškoti transporto priemonių...',
    searchHits: 'Paieškos rezultatai',
    lists: 'Sąrašai',
    alarms: 'Signalizacijos',
    online: 'Prisijungę',
    offline: 'Neprisijungus',
    all: 'Visi',
    noVehicles: 'Nepasirinkta jokių transporto priemonių',
    loading: 'Įkeliama...',
    fitBounds: 'Pritaikyti žemėlapio vaizdą',
    status: 'Būsena',
    regNumber: 'Reg. ne.',
    name: 'Vardas',
    receivedTime: 'Gautas laikas',
    location: 'Vieta',
    speed: 'Greitis',
    direction: 'Kryptis',
    acc: 'ACC',
    selectAll: 'Pasirinkite viską',
    deselectAll: 'Panaikinkite visų pasirinkimą',
    live: 'Tiesiogiai',
    connecting: 'Jungiamasi…',
    liveDelayed: 'Tiesiogiai (vėluoja)',
    dataStaleWarning: 'Realaus laiko duomenys nebuvo atnaujinti {{minutes}} min. Žemėlapis gali laikinai būti netikslus (tinklas, įrenginys ar paslauga). Jei tai kartojasi, kreipkitės į palaikymą.',
    pollingFallback: 'Pozicijos atnaujinimai periodiškai apklausiami kaip atsarginis variantas, kai aktyvi „Live“.',
    saveAsStartView: 'Išsaugokite šį rodinį kaip pradžios rodinį',
    goToStartView: 'Eikite į išsaugotą pradžios rodinį',
    exitFullscreen: 'Išeikite per visą ekraną',
    fullscreen: 'Visas ekranas',
    driving: 'vairuojant',
    noDataOver1h: 'Nėra duomenų >1 val.',
    loadingMap: 'Įkeliamas žemėlapis...',
    noVehiclesSelected: 'Nepasirinkta jokių transporto priemonių',
    regNr: 'Reg. ne.',
    statusDriving: 'Vairavimas',
    statusStationary: 'Stovėjimas',
    statusLostWhileDriving: 'Važiavo, nėra ryšio >1 val.',
    statusNoContact: 'Nėra ryšio >6 val.',
    markerLegendDriving: 'Vairuoja',
    markerLegendStationary: 'Stovi',
    markerLegendLostWhileDriving: 'Važiavo, nėra ryšio >1 val.',
    markerLegendNoContact: 'Nėra ryšio >6 val.',
    lostWhileDrivingHint: 'Paskutinį kartą važiavo — nėra duomenų {{minutes}} min',
    lastSeenMinutesAgo: 'Paskutinį kartą matyta: prieš {{minutes}} min',
    ignitionOn: 'Įjungta',
    ignitionOff: 'Išjungta',
    mapNotReady: 'Žemėlapis neparengtas',
    restoredToSavedView: 'Atkurta į išsaugotą rodinį',
    statusStaleParked: 'Stovėjo, duomenų nėra >1val',
    markerLegendStaleParked: 'Stovėjo, duomenų nėra >1val',
    areaFilter: {
      title: 'Filtro sritis',
      open: 'Ploto filtras',
      active: '{{count}} transporto priemonių rajone',
      clear: 'Išvalyti srities filtras',
      help: 'Žemėlapyje nubrėžkite sritį (mažiausiai 3 taškai). Pasirinkite, ar norite matyti transporto priemones pagal vietą ar dabartinę padėtį.',
      modePlacement: 'Vieta rajone',
      modeCurrent: 'Dabar rajone',
      privateExcluded: 'Transporto priemonės, kurios suplanuotos būti privačios, nerodomos.',
      apply: 'Filtruoti',
      resultCount: '{{count}} transporto priemonė atitinka filtrą',
      error: 'Nepavyko filtruoti transporto priemonių rajone',
      placementMarker: 'Vieta',
      placementClusterCount: '{{count}} transporto priemonės toje pačioje vietoje',
      drawOnMapHint: 'Laikykite nuspaudę pelės mygtuką ir vilkite stačiakampį žemėlapyje.',
      placementModeActive: 'Rodo vietą (violetinės spalvos taškai)',
    },
  },
  crm: {
    title: 'CRM',
    crmModule: 'Klientų valdymas',
    economyModule: 'Ekonomika',
    customers: 'Klientai',
    customersDescription: 'Tvarkykite klientų korteles ir kontaktus',
    projects: 'Projektai',
    projectsDescription: 'Vykdomi ir planuojami projektai',
    procurements: 'Pirkimai',
    procurementsDescription: 'Viešųjų pirkimų procesai',
    pipeline: 'Pardavimo vamzdynas',
    pipelineDescription: 'Pardavimo piltuvas ir potencialūs klientai',
    economyOverview: 'Ekonominė apžvalga',
    economyOverviewDescription: 'Slenkantis 12, tendencijos ir pajamos',
    invoices: 'Sąskaitos faktūros pagrindas',
    invoicesDescription: 'Kurkite ir tvarkykite sąskaitas faktūras',
    pricelist: 'Kainoraštis',
    pricelistDescription: 'Paslaugos, medžiagos ir kainos',
    scbTesting: 'SCB API testavimas',
    scbTestingDescription: 'Išbandykite SCB API galinius taškus ir peržiūrėkite rezultatus',
    moduleCatalog: {
      versionFilter: 'Versija',
      allVersions: 'Visos versijos',
      title: 'Modulio katalogas',
      dashboardDescription: 'Visų modulių ir funkcijų apžvalga',
      searchPlaceholder: 'Paieškos modulis, paskirtis, funkcija...',
      sync: 'Sinchronizuoti',
      syncDone: 'Sinchronizuota: {{inserted}} naujas, {{updated}} atnaujintas',
      syncError: 'Sinchronizuoti nepavyko',
      addCustom: 'Pridėkite savo',
      editEntry: 'Redaguoti modulį',
      exportPdf: 'Eksportuoti PDF',
      exportError: 'Eksportuoti nepavyko',
      exportGenerated: 'Sugeneruota {{date}}',
      exportPageOf: 'Puslapis {{page}} iš {{pages}}',
      empty: 'Modulių nerasta.',
      customBadge: 'Savo',
      appBadge: 'Programėlė',
      confirmDelete: 'Ištrinti / išjungti šį įrašą?',
      systemKey: 'sistema (raktas)',
      systemName: 'Sistemos pavadinimas',
      name: 'Modulio pavadinimas',
      purpose: 'Tikslas',
      functions: 'Funkcijos',
      requirementsNotes: 'Reikalavimų pastabos (privalomi / privalomi reikalavimai)',
    },
    searchCustomerPlaceholder: 'Ieškoti kliento, organizacijos Nr., miesto...',
    listColOrgNumber: 'Org. nr.',
    listColPackage: 'Paketas',
    listExtraModules: 'Papildomi moduliai',
    listColUserCount: 'Naudotojai',
    listColContact: 'Kontaktinis asmuo',
    listColDevices: 'Įrenginiai',
    listColDevicesHint: 'Prijungti / sandėlyje',
    listColDevicesTitle: '{{linked}} prijungti, {{stock}} sandėlyje',
    listColBillingFrom: 'Sąskaitos nuo',
    allStatus: 'Visa būsena',
    totalLabel: 'Iš viso',
    contactsLabel: 'Kontaktai',
    notesLabel: 'Pastabos',
    statusAndType: 'Būsena ir tipas',
    signupDomains: 'Registracijos el. pašto domenas',
    signupDomainsHelp: 'Vienas domenas vienam klientui. Jei naudotojas registruojasi su el. paštu iš šio domeno, paskyra susiejama su kliento organizacija Viewer role.',
    signupDomainsEmpty: 'Domenas nenustatytas',
    signupDomainsListTitle: 'Išsaugotas registracijos domenas',
    signupDomainsAddedAt: 'Pridėta {{date}}',
    signupDomainsNoOrg: 'Klientui reikia susietos organizacijos (aktyvus klientas), kad būtų galima pridėti domenų.',
    signupDomainPlaceholder: 'pvz. imone.lt',
    signupDomainAdd: 'Pridėti',
    signupDomainSave: 'Išsaugoti domeną',
    signupDomainSaved: 'Domenas išsaugotas',
    signupDomainRemove: 'Pašalinti domeną',
    signupDomainsLoadError: 'Nepavyko įkelti domenų',
    signupDomainAdded: 'Domenas pridėtas',
    signupDomainAddError: 'Nepavyko pridėti domeno',
    signupDomainRemoved: 'Domenas pašalintas',
    signupDomainRemoveError: 'Nepavyko pašalinti domeno',
    newCustomer: 'Naujas klientas',
    createCustomer: 'Sukurti naują klientą',
    editCustomer: 'Redaguoti klientą',
    deleteCustomer: 'Ištrinti klientą',
    deleteCustomerConfirm: 'Ar tikrai norite ištrinti šį klientą?',
    removalTitle: 'Pašalinti klientą',
    removalIntro: 'Archyvavimas paslepia klientą ir palieka duomenis. Ištrynimas pašalina klientą. Įrenginiai ir jutikliai grąžinami į sandėlį.',
    archiveCustomer: 'Archyvuoti',
    archiveCustomerHint: 'Klientas paslepiamas. Transportas, naudotojai ir istorija lieka.',
    purgeCustomer: 'Ištrinti',
    purgeCustomerHint: 'Visi kliento duomenys pašalinami. GPS įrenginiai ir jutikliai grąžinami į sandėlį.',
    purgeConfirmLabel: 'Įrašykite kliento pavadinimą, kad ištrintumėte',
    purgeConfirmAction: 'Ištrinti klientą',
    customerArchived: 'Klientas suarchyvuotas',
    customerPurged: 'Klientas ištrintas',
    removalCancel: 'Atšaukti',
    contacts: 'Kontaktai',
    newContact: 'Naujas kontaktas',
    editContact: 'Redaguoti kontaktą',
    deleteContact: 'Ištrinti kontaktą',
    statusProspect: 'Prospektas',
    statusActive: 'Aktyvus',
    statusPaused: 'Pristabdyta',
    statusAtRisk: 'Rizikuojant',
    billingStartsOn: 'Sąskaitos nuo',
    billingStartsOnShort: 'Sąskaitos nuo',
    billingStartsOnHelp: 'Data, nuo kurios klientas turėtų būti faktūruojamas. Palikite tuščią, jei dar nenuspręsta.',
    billingStartsOnNotSet: 'Nenustatyta',
    typeMunicipality: 'savivaldybė',
    typeRegion: 'Regionas',
    typePrivate: 'Privatus',
    typePartner: 'Partneris',
    typeCarRental: 'Automobilių nuoma',
    carRental: 'Automobilių nuoma',
    federation: 'Federacija',
    federationDescription: 'Konfigūruokite kliento vienkartinį prisijungimą (SSO).',
    saml: 'SAML 2.0',
    oidc: '„OpenID Connect“.',
    samlConfig: 'SAML konfigūracija',
    oidcConfig: 'OIDC konfigūracija',
    entityId: 'Subjekto ID / emitentas',
    ssoUrl: 'SSO URL',
    sloUrl: 'SLO URL (vienas atsijungimas)',
    certificate: 'IdP sertifikatas',
    nameIdFormat: 'Vardo ID formatas',
    issuerUrl: 'Išdavėjo URL',
    clientId: 'Kliento ID',
    clientSecret: 'Kliento paslaptis',
    scopes: 'Taikymo sritis',
    provider: 'Teikėjas',
    activateSaml: 'Įgalinti SAML 2.0',
    activateOidc: 'Įgalinti „OpenID Connect“.',
    spMetadata: 'Paslaugų teikėjo metaduomenys',
    redirectUri: 'Peradresuoti URI',
    configuredButInactive: 'Sukonfigūruotas, bet neaktyvus',
    notConfigured: 'Nesukonfigūruotas',
    saveSaml: 'Išsaugoti SAML',
    updateSaml: 'Atnaujinkite SAML',
    saveOidc: 'Išsaugokite OIDC',
    updateOidc: 'Atnaujinkite OIDC',
    deleteSaml: 'Ištrinkite SAML',
    deleteOidc: 'Ištrinkite OIDC',
    samlCreated: 'Sukurta SAML konfigūracija',
    samlUpdated: 'SAML konfigūracija atnaujinta',
    samlDeleted: 'SAML konfigūracija ištrinta',
    oidcCreated: 'Sukurta OIDC konfigūracija',
    oidcUpdated: 'OIDC konfigūracija atnaujinta',
    oidcDeleted: 'OIDC konfigūracija ištrinta',
    customerMustBeActivated: 'Klientas turi būti suaktyvintas, kad galėtų konfigūruoti federaciją',
    municipality: 'savivaldybė',
    region: 'Regionas',
    privateCompany: 'Privati ​​įmonė',
    partner: 'Partneris',
    loadCustomerError: 'Nepavyko įkelti kliento',
    fetchCorporateStructureError: 'Nepavyko gauti įmonės struktūros',
    customerUpdated: 'Klientas atnaujintas',
    saveContactError: 'Nepavyko išsaugoti kontakto',
    ssoUrlAndCertRequired: 'Reikalingas SSO URL ir sertifikatas',
    saveSamlError: 'Nepavyko išsaugoti SAML konfigūracijos',
    samlConfigRemoved: 'SAML konfigūracija pašalinta',
    deleteSamlError: 'Nepavyko ištrinti SAML konfigūracijos',
    issuerAndClientIdRequired: 'Reikalingas išdavėjo URL ir kliento ID',
    saveOidcError: 'Nepavyko išsaugoti OIDC konfigūracijos',
    oidcConfigRemoved: 'OIDC konfigūracija pašalinta',
    deleteOidcError: 'Nepavyko ištrinti OIDC konfigūracijos',
    createApiKeyError: 'Nepavyko sukurti API rakto',
    deactivateApiKeyError: 'Nepavyko išjungti API rakto',
    updateEndpointAccessError: 'Nepavyko atnaujinti galinio taško prieigos',
    loadPricelistError: 'Nepavyko įkelti kainoraščio',
    saveProductError: 'Nepavyko išsaugoti produkto',
    duplicateProductCode: 'Produkto kodas jau egzistuoja – pasirinkite unikalų kodą',
    deleteProductError: 'Nepavyko ištrinti produkto',
    loadSystemConfigError: 'Nepavyko įkelti sistemos konfigūracijos',
    changeSystemStatusError: 'Nepavyko pakeisti sistemos būsenos',
    changeModuleStatusError: 'Nepavyko pakeisti modulio būsenos',
    loadCustomersError: 'Nepavyko įkelti klientų',
    tabs: {
      devices: 'Prietaisai',
      vehicleOrg: 'Organizacijos Nr. Transporto priemonės',
    },
    vehicleOrg: {
      title: 'Transporto priemonių valdymo organizacijos numeriai',
      orgNumber: 'Organizacijos numeris',
      companyName: 'Įmonės pavadinimas',
      companyNamePlaceholder: 'Neprivalomas įmonės pavadinimas',
      source: 'Šaltinis',
      sourceKoncern: 'Grupė',
      sourceManual: 'vadovas',
      fetchFromKoncern: 'Paimkite iš įmonės struktūros',
      addManual: 'Pridėti rankiniu būdu',
      empty: 'Nėra registruotų organizacijos numerių',
      emptyHint: 'Spustelėkite „Paimti iš įmonės struktūros“, kad užpildytumėte grupės bendroves',
      alreadyExists: 'Jau užregistruotas organizacijos numeris',
      totalCount: '{{count}} organizacijos numeriai užregistruoti',
    },
    customerDevices: {
      inVehicle: 'Transporto priemonėje',
      customerStock: 'Klientų atsargos',
      total: 'Iš viso įrenginių',
      searchPlaceholder: 'Ieškoti IMEI, reg.nr...',
      allStatuses: 'Visos būsenos',
      noDevices: 'Su šiuo klientu nesusietų įrenginių nėra',
      noMatch: 'Jokie įrenginiai neatitiko filtro',
      updated: 'Atnaujinta',
    },
    tabProducts: 'Produktai ir paslaugos',
    tabPackages: 'Sistemos paketas',
    categoriesTitle: 'Kategorijos',
    allProducts: 'Visi produktai',
    colCode: 'Kodas',
    colName: 'Vardas',
    colType: 'Tipas',
    colPricingModel: 'Kainodaros modelis',
    colPrice: 'Kaina',
    colUnit: 'Vienetas',
    newProduct: 'Naujas produktas',
    noProductsInCategory: 'Šioje kategorijoje prekių nėra',
    editProduct: 'Redaguoti produktą',
    productTypeService: 'Aptarnavimas',
    productTypeMaterial: 'Medžiaga',
    productTypeBundle: 'Paketas',
    pricingHourly: 'Per valandą',
    pricingMonthly: 'Per mėnesį',
    pricingPerVehicle: 'Vienai transporto priemonei',
    pricingPerUser: 'Vienam vartotojui',
    pricingOneTime: 'Vienkartiniai',
    pricingCustom: 'Pritaikyta',
    labelCode: 'Kodas',
    labelCategory: 'Kategorija',
    labelName: 'Vardas *',
    labelDescription: 'Aprašymas',
    labelProductType: 'Produkto tipas',
    labelPricingModel: 'Kainodaros modelis',
    labelPrice: 'Kaina (SEK)',
    labelUnit: 'Vienetas',
    noCategory: 'Nėra kategorijos',
    unitPlaceholder: 'kompiuteris, valanda, mėnuo...',
    productCreated: 'Sukurtas produktas',
    productUpdated: 'Produktas atnaujintas',
    productDeleted: 'Produktas pašalintas',
    confirmDeleteProduct: 'Pašalinti produktą?',
    customerNotFound: 'Klientas nerastas',
    backToCustomerList: '← Atgal į klientų sąrašą',
    activateCustomer: 'Suaktyvinti klientą',
    activating: 'Įgalinama...',
    edit: 'Redaguoti',
    save: 'Išsaugoti',
    cancel: 'Atšaukti',
    tabInfo: 'Kliento informacija',
    tabServices: 'Paslaugos',
    tabStatistics: 'Statistika',
    tabFederation: 'Federacija',
    companyInfoTitle: 'Įmonės informacija',
    contactsTitle: 'Kontaktiniai asmenys',
    addContact: 'Pridėti',
    noContacts: 'Nėra kontaktinių asmenų',
    primaryBadge: 'Pirminis',
    noNotes: 'Jokių užrašų',
    labelStatus: 'Būsena',
    labelCustomerType: 'Kliento tipas',
    companyRegister: 'Įmonės registras',
    loadingCheckbiz: 'Įkeliami duomenys iš „Checkbiz“...',
    noCheckbizData: 'Nerasta duomenų apie organizacijos numerį {{orgNumber}}',
    checkbizApiNote: '(Checkbiz API gali būti nesukonfigūruota arba organizacijos numerio nėra registre)',
    vehiclesInGroup: 'Transporto priemonės grupėje (iš viso {{total}})',
    companyGroupTitle: 'Grupės struktūra ({{count}} įmonė)',
    fetchAndSave: 'Atsisiųskite ir išsaugokite',
    orgNumber: 'Org. ne',
    ownerShare: 'Nuosavybės dalis',
    labelOrgNumber: 'Organizacijos numeris',
    labelAddress: 'Adresas',
    labelPostalCode: 'Pašto kodas',
    labelCity: 'Vieta',
    labelWebsite: 'Svetainė',
    partnerSupportTitle: 'Palaikymo kontaktas programoje',
    partnerSupportHint: 'Šio kliento naudotojams rodomas pokalbių burbule. Ne Deque el. paštas. Tušti laukai paveldimi iš pirminio partnerio.',
    partnerSupportShow: 'Programėlėje parodykite partnerio el. paštą ir telefoną',
    partnerSupportEmail: 'Partnerio palaikymo el. paštas',
    partnerSupportPhone: 'Partnerio palaikymo telefonas',
    labelSniCode: 'SNI kodas',
    labelSizeClass: 'Dydžio klasė',
    wizard: {
      basicInfo: 'Pagrindinė informacija',
      addressContact: 'Adresas ir kontaktai',
      contactPerson: 'Kontaktinis asmuo',
      pricing: 'Kainodara',
      summary: 'Santrauka',
      companyName: 'Įmonės pavadinimas *',
      orgNumber: 'Organizacijos numeris',
      customerType: 'Kliento tipas*',
      statusLabel: 'Būsena*',
      statusProspect: 'Prospektas',
      statusProspectNote: '(organizacija nesukurta)',
      statusActive: 'Aktyvus',
      statusActiveNote: '(kuria organizaciją)',
      address: 'Adresas',
      postalCode: 'Pašto kodas',
      city: 'Vieta',
      website: 'Svetainė',
      firstName: 'Vardas',
      lastName: 'Pavardė',
      email: 'paštas',
      emailRequired: 'Kontaktiniam asmeniui privalomas el',
      phone: 'Telefonas',
      mobile: 'Mobilusis',
      role: 'Vaidmuo',
      sendWelcomeEmail: 'Išsiųskite sveikinimo laišką ir susikurkite vartotojo paskyrą',
      sendWelcomeEmailDesc: 'Kontaktinis asmuo gauna el. laišką su nuoroda, leidžiančia suaktyvinti savo paskyrą kaip administratorių DQFleet.',
      pricingModel: 'Kainodaros modelis',
      monthlyFee: 'Mėnesinis mokestis (SEK)',
      pricePerVehicle: 'Kaina už transporto priemonę (SEK/mėn.)',
      pricePerUser: 'Kaina vienam vartotojui (SEK/mėn.)',
      perVehicle: 'Vienai transporto priemonei',
      customPricing: 'Pritaikyta',
      notes: 'Pastabos',
      noOrgNumber: 'Nėra org. ne',
      statusActiveLabel: '✓ Aktyvus (organizacija sukurta)',
      pricingLabel: 'Kainodaros modelis',
      back: 'Atgal',
      next: 'Kitas',
      creating: 'Kuriama...',
      createCustomer: 'Sukurti klientą',
      municipality: 'savivaldybė',
      region: 'Regionas',
      partner: 'Partneris',
      carRental: 'Automobilių nuomos įmonė',
      roleDecisionMaker: 'Sprendimų priėmėjas',
      roleTechnical: 'Techninis kontaktas',
      roleBilling: 'Sąskaita faktūra',
      roleOther: 'Kita',
    },
  },
  fleet: {
    title: 'Automobilių parkas',
    overview: 'Automobilių parkas',
    overviewDescription: 'Peržiūrėkite ir tvarkykite visas transporto priemones',
    liveTrackingDescription: 'Pamatykite transporto priemones žemėlapyje realiuoju laiku',
    vehicle: 'Transporto priemonė',
    status: 'Būsena',
    position: 'Padėtis',
    speed: 'Greitis',
    noVehicles: 'Transporto priemonių nerasta',
    tryAllOrganizations: 'Pabandykite filtre pasirinkti „Visos organizacijos“.',
    loading: 'Įkeliamos transporto priemonės...',
    error: 'Nepavyko pakrauti transporto priemonių',
    searchPlaceholder: 'Ieškoti visuose laukuose (reg.nr., IMEI, markė, modelis, organizacija, kuro rūšis, įranga, nuosava, lizingas...)',
    searchPlaceholderShort: 'Ieškoti reg.nr., IMEI, markės, modelio, nuorodos, įrangos, nuosava ar lizingas …',
    ownershipColumn: 'Nuosava / lizingas / lizingas baigtas',
    ownershipOwned: 'Nuosava',
    ownershipLeased: 'Lizingas',
    ownershipLeaseEnded: 'Lizingas baigtas',
    showing: 'Rodoma',
    of: 'iš',
    vehicles: 'transporto priemonių',
    page: 'Puslapis',
    first: 'Pirma',
    last: 'Paskutinis',
    lastSeen: 'Paskutinį kartą matytas',
    referenceNumber: 'Nuoroda',
    referenceChooseOrType: 'Pasirinkite arba įrašykite',
    organization: 'Organizacija',
    connected: 'Prisijungta',
    filterAll: 'Visi',
    filterConnected: 'Prisijungta',
    filterDisconnected: 'Atjungtas',
    filterTaxDue: 'Mokestis per 45 dienas',
    filterInspectionDue: 'Apžiūra per 40 dienų',
    filterAllOrganizations: 'Visos organizacijos',
    exportVehicleRegister: 'Transporto priemonių sąrašas',
    exportVehicleRegisterExcel: 'Excel',
    exportVehicleRegisterCsv: 'CSV',
    exportVehicleRegisterSuccess: 'Atsisiuntimas pradėtas',
    exportVehicleRegisterError: 'Nepavyko eksportuoti sąrašo',
    statusActive: 'Aktyvus',
    statusMaintenance: 'Priežiūra',
    statusInactive: 'Neaktyvus',
    statusRetired: 'Išėjęs į pensiją',
    functions: 'Funkcijos',
    deactivate: 'Išjungti transporto priemonę',
    activateVehicle: 'Aktyvinti transporto priemonę iš naujo',
    confirmActivate: 'Aktyvinti iš naujo transporto priemonę {{reg}}?\n\nBūsena bus nustatyta kaip aktyvi. Jei GPS įrenginys vis dar prijungtas, įrenginio istorijoje bus atidarytas naujas montavimo intervalas, kad duomenys vėl būtų priskirti transporto priemonei.',
    activatedSuccess: 'buvo aktyvuota iš naujo',
    connectDevice: 'Prijunkite įrenginį',
    connectKey: 'Prijunkite raktą',
    connectKeyModal: {
      editTooltip: 'Keisti rakto susiejimą',
      title: 'Susieti raktą su {{reg}}',
      editTitle: 'Keisti rakto susiejimą: {{reg}}',
      pickupLocation: 'Atsiėmimo vieta',
      selectPickupLocation: 'Pasirinkite atsiėmimo vietą',
      noPickupLocations: 'Nėra atsiėmimo vietų.',
      noCabinets: 'Prie šios atsiėmimo vietos neprijungta spintelių.',
      selectKey: 'Pasirinkite laisvą žalią raktą.',
      selectedKey: 'Pasirinktas raktas: {{name}}',
      saved: 'Raktas susietas su {{reg}}',
      loadError: 'Nepavyko gauti raktų duomenų',
      saveError: 'Nepavyko išsaugoti susiejimo',
    },
    subscribe: 'Prenumeruokite ataskaitas',
    milError: 'Variklio gedimas - dega lemputė',
    milNoData: 'Duomenų nėra',
    milOk: 'Jokių gedimų',
    fuelLevel: 'degalai (%)',
    fuelEvTooltip: 'Kuro % (EV akumuliatoriaus %)',
    evRange: 'Diapazonas',
    serviceDistance: 'Km iki serviso',
    installedTires: 'Sumontuotos padangos',
    make: 'Padaryti',
    model: 'Modelis',
    year: 'Metai',
    fuelType: 'Kuro tipas',
    sitplatser: 'Sėdynės',
    costCenter: 'Išlaidų centras',
    initialOdometer: 'Pradinis odometras (km)',
    initialOdometerHint: 'Odometro rodmenys registruojantis',
    isPoolcar: 'Baseino transporto priemonė',
    sharedCompanyCar: 'Bendra įmonės transporto priemonė',
    sharedCompanyCarHint: 'Keliese gali vairuoti. Programėlė girdi GPS įrenginį ir parodo, kas važiavo.',
    registrationNumber: 'Registracijos numeris',
    fuelTypes: {
      petrol: 'Benzinas',
      diesel: 'Dyzelinas',
      electric: 'Elektrinis',
      hybrid: 'Hibridinis',
      pluginHybrid: 'Prijungiamasis hibridas',
      gas: 'Dujos',
      ethanol: 'Etanolis',
    },
    addVehicle: {
      button: 'Nauja Transporto priemonė',
      title: 'Užregistruokite naują transporto priemonę',
      fetchCarInfo: 'Gaukite iš Car.info',
      fetched: 'Gauta',
      enterRegNumber: 'Pirmiausia įveskite registracijos numerį',
      carInfoSuccess: 'Transporto priemonės duomenys gauti iš Car.info',
      carInfoNotFound: 'Automobilis nerastas Car.info',
      carInfoLoaded: 'Transporto priemonės duomenys įkelti iš Car.info',
      stolenWarning: 'ĮSPĖJIMAS: Pranešama, kad ši transporto priemonė pavogta!',
      drivingBanWarning: 'ĮSPĖJIMAS: Šiai transporto priemonei taikomas vairavimo draudimas!',
      regRequired: 'Reikalingas registracijos numeris',
      orgRequired: 'Pasirinkite organizaciją',
      selectOrg: 'Pasirinkite organizaciją',
      success: 'Transporto priemonė registruota!',
      error: 'Nepavyko sukurti transporto priemon?s',
      save: 'I?saugoti transporto priemon?',
    },
    backToDeque: 'Grįžti į Deque',
    filterBarLabel: 'Filtruoti',
    columnFilterToggle: 'Kolonėlės filtras',
    columnFilterToggleHint: 'Norėdami filtruoti sąrašą, rodyti / slėpti paieškos laukelį kiekviename stulpelyje',
    placementCity: 'Vieta',
    systemStatus: 'Sistemos būsena',
    filterPreset: 'Filtruoti',
    filterPresetAll: 'Visi',
    filterPoolcars: 'Visi baseino automobiliai',
    filterMil: 'Patikrinkite variklio lemputę (MIL)',
    filterUsageStatus: 'Būsena',
    exportCarInfoVehicleReportExcel: 'Transporto priemonės ataskaita Excel',
    exportCarInfoVehicleReportSuccess: 'Transporto priemonės ataskaita atsisiųsta',
    exportCarInfoVehicleReportError: 'Nepavyko eksportuoti transporto priemonės ataskaitos',
    exportFleetReport: 'Transporto priemonės ataskaita',
    exportFleetReportExcel: 'Excel',
    exportFleetReportCsv: 'CSV',
    exportFleetReportSuccess: 'Transporto priemonės ataskaita atsisiųsta',
    exportFleetReportError: 'Nepavyko eksportuoti transporto priemonės ataskaitos',
    imeiColumn: 'IMEI',
    imeiFirmware: 'Firmware',
    imeiConfig: 'Konfigūracija',
    imeiUnknown: 'nežinomas',
    currentOdometer: 'Dabartinis skaitiklio rodmuo',
    flinkeyBoxColumn: 'prašmatni dėžutė',
    transmissionColumn: 'Pavarų dėžė',
    pickupPlacementColumn: 'Pristatymo vieta',
    businessResponsibilityColumn: 'Verslo atsakomybė',
    assignedUserColumn: 'Prisijungęs vartotojas',
    vehicleCategoryColumn: 'Transporto priemonės kategorija',
    alternativeFuelColumn: 'Alternatyvus kuras',
    vehicleStatusColumn: 'Būsena',
    noUsageStatus: 'Nėra statuso',
    columnSettings: {
      button: 'Stulpeliai',
      title: 'Lentelės stulpeliai',
      description: 'Pasirinkite, kuriuos stulpelius rodyti ir kokia tvarka. Norėdami pakeisti tvarką, vilkite matomas eilutes. Nustatymas išsaugomas jūsų vartotojo paskyroje.',
      fixedHint: 'Stulpelis Transporto priemonės visada rodomas pirmas, o funkcijos visada paskutinis.',
      searchPlaceholder: 'Paieškos stulpelis...',
      noResults: 'Nėra paieškos atitinkančių stulpelių',
      visibleColumns: 'Matomi stulpeliai',
      hiddenColumns: 'Paslėpti stulpeliai',
      dragHint: 'Norėdami pertvarkyti, vilkite',
      reset: 'Atkurti numatytuosius nustatymus',
      saveSuccess: 'Stulpelio nustatymai išsaugoti',
      saveError: 'Nepavyko išsaugoti stulpelio nustatymų',
      resetSuccess: 'Stulpeliai atstatyti į numatytuosius nustatymus',
    },
  },
  flinkey: {
    sectionTitle: 'flinkey (skaitmeninis raktas)',
    attach: 'Prijungti flinkey',
    detach: 'Pa?alinti ry??',
    assignKey: 'Priskirti rakt?',
    boxIdPlaceholder: 'flinkey d??ut?s ID',
    assignModalTitle: 'Priskirti skaitmenin? rakt?',
    assignUser: 'Vartotojas (ID)',
    validFrom: 'Galioja nuo (neb?tina)',
    validUntil: 'Galioja iki (neb?tina)',
    assign: 'Priskirti',
    selectBox: '— Select box —',
    noBoxesForOrg: 'No Flinkey boxes registered for the organization',
    listLoadError: 'Could not load Flinkey boxes. Check network or permissions.',
    noBoxLinked: 'Nėra susietos Flinkey dėžutės su šia TP',
    chooseBox: 'Pasirinkti dėžutę',
    changeBox: 'Keisti dėžutę',
    orgBoxCount: 'Organizacijoje (įskaitant viršesnes): {{count}} dėžutė(-ės)',
    searchBoxesPlaceholder: 'Ieškoti pagal produkto ID, serijos nr. ar valst. Nr.',
    searchNoHits: 'Nerasta',
    boxOnOtherVehicle: 'Susieta su TP {{reg}} — pasirinkite perkėlimui čia',
    boxUnassigned: 'Laisva dėžutė',
    currentBoxBadge: 'Ši TP',
    notLicensedForOrg: 'Organizacijoje nėra registruotų Flinkey langelių',
  },
  carInfoFilter: {
    title: 'Filtruoti',
    addFilter: 'Prid?ti filtr?',
    noFilters: 'Nepasirinkta joki? filtr?',
    noFiltersAdded: 'Filtr? neprid?ta',
    addFilterHint: 'Norėdami pradėti, spustelėkite „Pridėti filtrą“.',
    enterValue: 'Įveskite vertę...',
    search: 'Ieškoti',
    clear: 'Aišku',
    loadError: 'Nepavyko įkelti filtrų',
    searchError: 'Paieška nepavyko',
    vehiclesFound: 'rastos transporto priemonės',
    filterButton: 'Car.info filtras',
    searchFields: 'Paieškos laukai...',
    searching: 'Ieškoma...',
    searchButton: 'Ieškoti',
    cancel: 'Atšaukti',
    noFiltersConfigured: 'Jokių filtrų nesukonfigūruota',
    enableFiltersHint: 'Įjunkite filtrus SysAdmin → Car.info Filter',
    selectFilterValue: 'Pasirinkite bent vieną filtro vertę',
    vehiclesFoundCount: 'Rasta transporto priemonių: {count}',
    resultIdsMissing: 'Paieška rado transporto priemones, bet jų nepavyko parodyti sąraše',
    searchFailed: 'Paieška nepavyko',
    allOption: '-- Visi --',
    otherCategory: 'Kita',
    loadingValues: 'Kraunamos reikšmės...',
  },
  sms: {
    title: 'Siųsti SMS komandą',
    message: 'Pranešimas',
    send: 'Siųsti',
    sending: 'Siunčiama...',
    sent: 'SMS išsiųsta!',
    sentSuccess: 'SMS išsiųsta!',
    sentDescription: 'Pranešimas išsiųstas į įrenginį.',
    hint: 'Komanda prasideda dviem tarpais autentifikavimui',
    noImei: 'Transporto priemonėje nėra prijungto įrenginio (trūksta IMEI)',
    emptyMessage: 'Pranešimo laukas negali būti tuščias',
    messageId: 'Pranešimo ID',
    status: 'Būsena',
    statusDelivered: 'Pristatyta',
    statusSent: 'Išsiųsta',
    statusPending: 'Laukiama',
    statusFailed: 'Nepavyko',
    statusCancelled: 'Atšaukta',
  },
  unbookedTrips: {
    title: 'Kelionės be užsakymo',
    from: 'Nuo',
    to: 'Iki',
    organization: 'Organizacija',
    all: 'Visos',
    show: 'Rodyti',
    empty: 'Šiuo laikotarpiu kelionių be užsakymo nėra.',
    vehicle: 'Transportas',
    start: 'Pradžia',
    end: 'Pabaiga',
    distance: 'Km',
    driver: 'Vairuotojas',
    purpose: 'Tikslas',
    extraPersons: 'Kiti asmenys',
    create: 'Sukurti užsakymą',
    print: 'Kelionės žurnalas',
    selectTrips: 'Pasirinkite bent vieną kelionę',
    sameVehicle: 'Kelionės turi būti ta pačia transporto priemone',
    created: 'Užsakymas išsaugotas',
    attached: 'Kelionės prijungtos prie esamo užsakymo',
    openCount: 'be užsakymo',
  },
  reports: {
    title: 'Ataskaitos',
    comingSoon: 'Pranešimai netrukus...',
    energyConsumption: {
      title: 'Energijos suvartojimas',
      description: 'Išanalizuoti degalų sąnaudas pagal organizaciją ir transporto priemonę',
    },
    speedCompliance: {
      title: 'Greičio laikymasis',
      description: 'Analizuoti, kaip transporto priemonė laikosi greičio apribojimų',
    },
    vehicleWear: {
      title: 'Transporto priemonių susidėvėjimas',
      description: 'Išanalizuokite, kaip vairavimo elgsena veikia transporto priemonės nusidėvėjimą',
    },
    underutilized: {
      title: 'Nepakankamai eksploatuojamos transporto priemonės',
      description: 'Identifikuokite mažo naudojimo transporto priemones',
    },
    co2: {
      title: 'CO₂ emisija',
      description: 'Apskaičiuokite ir analizuokite CO₂ emisiją',
    },
    geofenceZone: {
      title: 'Geotvoros zonos ataskaita',
      description: 'Išanalizuokite, kaip dažnai transporto priemonės yra zonose',
    },
    vehicleKpi: {
      title: 'Transporto priemonės KPI',
      description: 'Pagrindinių metrikų pagal transporto priemonę, mėnesį ir metus suvestinė',
      tabs: {
        overview: 'Organizacijos apžvalga',
        vehicleYear: 'Metų ataskaita / transporto priemonė',
        vehicleMonth: 'Transporto priemonė / mėnuo',
      },
      filters: {
        organization: 'Organizacija',
        year: 'Metai',
        vehicle: 'Transporto priemonė',
        month: 'Mėnuo',
      },
      summary: {
        totalVehicles: 'Iš viso transporto priemonių',
        totalDistance: 'Bendras atstumas',
        totalFuel: 'Bendras kuras',
        avgFuelPer100km: 'Vid. L/100km',
        totalCo2: 'Bendras CO₂',
        totalDuration: 'Bendras vairavimo laikas',
        totalIdling: 'Bendras tuščiosios eigos laikas',
        daysDriven: 'Vairuotos dienos',
        avgElectricShare: 'Vidutinė elektros energijos dalis',
      },
      columns: {
        registrationNumber: 'Reg. Nr.',
        organization: 'Grupė',
        make: 'Padaryti',
        model: 'Modelis',
        period: 'Laikotarpis',
        date: 'Data',
        month: 'Mėnuo',
        distanceKm: 'Atstumas (km)',
        fuelL: 'Degalai (L)',
        fuelPer100km: 'Vid. (l/100 km)',
        co2Kg: 'CO₂ (kg)',
        daysDriven: 'Vairuotos dienos',
        kmPerDay: 'Km/dieną',
        duration: 'Vairavimo laikas',
        avgSpeed: 'Vidutinis greitis',
        idling: 'Tuščiosios eigos laikas',
        status: 'Būsena',
        fuelType: 'Kuro tipas',
        trend: 'Tendencija',
        electricSharePct: 'Elektros energijos dalis',
      },
      status: {
        active: 'Aktyvus',
        inactive: 'Neaktyvus',
        sold: 'Parduota',
      },
      breadcrumb: {
        overview: 'Apžvalga',
        backToOverview: 'Grįžti į apžvalgą',
        backToYear: 'Atgal į metų ataskaitą',
      },
      export: 'Eksportuoti CSV',
      noData: 'Nerasta jokių pasirinkto laikotarpio duomenų',
      selectOrganization: 'Norėdami peržiūrėti transporto priemones, pasirinkite organizaciją',
      selectVehicleForYear: 'Metinė transporto priemonės suvestinė. Spustelėkite transporto priemonę, kad galėtumėte paskirstyti kas mėnesį.',
      selectVehicleForMonth: 'Sąraše pasirinkite transporto priemonę, kad pamatytumėte pasirinkto mėnesio dienos paskirstymą.',
    },
    dtc: {
      title: 'DTC gedimo ataskaita',
      description: 'Peržiūrėkite ir analizuokite kiekvienos transporto priemonės diagnostikos gedimų kodus (DTC).',
      activeDtc: 'Aktyvūs DTC',
      vehiclesWithDtc: 'Transporto priemonės su DTC',
      highSeverity: 'Aukštas / kritinis',
      lowSeverity: 'Žemas/Vidutinis',
      byCategory: 'Pagal kategoriją',
      bySeverity: 'Pagal sunkumą',
      topCodes: 'Dažniausiai pasitaikantys gedimų kodai',
      code: 'DTC kodas',
      category: 'Kategorija',
      severity: 'Sunkumas',
      firstSeen: 'Pirmą kartą pamatytas',
      lastSeen: 'Paskutinį kartą matytas',
      resolvedAt: 'Išspręsta',
      active: 'Aktyvus',
      resolved: 'Išspręsta',
      codeSearch: 'DTC paieška',
      searchTitle: 'Ieškokite DTC kodo',
      whatDoesItMean: 'Ką tai reiškia?',
      symptoms: 'Simptomai',
      causes: 'Galimos priežastys',
      repairSteps: 'Diagnostika ir remontas',
      notAvailable: 'Informacijos nėra',
      notAvailableDetailed: '„DQFleet“ neturi šios informacijos. Kodas yra duomenų bazėje, tačiau jam trūksta aprašymo.',
      noDetailedInfo: 'Nėra išsamios informacijos apie šį gedimo kodą.',
    },
    workTrips: {
      title: 'Darbo kelionės',
      description: 'Kelionės bendrais įmonės automobiliais, su vairuotoju ir ar programėlė ką nors identifikavo',
      filtersTitle: 'Transporto priemonė ir laikotarpis',
      vehicleLabel: 'Transporto priemonė',
      allVehicles: 'Visi bendri automobiliai',
      fromDate: 'Nuo',
      toDate: 'Iki',
      identificationLabel: 'Identifikavimas',
      identificationAll: 'Visos kelionės',
      identificationIdentified: 'Identifikuota per programėlę',
      identificationUnidentified: 'Be identifikavimo',
      fetch: 'Gauti keliones',
      fetchError: 'Nepavyko gauti darbo kelionių',
      tripCount: 'Kelionės',
      identifiedCount: 'Identifikuota per programėlę',
      unidentifiedCount: 'Be identifikavimo',
      totalDistance: 'Atstumas',
      colVehicle: 'Transporto priemonė',
      colDate: 'Data',
      colTime: 'Laikas',
      colFrom: 'Iš',
      colTo: 'Į',
      colDistance: 'Atstumas',
      colDuration: 'Trukmė',
      colDriver: 'Vairuotojas',
      colIdentification: 'Identifikavimas',
      colPresent: 'Automobilyje',
      colPurpose: 'Tikslas',
      presenceDriver: 'Identifikuota',
      presenceNotChosen: 'Identifikuota, vairuotojas nepasirinktas',
      presenceSingleScan: 'Identifikuota (vienas skenavimas)',
      presenceUnknown: 'Be identifikavimo',
      presenceNone: 'Be identifikavimo',
      noDriver: 'Nežinomas vairuotojas',
      empty: 'Šiuo laikotarpiu kelionių nėra',
      exportSuccess: 'CSV eksportuotas',
    },
    drivingLog: {
      title: 'Vairavimo žurnalas',
      description: 'Vairavimo žurnalas pagal Švedijos mokesčių tarnybos rekomendacijas',
      selectVehicle: 'Pasirinkite transporto priemonę',
      fetchError: 'Nepavyko gauti vairavimo įrašo',
      purposeUpdateError: 'Nepavyko atnaujinti tikslo',
      noteUpdateError: 'Nepavyko išsaugoti užrašo',
      noDataToSubmit: 'Vairavimo įrašo pateikti nėra',
      submitConfirm: 'Ar norite išsiųsti pasirinkto laikotarpio vairavimo įrašą organizacijos persiuntimo adresu? Po pateikimo redagavimas užrakinamas.',
      submitSuccess: 'Vairavimo įrašas pateiktas ir užrakintas.',
      submitError: 'Nepavyko pateikti vairavimo įrašo',
      noExportData: 'Nėra eksportuojamų duomenų',
      csvColType: 'Tipas (privatus / paslauga)',
      csvColPurposeShort: 'Paskirtis (T/P)',
      csvColNote: 'Pastaba',
      business: 'Aptarnavimas',
      private: 'Privatus',
      undefined: 'Neapibrėžta',
      totalDistanceLabel: 'Visas nuvažiuotas atstumas (km)',
      privateDistanceLabel: 'Važiuota privačiai (km)',
      businessDistanceLabel: 'Nuvažiuota servise (km)',
      undefinedDistanceLabel: 'Nuvažiuota neapibrėžta (km)',
      undefinedDistanceShort: 'Paleisti neapibrėžtą',
      csvSummaryHeading: 'SUMMA',
      tripCountLabel: 'Bėjimų skaičius',
      periodLabel: 'Laikotarpis',
      exportSuccess: 'CSV eksportuota',
      filtersTitle: 'Pasirinkite transporto priemonę ir laikotarpį',
      vehicleLabel: 'Transporto priemonės',
      fromDate: 'Nuo datos',
      toDate: 'Iki šiol',
      fetch: 'Atsisiųsti vairavimo įrašą',
      print: 'Spausdinti',
      submit: 'Atsiųsk',
      submitting: 'Siunčiama...',
      periodLockedHint: 'Šis laikotarpis buvo pateiktas ir negali būti redaguojamas.',
      tripCountShort: 'Bėjimų skaičius',
      totalDistanceShort: 'Visas nuvažiuotas atstumas',
      privateDistanceShort: 'Važiavo privačiai',
      businessDistanceShort: 'Nuvežtas į tarnybą',
      colDate: 'Data',
      colTime: 'Laikas',
      colFrom: 'Iš',
      colTo: 'Į',
      colOdoStart: 'Skaitiklio paleidimas',
      colOdoEnd: 'Matuoklis',
      colDistance: 'Ištempti',
      colDuration: 'Kelionės laikas',
      colToll: 'Muitinė (SEK)',
      tollSummaryTitle: 'Pareigos (laikotarpis)',
      csvTollBusinessLabel: 'Muitinės paslauga (iš viso SEK)',
      csvTollPrivateLabel: 'Privati ​​muitinė (iš viso SEK)',
      csvTollUndefinedLabel: 'Muitas neapibrėžtas (iš viso SEK)',
      tollFollowsTripPurposeHint: 'Muito mokestis yra susietas su kelione. Kelionei rinkitės paslaugą ar privačią – tas pats tikslas taikomas atstumui ir rinkliavoms.',
      colTripType: 'Paslauga/privatus',
      colPurpose: 'Tikslas',
      colNote: 'Tikslas/pastaba',
      adjustmentPurposeDisabledTitle: 'Skaitiklio reguliavimas – paskirtis (paslauginis/privatus) šiai eilutei netaikomas',
      correctionPurposeLabel: 'Pataisymas',
      adjustmentDistanceShort: 'Skaitiklio reguliavimas',
      adjustmentDistanceLabel: 'Manometro reguliavimas (koregavimas, ne vairavimas)',
      togglePrivateTitle: 'Perjungti į paslaugą',
      toggleBusinessTitle: 'Perjungti į privatų',
      toggleUnsetTitle: 'Įveskite privačią arba paslaugą',
      notePlaceholder: 'Aprašykite kelionės tikslą…',
      footerSum: 'Bendras atstumas',
      emptyTitle: 'Jokių kelionių per laikotarpį',
      emptyBody: 'Pasirinkite transporto priemonę ir laikotarpį ir spustelėkite Atsisiųsti vairavimo įrašą.',
      infoTitle: 'Patarimai dėl dokumentų',
      infoLine1: 'Pažymėkite kiekvienos vairavimo kelionės paskirtį (skirstymo skydelį) – stulpelis Paslauga/Privatus seka ir išsaugomas. Visas nuvažiuotas atstumas = privatus + paslauga + neapibrėžta (tik faktinis važiavimas; skaitiklio reguliavimas nurodomas atskirai, žr. paskutinį punktą).',
      infoLine2: 'Jei reikia, pastabų laukelyje įveskite tikslą.',
      infoLine3: 'Eksportuoti arba spausdinti dokumentus apskaitai.',
      infoLine4: 'Pateikti siunčia viršutinio mazgo persiuntimo adresu ir užrakina laikotarpį.',
      infoLine5: 'Adresai rodomi, kai jie yra sistemoje.',
      infoLine6: '„Bendras nuvažiuotas atstumas“, taip pat privatus / paslauga / neapibrėžtas, apibendrina tik faktinį vairavimą. Skaitiklio reguliavimas (pataisymas) rodomas atskirai ir neįtraukiamas į šias sumas.',
    },
    odometerReport: {
      title: 'Odometro ataskaita',
      description: 'Peržiūrėkite transporto priemonės odometro rodmenis tam tikrą dieną',
      organizationGroup: 'Organizacija / grupė',
    },
    rentalReport: {
      title: 'Nuomos ataskaita',
      description: 'Pilna nuomos ataskaita su kelionėmis, išlaidomis ir būsena',
      tabs: {
        overview: 'Apžvalga',
        trips: 'Kelionės',
        geofences: 'Geotvoros',
        warnings: 'Įspėjimai',
        environment: 'Aplinka',
        status: 'Būsena',
      },
      vehicle: 'Transporto priemonė',
      period: 'Laikotarpis',
      startDate: 'Pradžios data',
      endDate: 'Pabaigos data',
      fetchReport: 'Gauti ataskaitą',
      downloadPdf: 'Atsisiųskite PDF',
      sendEmail: 'Siųsti elektroniniu paštu',
      totalDistance: 'Bendras atstumas',
      totalTrips: 'Iš viso kelionių',
      totalWarnings: 'Bendri įspėjimai',
      geofenceCosts: 'Geotvoros išlaidos',
      fuelStatus: 'Kuro būsena',
      tankFull: 'Bakas pilnas',
      tankMissing: 'Trūksta maždaug',
      milAlarm: 'MIL signalizacija',
      noMilAlarms: 'Šiuo laikotarpiu MIL signalų nėra',
      milActive: 'MIL signalas aktyvus',
      co2Emissions: 'CO₂ emisija',
      fuelConsumption: 'Kuro sąnaudos',
      fuel: 'Kuras',
      fuelKinds: 'Kuro rūšys',
      consumption: 'Sąnaudos',
      perKm: '100 km',
      electricShare: 'Elektros dalis',
      electricUsed: 'Elektros sąnaudos',
      electricPerKm: 'Elektra 100 km',
      emailSent: 'Pranešimas išsiųstas!',
      recipientEmail: 'El. pašto adresas',
      recipientName: 'Gavėjo vardas',
      message: 'Pranešimas',
    },
    decodeBinError: 'Nepavyko iššifruoti šiukšliadėžės failo',
    bookingStats: {
      title: 'Užsakymų statistika',
      description: 'Apimtis, užimtumas, užklausų srautas, laiko sąmata, aktyvinimas į Flinkey ir užsakymų tendencija.',
      from: 'Iš',
      to: 'Į',
      granularity: 'Laiko raiška',
      granularityDay: 'Diena',
      granularityWeek: 'Savaitė',
      granularityMonth: 'Mėnuo',
      basis: 'Dangos pagrindas',
      basisCalendar: 'Kalendorinė diena',
      basisWorkdays: 'Darbo dienos',
      pickupLocation: 'Pristatymo vieta',
      allPickupLocations: 'Visos vietos',
      allOrganizations: 'Visos organizacijos',
      refresh: 'Atnaujinti',
      loadError: 'Nepavyko gauti užsakymo statistikos.',
      noData: 'Duomenų už laikotarpį nėra.',
      totalBookings: 'Bendras užsakymų skaičius',
      requestFlow: 'Prašymas / paskirta',
      requestSharePct: 'Bendrinimo užklausa: {{pct}}%',
      occupancy: 'Užimtumas',
      avgLength: 'Vidutinis ilgis',
      uniqueBookers: 'Unikalūs rezervuotojai',
      uniqueBookersSub: 'Paskyra, RSID arba vardas',
      totalKm: 'Rida (km)',
      totalKmSub: 'Tikrasis atstumas paėmimo metu',
      vehicleCount: 'Transporto priemonių skaičius',
      noShow: 'Jokio pasirodymo',
      noShowSub: 'Automatiškai išleistas (nesurinktas laiku)',
      serviceNotUsed: 'Paslaugų užsakymai nepanaudoti',
      serviceNotUsedSub: 'Paslaugų užsakymų dalis: {{pct}}%',
      byStatus: 'Apimtis pagal būseną',
      byCarClass: 'Pasiskirstymas pagal automobilių klases',
      trend: 'Tendencija (apimtis)',
      topVehicles: 'Dažniausiai užsakomos transporto priemonės',
      timingTitle: 'Laiko įvertinimas ir Flinkey',
      timingHint: 'Taikoma užsakymams, sukurtiems pradėjus saugoti pradinį laiką. Laike = per ±{{minutes}} min, palyginti su pradiniu laiku.',
      timingNoSamples: 'Šiuo laikotarpiu dar nėra užsakymų su pradiniu laiku.',
      pickupVsOriginal: 'Paėmimas vs originalas',
      returnVsOriginal: 'Grąžinimas prieš originalą',
      activateToUnlock: 'Aktyvinimas → Flinkey atidarymas',
      avgDelta: 'Vidutinis nuokrypis',
      earlier: 'Ankstesnis',
      onTime: 'Laiku',
      later: 'Vėliau',
      sampleCount: '{{count}} užsakymai',
      unlockAvg: 'Vidutinis {{minutes}} min',
      unlockUnder2: 'Mažiau nei 2 min',
      unlock2to5: '2–5 min',
      unlock5to15: '5–15 min',
      unlockOver15: 'Virš 15 min',
    },
    fuelAnalysis: {
      title: 'Kuro analizė',
      description: 'Išanalizuoti kuro sąnaudas ir sąnaudas iš importuotų sandorių',
      totalCost: 'Bendra kaina',
      totalLiters: 'Bendras tūris',
      costPerMil: 'Kaina už mylią',
      avgPricePerLiter: 'Vidutinė kaina',
      cost: 'Kaina',
      liters: 'Litro',
      fuelType: 'Kuro tipas',
      costByOrg: 'Kaina vienai organizacijai',
      byFuelType: 'Pagal kuro rūšį',
      costTrend: 'Išlaidų tendencija (kr/10 km)',
      costVolumeTrend: 'Kaina ir apimtis per mėnesį',
    },
    fleetTco: {
      title: 'Laivyno išlaidų analizė (TCO)',
      description: 'Bendros transporto priemonės nuosavybės išlaidos: kuras, paslauga, lizingas ir draudimas',
      totalCost: 'Bendra kaina',
      costPerKm: 'Kaina už km',
      costPerMonth: 'Kaina per mėnesį',
      totalDistance: 'Bendra rida',
      fuel: 'Kuro',
      service: 'Aptarnavimas',
      leasing: 'Lizingas',
      insurance: 'Draudimas',
      tax: 'Mokestis/malus',
      total: 'Iš viso',
      breakdown: 'Sąnaudų paskirstymas',
      byFuelType: 'Kaina pagal transporto priemonės tipą',
      vehicle: 'Transporto priemonės',
      tabs: {
        overview: 'Apžvalga',
        byType: 'Pagal transporto priemonės tipą',
      },
    },
    executive: {
      title: 'Valdymo ataskaita',
      statisticsTitle: 'Statistinė apžvalga',
      description: 'Viso K ir PI rinkinys CO₂',
      period: 'Laikotarpis',
      periodWeek: 'Savaitė',
      periodMonth: 'Mėnuo',
      periodQuarter: 'Ketvirtis',
      periodYear: 'Metai',
      totalDistance: 'Bendra rida',
      totalFuelCost: 'Degalų sąnaudos',
      totalTco: 'Bendra nuosavybės kaina',
      utilization: 'Panaudojimo rodiklis',
      co2: 'CO₂ emisija',
      activeVehicles: 'Aktyvios transporto priemonės',
      costTrend: 'Kainų tendencija',
      co2Trend: 'CO₂ tendencija',
      topDeviations: '5 geriausi nukrypimai',
      exportPdf: 'Eksportuoti PDF',
      noDeviations: 'Laikotarpio nukrypimų nėra',
    },
  },
  co2: {
    title: 'CO₂ emisija',
    description: 'Apskaičiuokite ir analizuokite transporto priemonių parko išmetamo CO₂ kiekį',
    totalCO2: 'Bendra CO₂ emisija',
    avgPerKm: 'Vid. CO₂/km',
    electricVehicles: 'Elektrinės transporto priemonės',
    fossilVehicles: 'Fosilinės transporto priemonės',
    co2Saved: 'Sutaupyta CO₂ (EV)',
    trendTitle: 'CO₂ emisija laikui bėgant',
    fuelTypeDistribution: 'Kuro tipo paskirstymas',
    vehicleDetails: 'CO₂ Vienai transporto priemonei',
    fuelType: 'Kuro',
    fuelUsed: 'Naudota',
    totalCO2Short: 'CO₂ (kg)',
    wltpCO2: 'WLTP',
  },
  geofenceZone: {
    title: 'Geotvoros zonos ataskaita',
    description: 'Išanalizuokite, kaip dažnai transporto priemonės yra pasirinktose zonose',
    selectZone: 'Pasirinkite zoną',
    totalZones: 'Iš viso zonos',
    totalVehicles: 'Transporto priemonės',
    totalVisits: 'Iš viso apsilankymų',
    totalTime: 'Visas laikas',
    totalCost: 'Bendra kaina',
    visitsOverTime: 'Apsilankymai laikui bėgant',
    zoneSummary: 'Santrauka pagal zonas',
    vehicleDetails: 'Transporto priemonės vienoje zonoje',
    zone: 'Zona',
    vehicles: 'Transporto priemonės',
    visits: 'Apsilankymai',
    costColumn: 'Kaina',
    totalDuration: 'Visas laikas',
    avgDuration: 'Vid. / apsilankymas',
    lastVisit: 'Paskutinis apsilankymas',
    noData: 'Nėra pasirinkto laikotarpio duomenų',
    fetchError: 'Nepavyko gauti ataskaitos',
    globalLabel: 'Pasaulinis',
    filteredLabel: 'Filtruojama',
    showingRowsCount: 'Rodoma {{count}} iš {{total}} eilučių',
  },
  underutilized: {
    title: 'Nepakankamai eksploatuojamos transporto priemonės',
    description: 'Identifikuokite mažai naudojančias transporto priemones ir generuokite įspėjimus',
    totalVehicles: 'Iš viso transporto priemonių',
    activeVehicles: 'Aktyvios transporto priemonės',
    underutilizedVehicles: 'Su įspėjimais',
    avgUtilization: 'Vid. panaudojimas',
    utilizationOverview: 'Naudojimo apžvalga',
    utilizationTrend: 'Naudojimo tendencija',
    showOnlyWarnings: 'Rodyti tik įspėjimus',
    vehiclesWithWarnings: 'Transporto priemonės su įspėjimais',
    allVehicles: 'Visos transporto priemonės',
    activeDays: 'Aktyvios dienos',
    utilization: 'Panaudojimas',
    warnings: 'Įspėjimai',
  },
  vehicleWear: {
    title: 'Transporto priemonių susidėvėjimas',
    description: 'Išanalizuokite, kaip vairavimo elgsena veikia transporto priemonės nusidėvėjimą',
    totalVehicles: 'Iš viso transporto priemonių',
    avgWearScore: 'Vidutinis nusidėvėjimo balas',
    worstCategory: 'Blogiausia kategorija',
    vehiclesAtRisk: 'Rizikos transporto priemonės',
    wearByVehicle: 'Nešioti transporto priemonėje',
    wearProfile: 'Dėvėjimo profilis',
    selectVehicle: 'Norėdami gauti daugiau informacijos, pasirinkite transporto priemonę',
    clickBarToSelect: 'Norėdami pamatyti išsamią informaciją, diagramoje spustelėkite transporto priemonę',
    recommendations: 'Rekomendacijos, skirtos',
    brakes: 'Stabdžiai',
    engine: 'Variklis',
    tires: 'Padangos',
    fuel: 'Kuro',
    overall: 'Apskritai',
  },
  login: {
    title: 'Prisijungti',
    subtitle: 'Įveskite el. paštą ir slaptažodį.',
    heroTitleLine1: 'Jūsų transporto parkas.',
    heroTitleLine2: 'Paprastesnis.',
    heroBody: 'Kelionės žurnalas, rezervacijos ir raktų valdymas vienoje sistemoje. Prisijunkite ir pažiūrėkite, kaip sekasi parkui.',
    brandFooter: '© {year} DEVIAQ AB · Linköping',
    emailLabel: 'El. paštas',
    passwordLabel: 'Slaptažodis',
    passwordRequired: 'Slaptažodis privalomas',
    emailPlaceholder: 'vardas@imone.lt',
    passwordPlaceholder: '',
    showPassword: 'Rodyti',
    hidePassword: 'Slėpti',
    forgotPassword: 'Pamiršote slaptažodį?',
    loggingIn: 'Prisijungimas...',
    loginButton: 'Prisijungti',
    noAccount: 'Naujas naudotojas?',
    createAccount: 'Sukurti paskyrą',
    welcomeMessage: 'Sveiki atvykę! Dabar esate prisijungę.',
    loginError: 'Neteisingas el. pašto adresas arba slaptažodis. Bandykite dar kartą.',
    verifyEmailTitle: 'Reikia patvirtinti el. paštą',
    verifyEmailBody: 'Prieš prisijungdami turite patvirtinti el. pašto adresą. Išsiųstas patvirtinimo laiškas.',
    verifyEmailBodyWithEmail: 'Prieš prisijungdami turite patvirtinti el. pašto adresą. Išsiųstas laiškas į {email}.',
    verifyOrgLinkedNote: 'Jūsų domenas susietas su organizacija. Po patvirtinimo gausite Viewer prieigą.',
    verifyManualOrgNote: 'Jei organizacija neatpažįsta jūsų el. pašto domeno, administratorius gali turėti susieti paskyrą rankiniu būdu.',
    resendVerification: 'Siųsti patvirtinimo laišką dar kartą',
    resendingVerification: 'Siunčiama...',
    resendVerificationSuccess: 'Naujas patvirtinimo laiškas išsiųstas.',
    resendVerificationError: 'Nepavyko išsiųsti patvirtinimo laiško',
  },
  sidebar: {
    user: 'Vartotojas',
    logout: 'Atsijungti',
    noFeatures: 'Nėra pasiekiamų funkcijų',
    groups: {
      overview: 'Apžvalga',
      operations: 'Veikla',
      followUp: 'Stebėsena',
      system: 'Sistema',
      other: 'Kita',
    },
    expandMenu: 'Išskleisti meniu',
    collapseMenu: 'Sumažinti meniu (tik piktogramos)',
  },
  drivers: {
    schedule: {
      title: 'Darbo grafikas',
      description: 'Nustatykite darbo valandas, kad kelionės būtų automatiškai klasifikuojamos kaip verslo ar privačios. Kelionės ne pagal tvarkaraštį pažymėtos kaip privačios.',
      sameAllDays: 'Visas dienas tuo pačiu laiku',
      commonTime: 'Darbo valandos (taikoma pasirinktomis dienomis)',
      noWorkTime: 'Privatus (be darbo laiko)',
      noSchedule: 'Tvarkaraštis nenustatytas – visos kelionės priskiriamos privačioms',
      activeInfo: 'dienų su nustatytomis darbo valandomis',
      weekdays: 'Darbo dienomis',
      weekend: 'Savaitgalis',
      weekdaysActive: 'darbo dienomis',
      weekendActive: 'savaitgalio dienomis',
      saveSuccess: 'Darbo grafikas išsaugotas',
      saveDraft: 'Baigta – išsaugoma sukuriant vartotoją',
      saveDraftSuccess: 'Tvarkaraštis įtraukiamas, kai spustelėsite Sukurti vartotoją.',
      days: {
        monday: 'Pirm',
        tuesday: 'antradienis',
        wednesday: 'trečia',
        thursday: 'Ketvirtadienis',
        friday: 'penk',
        saturday: 'Šešt',
        sunday: 'Saulė',
      },
      modeLabel: 'Naudojimas',
      mode: {
        privateManual: 'Privatus – serviso keliones pažymėkite rankiniu būdu',
        privateManualHelp: 'Automobilis žemėlapyje nematomas. Visos kelionės tampa privačios, kol vairavimo įraše pažymėsite jas kaip paslaugą.',
        workHours: 'Tarnybinis automobilis su darbo valandomis',
        workHoursHelp: 'Automobilis žemėlapyje matomas nurodytomis darbo valandomis. Kelionės automatiškai klasifikuojamos kaip tarnybinės arba privačios.',
        companyCar: 'Įmonės automobilis – visada matomas',
        companyCarHelp: 'Automobilis visada matomas žemėlapyje. Visos kelionės priskiriamos pareigoms.',
        alwaysBusiness: 'Visada budėti',
      },
      applyOrgDefaults: 'Naudokite organizacinį standartą (darbo dienomis)',
      orgDefaultsReady: 'Pristatomas organizacijos standartas. Spustelėkite Išsaugoti, kad išsaugotumėte serveryje.',
      emptyPrefilledFromOrg: 'Serveryje nebuvo išsaugotas joks tvarkaraštis. Žemiau yra numatytoji organizacijos – spustelėkite Išsaugoti, kad ją naudotumėte, arba pakeiskite savo tvarkaraščio laiką.',
      applyOrgDefaultsHelp: 'Pirmadieniais–penktadieniais užpildomas standartinis aptarnavimo laikas iš kliento vairavimo įrašo nustatymų viršutiniame mazge. Išsaugokite, kad galėtumėte rašyti į serverį.',
      applyOrgDefaultsMissing: 'Viršutiniame mazge nesukonfigūruotas joks numatytasis organizacijos parametras.',
      applyOrgDefaultsNoOrg: 'Pirmiausia pasirinkite naudotojo organizaciją.',
    },
    assignment: {
      title: 'Transporto priemonės paskyrimas',
      selectVehicle: 'Pasirinkite transporto priemonę',
      searchVehicle: 'Ieškoti registracijos numerio...',
      noVehiclesFound: 'Transporto priemonių nerasta',
      typeToSearch: 'Įveskite norėdami ieškoti transporto priemonių',
      hasDriver: 'Turi vairuotoją',
      selectDate: 'Pradžios data',
      selectTrip: 'Pasirinkite pradėti kelionę (neprivaloma)',
      currentVehicle: 'Dabartinė transporto priemonė',
      since: 'Kadangi',
      currentDriverWarning: 'Transporto priemonėje jau yra vairuotojas: {{name}}. Ta užduotis bus baigta automatiškai.',
      newAssignment: 'Nauja užduotis',
      assign: 'Priskirti transporto priemonę',
      endAssignment: 'Baigti užduotį',
      confirmEnd: 'Ar tikrai norite baigti šią užduotį?',
      assignSuccess: 'Transporto priemonei paskirtas vairuotojas',
      endSuccess: 'Užduotis baigėsi',
      history: 'Užduočių istorija',
      noUnassignedVehicles: 'Nėra laisvų transporto priemonių — visos jau turi aktyvų vairuotojo priskyrimą',
      noTrips: 'Šią dieną kelionių nėra',
      modePickUnassigned: 'Nemokama transporto priemonė organizacijoje',
      modeLinkDevice: 'Prijunkite įrenginį prie esamos transporto priemonės',
      modeRegisterNew: 'Užregistruoti naują transporto priemonę',
      modeHelpPick: 'Klientų struktūroje pasirinkite transporto priemonę be aktyvaus vairuotojo priskyrimo.',
      modeHelpLink: 'Ieškokite transporto priemonių pagal registracijos numerį, pasirinkite neįmontuotą įrenginį ir pradžios datą. Esamas transporto priemonės vairuotojas pakeičiamas paskyrus.',
      modeHelpRegister: 'Atsisiųskite duomenis iš Car.info, įveskite skaitiklio rodmenis, pasirinkite matavimo vienetą ir datą. Transporto priemonė kuriama pasirinktoje organizacijoje.',
      orgRequired: 'Šiam veiksmui reikalinga organizacija.',
      searchVehicleInOrg: 'Transporto priemonių (reg. Nr.) paieška organizacijoje',
      searchDevice: 'Ieškoti įrenginio (IMEI)…',
      selectDevice: 'Pasirinkite įrenginį',
      noDevicesFound: 'Nerasta jokių įrenginių',
      deviceGlobalSearch: 'Visi neprijungti sistemos įrenginiai (visuotinis administratorius)',
      existingDevicePolicy: 'Transporto priemonėje jau yra įrenginys',
      unmountExisting: 'Išardykite esamą',
      swapDevices: 'pakeisti vietą (keisti)',
      linkDeviceAndAssign: 'Prijunkite įrenginį ir priskirkite tvarkyklę',
      linkDeviceSuccess: 'Įrenginys prijungtas ir vairuotojas priskirtas',
      registerRegPlaceholder: 'ABC123',
      fetchCarInfo: 'Atsisiųskite iš Car.info',
      initialOdometerKm: 'Odometro rodmuo starto metu (km)',
      createVehicleAndAssign: 'Sukurkite transporto priemonę, prijunkite įrenginį ir priskirkite',
      registerSuccess: 'Transporto priemonė sukurta ir vairuotojas priskirtas',
      scheduleApplied: 'Vairuotojų tvarkaraštis atnaujintas pagal organizaciją',
      scheduleApplyWarn: 'Nepavyko nustatyti tvarkaraščio iš organizacijos (patikrinkite viršutinio mazgo paleidimo žurnalo nustatymus).',
      regLabel: 'Reg. ne',
      makePlaceholder: 'Padaryti',
      modelPlaceholder: 'Modelis',
      yearPlaceholder: 'Metai',
      fuelPlaceholder: 'Kuro',
      fuelPetrol: 'Benzinas',
      fuelDiesel: 'Dyzelinas',
      fuelElectric: 'Elektra',
      fuelHybrid: 'Hibridinis',
    },
  },
  profile: {
    title: 'Mano profilis',
    edit: 'Redaguoti',
    personalInfo: 'Asmeninė informacija',
    firstName: 'Vardas',
    lastName: 'Pavardė',
    email: 'El. paštas',
    phone: 'Mobilusis Telefonas',
    role: 'Vaidmuo',
    organization: 'Organizacija',
    cabinetPin: 'PIN kodas',
    cabinetPinHint: 'Jūsų raktų spintelės PIN kodas.',
    noCabinetPin: 'PIN kodas dar nesuteiktas',
    changePassword: 'Keisti slaptažodį',
    currentPassword: 'Dabartinis slaptažodis',
    newPassword: 'Naujas slaptažodis',
    confirmPassword: 'Patvirtinkite slaptažodį',
    saveSuccess: 'Profilis sėkmingai atnaujintas',
    driverInfo: 'Vairuotojo informacija',
    licenseNumber: 'Licencijos numeris',
    licenseExpiry: 'Licencijos galiojimo laikas',
    licenseCategories: 'Licencijos kategorijos',
    employeeId: 'Darbuotojo ID',
    department: 'skyrius',
    costCenter: 'Išlaidų centras',
    currentPasswordRequired: 'Norint pakeisti slaptažodį, reikalingas dabartinis slaptažodis',
    passwordTooShort: 'Slaptažodį turi sudaryti bent 6 simboliai',
    passwordMismatch: 'Slaptažodžiai nesutampa',
    passwordMinLength: 'Bent 6 simboliai',
    roleDriver: 'Vairuotojas',
    roleViewer: 'Žiūrovas',
    defaultPickupLocation: 'Numatytoji atsiėmimo vieta',
    defaultPickupLocationHint: 'Atsiėmimo vieta, kuri parenkama automatiškai, pvz., rezervuojant.',
    selectPickupLocation: '— Pasirinkite atsiėmimo vietą —',
    selectPickupLocationRequired: 'Pasirinkite atsiėmimo vietą',
    noDefaultPickupLocation: 'Nepasirinkta',
    pickupPromptTitle: 'Pasirinkite numatytąją atsiėmimo vietą',
    pickupPromptDescription: 'Prieš tęsdami turite pasirinkti numatytąją atsiėmimo vietą. Pasirinkite dažniausiai naudojamą vietą ir ji bus automatiškai užpildoma ateityje. Pasirinkimą bet kada galite pakeisti skiltyje „Mano profilis".',
    pickupPromptLater: 'Vėliau',
  },
  sysAdmin: {
    title: 'Sistemos administratorius',
    manageRoles: 'Tvarkykite vaidmenis ir leidimus',
    manageOrganizations: 'Tvarkyti organizacijas',
    dataMigration: 'Duomenų perkėlimas',
    migrateData: 'Perkelkite duomenis iš senos duomenų bazės',
    deviceCommands: 'Įrenginio komandos',
    deviceCommandsDescription: 'Siųsti komandas į įrenginius',
    auditLog: 'Audito žurnalas',
    auditLogDescription: 'Peržiūrėkite išsiųstų komandų žurnalą',
    generalAuditLog: 'Pakeitimų žurnalas',
    generalAuditLogDescription: 'Peržiūrėti visus pakeitimus (KURTI, ATNAUJINTI, IŠTRINTI)',
    errorLog: {
      name: 'Klaidų žurnalas',
      title: 'Klaidų žurnalas',
      description: 'Visų sistemos klaidų ir išimčių žurnalas',
      viewDetails: 'Klaida – detalės',
      close: 'Uždaryti',
      resolutionNotes: 'Rezoliucijos pastabos',
      resolutionNotesPlaceholder: 'Neprivalomi užrašai...',
      saveStatus: 'Išsaugoti būseną',
      saveStatusSuccess: 'Būsena atnaujinta',
      loading: 'Įkeliama...',
      noErrorsFound: 'Klaidų nerasta',
      noResultsMatchFilters: 'Nėra klaidų, atitinkančių dabartinius filtrus. Išvalykite filtrus arba pakeiskite sunkumą / būseną, kad pamatytumėte klaidas.',
      status: 'Būsena',
      clearFilters: 'Išvalyti filtrai',
      searchPlaceholder: 'Ieškoti klaidos pranešime...',
      searchLabel: 'Ieškoti',
      severityLabel: 'Sunkumas',
      statusLabel: 'Būsena',
      clearLog: 'Išvalykite klaidų žurnalą',
      clearLogTitle: 'Išvalykite klaidų žurnalą',
      clearLogDescription: 'Pasirinkite, ar norite ištrinti visas klaidas, ar tik senesnes nei tam tikras dienų skaičius.',
      clearOlderThanLabel: 'Ištrinti įrašus, senesnius nei (dienų)',
      clearOlderThanPlaceholder: 'Palikite tuščią, kad ištrintumėte viską',
      clearOlderThanHint: 'Ištrina senesnius nei {days} d. įrašus.',
      clearAllHint: 'Palikite tuščią, kad ištrintumėte VISUS įrašus.',
      deleteAll: 'Ištrinti viską',
      deleteOlderThan: 'Ištrinti senesnes nei {days} d',
      deleting: 'Ištrinama...',
      deletedSuccess: '{count} klaida buvo ištrinta iš klaidų žurnalo.',
      deletedError: 'Nepavyko išvalyti klaidų žurnalo',
      showing: 'Rodoma {from} - {to} iš {total}',
      previous: 'Ankstesnis',
      next: 'Kitas',
      totalLabel: 'Iš viso',
      messageLabel: 'Pranešimas',
      errorTypeLabel: 'Klaidos tipas',
      errorCodeLabel: 'Kodas',
      serviceLabel: 'Aptarnavimas',
      moduleLabel: 'Modulis',
      functionLabel: 'Funkcija',
      timeLabel: 'Laikas',
      requestLabel: 'Prašymas',
      resolvedLabel: 'Laisvai',
    },
    errorLogDescription: 'Peržiūrėkite visas sistemos klaidas ir išimtis',
    systemMonitor: {
      title: 'Sistemos stebėjimas',
      description: 'Stebėkite procesorių, atmintį, diską, duomenų bazes ir eiles',
      docker: {
        title: 'Docker konteineriai',
        notAvailable: '„Docker“ šiame serveryje nepasiekiamas',
        total: 'Iš viso',
        running: 'Bėgimas',
        stopped: 'Sustojo',
        healthy: 'Sveikas',
        unhealthy: 'Nesveika',
        container: 'Konteineris',
        image: 'Vaizdas',
        status: 'Būsena',
        health: 'Sveikata',
        cpu: 'CPU',
        memory: 'Atmintis',
        swarm: {
          title: 'Dokerių spiečius',
          nodes: 'Mazgai',
          services: 'Paslaugos',
          host: 'Šeimininkas',
          manager: 'Vadovas',
          service: 'Aptarnavimas',
          replicas: 'Kopijos',
        },
      },
      scheduledJobs: {
        title: 'Suplanuoti darbai',
        jobStatus: 'Darbo būsena',
        jobs: 'Darbai',
        runningNow: 'Bėgimas',
        successLast24h: 'gerai (24h)',
        failedLast24h: 'Nepavyko (24 val.)',
        schedule: 'Tvarkaraštis',
        nextRun: 'Kitas',
        recentRuns: 'Naujausi bėgimai',
        noHistory: 'Dar nėra bėgimo istorijos',
        job: 'Darbas',
        startTime: 'Pradžios laikas',
        duration: 'Trukmė',
        processed: 'Gerai/nepavyko',
        success: 'GERAI',
        failed: 'NEPAVYKO',
        running: 'VYKDOMA',
      },
    },
    slowQueries: {
      title: 'Lėti užklausos',
      description: 'Analizuoti lėtas SQL užklausas',
    },
    apiMetrics: {
      title: 'Našumas',
      cardDescription: 'Vartotojų augimas, rezervacijos ir API vėlinimas prieš sistemos apkrovą',
      description: 'Grafikai apie vartotojus, rezervacijas ir API laiką. Vėlinimas saugomas Redis pagal normalizuotą maršrutą. p50/p95 yra trukmės intervalo viršutinė riba. Gyvi rodikliai atnaujinami kas minutę.',
      loadError: 'Nepavyko įkelti API matavimo',
      loadErrorHistory: 'Nepavyko įkelti našumo istorijos',
      empty: 'Dar nėra užklausų. Naudokite sistemą ir atnaujinkite.',
      emptyHistory: 'Pasirinktam laikotarpiui dar nėra istorijos.',
      periodDays: '{{n}} dienos',
      usersTitle: 'Vartotojai ir sistemos apkrova',
      usersHint: 'Nauji ir aktyvūs vartotojai prieš API kiekius ir p95. Aktyvus reiškia, kad paskutinis prisijungimas buvo tą dieną.',
      cumulativeUsers: 'Kaupiamieji vartotojai',
      newUsers: 'Nauji vartotojai',
      activeUsers: 'Aktyvūs (paskutinis prisijungimas)',
      activeAccounts: '{{count}} aktyvios paskyros',
      bookingsTitle: 'Rezervacijos',
      bookingsHint: 'Sukurta prieš soft delete (deleted_at). Brūkšninė linija – atšaukimas be soft delete.',
      bookingsCreated: 'Sukurta',
      bookingsSoftDeleted: 'Atšaukta (soft delete)',
      bookingsCancelledOnly: 'Atšaukta be delete',
      apiTitle: 'API užklausos ir klaidos',
      apiHint: 'Užklausos per dieną, svertinis p95 ir 5xx dalis.',
      requestsPerDay: 'Užklausos/dieną',
      p95Ms: 'p95 (ms)',
      errorShare: '5xx dalis',
      watchlistTitle: 'p95 pagal kliūtį',
      watchlistHint: 'Spustelėkite lentelės eilutę, kad pridėtumėte maršrutą į grafiką.',
      selectedRoute: 'Pasirinkta: {{route}}',
      actionTitle: 'Veiksmai',
      actionHint: 'Geltona = ispejimas (letas atsakymas). Raudona = veikti. Sarase letos uzklausos ir serverio klaidos.',
      actionEmpty: 'Per paskutine diena niekas nevirsijo slenksčio.',
      actionWarn: 'Įspėjimas',
      actionFix: 'Taisyti',
      actionErrors: 'Serverio klaidos 5xx:',
      actionTrend: 'Ankstesne diena:',
      unitMs: 'ms',
      hourP95: 'Valandos p95 {{value}}',
      hourTitle: 'Ši valanda',
      todayTitle: 'Visa diena',
      requests: 'užklausos',
      colRoute: 'Maršrutas',
      colStatus: 'Būsena',
      colCount: 'Skaičius',
      colP50: 'p50',
      colP95: 'p95',
      colAvg: 'Vid.',
      colMax: 'Maks.',
      apiHeap: 'API heap',
      redisMemory: 'Redis atmintis',
      redisMax: 'Limit {{value}}',
      tripState: 'trip:state raktai',
      tripStateSample: 'Imties vidurkis {{value}}',
      gpsWorker: 'GPS worker heap',
      gpsWorkerWaiting: 'Laukiama worker duomenų',
      gpsPackets: '{{count}} paketai, vid. {{avg}}',
    },
    ssoLog: {
      title: 'SSO žurnalas',
      cardDescription: 'Nepavykę ir nutraukti SSO bandymai pagal klientą ir įrenginį',
      description: 'Nepavykę SSO prisijungimai: kas bandė, kuris klientas, kodėl sustojo ir ar tai buvo telefonas ar kompiuteris.',
      loadError: 'Nepavyko įkelti SSO žurnalo',
      empty: 'Nėra SSO bandymų pagal filtrus',
      period: 'Laikotarpis',
      days: '{{count}} dienos',
      customer: 'Klientas',
      allOrgs: 'Visi klientai',
      user: 'Vartotojas',
      userPlaceholder: 'El. paštas arba vardas',
      channel: 'Kanalas',
      deviceLabel: 'Įrenginys',
      statusLabel: 'Būsena',
      colCustomer: 'Klientas',
      colWhen: 'Kada',
      colEmail: 'Prisijungimo adresas',
      colSentToIdp: 'Išsiųsta į Microsoft',
      colUser: 'Vartotojas',
      unknownEmail: 'Nežinoma (nėra el. pašto prieš Microsoft)',
      nothingSentToIdp: 'Į Microsoft nieko nesiųsta',
      sentToIdp: 'Išsiųsta į Microsoft: {{value}}',
      sentToIdpNone: 'Išsiųsta į Microsoft: nieko',
      idpUsernameFilledThere: 'Vartotojas įveda vardą IdP (Skåne: rsid@skane.se)',
      nothingPrefillsIdp: 'Microsoft nerodomas vartotojo vardas',
      exportError: 'Nepavyko eksportuoti CSV',
      colOrg: 'Klientas',
      colChannel: 'Kanalas',
      colDevice: 'Įrenginys',
      colReason: 'Priežastis',
      showing: 'Rodoma {{from}}–{{to}} iš {{total}}',
      client: {
        web: 'Kompiuteris (saitynas)',
        mobile: 'Mobilioji programėlė',
        unknown: 'Nežinomas kanalas',
      },
      device: {
        phone: 'Telefonas',
        tablet: 'Planšetė',
        computer: 'Kompiuteris',
        unknown: 'Nežinomas įrenginys',
      },
      os: {
        ios: 'iOS',
        android: 'Android',
        windows: 'Windows',
        macos: 'macOS',
        linux: 'Linux',
        unknown: 'nežinoma OS',
      },
      status: {
        all: 'Visos',
        unsuccessful: 'Nepavykę ir nutraukti',
        failed: 'Nepavyko',
        abandoned: 'Nutraukta',
        in_progress: 'Vyksta',
        success: 'Pavyko',
      },
      reason: {
        none: '–',
        idp_error: 'Atmesta Microsoft / IdP',
        callback_error: 'Klaida grįžus iš prisijungimo',
        initiate_error: 'Nepavyko pradėti SSO',
        app_no_exchange: 'Programėlė nepaėmė sesijos',
        abandoned_at_idp: 'Nutraukta Microsoft (negrįžo)',
        abandoned_after_callback: 'Nutraukta po grįžimo',
        unknown_error: 'Nežinoma klaida',
      },
    },
    dataReplay: {
      title: 'Duomenų atkūrimas',
      description: 'Pakartokite istorinius GPS duomenis',
    },
    importSources: {
      title: 'Importuoti šaltinius',
      description: 'Tvarkykite importo sinchronizavimo pašto dėžutę ir SFTP šaltinius',
      loadError: 'Nepavyko įkelti importo šaltinių',
      saveError: 'Nepavyko išsaugoti importavimo šaltinio',
      deleteError: 'Nepavyko ištrinti importavimo šaltinio',
      testError: 'Ryšio testas nepavyko',
      testSuccess: 'Ryšys gerai',
      created: 'Importavimo šaltinis sukurtas',
      updated: 'Importavimo šaltinis atnaujintas',
      deleted: 'Importavimo šaltinis ištrintas',
      newSource: 'Naujas šaltinis',
      createSource: 'Sukurti šaltinį',
      editSource: 'Redaguoti šaltinį',
      create: 'Sukurti',
      saveChanges: 'Išsaugoti pakeitimus',
      sourcesList: 'Importuoti šaltinius',
      noSources: 'Dar nesukurta jokių importavimo šaltinių',
      confirmDelete: 'Ištrinti šį importavimo šaltinį?',
      testConnection: 'Bandomasis ryšys',
      syncNow: 'Sinchronizuoti dabar',
      syncSuccess: 'Sinchronizavimas baigtas',
      syncError: 'Sinchronizuoti nepavyko',
      type: 'Tipas',
      mailbox: 'Pašto dėžutė',
      sftp: 'SFTP',
      local: 'Vietinis katalogas',
      localDirectoryPath: 'Katalogo kelias (serveryje)',
      localDirectoryHint: 'Absoliutus kelias iki katalogo, iš kurio backend skaito failus (pvz. SFTP įkėlimo katalogas).',
      name: 'Vardas',
      namePlaceholder: 'Pvz. Bendrinama pašto dėžutė Circle K',
      mailboxEmail: 'Pašto dėžutės el',
      sftpHost: 'Šeimininkas',
      sftpPort: 'Uostas',
      sftpUsername: 'Vartotojo vardas',
      sftpPassword: 'Slaptažodis (neprivaloma)',
      sftpPrivateKeyPath: 'Privataus rakto kelias (neprivaloma)',
      sftpPassphrase: 'Rakto slaptažodis (neprivaloma)',
      sftpBasePath: 'Bazinis kelias',
      allowedExtensions: 'Leidžiami plėtiniai (atskirti kableliais)',
      filenameExclusions: 'Failų pavadinimų išskyrimai (atskirti kableliais)',
      minDate: 'Min. data (pašto dėžutė, MMMM-MM-DD)',
      pathPattern: 'Kelio šablonas (SFTP)',
      retentionDays: 'Išlaikymas (dienos)',
      isActive: 'Aktyvus šaltinis',
      inactive: 'Neaktyvus',
      lastFetchAt: 'Paskutinį kartą',
      lastFetchError: 'Paskutinė klaida',
      lastFetchFilesCount: 'Paskutiniai sinchronizuoti failai',
      validation: {
        nameRequired: 'Vardas yra būtinas',
        mailboxEmailRequired: 'Pašto dėžutės šaltiniui reikalingas pašto dėžutės el',
        sftpRequired: 'SFTP šaltiniui reikia pagrindinio kompiuterio, vartotojo vardo ir bazinio kelio',
        localDirectoryRequired: 'Vietiniam šaltiniui reikia katalogo kelio',
      },
      totalFilesInSource: 'failus šaltinyje',
    },
    tripValidation: {
      title: 'Kelionės patvirtinimas',
      description: 'Patvirtinkite keliones tarp MongoDB ir MariaDB',
      resolveTitle: 'Tvarkyti patvirtinimo klaida',
      errorType: 'Klaidos tipas',
      date: 'Data',
      binAnalysisTitle: 'Bin failų analizė',
      analyzeBinFile: 'Išanalizuoti bin failą',
      analyzing: 'Analizuojama...',
      binAnalysisFailed: 'Nepavyko išanalizuoti šiukšliadėžės failo',
      binAnalysis502Hint: 'Serveris neatsakė (502). Bin failo analizės laikas gali pasibaigti arba bin failo nėra serveryje (gps-data). Patikrinkite užpakalinės sistemos žurnalus.',
      tryAgain: 'Bandykite dar kartą',
      clearLog: 'Išvalyti visą žurnalą',
      clearLogConfirm: 'Ar esi tikras? Visi įrašai kelionės patvirtinimo žurnale bus ištrinti. To negalima anuliuoti.',
      clearLogSuccess: 'Žurnalas išvalytas. {{count}} įrašai pašalinti.',
      clearLogFailed: 'Nepavyko išvalyti žurnalo',
      replayAllDatesQueue: 'Pakartoti visas datas (eilė)',
      replayAllDatesQueueTitle: 'Vykdykite pakartojimą per eilę (gps_worker_*_replay) visoms unikalioms sąrašo datoms',
      bulkClean: 'Išvalykite papildomas MariaDB keliones',
      bulkCleanTitle: 'Pašalina MariaDB keliones be atitinkamos MongoDB kelionės ir sinchronizuoja trūkstamas keliones. Tvarko visus sinchronizavimo nesutapimo įrašus.',
      bulkCleanSuccess: '{{deleted}} papildomos MariaDB kelionės pašalintos, {{synced}} MongoDB kelionės sinchronizuojamos.',
      bulkCleanFailed: 'Masinis valymas nepavyko',
      syncMismatchInfo: 'Sinchronizavimo neatitikimas reiškia, kad „MongoDB“ ir „MariaDB“ kelionių skaičius skiriasi. Dėžės failų analizė negalima šio tipo klaidos atveju. Norėdami sinchronizuoti duomenis, paleiskite pakartojimą.',
      syncMismatchWhyTitle: 'Kodėl dvi kelionės MariaDB, bet teisingas skaičius MongoDB?',
      syncMismatchWhyMongo: 'turi pasikartojančius patikrinimus: prieš išsaugant naudojamas findDuplicateTrip (ta pati transporto priemonė, starto laikas ±10 s, atstumas ±200 m). Jei atitinkanti kelionė jau yra, nauja neišsaugoma – Mongo išsaugoma tik viena loginė kelionė per laiko langelį.',
      syncMismatchWhyMaria: 'neturėjo lygiaverčio patikrinimo: kiekvienas sinchronizavimo skambutis atliko INSERT (su savo trip_id). Jei sinchronizavimas anksčiau buvo iškviestas net tada, kai kelionė nebuvo išsaugota Mongo (pvz., atmestas dublikatas su kitu trip_id), MariaDB gavo papildomą eilutę. Taigi galite matyti dvi eilutes MariaDB (du skirtingus trip_id), bet tik vieną MongoDB.',
      syncMismatchToday: 'Šiandien MariaDB sinchronizavimas iškviečiamas tik tada, kai kelionė pirmą kartą išsaugoma MongoDB, taip pat pridėjome pasikartojančius patikrinimus MariaDB įdėkle (ta pati transporto priemonė + starto laikas ±10 s, atstumas ±200 m). Todėl neturėtų atsirasti naujų tokio tipo dublikatų.',
      syncMismatchAction: 'Veiksmas: paleiskite „Pakartoti dienos duomenis“, kad užpildytumėte MongoDB iš bin failo, arba pašalinkite papildomą MariaDB eilutę (kurios trūksta MongoDB) rankiniu būdu, jei ji yra tikra dublikatas.',
      syncMismatchMariaMore: 'MariaDB turi daugiau kelionių nei MongoDB. Aukščiau pateiktame sąraše „MariaDB kelionės“ rodomi, kurie taip pat egzistuoja MongoDB (✓ MongoDB) ir tik MariaDB – jie galėjo būti sukurti dėl ankstesnės sinchronizavimo klaidos arba rankiniu būdu. Prieš paleisdami pakartojimą išanalizuokite, kurios kelionės trūksta MongoDB; po pakartojimo gali reikėti rankiniu būdu pašalinti papildomas keliones, kurios vis dar egzistuoja tik MariaDB.',
      currentPoints: 'Dabartiniai taškai',
      pointsInBinFile: 'Taškai bin faile',
      totalInFile: 'Iš viso faile',
      tripTime: 'Laikotarpis',
      updateMongoDB: 'Atnaujinkite MongoDB su {{count}} taškais',
      repairing: 'Taisoma...',
      repairSuccess: 'Kelionė pataisyta naudojant {{count}} GPS taškus',
      repairFailed: 'Nepavyko pataisyti kelionės',
      noPointsFound: 'Šios kelionės bin faile nerasta jokių GPS taškų',
      tooFewPoints: 'Rastas tik {{count}} taškas, reikia bent 2',
      manualResolveTitle: 'Pažymėkite rankiniu būdu',
      notes: 'Pastabos (neprivaloma)',
      notesPlaceholder: 'Aprašykite, kaip problema buvo išspręsta...',
      markResolved: 'Pažymėti kaip išspręstą',
      mongoTrips: 'MongoDB kelionės (galima ištrinti)',
      deleteTripTitle: 'Ištrinti kelionę',
      deleteTripWarning: 'Ketinate ištrinti kelionę su {{count}} taškais. To negalima anuliuoti.',
      deleteReason: 'Ištrynimo priežastis*',
      deleteReasonPlaceholder: 'Aprašykite, kodėl ši kelionė ištrinama (mažiausiai 5 simboliai)...',
      deleteReasonError: 'Reikalingi bent 5 simboliai',
      deleteTrip: 'Ištrinti kelionę',
      deletingTrip: 'Ištrinama...',
      deleteTripSuccess: 'Kelionė {{tripId}} ištrinta',
      deleteTripFailed: 'Nepavyko ištrinti kelionės',
      createInMariaDB: 'Sukurkite MariaDB',
      creatingInMariaDB: 'Kuriama...',
      createInMariaDBSuccess: 'Kelionė sukurta MariaDB',
      createInMariaDBFailed: 'Nepavyko sukurti kelionės MariaDB',
      replayDay: 'Pakartokite dienos duomenis',
      replayDaySuccess: 'Prasidėjo pakartojimas',
      systematicErrorHint: 'Daugelis to paties tipo klaidų gali rodyti sistemingą problemą – pvz. tam tikru laikotarpiu nepavyko sinchronizuoti su MariaDB. Patikrinkite klaidų ataskaitą (Administravimas → Klaidos ataskaita) „TripSyncService“ arba „syncTripToMariaDB“ ir apsvarstykite galimybę paleisti „Replay“ paveiktoms datoms.',
      binSegmentsExcludedNote: '{{count}} greičio segmentai bin faile nėra išvardyti (po {{minDuration}} s arba po {{minDistance}} m – toks pat minimalus kaip ir išsaugotos kelionės atveju).',
    },
    tripSync: {
      title: 'Kelionės sinchronizavimas',
      description: 'Foninis darbas, sinchronizuojantis keliones iš MongoDB į MariaDB',
      jobEnabled: 'Fono užduotis įjungta',
      jobDisabled: 'Foninė užduotis išjungta',
      intervalInfo: 'Veikia kas {{minutes}} minutę. Kelionės, kurios yra MongoDB, bet kurių nėra MariaDB, sinchronizuojamos automatiškai.',
      lastRun: 'Paskutinis bėgimas',
      lastRunTime: 'Veikimo laikas',
      synced: 'Sinchronizuota',
      failed: 'Nepavyko',
      duration: 'Trukmė',
      runManualSync: 'Paleiskite sinchronizavimą rankiniu būdu',
      syncing: 'Sinchronizuojama...',
      jobRunning: 'Vykdoma sinchronizavimo užduotis.',
      missingTripsTitle: 'Trūksta kelionių (pavyzdys)',
      missingTripsDescription: 'Kelionių, kurios yra MongoDB, bet kurių trūksta MariaDB, skaičius (rodoma daugiausia 100). Kito paleidimo metu jie bus sinchronizuojami.',
      manualSyncSuccess: 'Sinchronizavimas baigtas: {{synced}} sinchronizuota, {{failed}} nepavyko, {{skipped}} praleista.',
      manualSyncError: 'Nepavyko sinchronizuoti rankiniu būdu',
    },
    carinfoFilter: {
      title: 'Car.info filtras',
      description: 'Pasirinkite, kuriuos Car.info laukus rodyti filtre',
    },
    ecoSettings: {
      title: 'ECO nustatymai',
      description: 'Konfigūruokite EKO vairavimo slenksčius',
      selectOrganization: 'Pasirinkite organizaciją',
      globalDefaults: 'Pasauliniai numatytieji nustatymai',
      harshDriving: 'Sunkus vairavimas',
      harshDrivingDescription: 'Sunkaus vairavimo aptikimo slenksčiai',
      maxAcceleration: 'Maksimalus pagreitis (m/s²)',
      maxBraking: 'Maksimalus stabdymas (m/s²)',
      maxCornering: 'Maksimalus posūkis (m/s²)',
      excessiveIdling: 'Per didelė tuščioji eiga (sekundėmis)',
      overspeedPercent: 'Greičio viršijimo riba (%)',
      greenDriving: 'Žalias vairavimas',
      greenDrivingDescription: 'Slenksčiai už sklandų vairavimą',
      greenMaxAcceleration: 'Maksimalus pagreitis važiuojant ekologiškai (m/s²)',
      greenMaxBraking: 'Maksimalus stabdymas ekologiškai važiuojant (m/s²)',
      greenMinSpeed: 'Minimalus greitis (km/h)',
      greenMinDuration: 'Minimali trukmė (sekundėmis)',
      save: 'Išsaugokite nustatymus',
      saved: 'Nustatymai išsaugoti',
      saveError: 'Nepavyko išsaugoti nustatymų',
      infoTitle: 'Apie slenksčius',
      infoText: 'Šie slenksčiai naudojami ECO vairavimo įvykiams aptikti. Teltonika standartinės vertės yra pagrįstos gamintojo rekomendacijomis. Galite tinkinti reikšmes kiekvienai organizacijai arba naudoti visuotinius numatytuosius nustatymus.',
    },
    generalAuditLogSection: {
      title: 'Keisti žurnalą',
      description: 'Užregistruokite visus sistemos pakeitimus',
      total: 'Iš viso',
      entityTypeLabel: 'Esybės tipas',
      entityTypePlaceholder: 'pavyzdžiui, transporto priemonė, naudotojas...',
      actionLabel: 'Išmatuoti',
      searchLabel: 'Ieškoti',
      searchPlaceholder: 'Ieškoti vartotojo, subjekto...',
      clearFilters: 'Išvalytas filtras',
      loading: 'Įkeliamas...',
      noChanges: 'Pakeitimų nerasta',
      colTime: 'Laikas',
      colUser: 'Vartotojas',
      colAction: 'Išmatuoti',
      colEntity: 'Esybė',
      colChanges: 'Pakeitimai',
      system: 'Sistema',
      fieldsCount: '{count} lauke',
      showing: 'Rodoma {from} - {to} iš {total}',
      previous: 'Ankstesnis',
      next: 'Kitas',
      allActions: 'Visi',
    },
    deviceQueues: {
      title: 'Įrenginių eilės',
      cardDescription: 'Jasper seansus, kol grandinė bus baigta',
      description: 'Tik Jasper SESSION_START įrenginiai. getver/getvin pirmiausia pereina per TCP, jei įrenginys yra prisijungęs, kitu atveju SMS. getvin N/A: palaukite, kol automobilis bus pastatytas rankiniu būdu (arba įjungtas), tada VIN bus paimtas iš registro ir P&P tęsis. Įrenginys be ryšio 30 dienų pašalinamas iš eilės ir grįš per kitą seansą. Geltonos linijos = Įstrigo (>24 val. be pažangos).',
      refresh: 'Atnaujinti',
      empty: 'Eilėje nėra aktyvių įrenginių.',
      emptyDone: 'Nėra aiškių įvykių (pastarosios 14 dienų).',
      viewLabel: 'Rodyti',
      viewQueue: 'Eilėje',
      viewDone: 'Aišku',
      sortColumn: 'Rikiuoti pagal {{column}}',
      countsShort: '{{queue}} eilėje · {{done}} atlikta',
      countsHint: '{{queue}} eilėje, {{done}} atlikta (dabartinis organizacijos filtras)',
      colCompleted: 'Aišku',
      loadError: 'Nepavyko gauti įrenginio eilių',
      searchPlaceholder: 'Ieškoti reg.nr., modelio, IMEI, grupės...',
      typeSession: 'Džaspis',
      typeCommand: 'Komandų eilė',
      typePnp: 'OBD P&P',
      typeForceNonObd: 'Ne OBD',
      colType: 'Fazė',
      colReg: 'Reg. ne',
      colMakeModel: 'Markė / modelis',
      colGroup: 'Grupė',
      colImei: 'Vieneto numeris',
      colFw: 'FW',
      colLastSeen: 'Paskutinis ryšys',
      colAdded: 'Pridėta',
      colStatus: 'Būsena',
      colActions: 'Veiksmai',
      cmdCount: '{{count}} komanda (-os)',
      actionForce: 'Tęsti / priversti',
      actionRemove: 'atšauktas',
      actionGetver: 'Paklausk FW (šunų)',
      confirmForce: 'Tęsti konvejerį / priverstinai atlikti kitą veiksmą šiame įrenginyje?',
      confirmRemove: 'Atšaukti įrenginio vamzdyną? (įrenginys / transporto priemonė nėra ištrinta)',
      forceOk: 'Vairavimas baigtas',
      forceQueued: 'Įrenginys neprisijungęs – parametrai yra eilėje kitam ryšiui',
      forceFail: 'Negalėjo priverstinai bėgti',
      removeOk: 'Atšauktas / pašalintas iš eilės',
      removeFail: 'Nepavyko pašalinti iš eilės',
      getverTitle: 'Firmware iš įrenginio',
      getverOk: 'davėjas gavo',
      getverQueued: 'Įrenginys neprisijungęs – atsidūrė eilėje',
      getverFail: 'Negalėjau paklausti FW',
      markInteresting: 'Pažymėti įdomiai',
      markOk: 'Pažymėta kaip įdomi',
      markFail: 'Nepavyko pažymėti',
      exportEmpty: 'Nėra eksportuojamų duomenų',
      exportOk: 'Eksportuotos {{count}} eilutės',
    },
    gpsDataLag: {
      title: 'GPS iškelties eilę',
      cardDescription: 'Įrenginiai, siunčiantys vėluojančius GPS duomenis',
      description: 'Rodo tik įrenginius, kuriuose yra aktyvi iškrovimo eilė (gaunami duomenys atsilieka nuo įrenginio GPS laiko). Kai įrenginys pasiveja, jis dingsta iš sąrašo. Flush siunčia komandą Teltonika per Jasper SMS.',
      refresh: 'Atnaujinti',
      loading: 'Įkeliama…',
      empty: 'Šiuo metu neatsilieka nė vienas padalinys.',
      loadError: 'Nepavyko gauti GPS iškelties eilės',
      searchPlaceholder: 'Ieškoti reg.nr, org, IMEI, ICCID...',
      summary: '{{count}} išrašymo eilėje · atnaujinta {{snapped}}',
      colReg: 'Reg. ne',
      colOrg: 'Organizacija',
      colImei: 'IMEI',
      colIccid: 'ICCID',
      colDumpLag: 'Sąvartyno įstatymas',
      colDeviceData: 'Duomenys vienetais',
      colReceived: 'Gauta',
      colLastRecs: 'Paskutinis įrašas',
      colActions: 'Veiksmai',
      flush: 'Nuplaukite',
      flushing: 'Siunčiama…',
      flushTitle: 'Siųsti „Flash“ SMS žinute (tuščia blykstė)',
      confirmFlush: 'Siųsti flush į {{reg}}?',
      flushOk: 'Nuplaukimas išsiųstas į {{reg}}',
      flushFail: 'Nepavyko išsiųsti išgryninimo',
      smsBadge: 'SMS',
    },
    certMonitor: {
      title: 'Sertifikatų stebėjimas',
      cardDescription: 'Stebėti baigiančius sertifikatus ir kaip jie atnaujinami',
      description: 'Stebėti pasibaigiančius sertifikatus – OIDC kliento sertifikatas aptinkamas automatiškai, OIDC kliento sertifikatas aptinkamas rankiniu būdu, kiti HTTPS prieglobos gali būti iš naujo tikrinamos tiesiogiai naudojant instrukcija.',
      refresh: 'Atnaujinti',
      addManual: 'Pridėti sertifikatą',
      editTitle: 'Redaguoti sertifikatą',
      empty: 'Joks sertifikatas dar nestebimas.',
      colName: 'Vardas',
      colStatus: 'Būsena',
      colExpires: 'Galiojimo laikas baigiasi',
      colSource: 'Šaltinis',
      colRenewal: 'Atnaujinimas',
      sourceAuto: 'Automatinis (OIDC)',
      sourceManual: 'Rankinis',
      statusOk: 'Gerai (liko {{days}} dienų)',
      statusExpiring: 'Galiojimas baigiasi po {{days}} d',
      statusExpired: 'Išvestis',
      statusUnknown: 'Nežinomas galiojimo laikas',
      bannerSummary: '{{expired}} sertifikato galiojimas baigėsi, o {{expiring}} netrukus baigsis.',
      bannerLink: 'Rodyti sertifikatų stebėjimą',
      fieldName: 'Vardas',
      fieldOrg: 'Organizacija',
      fieldCheckHost: 'HTTPS priegloba (automatinis)',
      fieldCheckHostHelp: 'Pavyzdžiui. dqfleet.deque.se – atnaujinant galiojimo pabaigos data automatiškai nuskaitoma per TLS.',
      fieldPem: 'Sertifikatas (PEM)',
      fieldPemHelp: 'Įklijuokite viešąjį sertifikatą, kad automatiškai nuskaitytumėte galiojimo datą, išdavėją ir nykščio atspaudą.',
      fieldValidTo: 'Galiojimo laikas',
      fieldWarningDays: 'Įspėti prieš dienų skaičių',
      fieldRenewal: 'Atnaujinimo instrukcija',
      fieldContact: 'Susisiekite (el. paštas)',
      fieldNotes: 'Pastabos',
      fieldActive: 'Aktyvus (stebėkite šį sertifikatą)',
      nameRequired: 'Reikalingas vardas',
      created: 'Pridėtas sertifikatas',
      updated: 'Sertifikatas atnaujintas',
      deleted: 'Sertifikatas pašalintas',
      confirmDelete: 'Pašalinti „{{name}}“?',
      refreshed: 'Nuskaitytas {{count}} sertifikatas',
      refreshedDetail: 'Atnaujintas {{oidc}} OIDC ir {{host}} HTTPS sertifikatas ({{errors}} klaida)',
      loadError: 'Nepavyko gauti sertifikato',
      saveError: 'Nepavyko išsaugoti sertifikato',
      deleteError: 'Nepavyko pašalinti sertifikato',
      refreshError: 'Nepavyko atnaujinti sertifikato',
    },
    security: {
      title: 'Sauga',
      description: 'CrowdSec įvykiai šiame serveryje, išleiskite IP ir saugių patikimų adresų sąrašą',
      loadError: 'Nepavyko gauti saugos būsenos',
      hostctlMissing: 'Neįdiegta fail2ban komanda šiame serveryje. Saugus sąrašas išsaugomas duomenų bazėje, bet draudimai ir žurnalai matomi tik tada, kai veikia ctl scenarijus.',
      fail2ban: 'fail2ban',
      crowdsec: 'CrowdSec',
      crowdsecMissing: 'CrowdSec neįdiegtas',
      eventsHint: 'Aktyvūs vietiniai draudimai rodomi viršuje. Bendruomenės blokavimo sąrašas (tūkstančiai IP) čia nerodomas.',
      localBans: '{{count}} aktyvios vietinės juostos',
      activeBansHeading: 'Aktyvios juostos',
      recentAlertsHeading: 'Naujausias signalas',
      bansMissingInList: '„CrowdSec“ turi aktyvių juostų, tačiau jų nėra sąraše. Atnaujinkite puslapį.',
      noEvents: 'Šiuo metu vietinių CrowdSec įvykių nėra',
      banActive: 'Aktyvus',
      banExpired: 'Išėjimas',
      alertOnly: 'Signalizacija (be juostos)',
      colWhen: 'Kada',
      colReason: 'Priežastis',
      colCountry: 'Šalis',
      colDetail: 'Žiniatinklis',
      colUntil: 'Būsena',
      active: 'Aktyvus',
      inactive: 'Neaktyvus',
      noBans: 'Šiuo metu nėra uždraustų IP',
      colIp: 'IP',
      colJail: 'Kalėjimas',
      unban: 'Paleisti',
      unbanOk: 'IP išleistas',
      unbanError: 'Nepavyko išleisti IP',
      safeList: 'Safelist (patikimi IP)',
      comment: 'komentuoti',
      addSafe: 'Pridėti kaip saugų',
      noSafe: 'Nėra išsaugotų patikimų IP',
      safeAddOk: 'IP pridėtas kaip saugus',
      safeAddError: 'Nepavyko pridėti IP',
      safeRemoveOk: 'IP pašalintas iš saugių sąrašo',
      safeRemoveError: 'Nepavyko pašalinti IP',
      noLogFile: 'Šiam šaltiniui žurnalo failas nerastas',
      emptyLog: 'Tuščias žurnalas',
      log: {
        fail2ban: 'fail2ban',
        ufw: 'UFW',
        crowdsec: 'CrowdSec',
        lifeline: 'Gelbėjimo linija',
      },
      scenario: {
        'ssh-bf': 'SSH brutali jėga',
        'ssh-slow-bf': 'SSH lėta brute-force',
        'ssh-time-based-bf': 'SSH išplėstinė brute-force',
        'http-bad-user-agent': 'HTTP blogas vartotojo agentas',
        'http-sensitive-files': 'HTTP jautrūs failai',
        'http-probing': 'HTTP zondavimas',
        'http-crawl-non_statics': 'HTTP tikrinimas',
        'http-path-traversal': 'HTTP kelio perėjimas',
        'http-admin-interface-probing': 'HTTP administratoriaus tikrinimas',
        'http-technology-probing': 'HTTP technologijos zondavimas',
        'http-cve-probing': 'HTTP CVE zondavimas',
        'http-generic-test': 'HTTP bendrasis testas',
      },
    },
    vehicleCarinfoSync: {
      title: 'Sinchronizuokite transporto priemones iš Car.info',
      description: 'Sinchronizuokite automobilio informaciją iš paslaugos Car.info',
    },
  },
  systems: {
    noModules: 'Nėra jokių modulių',
    selectModule: 'Norėdami tęsti, pasirinkite modulį',
  },
  deviceCommands: {
    title: 'Siųsti komandas į įrenginį',
    description: 'Pasirinkite komandas ir nusiųskite į įrenginį',
    availableCommands: 'Galimos komandos',
    selectedCommands: 'Pasirinktos komandos',
    addCommand: 'Pridėti komandą',
    removeCommand: 'Pašalinti',
    deviceImei: 'Įrenginio IMEI',
    deviceImeiPlaceholder: 'Įveskite IMEI (pvz., 869616066816375)',
    searchCommands: 'Ieškoti komandos...',
    noCommands: 'Nerasta jokių komandų',
    noCommandsSelected: 'Pasirinkite komandas iš katalogo',
    sendCommands: 'Siųsti komandas',
    sending: 'Siunčiama...',
    commandsSent: 'Komanda (-os) išsiųsta (-os).',
    errorSending: 'Nepavyko išsiųsti komandų',
    errorLoading: 'Nepavyko įkelti komandų',
    requiredParameter: 'Reikalingas parametras',
    enterImei: 'Įveskite įrenginio IMEI',
    selectAtLeastOne: 'Pasirinkite bent vieną komandą',
    searchDevicePlaceholder: 'Ieškoti IMEI arba transporto priemonės...',
    noDevicesFound: 'Nerasta jokių įrenginių',
    loadingDevices: 'Įkeliami įrenginiai...',
    loading: 'Įkeliamas...',
    sendCount: 'Siųsti {count} komandą (-as)',
    vehicleLabel: 'Transporto priemonės',
    selectOption: 'Pasirinkite...',
    booleanYes: 'Taip',
    booleanNo: 'Nr',
  },
  auditLog: {
    title: 'Mano išsiųstos komandos',
    description: 'Visų komandų ir užklausų, kurias išsiuntėte į įrenginius, žurnalas',
    dateTime: 'Data/Laikas',
    device: 'Įrenginys (IMEI)',
    command: 'komandą',
    parameters: 'Parametrai',
    status: 'Būsena',
    response: 'Atsakymas',
    showParameters: 'Rodyti parametrus',
    showResponse: 'Rodyti atsakymą',
    received: 'Gauta',
    noCommands: 'Nerasta jokių komandų',
    loading: 'Įkeliama...',
    total: 'Iš viso',
    successful: 'Sėkmingai',
    pending: 'Laukiama',
    failed: 'Nepavyko',
    devices: 'Prietaisai',
    commandTypes: 'Komandų tipai',
    filterImei: 'Ieškoti IMEI...',
    filterCommand: 'Ieškoti komanda...',
    filterStatus: 'Visos būsenos',
    filterDateFrom: 'Nuo datos',
    filterDateTo: 'Iki šiol',
    statusPending: 'Laukiama',
    statusSent: 'Išsiųsta',
    statusAcknowledged: 'Pripažino',
    statusFailed: 'Nepavyko',
    statusTimeout: 'Laiko pabaiga',
    showing: 'Rodoma',
    of: 'iš',
    previous: 'Ankstesnis',
    next: 'Kitas',
    queueStatus: 'Eilės būsena',
    lastSeen: 'Paskutinis prisijungimas',
    inQueue: 'Eilėje',
    showCount: 'Žiūrėti ({count})',
    none: 'Nr',
    deleteCommand: 'Šalinti komandą',
    justNow: 'Šiuo metu',
    minutesAgo: '{count} prieš',
    hoursAgo: 'prieš {count} valandas',
    daysAgo: 'prieš {count} dienų',
    never: 'Niekada',
  },
  migration: {
    title: 'Duomenų perkėlimas',
    description: 'Perkelkite duomenis iš senų duomenų bazių į naują sistemą',
    selectDatabase: 'Pasirinkite Duomenų bazė',
    selectMigrations: 'Pasirinkite, ką perkelti',
    migrationOrder: 'Perkėlimai vykdomi nurodyta tvarka. Pažymėkite tuos, kuriuos norite paleisti.',
    testConnection: 'Bandomasis ryšys',
    testing: 'Testuojama...',
    connected: 'Prisijungta',
    disconnected: 'Atjungtas',
    connectionSuccess: 'Prisijungimas sėkmingas',
    connectionFailed: 'Nepavyko prisijungti',
    connectionError: 'Ryšio bandymo klaida',
    errorLoadingDatabases: 'Įkeliant duomenų bazes įvyko klaida',
    selectDatabaseFirst: 'Pirmiausia pasirinkite duomenų bazę',
    selectMigrationsFirst: 'Pasirinkite bent vieną perkėlimą, kurį norite vykdyti',
    runSelected: 'Vykdyti pasirinktą',
    dryRun: 'Sausas bėgimas',
    dryRunDescription: 'Parodykite, kas būtų perkelta neišsaugojus duomenų',
    run: 'Vykdykite migraciją',
    rerun: 'Paleisti Vėl',
    running: 'Bėgimas',
    completed: 'Užbaigta',
    failed: 'Nepavyko',
    success: 'Perkėlimas pavyko: {succeeded} iš {processed} įrašų',
    error: 'Perkėlimo klaida',
    runAll: 'Vykdyti visas migracijas',
    records: 'įrašų',
    processed: 'Apdorotas',
    succeeded: 'Pavyko',
    errors: 'Klaidos',
    warnings: 'Įspėjimai',
    users: 'Vartotojai',
    usersDescription: 'Perkelti vartotojus iš senos duomenų bazės',
    organizations: 'Organizacijos',
    organizationsDescription: 'Perkelti organizacijas iš senos duomenų bazės (pirmiausia turi paleisti)',
    vehicles: 'Transporto priemonės',
    vehiclesDescription: 'Perkelkite transporto priemones iš senos duomenų bazės',
    deviceVehicleHistory: 'Įrenginio – automobilio istorija',
    deviceVehicleHistoryDescription: 'Importuoti, kai prie kurios transporto priemonės buvo prijungtas IMEI (obd_config_logger). Pirmiausia reikia paleisti transporto priemonės perkėlimą.',
    deviceOrganizations: 'Prietaisai organizacijoms',
    deviceOrganizationsDescription: 'Susiekite IMEI įrenginius su organizacijomis iš tobd. Nustato būseną CUSTOMER įrenginiuose, kurie dar nėra sumontuoti transporto priemonėje.',
    step1: 'Pasirinkite duomenų bazę',
    step2: 'Pasirinkite organizacijas',
    step3: 'Vykdykite migracijas',
    selectOrganizations: 'Pasirinkite organizacijas, kurias norite importuoti',
    selectOrganizationsDescription: 'Sąrašas sugrupuotas pagal viršutinį mazgą. Išskleiskite viršutinį mazgą, kad matytumėte, kas jam priklauso. Pavaldžios organizacijos įtraukiamos automatiškai.',
    loadingOrganizations: 'Įkeliamos organizacijos...',
    noOrganizationsFound: 'Duomenų bazėje nerasta jokių organizacijų',
    selectAll: 'Pasirinkite viską',
    deselectAll: 'Panaikinkite visų pasirinkimą',
    selectedCount: 'Pasirinkta: {count}',
    next: 'Kitas',
    back: 'Atgal',
    searchOrganizations: 'Ieškoti organizacijų...',
    selectOrganizationsFirst: 'Pasirinkite bent vieną organizaciją, kurią norite importuoti',
    children: 'vaikai',
    topNode: 'Viršutinis mazgas',
    expandAll: 'Išskleisti viską',
    collapseAll: 'Sutraukti viską',
    otherOrganizations: 'Kitos organizacijos',
    noSearchResults: 'Nėra organizacijų, atitinkančių paiešką',
    sso: 'SSO',
    mongoTripsVehicleBackfill: 'Mongo: sinchronizuoti kelionės transporto priemonės ID',
    mongoTripsVehicleBackfillDescription: 'Atnaujina MongoDB trips.vehicleId pagal aktyvius įrenginius.vehicle_id per IMEI (tas pats principas kaip trip-sync IMEI-remap). Važiuoti po transporto priemonės migracijos; paveikia visą duomenų bazę, o ne tik pasirinktą organizaciją.',
    bookingPlaces: 'Užsakymas: pristatymo vietos',
    bookingPlacesDescription: 'Sukuria pristatymo vietas iš DQBooking ir sujungia esamus automobilius bei kitus išteklius. Varomas organizacijų ir transporto priemonių. Nepaisyti atnaujinimų be dublikatų.',
    bookingUsers: 'Užsakymas: vartotojas',
    bookingUsersDescription: 'Sukuria naudotoją iš DQBooking be slaptažodžio. Jei el. pašto adresas jau yra, tas vartotojas naudojamas. Vardas ir telefonas atnaujinti. Naujiems vartotojams priskiriamas numatytasis organizacijos vaidmuo. Prisijungimo būdą pasirenka klientas ir jis taikomas visiems vartotojams. Slaptažodžiai, jau nustatyti DQFleet, neliečiami.',
    bookingBookings: 'Užsakymas: užsakymai',
    bookingBookingsDescription: 'Sukuriami užsakymai nuo 2025-01-01. Aplenkimas atnaujina tą patį užsakymą. Ištrinti užsakymai atšaukiami.',
    fuelCards: 'Degalų kortelės',
    fuelCardsDescription: 'Sujungia degalų korteles su automobiliais, kurie jau buvo importuoti. Kortelės pakeitimas išsaugomas su paleidimu ir sustabdymu. Kiti automobiliai neįtraukti.',
    preview: 'Peržiūra / patvirtinimas',
    previewing: 'Tvirtinamas...',
    previewTitle: 'Peržiūra / patvirtinimas',
    previewDescription: 'Prieš staigiai važiuodami patikrinkite pavadinimų susidūrimus, struktūrų konfliktus ir transporto priemonių grupę. Nekeičia jokių duomenų.',
    previewError: 'Peržiūros klaida',
    previewOrgs: 'Organizacijos',
    previewCollisions: 'Vardų susidūrimai',
    previewConflicts: 'Struktūriniai konfliktai',
    previewVehicles: 'Transporto priemonės (gerai / iš viso)',
    previewVehicleIssues: 'Praleistos transporto priemonės',
    previewColName: 'Vardas',
    previewColPath: 'Šaltinio o_path',
    previewColExisting: 'Esama taikinyje',
    previewColCurrentParent: 'Dabartinis tėvas',
    previewColSourceParent: 'Tėvas šaltinyje',
    previewColReg: 'Reg. ne',
    previewColImei: 'IMEI',
    previewColStatus: 'Būsena',
    previewStatusUnmapped: 'Organizacija nesusieta (praleista)',
    previewStatusNoImei: 'Trūksta IMEI (praleista)',
    previewCollisionNote: 'Tas pats pavadinimas jau yra taikinyje (skirtinga struktūra / šaltinis). Importuojant sukuriamas ATSKIRAS mazgas – nėra pavadinimų sujungimo.',
    previewNoIssues: 'Nerasta jokių problemų.',
    previewGroups: 'Grupės (yra / iš viso)',
    previewNewShort: 'naujas',
    previewGroupOverview: 'Grupės – egzistuoja sistemoje?',
    previewColInSystem: 'Sistemoje',
    previewGroupExists: 'Galima',
    previewGroupNameCollision: 'Vardas yra (kita grupė)',
    previewGroupNew: 'Trūksta – sukurta',
    previewGroupWillCreate: 'Sukurta importuojant',
    previewGroupNote: 'Grupės, pažymėtos „Trūksta – reikia sukurti“, sistemoje neegzistuoja ir yra sukuriamos importuojant. "Vardas egzistuoja (kita grupė)" = tas pats pavadinimas jau yra, bet kitame mazge.',
    previewVehiclesOtherGroup: 'Automobiliai kitoje grupėje',
    previewVehiclesOtherGroupNote: 'Šie automobiliai jau yra sistemoje, bet yra kitoje grupėje nei ta, kuriai jie turėtų būti priskirti.',
    previewVehiclesSameRegistration: 'Ta pati reg. ne',
    previewVehiclesSameRegistrationNote: 'Registracijos numeris jau yra, dažnai dėl to, kad automobilis pakeitė vienetus arba buvo sukurtas VIN apvalkalas. Importuojant atnaujinama esama transporto priemonė ir nesukuriama nauja eilutė. Papildomos eilutės su tuo pačiu registracijos numeriu ištrinamos, jei jos neturi savo padalinio. Automobiliui nebepriklausantis įrenginys perkeliamas į automobilį, kuriame jau yra IMEI.',
    previewColExistingVehicle: 'Esama transporto priemonė',
    previewColExistingImei: 'Esamas IMEI',
    previewColExtraRows: 'Papildomos linijos',
    previewColCurrentGroup: 'Dabar įsikūrusi',
    previewColTargetGroup: 'Būtų susietas su',
  },
  devices: {
    imei: 'IMEI',
    model: 'Modelis',
    currentFirmware: 'Dabartinė programinė įranga',
    fotaStatus: 'FOTA būsena',
    currentConfiguration: 'Dabartinė konfigūracija',
    gsmNumber: 'GSM numeris',
    searchPlaceholder: 'Ieškokite pagal IMEI (visą ar dalį), modelį, programinę-aparatinę įrangą, konfigūraciją arba GSM...',
    showingResults: 'Rodoma įrenginių: {count} iš {total}',
    lastSync: 'Paskutinį kartą sinchronizuota',
    lastSeen: 'Paskutinį kartą matytas',
    seenAt: 'Pamatyta',
    online: 'Prisijungę',
    offline: 'Neprisijungus',
    noResults: 'Jokie įrenginiai neatitiko paieškos',
    noDevices: 'Nerasta jokių įrenginių',
    loadCommandsError: 'Nepavyko įkelti komandų',
    loadDevicesError: 'Nepavyko įkelti įrenginių',
    sendCommandsError: 'Nepavyko išsiųsti komandų',
    simStatus: 'SIM SIM STATUSAS',
    simStatusChanged: 'SIM būsena pakeista',
    couldNotChangeStatus: 'Nepavyko pakeisti būsenos',
    statusChangeError: 'Klaida keičiant būseną',
    noSim: 'Nėra SIM',
    deviceDetailsTitle: 'Išsami įrenginio informacija',
    firmware: 'Programin? ?ranga',
    configuration: 'Konfigūracija',
    simCardJasper: 'SIM kortelė (Jasper)',
    fetchingSimStatus: 'Gaunama SIM būsena...',
    ratePlan: 'Įkainių planas',
    commPlan: 'Comm. Planuoti',
    usageThisPeriod: 'Naudokite šį laikotarpį',
    sessions: 'Sesijos',
    couldNotFetchSimStatus: 'Nepavyko gauti SIM būsenos',
    simStatusActivated: 'Aktyvuota',
    simStatusReady: 'Paruošta',
    simStatusInactive: 'Neaktyvus',
    simStatusInventory: 'Inventorius',
    simStatusRetired: 'Išėjęs į pensiją',
    simStatusTest: 'Testas',
    syncNow: 'Sinchronizuoti įrenginius dabar',
    syncStarted: 'Įrenginių sinchronizavimas pradėtas',
    syncStartedBody: 'Teltonika ir Jasper atnaujinimai vykdomi fone (gali užtrukti kelias minutes). FOTA laukai ir paskutinis sinchronizavimas atsinaujins užbaigus darbą.',
    syncForbidden: 'Neturite leidimo pradėti įrenginių sinchronizavimo.',
    syncFailed: 'Nepavyko pradėti įrenginių sinchronizavimo',
  },
  vehicles: {
    loadError: 'Nepavyko pakrauti transporto priemonių',
    deviceLink: {
      modalTitle: 'Prijunkite įrenginį prie {{reg}}',
      successTitle: 'Prietaisas prijungtas',
      successMessage: 'Prietaisas prijungtas prie {{reg}}',
      successAssigned: 'Dabar įrenginys priskirtas {{org}}',
      existingDeviceWarning: 'Transporto priemonėje jau yra įrenginys:',
      unmountToStock: 'Išardyti esamą (į sandėlį)',
      swap: 'apsikeitimas (SWAP)',
      searchPlaceholder: 'Ieškoti IMEI, modelio, ICCID...',
      filterAvailable: 'Yra (nemontuojamas)',
      filterStock: 'Atsargos',
      filterCustomer: 'Klientas',
      filterReturned: 'Sugrįžo',
      countAvailable: 'Rodomi {{count}} nemokami vienetai',
      countAvailablePaged: 'Rodoma {{shown}} iš {{total}} nemokamų vienetų',
      loadMore: 'Rodyti daugiau',
      countFilteredOrg: 'Nuosavas nemokami vienetai ir Deque sluoksniai',
      platformStock: 'Deque sluoksnis',
      assignedToOrg: 'Prisijungiant priskirta „{{org}}“.',
      noDevicesFound: 'Nerasta jokių galimų vienetų',
      loadingDevices: 'Įkeliami įrenginiai...',
      statusCurrent: 'Dabartinė',
      selectedDevice: 'Pasirinktas įrenginys:',
      deviceMountedElsewhere: 'Pastaba: įrenginys sumontuotas {{reg}} – jis bus atjungtas iš ten',
      linking: 'Jungiamasi...',
      linkButton: 'Prijunkite įrenginį prie transporto priemonės',
      statusStock: 'Atsargos',
      statusCustomer: 'Klientas',
      statusVehicle: 'Sumontuotas',
      statusReturned: 'Sugrįžo',
    },
  },
  simCards: {
    title: 'SIM kortelių valdymas',
    description: 'Tvarkykite SIM korteles, peržiūrėkite naudojimą ir kurkite ataskaitas',
    overview: 'Apžvalga',
    simCards: 'SIM kortelės',
    reports: 'Ataskaitos',
    totalSimCards: 'Iš viso SIM kortelių',
    totalDataUsage: 'Bendras duomenų naudojimas',
    totalSms: 'Iš viso SMS',
    billingCycle: 'Atsiskaitymo ciklas',
    ratePlans: 'Kainų planai',
    refresh: 'Atnaujinti',
    fetch: 'Atnešti',
    allStatuses: 'Visos būsenos',
    searchPlaceholder: 'Ieškoti ICCID, MSISDN, IMEI...',
    ratePlan: 'Įkainių planas',
    dataMB: 'Duomenys (MB)',
    activated: 'Aktyvuota',
    noSimCards: 'Nerasta SIM kortelių',
    loading: 'Įkeliama...',
    createReport: 'Sukurti ataskaitą',
    creatingReport: 'Kuriama ataskaita...',
    reportCreated: 'Sukurta ataskaita',
    latestReport: 'Naujausia ataskaita',
    deviceCount: 'Įrenginių skaičius',
    totalData: 'Iš viso duomenų',
    period: 'Laikotarpis',
    invoiceNote: 'Sąskaitų faktūrų negalima gauti automatiškai. Prisijunkite prie „Jasper Control Center“, kad atsisiųstumėte sąskaitas faktūras.',
    statusActivated: 'Aktyvuota',
    statusActivationReady: 'Paruošta',
    statusDeactivated: 'Neaktyvus',
    statusInventory: 'Inventorius',
    statusRetired: 'Išėjęs į pensiją',
    statusTestReady: 'Testas',
    statusDistribution: 'Būsenos paskirstymas',
    activatedCount: 'Aktyvuota',
    deactivatedCount: 'Išjungta',
    otherCount: 'Kita',
    lastSynced: 'Paskutinį kartą sinchronizuota',
    showingRange: 'Rodoma {start}-{end} iš {total}',
    previous: 'Ankstesnis',
    next: 'Kitas',
    createUsageReport: 'Sukurti naudojimo ataskaitą',
    createUsageReportDesc: 'Sugeneruokite apibendrintą viso dabartinio atsiskaitymo ciklo SIM kortelės naudojimo ataskaitą.',
    noteLabel: 'Pastaba:',
    fetchError: 'Nepavyko gauti duomenų',
    createReportError: 'Nepavyko sukurti ataskaitos',
  },
  geofences: {
    title: 'Geotvoros',
    subtitle: 'Tvarkyti geografines sritis',
    list: 'Geotvoros',
    create: 'Sukurkite geotvorą',
    edit: 'Redaguoti geotvorą',
    delete: 'Ištrinti geotvorą',
    noGeofences: 'Jokių geotvorų nesukurta',
    searchPlaceholder: 'Ieškoti geotvorų...',
    showSystemGeofences: 'Rodyti sistemos geotvoras',
    area: 'Plotas',
    polygonWith: 'Daugiakampis su',
    points: 'taškų',
    editPoints: 'Redaguoti taškus',
    redraw: 'Perbraižyti',
    drawPolygon: 'Žemėlapyje nubrėžkite daugiakampį',
    editModeActive: 'Redagavimo režimas aktyvus',
    dragPoints: 'Vilkite',
    redPointsToMove: 'raudonais taškais juos perkelti',
    clickGreenPoints: 'Spustelėkite žalius taškus',
    toAdd: 'pridėti naujų taškų',
    rightClickRedPoint: 'Dešiniuoju pelės mygtuku spustelėkite',
    onRedToRemove: 'ant raudono taško, kad jį pašalintumėte',
    doneBackToForm: 'Atlikta – Grįžti į formą',
    name: 'Vardas',
    description: 'Aprašymas',
    scope: 'Taikymo sritis',
    scopeGlobal: 'Pasaulinis (visos organizacijos)',
    scopeOrganization: 'Konkreti organizacija',
    organization: 'Organizacija',
    isActive: 'Aktyvus',
    alarmOnEnter: 'Signalizacija įeinant',
    alarmOnExit: 'Signalizacija išeinant',
    filterCoordinates: 'Slėpti koordinates srityje',
    isToll: 'Mokama sritis',
    costPerEntry: 'Mokestis už įėjimą (SEK)',
    costPerMinute: 'Mokestis už minutę (SEK)',
    polygonDrawn: 'Nubraižytas daugiakampis',
    finishDrawing: 'Baigti',
    cancelDrawing: 'Atšaukti',
    minPoints: 'Daugiakampis turi turėti bent 3 taškus',
    hide: 'Slėpti',
    show: 'Rodyti',
    inactive: 'Neaktyvus',
    alarmIn: 'Signalizacija įjungta',
    alarmOut: 'Signalizacija išjungta',
    activated: 'Suaktyvinta geotvora',
    deactivated: 'Geofence išjungta',
    created: 'Sukurta geotvora',
    updated: 'Atnaujinta geotvora',
    deleted: 'Ištrinta geotvora',
    errorLoading: 'Nepavyko įkelti geotvorų',
    errorSaving: 'Nepavyko išsaugoti geotvoros',
    errorDeleting: 'Nepavyko ištrinti geotvoros',
    confirmDelete: 'Ar norite ištrinti geotvorą',
    minPointsRequired: 'Reikalingi bent 3 balai',
    pointRemoved: 'Taškas pašalintas',
    pointAdded: 'Pridėtas naujas punktas',
    loadError: 'Nepavyko įkelti geotvorų',
    events: {
      title: 'Geofence Renginiai',
      subtitle: 'Peržiūrėkite visus įėjimo ir išvykimo įvykius su vieta, laiku ir kaina',
      filter: 'Filtruoti',
      vehicle: 'Transporto priemonė',
      allVehicles: 'Visos transporto priemonės',
      geofence: 'Geotvora',
      searchGeofence: 'Ieškoti geotvoros...',
      allGeofences: 'Visos geotvoros',
      geofencesMatch: 'geotvoros rungtynės',
      eventType: 'Renginio tipas',
      allTypes: 'Visų tipų',
      enter: 'Įeikite',
      exit: 'Išeiti',
      fromDate: 'Nuo datos',
      toDate: 'Iki šiol',
      clearFilters: 'Išvalyti filtrai',
      refresh: 'Atnaujinti',
      vehicleColumn: 'Transporto priemonė',
      geofenceColumn: 'Geotvora',
      eventTypeColumn: 'Tipas',
      locationColumn: 'Vieta',
      timeColumn: 'Laikas',
      durationColumn: 'Trukmė',
      costColumn: 'Kaina',
      totalCost: 'Bendra kaina',
      noEvents: 'Nerasta jokių įvykių',
      loading: 'Įkeliami įvykiai...',
      error: 'Nepavyko įkelti geotvoros įvykių',
      totalEvents: 'Iš viso įvykių',
      enterEvents: 'Įveskite įvykius',
      eventColumn: 'Renginys',
      durationInside: 'Trukmė viduje',
      exitEvents: 'Išeiti iš praėjimo',
      error404: 'Trūksta geotvoros įvykių API (404)',
      error401: 'Reikalingas autentifikavimas (401)',
      searchVehicle: 'Ieškoti transporto priemonės...',
      vehicleFallback: 'Transporto priemonės',
      showing: 'Parodos',
      of: 'iš',
      events: 'įvykius',
      page: 'Puslapis',
      vehiclesMatch: 'transporto priemonės atitinka',
    },
  },
  trips: {
    private: 'Privati ​​kelionė',
    business: 'Verslo kelionė',
    privateHidden: 'Privatus – detalės paslėptos',
    privateNoMap: 'Žemėlapio vaizdas negalimas privačioms kelionėms',
    title: 'Kelionės',
    description: 'Peržiūrėkite ir analizuokite savo transporto priemonių keliones',
    selectVehicle: 'Pasirinkite Transporto priemonė',
    selectVehiclePlaceholder: '-- Pasirinkite transporto priemonę --',
    tripsList: 'Kelionės',
    loading: 'Įkeliamos kelionės...',
    noTrips: 'Šiai transporto priemonei kelionių nerasta',
    selectVehicleFirst: 'Norėdami peržiūrėti keliones, pasirinkite transporto priemonę',
    fromDate: 'Nuo datos',
    toDate: 'Iki šiol',
    clearDateFilter: 'Išvalyti datos filtrą',
    selectTripToView: 'Pasirinkite kelionę, kurią norite peržiūrėti žemėlapyje',
    selectVehicleToView: 'Pasirinkite transporto priemonę, kurią norite užvesti',
    completed: 'Užbaigta',
    errorLoadingVehicles: 'Nepavyko pakrauti transporto priemonių',
    errorLoadingTrips: 'Nepavyko įkelti kelionių',
    speedChart: 'Greičio diagrama',
    showSpeedChart: 'Rodyti greičio diagramą',
    hideSpeedChart: 'Slėpti greičio diagramą',
    vehicleSpeed: 'Transporto priemonės greitis',
    speedLimit: 'Greičio apribojimas',
    showOverSpeed: 'Rodyti greičio viršijimą',
    overSpeed: '10 % virš ribos',
    speedUnit: 'km/val',
    playTrip: 'Žaisti',
    pauseTrip: 'Pauzė',
    resetTrip: 'Nustatyti iš naujo',
    speed: 'Greitis',
    routePointCount: 'Maršruto taškai',
    noSpeedLimitData: 'Trūksta greičio apribojimo duomenų visuose šios kelionės taškuose. Gali trūkti duomenų apie senesnes keliones arba jei OSM paslauga negalėjo gauti greičio apribojimų.',
    speedLimitRefreshHint: 'Pasibaigus kelionei, greičio apribojimai pridedami fone. Iš naujo įkelkite kelionę (perjunkite kelionę ir atgal arba atnaujinkite puslapį) po kelių sekundžių, jei jų vis dar trūksta.',
    partialSpeedLimitData: 'Greičio apribojimas pasiekiamas tik {withLimit} iš {total} taškų.',
    loadRouteError: 'Nepavyko įkelti kelionės maršruto',
    loadingRoute: 'Įkeliamas maršrutas...',
    showPointsTable: 'Rodyti taškų lentelę',
    hidePointsTable: 'Slėpti taškų lentelę',
    pointsTableTitle: 'Taškai (laikas, greitis, nuvažiuotas atstumas)',
    avl199: 'Nuvažiuotas atstumas (km)',
    time: 'Laikas',
    binData: 'Duomenų dėžės duomenys',
    binDataModalTitle: 'Bin duomenys – kelionė',
    binDataLoading: 'Įkeliami dėžės duomenys...',
    binDataFetchError: 'Nepavyko įkelti šiukšliadėžės duomenų',
    saveAsCsvColon: 'Išsaugoti kaip CSV (atskirta kabliataškiu)',
    close: 'Uždaryti',
    binDataTimestamp: 'Laiko žyma',
    binDataAvl: 'AVL',
    binDataParameter: 'Parametras',
    binDataDescription: 'Aprašymas',
    binDataValue: 'Vertė',
    alarms: 'Signalizacija',
    alarmCount: '{{count}} signalas',
    alarmCountTitle: 'Įspėjimai apie vairavimo elgesį šioje kelionėje',
    noAlarms: 'Jokių žadintuvų',
    electricShare: 'Elektros energijos dalis {{pct}} %',
    electricDistance: '{{km}} km elektrinis',
    electricShareTitle: 'Atstumo dalis važiuojant elektra ({{km}} km elektrinis)',
    jammingLegend: 'Jamming (AVL 249) – {count} GPS taškai',
  },
  eco: {
    title: 'EKO vairavimas',
    description: 'Analizuoti vairavimo įpročius ir poveikį aplinkai',
    score: 'EKO balas',
    overview: 'Apžvalga',
    events: 'Renginiai',
    trends: 'Tendencijos',
    comparison: 'Palyginimas',
    totalEvents: 'Iš viso įvykių',
    harshAcceleration: 'Stiprus pagreitis',
    harshBraking: 'Stiprus stabdymas',
    harshCornering: 'Griežtas posūkis',
    overspeed: 'Greitis',
    excessiveIdling: 'Per didelė tuščioji eiga',
    coasting: 'Pakrantė',
    greenDriving: 'Žalias vairavimas',
    fuelWaste: 'Kuro atliekos',
    fuelSaved: 'Sutaupytas kuras',
    energySaved: 'Sutaupyta energija',
    co2Emission: 'CO₂ emisija',
    scoreImpact: 'Rezultato poveikis',
    eventsPerTrip: 'Renginiai per kelionę',
    environmentImpact: 'Poveikis aplinkai',
    distributionByType: 'Pasiskirstymas pagal tipą',
    eventsPerDay: 'Renginiai per dieną',
    noEvents: 'Pasirinktu laikotarpiu įvykių nėra',
    basedOnTrips: 'Remiantis {trips} kelionių ir {events} įvykių',
    of100: 'iš 100',
    totalScoreImpact: 'Bendras balo poveikis',
    energyLoss: 'Energijos praradimas',
    estimatedExtraCo2: 'Apskaičiuota papildoma CO₂ emisija',
    estimatedFuelLoss: 'Numatomas kuro nuostolis',
    noTailpipeEmissions: 'Elektromobilis – iš transporto priemonės nėra išmetamų dujų',
    comparisonWithinOrg: 'Palyginimas jūsų organizacijoje',
    fuelLossPerDay: 'Degalų nuostoliai per dieną (ml)',
    energyLossPerDay: 'Energijos nuostoliai per dieną (kWh)',
  },
  speedCompliance: {
    title: 'Greičio laikymasis',
    description: 'Analizuoti greičio atitiktį pagal organizaciją ir transporto priemonę',
    overview: 'Apžvalga',
    organizations: 'Pagal organizaciją',
    vehicles: 'Su transporto priemone',
    trend: 'Tendencija',
    complianceRate: 'Atitiktis',
    overspeeds: 'Pažeidimai',
    trips: 'Kelionės',
    distance: 'Atstumas',
    timeOverLimit: 'Laikas viršijo limitą',
    exportExcel: 'Eksportuoti Excel',
    topOffenders: 'Dauguma pažeidimų (transporto priemonės)',
    complianceByOrg: 'Atitiktis pagal organizaciją',
    trendOverTime: 'Atitiktis laikui bėgant',
    newSystem: 'DQFleet (nauja sistema)',
    oldSystem: 'Sena Sistema',
    noLegacyConnection: 'Transporto priemonė neprisijungusi prie senos sistemos',
    tripsFound: 'rasta kelionių',
    noTripsForDate: 'Pasirinkta data kelionių nėra',
    selectVehicle: 'Pasirinkite transporto priemonę',
    loadingTrips: 'Įkeliamos kelionės...',
    loadingOldTrips: 'Įkeliamos kelionės iš senos sistemos...',
    source: 'Šaltinis',
    oldId: 'Senas ID',
    notMigrated: 'Neperkelta',
    gpsPoints: 'GPS taškai',
    totalDistance: 'Bendras atstumas',
  },
  energyConsumption: {
    title: 'Energijos suvartojimas',
    description: 'Išanalizuoti degalų sąnaudas pagal organizaciją ir transporto priemonę',
    totalVehicles: 'Iš viso transporto priemonių',
    totalDistance: 'Bendras atstumas',
    totalFuel: 'Bendras sunaudotas kuras',
    avgConsumption: 'Vidutinis suvartojimas',
    fuel: 'Degalai (L)',
    wltp: 'WLTP kombinuotas',
    consumption: 'Vartojimas',
    avgSpeed: 'Vidutinis greitis',
    fuelByOrg: 'Kuras pagal organizaciją',
    consumptionDist: 'Vartojimo paskirstymas',
    consumptionTrend: 'Vartojimo tendencija',
    distanceTrend: 'Atstumo tendencija',
    lowConsumption: 'Mažas suvartojimas',
    mediumConsumption: 'Vidutinis suvartojimas',
    highConsumption: 'Didelis suvartojimas',
  },
  jamDetection: {
    title: 'Trikdžių aptikimas',
    from: 'Nuo',
    to: 'Iki',
    refresh: 'Atnaujinti',
    markers: 'Žymekliai',
    heatmap: 'Šilumos žemėlapis',
    totalPoints: 'Trikdžių taškai',
    affectedVehicles: 'Paveiktos transporto priemonės',
    vehicle: 'Transporto priemonė',
    truncated: 'Rodoma daugiausiai 20 000 taškų – susiaurinkite datų intervalą',
    noData: 'Per laikotarpį trikdžių nėra',
    loadError: 'Nepavyko įkelti trikdžių aptikimo duomenų',
  },
  heatmap: {
    title: 'Šilumos žemėlapis',
    description: 'Vizualizuokite GPS duomenis ir greičio pažeidimus',
    organization: 'Organizacija',
    selectOrganization: 'Pasirinkite organizaciją...',
    vehicles: 'Transporto priemonės',
    selectVehicle: 'Pasirinkite transporto priemonę...',
    selectVehicleFromOrg: 'Pasirinkite transporto priemonę iš organizacijos...',
    allVehicles: 'Visi',
    allVehiclesInOrg: 'Visos transporto priemonės organizacijoje',
    vehiclesInOrg: 'transporto priemonės organizacijoje',
    fromDate: 'Nuo datos',
    toDate: 'Iki šiol',
    mode: 'Režimas',
    modeAll: 'Visi taškai',
    modeOverspeed: 'Greičio pažeidimai',
    modeIdling: 'Tuščiosios eigos / tuščiosios eigos laikas',
    modeParking: 'Parkavimas',
    modeEco: 'EKO-įvykiai / Griežtas vairavimas',
    modeTimePattern: 'Laiku pagrįsti modeliai',
    modeGeofence: 'Geo tvoros pažeidimai',
    modeIncidents: 'Nelaimingi atsitikimai / incidentai',
    modeCharging: 'Įkrovimo stotelės',
    modeRiskScore: 'Kombinuotas rizikos balas',
    timePattern: 'Laiko modelis',
    timePatternAll: 'Visus laikus',
    timePatternMorning: 'Rytas (06:00-09:00)',
    timePatternDay: 'Diena (09:00-17:00)',
    timePatternEvening: 'Vakaras (17:00-22:00)',
    timePatternNight: 'Naktis (22:00-06:00)',
    loadData: 'Įkelti duomenis',
    loading: 'Įkeliama...',
    loadingData: 'Įkeliami šilumos žemėlapio duomenys...',
    dataLoaded: 'Įkelta taškų: {count}',
    tripCount: '{count} kelionių, {points} taškų',
    errorLoadingVehicles: 'Nepavyko pakrauti transporto priemonių',
    errorLoadingData: 'Nepavyko įkelti šilumos žemėlapio duomenų',
    showInfo: 'Rodyti informaciją apie analizės režimus',
    infoTitle: 'Informacija apie analizės režimus',
    infoAll: 'Rodomi visi GPS taškai iš pasirinktų transporto priemonių per pasirinktą laikotarpį. Intensyvumas priklauso nuo taškų skaičiaus vienoje srityje.',
    infoOverspeed: 'Rodo, kur transporto priemonės viršijo greitį. Intensyvumas priklauso nuo pažeidimų skaičiaus ir didžiausio greičio viršijimo.',
    infoIdling: 'Rodo, kur transporto priemonės stovėjo su įjungtu degimu. Intensyvumas pagrįstas bendru tuščiosios eigos laiku vienoje vietoje.',
    infoParking: 'Rodo, kur baigiasi kelionės (parkavimo vietos). Kiekvienas smeigtukas žymi stovėjimo vietą 100 metrų spinduliu. Spalva priklauso nuo parkavimo kartų skaičiaus: žalia (1–2), geltona (3–5), oranžinė (6–10), raudona (11+).',
    infoEco: 'Rodo atšiaurų vairavimą (smarkus greitėjimas, stabdymas, posūkiai). Intensyvumas priklauso nuo įvykių skaičiaus ir sunkumo.',
    infoTimePattern: 'Rodo eismo modelius pagal paros laiką. Pasirinkite rytą, dieną, vakarą arba naktį, kad pamatytumėte, kada transporto priemonės yra aktyviausios.',
    infoGeofence: 'Rodo, kur transporto priemonės išvažiavo arba įvažiavo į geotvoros zonas. Intensyvumas priklauso nuo pažeidimų skaičiaus.',
    infoIncidents: 'Rodomi rimti įvykiai, pvz., panikos signalai, avarijos ar avarijos. Intensyvumas priklauso nuo incidentų sunkumo ir skaičiaus.',
    infoCharging: 'Rodo, kur buvo įkrautos transporto priemonės (EV). Remiantis ilgais sustojimais (mažiausiai 5 minutes). Intensyvumas priklauso nuo įkrovimų ir unikalių transporto priemonių skaičiaus.',
    infoRiskScore: 'Sujungia kelis rizikos veiksnius (greičio pažeidimus, ECO įvykius, incidentus), kad parodytų didelės rizikos sritis. Intensyvumas yra pagrįstas kombinuotu rizikos balu.',
  },
  heatmapImport: {
    title: 'Šilumos žemėlapio importavimas',
    selectFile: 'Pasirinkite CSV failą, kurį norite importuoti',
    fileFormat: 'Formatas: laiko žyma;platuma;ilguma;registracijos_numeris;greitis;greičio_riba',
    selectFileButton: 'Pasirinkite failą',
    uploading: 'Įkeliama...',
    uploadSuccess: 'Importuota eilučių: {valid} iš {total}',
    invalidRows: '{count} eilučių nepavyko importuoti',
    uploadError: 'Nepavyko įkelti failo',
    invalidFileType: 'Leidžiami tik CSV failai',
    fileTooLarge: 'Failas per didelis (maks. 100 MB)',
    importComplete: 'Importavimas baigtas',
    importStats: '{valid} taškai, {vehicles} transporto priemonės',
    clear: 'Aišku',
    cleared: 'Importuoti duomenys išvalyti',
    clearError: 'Nepavyko išvalyti duomenų',
    selectVehicle: 'Pasirinkite transporto priemonę...',
  },
  realtime: {
    loading: 'Įkeliamos pozicijos...',
    fetchError: 'Nepavyko gauti pozicijų realiuoju laiku',
    speed: 'Greitis',
    heading: 'Antraštė',
    ignition: 'Uždegimas',
    movement: 'Judėjimas',
    voltage: 'Įtampa',
    battery: 'Baterija',
    on: 'Įjungta',
    off: 'Išjungta',
    moving: 'Judėjimas',
    still: 'Vis tiek',
  },
  supportAdmin: {
    title: 'Palaikymo administracija',
    subtitle: 'Tvarkykite palaikymo bilietus ir sistemos pranešimus',
    openKeywin: 'KeyWin administravimas',
    openKeywinTitle: 'Atidaryti KeyWin administravimą naujame skirtuke',
    openProvisioning: 'Spintelių parengimas',
    openProvisioningTitle: 'Atidaryti spintelių parengimą (tik vidinis/VPN)',
    queue: 'Palaikymo eilė',
    broadcasts: 'Transliacijos',
    stats: 'Statistika',
    allTickets: 'Visi bilietai',
    assignToMe: 'Paskirti man',
    internalNote: 'Vidinė pastaba',
    sendReply: 'Siųsti atsakymą',
    sendBroadcast: 'Siųsti transliaciją',
    targetAll: 'Visi vartotojai',
    targetOrg: 'Konkreti organizacija',
    includeChildren: 'Įtraukti suborganizacijas',
    pinMessage: 'Prisegti pranešimą',
    newBroadcast: 'Siųsti naują transliaciją',
    sentBroadcasts: 'Išsiuntė transliacijas',
    readBy: 'skaityti',
    selectOrg: 'Pasirinkite organizaciją',
    organizationAll: 'Visos organizacijos',
    organizationExternal: 'Be organizacijos',
    priorityInfo: 'Informacija (mėlyna)',
    priorityWarning: 'Įspėjimas (geltonas)',
    priorityCritical: 'Kritinis (raudonas)',
    faq: 'FAQ',
    faqQuestion: 'Klausimas',
    faqAnswer: 'Atsakymas',
    faqQuestionPlaceholder: 'Klausimas...',
    faqAnswerPlaceholder: 'Atsakymas...',
    addToFaq: 'Pridėti prie DUK',
    markComplete: 'Pažymėti atlikta',
    ticketStatusOpen: 'Atidarytas',
    ticketStatusInProgress: 'Vykdoma',
    ticketStatusWaiting: 'Laukiama kliento',
    ticketStatusResolved: 'Išspręsta',
    ticketStatusClosed: 'Atlikta',
    addToFaqFromTicket: 'Pridėkite šį bilietą kaip DUK',
    saveToFaq: 'Išsaugoti DUK',
    newFaq: 'Nauji DUK',
    faqList: 'DUK sąrašas',
    sortOrder: 'Rūšiavimo tvarka',
    fillQuestionAnswer: 'Užpildykite klausimą ir atsakykite',
    deleteFaqConfirm: 'Ar tikrai norite ištrinti šiuos DUK?',
    deleteBroadcastConfirm: 'Ar norite ištrinti šią transliaciją?',
    searchTickets: 'Ieškoti bilieto, vardo ar el. pašto...',
    noTickets: 'Jokių bilietų',
    messageTitlePlaceholder: 'Pranešimo pavadinimas',
    categoryPlaceholder: 'pvz. Įdiegimas ir nustatymas',
    internalNoteBadge: '🔒 Vidinė pastaba',
    callTranscriptBadge: '🔒 Skambučio medžiaga – vidinė',
    callTranscriptNeverToCustomer: 'Niekada nesiunčiama klientui',
    telephonyRecordingOn: 'Skambučiai įrašomi. Transkripcija ir santrauka visada vidinės.',
    editInternalNote: 'Redaguoti vidinę pastabą',
    internalNoteUpdated: 'Vidinė pastaba atnaujinta',
    editInternalNoteError: 'Nepavyko atnaujinti vidinės pastabos',
    editedLabel: 'redaguota',
    replyEmailPlaceholder: 'Rašykite atsakymą (siunčiama el. paštu)...',
    viaEmail: 'El. paštu',
    viaChat: 'Per pokalbį',
    viaPhone: 'Telefonu',
    forwarded: 'Persiųsta',
    forwardedTo: 'Persiųsta į {{email}}',
    telephonyTab: 'Telefonija',
    telephonyNumberTitle: 'Pagalbos numeris',
    telephonyNumberHelp: 'Pasirinkite, kuris 46elks numeris priims pagalbos skambučius.',
    telephonyActiveNumber: 'Aktyvus numeris',
    telephonyActive: 'Aktyvus',
    telephonyUseNumber: 'Naudoti kaip pagalbos numerį',
    telephonyDisabled: 'Balsas išjungtas (ELKS_VOICE_ENABLED).',
    telephonyNoElksNumbers: '46elks numerių dar nėra.',
    telephonyNumberActivated: 'Pagalbos numeris įjungtas',
    telephonyAgentsTitle: 'Paieškos sąrašas',
    telephonyAgentsHelp: 'Skambutis jungiamas prie pirmo telefono. Užimtas – iškart toliau, neatsakyta – po {seconds} s.',
    callEvent: {
      incoming: 'Įeinantis skambutis',
      greeting: 'Sveikinimas grojamas',
      ringing: 'Skambina',
      busy: 'Užimta',
      noanswer: 'Neatsakyta',
      answered: 'Atsakyta',
      hangup: 'Skambutis baigtas',
      abandoned: 'Padėjo ragelį prieš atsakymą',
    },
    callState: {
      ringing: 'Vyksta',
      answered: 'Atsakyta',
      missed: 'Praleista',
      busy: 'Užimta',
      failed: 'Nepavyko',
      abandoned: 'Padėjo prieš atsakymą',
    },
    telephonySelectAgent: 'Pasirinkite asmenį',
    telephonyPhonePlaceholder: 'Mobilusis +46…',
    telephonyAgentSaved: 'Mobilusis pridėtas',
    telephonySaveError: 'Nepavyko išsaugoti',
    telephonyNoAgents: 'Nėra mobiliųjų sąraše.',
    telephonyMoveUp: 'Aukštyn',
    telephonyMoveDown: 'Žemyn',
    telephonyCallsTitle: 'Paskutiniai skambučiai',
    telephonyCallFrom: 'Iš',
    telephonyCallState: 'Būsena',
    telephonyCallAnswered: 'Atsakė',
    telephonyCallStarted: 'Pradžia',
    telephonyCallDuration: 'Trukmė',
    statsPerSource: 'Pagal šaltinį',
    statsTelephony: 'Telefonija',
    statsCallsTotal: 'Skambučiai',
    statsCallOffered: 'Skambino',
    statsCallAnswered: 'Atsakė',
    statsCallAnsweredSomeone: 'Kažkas atsakė',
    statsCallReceived: 'Priimta',
    statsCallMissedByAgent: 'Praleista',
    statsCallNobodyAnswered: 'Niekas neatsakė',
    statsCallAbandoned: 'Padėjo prieš atsakymą',
    telephonyNoticeTitle: 'Sveikinimas prieš sujungimą',
    telephonyNoticeHelp: 'Įkelkite savo WAV įrašą, kuris grojamas skambinančiajam vietoj numatytojo sintetinio balso.',
    telephonyNoticeCustom: 'Savo įrašas: {{name}}',
    telephonyNoticeDefault: 'Naudojamas numatytasis sintetinis balsas, kol įkelsite savo.',
    telephonyNoticeUpload: 'Įkelti WAV',
    telephonyNoticeReset: 'Atkurti numatytąjį',
    telephonyNoticeSaved: 'Sveikinimas išsaugotas',
    telephonyNoticeRemoved: 'Savo sveikinimas pašalintas',
    statsCallUnanswered: 'Neatsakyta',
    statsCallNotTried: 'Nejungta',
    statsCallRinging: 'Vyksta',
    statsAvgCallDuration: 'Vid. trukmė',
    statsPerCallAgent: 'Pagal asmenį sąraše',
    statsPerCallAgentHelp: 'Priimta – skambučiai, kuriuos asmuo atsiliepė. Praleista – skambino, bet neatsiliepė. Niekas neatsakė – skambučiai be atsakymo.',
    statsHandlingTab: 'Tvarkymo laikas',
    statsHandlingHelp: 'Laikas nuo tada, kai paimate užklausą, iki uždarymo ar perdavimo. Laukimas kliento atsakymo neįskaičiuojamas.',
    statsHandlingYear: 'Metai',
    statsHandlingMonth: 'Mėnuo',
    statsHandlingAllMonths: 'Visi metai',
    statsHandlingPerson: 'Asmuo',
    statsHandlingCompany: 'Visa įmonė',
    statsHandlingAvg: 'Vid. tvarkymo laikas',
    statsHandlingClosed: 'Uždaryta / perduota',
    statsHandlingWaitExcluded: 'Laukimas kliento (neįskaičiuota)',
    statsHandlingTotal: 'Bendras tvarkymo laikas',
    statsHandlingCompanyYear: 'Įmonė {{year}}',
    statsHandlingPersonYear: '{{name}} {{year}}',
    statsHandlingByPersonYear: 'Pagal asmenį, metai',
    statsHandlingByPersonMonth: 'Pagal asmenį, {{month}}',
    statsHandlingEmpty: 'Pasirinktu laikotarpiu nėra baigtų tvarkymų.',
    statsNoCallData: 'Skambučių duomenų dar nėra.',
    telephonyNoCalls: 'Skambučių dar nėra.',
    telephonyTicket: 'Užklausa',
    replyAfterStatus: 'Po atsakymo',
    replyStatusWaiting: 'Laukiama atsakymo',
    replyStatusResolved: 'Išspręsta',
    sendEmailAria: 'Siųsti el. laišką',
    sendReplyAria: 'Siųsti atsakymą',
    replySent: 'Atsakymas išsaugotas',
    replySentEmail: 'Atsakymas išsiųstas el. paštu',
    internalNoteSaved: 'Vidinė pastaba išsaugota',
    createTicketButton: 'Naujas bilietas',
    createTicketTitle: 'Sukurti bilietą rankiniu būdu',
    createTicketSubtitle: 'Skambučiams, vizitams ar laiškams, kurie nebuvo sinchronizuoti',
    createTicketName: 'Kontaktinis asmuo',
    createTicketNamePlaceholder: 'Asmens, kuriam atsakysite, vardas',
    createTicketReplyTo: 'Atsakyti',
    createTicketReplyToHint: 'Įveskite telefoną ir/arba el. paštą. Reikalingas bent vienas.',
    createTicketPhone: 'Telefonas',
    createTicketPhonePlaceholder: '070-123 45 67',
    createTicketRegNumber: 'Valst. nr.',
    createTicketRegNumberPlaceholder: 'ABC123',
    createTicketBookingNumber: 'Rezervacijos numeris',
    createTicketBookingNumberPlaceholder: 'pvz. 1812',
    createTicketEmail: 'El. paštas',
    createTicketEmailPlaceholder: 'klientas@pavyzdys.lt',
    createTicketOrg: 'Organizacija',
    createTicketOrgNone: 'Nėra / nežinoma organizacija',
    createTicketSubject: 'Tema',
    createTicketMessage: 'Aprašymas',
    createTicketMessagePlaceholder: 'Kokia problema? Įrašykite pokalbį čia.',
    createTicketAssignMe: 'Priskirti bilietą man',
    createTicketSubmit: 'Sukurti bilietą',
    createTicketSuccess: 'Bilietas sukurtas',
    createTicketError: 'Nepavyko sukurti bilieto',
    queueTab: 'Palaikymo eilė',
    partnerHandling: 'Partneris valdo',
    handlingFilter: 'Tvarko',
    handlingAll: 'Visi',
    handlingPartner: 'Partneris',
    handlingDeque: 'Deque',
    escalateToDeque: 'Perduokite į Deque',
    returnToPartner: 'Grąžinkite partneriui',
    escalateSuccess: 'Byla buvo perduota Deque',
    returnSuccess: 'Klausimas buvo grąžintas partneriui',
    partnerReplyLocked: 'Partneris tvarko bylą. Galite parašyti vidinį pranešimą, bet neatsakyti klientui.',
    transferError: 'Nepavyko perkelti bylos',
    broadcastTab: 'Transliacijos',
    broadcastSendTitle: 'Siųsti naują transliaciją',
    broadcastSentTitle: 'Išsiuntė transliacijas',
    noBroadcasts: 'Neišsiųsta jokių transliacijų',
    broadcastMessage: 'žinutė*',
    broadcastMessagePlaceholder: 'Rašyk savo žinutę...',
    broadcastTitle: 'Pavadinimas *',
    broadcastPinned: 'Prisegti pranešimą (rodomas viršuje)',
    broadcastScope: 'Tikslinė grupė',
    broadcastPriority: 'Pirmenybė',
    broadcastOrg: 'Organizacija',
    broadcastSelectOrg: 'Pasirinkite organizaciją',
    broadcastScopeAll: 'Visi vartotojai',
    broadcastScopeOrg: 'Konkreti organizacija',
    sendBroadcastButton: 'Siųsti transliaciją',
    statusAll: 'Visos būsenos',
    statusOpen: 'Atidaryti',
    statusInProgress: 'Vykdoma',
    statusWaiting: 'Laukiantis klientas',
    statusResolved: 'Išspręsta',
    statusClosed: 'Uždaryta',
    priorityAll: 'Visi prioritetai',
    priorityCritical2: 'Kritinis',
    priorityHigh: 'Aukštas',
    priorityMedium: 'Vidutinis',
    priorityLow: 'Žemas',
    ticketCountsOpen: 'Atidaryti',
    ticketCountsInProgress: 'Vykdoma',
    ticketCountsWaiting: 'Laukia',
    ticketCountsResolved: 'Išspręsta',
    unknownUser: 'Nežinoma',
    assignedTo: 'Paskirta',
    selectCategory: 'Pasirinkite kategoriją',
    categoryLabel: 'Kategorija',
    assignLabel: 'Priskirti',
    notAssigned: 'Nepriskirta',
    internalNoteLabel: 'Vidinis sąrašas',
    internalNotePlaceholder: 'Rašyti vidinį užrašą...',
    replyPlaceholder: 'Rašyti atsakymą klientui...',
    statsOverview: 'Apžvalga',
    statsTotalTickets: 'Iš viso atvejų',
    statsOpenTickets: 'Atviros bylos',
    statsResolvedTickets: 'Išspręstos bylos',
    statsAvgResponse: 'Vidutinis atsakymo laikas',
    statsMin: 'mano',
    statsPerCategory: 'Per category',
    statsPerPriority: 'Per priority',
    statsPerOrg: 'Per organization',
    statsPerAssignee: 'Per assigned',
    statsPerCategoryTab: 'Per category',
    statsOrgColumn: 'Organizacija',
    statsPersonColumn: 'Person',
    statsCategoryColumn: 'Kategorija',
    statsTotal: 'Iš viso',
    statsOpen: 'Atidaryti',
    statsResolved: 'Išspręsta',
    statsAvgTime: 'Average time',
    statsSolvePct: 'Solve rate',
    statsLoading: 'Loading statistics...',
    addCategoryTitle: 'Add category',
    categoryNameLabel: 'Name (internal) *',
    categoryNamePlaceholder: 'pvz., diegimas',
    categoryDescLabel: 'Aprašymas',
    confirmLabel: 'Patvirtinti',
  },
  chat: {
    title: 'Žinutės ir palaikymas',
    support: 'Palaikymas',
    chat: 'Pokalbis',
    broadcasts: 'Informacija',
    newTicket: 'Naujas bilietas',
    noTickets: 'Jokių bilietų',
    noBroadcasts: 'Jokių pranešimų',
    subject: 'Tema',
    phoneOptional: 'Telefonas (neprivaloma)',
    emailOptional: 'El. paštas (neprivaloma)',
    regNumberOptional: 'Valst. nr. (neprivaloma)',
    bookingNumberOptional: 'Rezervacijos numeris (neprivaloma)',
    message: 'Aprašykite savo problemą...',
    send: 'Siųsti',
    typeReply: 'Įveskite atsakymą...',
    fillAllFields: 'Užpildykite visus laukus',
    ticketCreated: 'Bilietas sukurtas',
    justNow: 'Tik dabar',
    statusOpen: 'Atidaryti',
    statusInProgress: 'Vykdoma',
    statusWaiting: 'Laukiama atsakymo',
    statusResolved: 'Išspręsta',
    statusClosed: 'Uždaryta',
    priorityLow: 'Žemas',
    priorityMedium: 'Vidutinis',
    priorityHigh: 'Aukštas',
    priorityCritical: 'Kritinis',
    chatComingSoon: 'Vidinis pokalbis netrukus!',
    chatDescription: 'Kalbėkitės su kolegomis savo organizacijoje',
    broadcastTitle: 'Sistemos pranešimai',
    markAsRead: 'Pažymėti kaip skaitytą',
    newConversation: 'Naujas pokalbis',
    noConversations: 'Jokių pokalbių',
    startConversation: 'Pradėkite naują pokalbį',
    searchUsers: 'Ieškoti vartotojų (vardas, el. paštas arba RSID)...',
    noUsers: 'Nerasta jokių vartotojų',
    noMessages: 'Pranešimų dar nėra',
    typeMessage: 'Įveskite pranešimą...',
    closeTicket: 'Pažymėti atlikta',
    ticketClosed: 'Bilietas uždarytas',
    ticketClosedByUser: 'Vartotojas uždarė bilietą.',
    ticketIsClosed: 'Šis bilietas uždarytas',
    faq: 'FAQ',
    faqSearchPlaceholder: 'Ieškoti DUK...',
    noFaqFound: 'Jokių atitikmenų',
    noFaqYet: 'Dar nepridėta jokių DUK',
    closeConversation: 'Uždaryti pokalbį',
    conversationClosed: 'Pokalbis uždarytas',
    couldNotClose: 'Nepavyko uždaryti pokalbio',
    minChars: 'Norėdami ieškoti, įveskite bent 2 simbolius',
    noUsersFound: 'Nerasta jokių vartotojų',
    searchToFind: 'Pradėkite rašyti, kad ieškotumėte vartotojų',
    partnerContactTitle: 'Susisiekite su palaikymo komanda:',
  },
  version: {
    title: 'Versija',
    fleetManagement: 'Laivyno valdymo sistema',
    currentRelease: 'Dabartinis leidimas',
    viewChangelog: 'Peržiūrėti pakeitimų žurnalą',
    releaseHistory: 'Išleidimo istorija',
    current: 'Dabartinė',
    upcoming: 'Būsimas',
    released: 'Išleista',
    unreleased: 'Nepriskirta versijai',
    noReleases: 'Nėra versijų istorijos',
    releaseAction: 'Išleisti versiją',
    releaseLoadError: 'Nepavyko apskaičiuoti kitos versijos',
    releaseSaved: 'v{{version}} išleista',
    releaseError: 'Nepavyko išleisti versijos',
    confirmLower: 'Laukiantys moduliai rodo aukštesnį lygį. Vis tiek išleisti?',
    pendingCount: '{{count}} moduliai be versijos bus įtraukti.',
    level: 'Lygis',
    releaseDate: 'Data',
    releaseTitle: 'Antraštė',
    summary: 'Trumpas tekstas',
    summaryEn: 'Trumpas tekstas (anglų k.)',
    notes: 'Punktai, po vieną eilutėje',
    bump: {
      patch: 'Patch',
      minor: 'Minor',
      major: 'Major',
    },
    release: {
      upcoming: {
        drivingLogApp: 'Vairavimo žurnalo programa',
      },
      v500: {
        newPlatform: 'Deque nauja platforma',
        dashboard: 'Tinkinamas prietaisų skydelis su nuvilkimu',
        fleet: 'Parko apžvalga su visu transporto priemonių valdymu',
        liveTracking: 'Sekimas realiuoju laiku su OSM žemėlapiais',
        reports: 'Ataskaitos (kelionės, vairavimo žurnalas, ekologiškas vairavimas, greitis, energija, nusidėvėjimas, CO2)',
        analysis: 'Analizės įrankiai (maršruto analizė, šilumos žemėlapis, avarijų aptikimas)',
        crm: 'CRM su klientų valdymu ir hierarchija',
        geofences: 'Geotvoros tvarkymas su renginiais',
        homecare: 'Priežiūros namuose modulis',
        deviceManagement: 'Įrenginių valdymas su SIM kortelėmis',
        admin: 'Administravimas (naudotojai, vaidmenys, organizacijos)',
        rbac: 'Vaidmenimis pagrįsta prieigos kontrolė (RBAC)',
        osmMaps: 'OpenStreetMap integracija',
      },
    },
  },
  scbTesting: {
    title: 'SCB API testavimas',
    description: 'Išbandykite SCB API galinius taškus ir peržiūrėkite rezultatus',
    selectEndpoint: 'Pasirinkite Endpoint',
    parameters: 'Parametrai',
    execute: 'Vykdyti Endpoint',
    executing: 'Vykdoma...',
    result: 'Rezultatas',
    success: 'Sėkmės',
    error: 'Klaida',
    responseData: 'Atsakymo duomenys',
    noResult: 'Rezultato dar nėra. Pasirinkite galinį tašką ir spustelėkite „Vykdyti galinį tašką“.',
  },
  vehicleCard: {
    refresh: 'Atnaujinkite iš Car.info',
    vehicleInfo: 'Transporto priemonės duomenys',
    engineInfo: 'Variklis ir našumas',
    dates: 'Datos',
    deviceInfo: 'Įrenginys',
    specifications: 'Specifikacijos',
    notes: 'Pastabos',
    tags: 'Papildoma informacija',
    vin: 'VIN',
    brand: 'Padaryti',
    model: 'Modelis',
    year: 'Modelio metai',
    vehicleType: 'Transporto priemonės tipas',
    fuelType: 'Kuro tipas',
    engine: 'Variklis',
    engineType: 'Variklio tipas',
    gearbox: 'Pavarų dėžė',
    horsepower: 'Galia',
    mileage: 'Rida',
    registerDate: 'Registruotas',
    manufacturedDate: 'Pagaminta',
    lastUpdated: 'Paskutinį kartą atnaujinta',
    externalVoltage: 'Išorinė įtampa',
    batteryLevel: 'Baterija',
    fuelLevel: 'Kuro lygis',
    stolenWarning: 'PRANEŠTA, kad ši transporto priemonė pavogta!',
    drivingBanWarning: 'ŠIAI TRANSPORTO PRIEMONEI TAIKOMAS VAIRAVIMO DRAUDIMAS!',
    statusActive: 'Aktyvus',
    statusMaintenance: 'Priežiūra',
    statusInactive: 'Neaktyvus',
    statusDeregistered: 'Išregistruotas',
    tabGeneral: 'Bendra informacija',
    tabEconomy: 'Ekonomika',
    tabCards: 'Kuro kortelės',
    tabSpec: 'Specifikacijos',
    tabProperties: 'Savybės',
    tabPlacement: 'Vieta',
    placement: {
      description: 'Išsaugokite, kur transporto priemonė paprastai stovi. Naudojama srities filtrams realaus laiko žemėlapyje. Įveskite adresą, pasirinkite tašką žemėlapyje arba paimkite iš GPS.',
      pickOnMap: 'Pasirinkti žemėlapyje',
      mapHelp: 'Spustelėkite žemėlapį, kad nustatytumėte vietą.',
      geocodeFromAddress: 'Gauti koordinates iš adreso',
      geocodeSuccess: 'Koordinatės gautos',
      geocodeNotFound: 'Adresas nerastas',
      geocodeError: 'Geokodavimo klaida',
      addressRequired: 'Įveskite bent adresą, pašto kodą arba miestą',
      coordinates: 'Koordinatės',
      clear: 'Išvalyti vietą',
      fromGps: 'Paimti iš GPS',
      fromGpsSuccess: 'Vieta paimta iš GPS. Spustelėkite Išsaugoti.',
      fromGpsMissing: 'Nėra dabartinės GPS pozicijos (nėra įrenginio, privati kelionė arba dar nėra duomenų)',
      fromGpsError: 'Koordinatės nustatytos iš GPS, bet adreso nepavyko rasti',
      gpsTime: 'Paskutinė GPS pozicija: {{time}}',
    },
    tabHistory: 'Istorija',
    tabBooking: 'Rezervacijos informacija',
    tabBookingBadge: 'NAUJA',
    tabNotes: 'Pastabos',
    tabAttachments: 'Priedai',
    booking: {
      banner: 'Rezervacijos nustatymai, kai transporto priemonė yra paėmimo vietos baseine. Redaguokite vietą ir baseiną skiltyje Rezervacijos.',
      sectionDescription: 'Rezervacijos aprašymas',
      descriptionHint: 'Redaguojamas tekstas rezervuojantiems darbuotojams (daugiausia 50 simbolių). Jei laukas tuščias, naudojamas valst. numeris ir pavarų dėžė.',
      charCount: '{{current}}/{{max}} simbolių',
      charCountLong: '{{current}}/{{max}} simbolių',
      sectionEmailNote: 'Pranešimas rezervacijos patvirtinime (el. paštas)',
      emailNoteHint: 'Rodoma tik el. laiške vartotojui, kai išsiunčiate kalendoriaus kvietimą / rezervacijos patvirtinimą. Iki 2000 simbolių.',
      emailNotePlaceholder: 'Papildoma informacija rezervavusiam asmeniui …',
      previewForStaff: 'Peržiūra (kaip mato rezervuojantys)',
      saveBookingDesc: 'Išsaugoti rezervacijos duomenis',
      bookingDescSaved: 'Rezervacijos duomenys išsaugoti',
      noDescription: '—',
      sectionSlot: 'Laiko langas',
      slotHint: 'Numatytas laiko langas, min./maks. rezervacija, tarpas ir rezervuojamos valandos valdomos rezervacijų modulyje pagal vietą ir kalendorių.',
      restMinutesLabel: 'Poilsio laikas tarp rezervacijų',
      restMinutesHint: 'Minutės, kurias ši transporto priemonė turi pailsėti tarp rezervacijų (pvz., elektromobilis, kurį reikia įkrauti). Tuščia = paveldėti iš baseino/organizacijos. 0 = be poilsio. Ši reikšmė pakeičia baseino/org.',
      restMinutesPlaceholder: 'Paveldėti',
      restMinutesUnit: 'minutės',
      restMinutesSave: 'Išsaugoti poilsio laiką',
      restMinutesSaved: 'Poilsio laikas išsaugotas',
      restMinutesInvalid: 'Įveskite teigiamą minučių skaičių (arba palikite tuščią)',
      sectionPoolLocker: 'Baseinas ir raktų spintelė',
      poolTitle: 'Baseinas / paėmimo vieta',
      lockerTitle: 'Raktų spintelė (Flinkey)',
      keyTagTitle: 'Rakto žyma',
      keyTagNone: 'Prie transporto priemonės neprijungta rakto žyma.',
      keyTagInHome: 'Spintelėje',
      keyTagTaken: 'Išimta',
      keyTagInOther: 'Kitoje spintelėje',
      keyTagUnknown: 'Būsena nežinoma',
      keyTagHomeCabinet: 'Namų spintelė: {{name}}',
      keyTagSlot: 'Vieta {{slot}}',
      keyTagOtherAllowed: 'Žyma gali būti kitoje spintelėje.',
      goToPickupLocations: 'Paėmimo vietos',
      goToVehiclePools: 'Transporto priemonių baseinai',
      available: 'Galima rezervuoti',
      unavailable: 'Negalima rezervuoti',
      noLockerLinked: 'Prie transporto priemonės neprijungta Flinkey dėžutė.',
      sectionBlock: 'Blokuoti transportą rezervacijai',
      blockHint: 'Nurodykite pradžią ir pabaigą. Kalendoriuje bus pilkas blokas. Persidengiančios rezervacijos lieka be priskirtos transporto priemonės ir rodomos skiltyje Susidūrimų rezervacijos (ankstesnis baseinas ir automobilis išsaugomi).',
      blockStart: 'Pradžia',
      blockEnd: 'Pabaiga',
      blockCreate: 'Blokuoti',
      blockRemove: 'Pašalinti',
      blockRemoveConfirm: 'Pašalinti šį blokavimą?',
      blockSaved: 'Blokavimas sukurtas',
      blockRemoved: 'Blokavimas pašalintas',
      blockListTitle: 'Artėjantys blokavimai',
      blockNone: 'Nėra artėjančių blokavimų.',
      blockCollisionLink: 'Susidūrimų rezervacijos →',
      openCalendar: 'Rezervacijų kalendorius',
      regHint: 'Dabartinis valst. numeris: {{reg}}',
    },
    general: {
      banner: 'Apžvalga iš Car.info (techninė apžiūra, mokesčiai) ir nuorodos iš ekonomikos, kai užpildyta.',
      sectionInspection: 'Techninė apžiūra',
      sectionTax: 'Mokesčiai',
      sectionReferences: 'Nuorodų numeriai',
      lastInspection: 'Paskutinė apžiūra',
      inspectionResult: 'Rezultatas',
      odometerAtInspection: 'Odometras apžiūros metu',
      nextInspectionDue: 'Kita apžiūra iki',
      inspectionStation: 'Apžiūros stotis',
      registeredForUse: 'Registruota naudojimui / eisme',
      emergencyVehicle: 'Avarinė transporto priemonė',
      hasDrivingBan: 'Vairavimo draudimas',
      ternaryYes: 'Taip',
      ternaryNo: 'Ne',
      ternaryNA: 'Netaikoma',
      annualVehicleTax: 'Metinis transporto priemonės mokestis',
      malus: 'Malus',
      taxationMonths: 'Mokėjimo mėnuo (-iai)',
      nextTaxDue: 'Kitas mokestis iki',
      taxDueHint: 'Mokestį reikia sumokėti iki mokėjimo mėnesio paskutinės dienos. Priminimas prieš 45 dienas.',
      taxPeriod: 'Mokesčių laikotarpis',
      noCarInfo: 'Nėra Car.info duomenų šiai transporto priemonei.',
      noTaxAttrs: 'Car.info nėra mokesčių laukų.',
      noEconomyRefs: 'Ekonomikoje dar neužpildyti nuorodų laukai.',
      ownership: 'Nuosava ar lizingas',
      leasingAgreementNo: 'Sutarties numeris (lizingas)',
      contractNo: 'Kontrakto numeris',
      costCenter: 'Išlaidų centras',
      sectionVehicleAttributes: 'Transporto priemonės detalės',
      alternativeFuel: 'Alternatyvus kuras',
      noAlternativeFuel: 'Nieko nepasirinkta',
      usageStatus: 'Būsena',
      noUsageStatus: 'Nėra statuso',
      businessResponsibility: 'Verslo atsakomybė',
      noBusinessResponsibility: 'Nieko nepasirinkta',
      businessResponsibilitySearch: 'Ieškokite RESPONSIBILITY_ID arba teksto...',
      businessResponsibilityIkpart: 'Verslo sritis',
      businessResponsibilityShowHistory: 'Žiūrėti istoriją',
      businessResponsibilityHideHistory: 'Slėpti istoriją',
      businessResponsibilityNoHistory: 'Istorijos dar nėra.',
      businessResponsibilityFrom: 'Ankstesnis',
      businessResponsibilityCleared: 'Nepažymėta',
      tempFordonsansvarigSection: 'Transporto priemonės valdytojas',
      tempFordonsansvarigRsid: 'RSID',
      tempFordonsansvarigName: 'Vardas',
      tempFordonsansvarigEmail: 'paštas',
      tempFordonsansvarigPhone: 'Telefonas',
    },
    color: 'Spalva:',
    changeDevice: 'pakeisti',
    selectDevice: 'pasirinkti',
    removeDeviceLink: 'Pašalinti įrenginio nuorodą',
    searchImei: 'Ieškoti IMEI...',
    odometerFromOem: 'Odometras paimamas iš transporto priemonės OĮG klasterio',
    distanceDriven: 'Nuvažiuotas atstumas:',
    currentOdometer: 'Dabartinis odometras:',
    saveOdometer: 'Išsaugokite odometrą',
    tripsRecalculated: 'Išsaugojus kelionės perskaičiuojamos automatiškai',
    noSpecifications: 'Specifikacijų nėra',
    noHistory: 'Istorija nepasiekiama',
    ownerChange: 'Savininko pasikeitimas',
    writeNotesHere: 'Rašykite pastabas čia...',
    unsavedChanges: 'Neišsaugoti pakeitimai',
    updateFromCarInfo: 'Atnaujinimas iš Car.info',
    tryAgain: 'Bandykite dar kartą',
    vehicleReportedStolen: 'PRANEŠTA, kad TRANSPORTO PRIEMONĖ VOGĖ!',
    userId: 'Vartotojas (ID)',
    userIdPlaceholder: 'Vartotojo ID',
    validFrom: 'Galioja nuo (neb?tina)',
    costCenter: 'Išlaidų centras',
    organizationGroup: 'Organizacija (grupė)',
    systemStatus: 'Sistemos būsena:',
    tabDevicePnP: 'Įrenginys / P&P',
    pnp: {
      globalOff: 'Plug & Play išjungtas visame pasaulyje (OBD_PROVISIONING_ENABLED≠tiesa). Konfigūruokite FMM003 bazinę liniją skiltyje Įrenginių valdymas, pasirinkite įrenginius su P&P, tada įjunkite .env.',
      baselineMissing: 'Šiam modeliui nenurodytas FW / konfigūracijos failas. Prieš suaktyvindami P&P, užpildykite pagrindinę eilutę skiltyje Įrenginių valdymas.',
      noDevice: 'Prie transporto priemonės neprijungtas joks įrenginys.',
      sectionDevice: 'Įrenginys ir programinė įranga',
      sectionProfile: 'Degalų profilis',
      sectionEye: 'AKIES parametrai',
      sectionParams: 'Nustatyti parametrus',
      paramsHint: 'Parametrai patvirtinus P&P/c. Sat = delivered in last successful step. Planuojama = įtraukta į profilį, bet dar nepatvirtinta.',
      paramId: 'ID',
      paramValue: 'Vertė',
      paramLabel: 'Reikšmė',
      paramGroup: 'Paketas',
      paramStatus: 'Būsena',
      groupIce: 'ICE',
      groupEv: 'EV / PHEV / ID.x',
      groupProblem: 'Problemų sąrašas',
      groupVin: 'VIN',
      statusApplied: 'Nustatyti',
      statusPlanned: 'Planuojama',
      statusSkipped: 'Peršoko',
      onProblemList: 'Onc / Renault Master problema NeOBD)',
      onProblemListDisable: 'Problemų sąraše (OBD-Išjungti 40000:0 / VW ID.x / BMW i4 / Mercedes)',
      problemListPending: 'Nustatymas dar nepateiktas – automobilis stovi, kol bus gautas.',
      problemListApplied: 'Nustatymas pateiktas {when}. Automobilis lieka problemų sąraše.',
      notOnProblemList: 'Neįtraukta į problemų sąrašą',
      imei: 'IMEI',
      model: 'Modelis',
      currentFw: 'Dabartinė programinė įranga',
      targetFw: 'Tikslinė programinė įranga',
      targetConfig: 'target-config',
      status: 'P&P būsena',
      fuelType: 'Degalai (transporto priemonė)',
      profile: 'Profilis',
      profileSource: 'Profilio šaltinis',
      profileIce: 'ICE',
      profilePheV: 'PHEV',
      profileEv: 'E.V',
      eyeParams: 'EYE ant įrenginio',
      eyeYes: 'Taip (aktyvios nuorodos)',
      eyeNo: 'Nr',
      eyeReset: 'Atkūrė P&P',
      eyeLinks: 'Aktyvios EYE nuorodos',
      enablePnp: 'Pažymėti kaip P&P',
      disablePnp: 'Panaikinkite P&P pasirinkimą',
      pnpEnabled: 'Įrenginys pažymėtas „Plug & Play“.',
      pnpDisabled: 'P&P atžymėtas įrenginyje',
      simulate: 'Imituoti grandinę',
      simulateDone: 'Simuliacija baigta',
      profileSaved: 'Profilis išsaugotas',
      loadError: 'Nepavyko gauti P&P būsenos',
      saveError: 'Nepavyko išsaugoti',
      runError: 'Nepavyko paleisti paruošimo',
    },
    propertiesSearchPlaceholder: 'Ieškoti visose nuosavybėse (pavadinime arba reikšmėje)…',
    propertiesSearchClear: 'Išvalyti paiešką',
    propertiesSearchNoResults: 'Nėra jūsų paiešką atitinkančių savybių.',
    propertiesSearchMatchCount: '{{count}} hitai',
    propertiesSearchMatchesInCategory: '{{count}} hitai',
    propertiesAttributeCount: '{{count}} atributas',
    propertiesBasicCategory: 'Pagrindinė informacija (Car.info)',
    propertiesExtendedCategory: 'Kita informacija (Car.info)',
    propertiesPackagesCategory: 'Įrangos paketas (Car.info)',
    propertiesTiresCategory: 'Padangos ir ratlankiai (Car.info)',
    propertiesAlertsCategory: 'Įspėjimai (Car.info)',
    historyActive: 'Aktyvus',
    historyIsCompany: 'Verslas',
    historyCompanyUrl: 'Įmonės svetainė',
    carInfoBasic: {
      brand: 'Padaryti',
      series: 'Serija',
      model: 'Modelis',
      generation: 'Karta',
      car_name: 'Automobilio pavadinimas',
      chassis: 'Važiuoklė',
      engine: 'Variklis',
      engine_type: 'Variklio tipas',
      horsepower: 'Arklio jėgos',
      engine_start_year: 'Variklis nuo metų',
      engine_end_year: 'Variklis iki metų',
      model_year: 'Metų modelis',
      trim_package: 'Įrangos lygis',
      licence_plate: 'Registracijos numeris',
      vin: 'VIN',
      vehicle_type: 'Transporto priemonės tipas',
      engine_name: 'Variklio pavadinimas',
      body_code: 'Kūno kodas',
      sales_name: 'Pardavimo pavadinimas',
      emergency_vehicle: 'Greitosios pagalbos automobiliai',
      has_driving_ban: 'Draudimas vairuoti',
      is_rebuilt: 'Atstatytas',
      milage_km: 'Skaitiklio nustatymas (Car.info)',
      is_stolen: 'Pavogtas',
      is_stolen_date: 'Pavogta, data',
      exported_date: 'Eksportavimo data',
      last_updated: 'Paskutinį kartą atnaujinta Car.info',
      is_active: 'Aktyvus registre',
      manufactured_date: 'Pagaminimo data',
      register_date: 'Registracijos data',
      pre_register_date: 'Išankstinė registracija',
      on_organization_numbers: 'Savininko organizacijos numeris',
      owned_by_company: 'Priklauso įmonei',
    },
    carInfoJson: {
      trim: 'Įrangos paketas',
      center_bore: 'Centrinė skylė',
      bolt_circle: 'Varžtų ratas',
      bolts: 'Varžtų skaičius',
      tpms: 'Padangų slėgio stebėjimas',
      tpms_type: 'Padangų slėgio stebėjimo tipas',
      tires: 'Padangų parinktys',
      front: 'Pirmyn',
      rear: 'Galinis',
      tire: 'Denis',
      rim: 'Ratlankis',
      tire_pressure: 'Padangų slėgis',
      load_index: 'Apkrovos indeksas',
      speed_rating: 'Greičio indeksas',
      warnings: 'Įspėjimai',
      errors: 'Klaida',
      message: 'Pranešimas',
      type: 'Tipas',
    },
    vehicleCategory: 'Transporto priemonės kategorija',
    noVehicleCategory: 'Nėra kategorijos',
    replacesVehicleReg: 'Pakeičia transporto priemonę (reg Nr.)',
    replacesVehicleRegPlaceholder: 'Reg Nr., kurį ši transporto priemonė pakeičia',
    viewDequeVehicleLog: 'Žiūrėti Deque žurnale',
    orgMoveTitle: 'Perkelti transporto priemones',
    orgMoveSameTopBody: 'Transporto priemonė perkeliama į pasirinktą organizaciją to paties kliento viduje. Istorija (kelionės, GPS) gali būti su transporto priemone arba likti senoje kortelėje. Sumontuotas įrenginys pateikiamas kartu su transporto priemone.',
    crossTopTitle: 'Perkelti pas kitą klientą (viršutinis mazgas)',
    crossTopBody: 'Transporto priemonė perkeliama į pasirinktą organizaciją kitame viršutiniame mazge. Flinkey ir aktyvios tanko kortelės yra atjungtos. Pasirinkite, ar turi būti įtraukta istorija ir ar įrenginys turi būti perkeltas į naują viršutinį mazgą.',
    crossTopMoveDeviceLabel: 'Ar įrenginį reikia perkelti į naują viršutinį mazgą?',
    crossTopMoveDeviceYes: 'Taip, perkelkite įrenginį',
    crossTopMoveDeviceYesHelp: 'Įrenginys įtraukiamas į naują organizaciją ir lieka pritvirtintas prie transporto priemonės.',
    crossTopMoveDeviceNo: 'Ne, palikite įrenginį',
    crossTopMoveDeviceNoHelp: 'Įrenginys išardomas ir lieka senoje organizacijoje.',
    crossTopMoveDeviceRequired: 'Pasirinkite, ar įrenginys turi būti įtrauktas.',
    crossTopKeepDataLabel: 'Laikykite duomenis su transporto priemone',
    crossTopKeepDataHelp: 'Įtraukiama ta pati transporto priemonės kortelė ir istorija (kelionės, GPS), net ir judant tame pačiame viršutiniame mazge.',
    crossTopStartFreshLabel: 'Pradėkite iš naujo',
    crossTopStartFreshHelp: 'Sukurta nauja transporto priemonės kortelė. Istorija lieka senoje kortelėje.',
    crossTopNoteLabel: 'Pastaba (neprivaloma)',
    crossTopConfirm: 'Patvirtinti judėjimą',
  },
  impersonation: {
    title: 'Perjungti į Vartotoją',
    switchUser: 'Perjungti vartotoją',
    searchPlaceholder: 'Ieškoti vartotojų...',
    noUsers: 'Nerasta jokių vartotojų',
    viewingAs: 'Žiūrima kaip',
    returnToAdmin: 'Grįžkite į savo paskyrą',
    returnButton: 'Grįžti',
    fetchError: 'Nepavyko gauti naudotojų',
    startError: 'Nepavyko pakeisti vartotojo',
    stopError: 'Nepavyko grįžti į administratorių',
    showingFirst: 'Rodoma pirmoji {{count}}',
    partnerSearchHint: 'Rodo naudotojus jūsų klientų organizacijose',
  },
  track: {
    title: 'Takelio atkūrimas',
    subtitle: 'Istorinis kelių transporto priemonių GPS sekimas',
    addVehicle: 'Pridėti transporto priemonę',
    selectVehicle: 'Pasirinkite transporto priemonę...',
    selectedVehicles: 'Pasirinktos transporto priemonės',
    timePeriod: 'Laikotarpis',
    interval: 'Intervalas',
    search: 'Ieškoti',
    noData: 'Pasirinkite transporto priemones ir laikotarpį, kad būtų rodomi takeliai',
    play: 'Žaisti',
    pause: 'Pauzė',
    stop: 'Sustok',
    reset: 'Nustatyti iš naujo',
    speed: 'Greitis',
    currentTime: 'Dabartinis laikas',
    pointsLoaded: 'GPS taškai įkelti',
    maxVehicles: 'Vienu metu galima sekti ne daugiau kaip 10 transporto priemonių',
    vehicleAlreadyAdded: 'Transporto priemonė jau pridėta',
    jammingLegend: 'Jamming (AVL 249) – {count} GPS taškai',
  },
  ai: {
    title: 'AI asistentas',
    pageTitle: 'AI analizė',
    pageDescription: 'Naudokite AI, kad analizuotumėte laivyną ir gautumėte rekomendacijų. Visi duomenys apdorojami lokaliai.',
    welcomeMessage: 'Sveiki! Galiu padėti išanalizuoti automobilių parką, paaiškinti metrikas ir pateikti rekomendacijas.',
    inputPlaceholder: 'Užduokite klausimą apie laivyną...',
    clearChat: 'Išvalyti pokalbį',
    selectOrganization: 'Norėdami pradėti analizę, pasirinkite organizaciją',
    allOrganizations: 'Visos organizacijos',
    organization: 'Organizacija',
    analyzing: 'Analizuojama...',
    runAnalysis: 'Vykdykite AI analizę',
    aiAnalysis: 'AI analizė',
    analysisResult: 'Analizės rezultatas',
    analysisError: 'Analizė nepavyko',
    fleetOverview: 'Laivyno apžvalga',
    topVehicles: 'Transporto priemonės',
    vehicleAnalysis: 'Transporto priemonių analizė',
    noVehicles: 'Nerasta transporto priemonių su duomenimis',
    status: {
      online: 'Prisijungę',
      offline: 'Neprisijungus',
      checking: 'Tikrinama...',
    },
    period: {
      label: 'Laikotarpis',
      week: 'Savaitė',
      month: 'Mėnuo',
      quarter: 'ketvirtis',
    },
    stats: {
      vehicles: 'Iš viso transporto priemonių',
      activeVehicles: 'Aktyvios transporto priemonės',
      distance: 'Bendras atstumas',
      totalKm: 'Bendras atstumas (km)',
      fuelConsumption: 'Vid. suvartojimas',
      fuelCost: 'Kuro sąnaudos',
      ecoScore: 'Ekologinis balas',
    },
    log: {
      title: 'AI žurnalas',
      description: 'Peržiūrėkite visas sistemoje pateiktas AI užklausas',
      question: 'Klausimas',
      response: 'Atsakymas',
      user: 'Vartotojas',
      organization: 'Organizacija',
      requestType: 'Tipas',
      responseTime: 'Reagavimo laikas',
      success: 'Būsena',
      createdAt: 'Laiko žyma',
      noLogs: 'AI užklausų nerasta',
      viewDetails: 'Peržiūrėkite išsamią informaciją',
      types: {
        chat: 'Pokalbis',
        analyze_vehicle: 'Transporto priemonių analizė',
        analyze_driver: 'Vairuotojo analizė',
        analyze_fleet: 'Laivyno analizė',
        compare_vehicles: 'Transporto priemonių palyginimas',
        explain_metric: 'Metrinis paaiškinimas',
      },
    },
  },
  routeAnalysis: {
    title: 'Maršruto analizė',
    pageTitle: 'Maršruto analizė – patikrinimas',
    description: 'Pasirinkite transporto priemonę ir datą. Žiūrėkite vairavimo laiką ir atstumą – palyginkite su keliui optimizuotu maršrutu (tos pačios stotelės, ta pati tvarka).',
    selectTrips: 'Pasirinkite keliones analizuoti',
    selectVehicle: 'Pasirinkite transporto priemonę',
    selectDate: 'Pasirinkite datą',
    tripsOnDate: 'Kelionės šią dieną',
    noTripsFound: 'Pasirinkta data kelionių nerasta',
    selectedTrips: 'Pasirinktos kelionės',
    selectAll: 'Pasirinkite viską',
    selectMorning: 'Pasirinkite rytą',
    selectAfternoon: 'Pasirinkite popietę',
    analyze: 'Analizuoti',
    analyzing: 'Analizuojama...',
    analyzeSelected: 'Išanalizuokite pasirinktas keliones',
    quickCompare: 'Greitas palyginimas',
    result: 'Palyginimas',
    actualRoute: 'Faktinis',
    actualRouteSubtitle: 'kaip transporto priemonė važiavo',
    optimalRoute: 'Optimizuotas maršrutas',
    optimalRouteSubtitle: 'tos pačios stotelės, ta pati tvarka',
    comparison: 'Skirtumas',
    comparisonIntro: 'Skirtumas tarp tikrojo ir pagal maršrutą optimizuoto vairavimo.',
    emptyState: 'Pasirinkite transporto priemonę ir datą, pasirinkite bent 2 keliones ir spustelėkite Analizuoti.',
    routeMapPerVehicle: 'Maršruto palyginimas pagal transporto priemonę',
    routeMapClickHint: 'Spustelėkite transporto priemonę, kad pamatytumėte žemėlapius su nuvažiuotu ir optimaliu maršrutu',
    totalDistance: 'Bendras atstumas',
    drivingTime: 'Vairavimo laikas',
    stopTime: 'Sustabdyti laiką',
    sameStopTime: 'tas pats',
    serviceTime: 'Tarnavimo laikas',
    stopCount: 'Sustojimų skaičius',
    routeOrder: 'Aplankykite užsakymą',
    freedPotential: 'Išlaisvintas potencialas',
    freedTime: 'Išlaisvintas laikas',
    freedTimeDescription: 'Atlaisvintas laikas kitoms užduotims',
    reducedDistance: 'Sumažintas atstumas',
    reducedDrivingTime: 'Sutrumpintas vairavimo laikas',
    distanceSimilar: 'Atstumas panašus',
    freedTimeUsage: 'Išlaisvintas laikas gali būti panaudotas',
    potentialExtraVisits: 'Papildomi klientų apsilankymai',
    potentialExtraTimePerStop: 'Papildomas laikas vienam klientui',
    betterService: 'Geresnis aptarnavimas',
    bufferTime: 'Buferis netikėtumams',
    economicEffect: 'Ekonominis efektas',
    fuelSavings: 'Mažesnės degalų sąnaudos',
    co2Reduction: 'CO₂ mažinimas',
    annualPotential: 'Metinis potencialas',
    annualFreedTime: 'Atlaisvintas laikas per metus',
    annualReducedDistance: 'Sumažintas atstumas per metus',
    workDaysPerYear: 'darbo dienos',
    showActualRoute: 'Rodyti tikrąjį maršrutą',
    showOptimalRoute: 'Rodyti optimalų maršrutą',
    compareRoutes: 'Palyginkite maršrutus',
    exportReport: 'Eksporto ataskaita',
    shareAnalysis: 'Pasidalinkite analize',
    vroomAvailable: 'Galimas maršruto optimizavimas',
    vroomUnavailable: 'Maršruto optimizavimas nepasiekiamas',
    minTripsRequired: 'Palyginimui reikalingos bent 2 kelionės',
    noOptimalRoute: 'Rodomi tik faktiniai vairavimo duomenys (optimalus maršrutas nepasiekiamas)',
    minutes: 'min',
    hours: 'val',
    kilometers: 'km',
    liters: 'litrų',
    sek: 'SEK',
    kg: 'kg',
    percent: '%',
    methodologyDisclaimer: 'Svarbu: „Maršrutas nuvažiuotas“ yra bendras kelionės laikas (nuo kelionės pradžios iki kelionės pabaigos) ir gali apimti laiką kiekvienoje stotelėje (pvz., apsilankymo laiką). „Optimalus maršrutas“ yra numatomas važiavimo laikas tik tarp sustojimų optimalia tvarka (maršrutas nuo A iki B). Todėl skirtumas yra teorinė viršutinė riba – prižiūrint namuose apsilankymo laiko negalima „sutaupyti“ geresniu maršrutu. Realus potencialas priklauso nuo laiko langų, apsilankymų trukmės ir nuo to, kaip apibrėžiamos kelionės.',
    methodologyNote: 'Per atstumą (pradžia → sustojimas): faktinis = atstumas ir laikas, kurį nuvažiavo transporto priemonė. Optimizuotas maršrutas = geriausias kelio atstumas ir numatomas važiavimo laikas nuo kelių tinklo. Tie patys taškai, palyginami.',
    calculatingRoute: 'Optimalus maršrutas skaičiuojamas...',
    vroomRequired: 'Šiam rodiniui reikalingas VROOM optimizavimas',
    checkingVroom: 'Tikrinama...',
    stopsCount: '{{count}} sustabdyti',
    stopsAnalyzed: '{{count}} nustoja analizuoti',
    showingTrip: 'Rodoma tripp {{num}}',
    showAllTrips: 'Rodyti visas keliones',
    showOnlyThisTrip: 'Rodyti tik šią kelionę',
    showAll: 'Rodyti viską',
    vehicles: 'transporto priemonė',
    trips: 'visiškai užkliūva',
    selected: 'išrinktas',
    expandAll: 'Išskleisti viską',
    collapseAll: 'Sutraukti viską',
    stopStart: 'Sustabdyti {{num}} (pradėti)',
    stopEnd: 'Sustabdyti {{num}} (pabaiga)',
    start: 'Pradėti',
    goal: 'CASE',
    actualRouteLabel: 'Vykdyti maršrutą (GPS iš MongoDB)',
    gpsPoints: '{{count}} GPS taškų',
    optimalRouteLabel: 'Optimalus maršrutas (VROOM)',
    points: '{{count}} taškų',
  },
  mapServices: {
    title: 'Žemėlapių paslaugos',
    liveTracking: 'Tiesioginis stebėjimas',
    liveTrackingDescription: 'Sekite transporto priemones žemėlapyje realiuoju laiku',
    track: 'Trasa',
    trackDescription: 'Istorinis GPS sekimas su kelių transporto priemonių atkūrimu',
    geofence: 'Geotvora',
    geofenceDescription: 'Tvarkyti geografines zonas ir teritorijų stebėjimą',
    heatmap: 'Šilumos žemėlapis',
    heatmapDescription: 'Vizualizuokite veiklos modelius kaip šilumos žemėlapį',
    opensInNewWindow: 'Atsidaro naujame lange',
  },
  analysis: {
    trends: {
      title: 'Tendencijos',
      description: 'Tendencijų analizė ir rida pagal lizingo sutartis',
      distance: 'Rida',
      fuelCost: 'Kuro sąnaudos',
      vsPrevious: 'Palyginti su ankstesniu laikotarpiu',
      forecastLiters: 'Prognozė kitam laikotarpiui',
      forecastHint: 'Tiesinė tendencija pagal istoriją',
      costTrend: 'Kilometrai ir kaina',
      seasonal: 'Sezoniniai svyravimai (12 mėn.)',
      behaviorTitle: 'Transporto priemonės su pakitusiu elgesiu',
      previousKm: 'Ankstesni km',
      recentKm: 'Naujausi km',
      change: 'Pokytis',
      reason: 'Priežastis',
      noBehavior: 'Nėra didelių nukrypimų nuo ankstesnio laikotarpio',
      tabTrends: 'Tendencijos',
      tabLeasing: 'Lizingo rida',
      leasing: {
        vehicle: 'Transporto priemonė',
        selectVehicle: 'Pasirinkite valstybinį numerį (neprivaloma)',
        clearVehicle: 'Rodyti visas transporto priemones',
        vehicles: 'Transporto priemonės',
        tableTitle: 'Rida pagal lizingo sutartį',
        allowed: 'Sutartyje numatyti km',
        measured: 'Išmatuoti km',
        estimatedUsed: 'Apskaičiuotas naudojimas',
        forecastEnd: 'Prognozė pabaigoje',
        delta: 'Nuokrypis',
        extraCost: 'Papildomos išlaidos',
        status: 'Būsena',
        statusOver: 'Viršijimo rizika',
        statusUnder: 'Nepanaudojimo rizika',
        statusOnTrack: 'Pagal sutartį',
        statusMissing: 'Trūksta duomenų',
        budgetLine: 'Sutarties biudžetas',
        measuredLine: 'Išmatuota',
        forecastLine: 'Prognozė (tempas)',
        rateHint: 'Prognozė grindžiama išmatuotais km per dieną tuo laikotarpiu, kai įrenginys siuntė duomenis — pradinio odometro nereikia.',
        lateInstallHint: 'Įrenginys greičiausiai sumontuotas po sutarties pradžios. Pirmi važiavimo duomenys:',
        shortHistoryHint: 'Trumpas matavimo laikotarpis — prognozė nepatikima.',
      },
    },
    benchmarks: {
      title: 'Palyginimai',
      description: 'Palyginkite padalinių ir organizacijų rezultatus',
      bestPractice: 'Geroji praktika',
      improve: 'Tobulinimo sritys',
      ranking: 'Reitingas pagal organizaciją',
      eco: 'ECO',
      lPer100: 'L/100 km',
      utilization: 'Išnaudojimas',
      drillHint: 'Spustelėkite organizaciją, kad priartintumėte jos transporto priemones.',
      vehicles: 'Transporto priemonės atrankoje',
    },
    crashDetection: {
      title: 'Avarijų aptikimas',
      description: 'Strigčių įvykių sąrašas ir vizualizacija (Crash Trace iš įrenginių).',
      regNumber: 'Registracijos numeris',
      imei: 'IMEI',
      date: 'Data',
      samples: 'Mėginiai',
      triggerCount: 'Trigeriai',
      timeSpan: 'Laiko tarpas',
      triggerPositions: '{{count}} pozicija (-os)',
      fromDate: 'Nuo datos',
      toDate: 'Iki šiol',
      imeiPlaceholder: 'Filtruoti pagal IMEI',
      noEvents: 'Nerasta jokių avarijų įvykių.',
      detailTitle: 'Avarijos įvykio duomenys',
      speedAtCrash: 'Greitis avarijos metu',
      speedAtCrashHint: 'Greitis yra nuo paleidimo momento įvykio metu.',
      xyzChart: 'Akselerometras X/Y/Z (mG)',
      xyzHint: 'Stabdymas rodomas kaip neigiamas smaigalys (pvz., Z). Šoninis judėjimas rodomas kaip Y arba X.',
      tripMap: 'Kelionė avarijos metu',
      mapTitle: 'Žemėlapis',
      speedChart: 'Greičio kreivė',
      speedChartHint: 'Greitis (km/h). Su kelionės duomenimis: ±2 min aplink įvykį. Kitu atveju: kiekvienas trigeris.',
      brakeChart: 'Stabdymo kreivė',
      brakeChartHint: 'Teigiama reikšmė = stabdymas (m/s²). Atsirado dėl greičio pasikeitimo.',
      noRouteForCharts: 'Nėra kelionės duomenų – greičio ir stabdymo kreivės reikalauja kelionės su GPS taškais.',
      speedAtEventOnly: 'Greitis įvykio metu: {{speed}} km/h. Nėra kreivės kelionės duomenų.',
    },
    stopTime: {
      title: 'Prastovos analizė - Elektros stulpų planavimas',
      description: 'Transporto priemonių sustojimo laiko analizė optimaliam įkrovimo infrastruktūros išdėstymui',
      startDate: 'Pradžios data',
      endDate: 'Pabaigos data',
      organization: 'Organizacija',
      selectOrganization: 'Pasirinkite organizaciją',
      update: 'Atnaujinti',
      loading: 'Įkeliamas...',
      totalLocations: 'Bendras vietų skaičius',
      totalHours: 'Bendras sustojimo laikas',
      totalStops: 'Bendras sustojimų skaičius',
      vehiclesAnalyzed: 'Išanalizuotos transporto priemonės',
      tabHeatmap: 'Šilumos žemėlapis',
      tabMap: 'Žemėlapis',
      emptyState: 'Norėdami peržiūrėti analizę, pasirinkite datą ir organizaciją',
    },
  },
  service: {
    title: 'Aptarnavimas',
    overview: 'Paslaugų apžvalga',
    servicePoints: 'Aptarnavimo taškai',
    addPoint: 'Pridėti aptarnavimo tašką',
    saveFailed: 'Nepavyko išsaugoti aptarnavimo taško. Bandykite dar kartą.',
    noCreatePermission: 'Neturite teisės pridėti aptarnavimo taškų.',
    syncCarInfo: 'Sinchronizuoti iš Car.info',
    noServicePoints: 'Nėra aptarnavimo punktų. Norėdami importuoti, spustelėkite „Sinchronizuoti iš Car.info“.',
    noServiceDue: 'Nėra aptarnavimo taškų, kuriuos būtų galima parodyti',
    horizonHint: 'Rodoma priežiūra per 300 km arba 60 dienas. Apžiūra rodoma 40 dienas iki termino (tik data).',
    horizonListEmpty: 'Nėra punktų per 300 km arba 60 dienų ir nėra apžiūros per 40 dienų.',
    inspectionDateOnly: 'Data',
    inspectionBookHint: 'Rezervuokite įmonėje, įveskite stotį, datą ir laiką ir patvirtinkite. Rezervacija išsaugoma iš karto. Laiškas adresu besiktning@deviaq.se retai spėja ateiti — jei ateina, laukus užpildome už jus.',
    inspectionConfirmEmailLabel: 'Kopijuoti grąžinimo adresą',
    inspectionConfirmEmailHint: 'Įklijuokite jį techninės apžiūros įmonėje kaip patvirtinimo el. paštą.',
    inspectionCopyEmail: 'Kopijuoti adresą',
    inspectionAppliesTo: 'Taikoma {reg}',
    inspectionCompare: 'Palyginti stotis (bokabesiktning.nu)',
    inspectionSwedac: 'Swedac akredituotos įmonės',
    inspectionStation: 'Stotis',
    inspectionStationPlaceholder: 'Pvz. Malmö Innerstaden',
    inspectionBookingTime: 'Laikas',
    inspectionOpenedHint: 'Rezervacijos puslapis atidarytas naujame skirtuke. Įveskite stotį, datą ir laiką ir patvirtinkite — tada rezervacija išsaugoma.',
    inspectionWaitingEmail: 'Laiškas retai spėja ateiti kol laukiate. Įveskite duomenis ir patvirtinkite, kad rezervacija būtų išsaugota.',
    inspectionFilledFromEmail: 'Duomenys užpildyti iš patvirtinimo laiško.',
    inspectionBookedFromEmail: 'Apžiūra rezervuota pagal patvirtinimo laišką.',
    inspectionCompanyRequired: 'Pasirinkite techninės apžiūros įmonę.',
    inspectionStationRequired: 'Įveskite rezervuotą stotį.',
    inspectionDateRequired: 'Įveskite rezervacijos datą.',
    inspectionBookFailed: 'Nepavyko išsaugoti rezervacijos. Bandykite dar kartą.',
    totalActions: 'Iš viso veiksmų',
    vehicles: 'transporto priemonių',
    actions: 'veiksmus',
    searchPlaceholder: 'Ieškoti transporto priemonių, paslaugų...',
    allStatuses: 'Visos būsenos',
    interval: 'Intervalas',
    nextDue: 'Kitas terminas',
    lastPerformed: 'Paskutinis atliktas',
    reminder: 'Priminimas',
    booking: 'Užsakymas',
    bookingInfo: 'Užsakymo informacija',
    bookingDate: 'Užsakymo data',
    book: 'Knyga',
    bookedFor: 'Užsakyta',
    confirmBooking: 'Patvirtinti rezervaciją',
    markComplete: 'Pažymėti kaip užbaigtą',
    confirmComplete: 'Pažymėti kaip užbaigtą',
    performedDate: 'Atlikimo data',
    performedKm: 'Odometras (km)',
    cost: 'Mokestis (SEK)',
    notes: 'Pastabos',
    history: 'Istorija',
    editReminder: 'Priminimas',
    updateReminder: 'Atnaujinti priminimą',
    warningKm: 'Įspėti (prieš km)',
    warningDays: 'Įspėti (prieš dienas)',
    workshopLabel: 'Dirbtuvė',
    noWorkshop: '-- Pasirinkite dirbtuvę --',
    days: 'dienų',
    intervalKm: 'Intervalas (km)',
    intervalMonths: 'Intervalas (mėnesiais)',
    existingType: 'Esamas tipas',
    customType: 'Pasirinktinis tipas',
    selectType: 'Pasirinkite paslaugos tipą',
    chooseType: '-- Pasirinkite --',
    typeName: 'Paslaugos tipo pavadinimas',
    categoryLabel: 'Kategorija',
    categoryCustom: 'Pasirinktinis',
    categoryMaintenance: 'Priežiūra',
    lastPerformedDate: 'Paskutinį kartą atlikta (data)',
    lastPerformedKm: 'Paskutinį kartą atliktas (km)',
    status: {
      ok: 'Gerai',
      warning: 'Greitai',
      overdue: 'Pavėluota',
      booked: 'Užsakyta',
      completed: 'Užbaigta',
    },
    attachments: {
      title: 'Priedai',
      noAttachments: 'Neįkelta jokių priedų',
      uploadHint: 'Spustelėkite „Įkelti“, kad pridėtumėte failus',
      upload: 'Įkelti',
      uploading: 'Įkeliama...',
      descriptionOptional: 'Aprašymas (nebūtina)',
      descriptionPlaceholder: 'Pvz. Patikrinimo aktas 2026 m',
      all: 'Visi',
      categoryInsurance: 'Draudimas',
      categoryInspection: 'Apžiūra',
      categoryDamage: 'Žala',
      categoryInvoice: 'Sąskaita faktūra',
      categoryContract: 'Sutartis',
      categoryService: 'Aptarnavimas',
      categoryOther: 'Kita',
    },
    tires: {
      title: 'Padangos',
      add: 'Pridėti',
      addNew: 'Naujas padangu komplektas',
      type: 'Padangos tipas',
      brand: 'Prekės ženklas',
      model: 'Modelis',
      size: 'Dydis',
      treadDepth: 'Protektoriaus gylis',
      storageType: 'Sandėliavimo tipas',
      storageLocation: 'Vieta',
      storage: 'Sandėliavimas',
      summer: 'Vasarinės padangos',
      winterFriction: 'Žieminės padangos (trinties)',
      winterStudded: 'Dygliuotos padangos',
      hotel: 'Padangų viešbutis',
      installed: 'Įdiegta',
      stored: 'Saugoma',
      other: 'Kita',
      installedSince: 'Įdiegta nuo',
      mount: 'Įdiegti',
      unmount: 'Pašalinti',
      save: 'Išsaugoti',
      none: 'Padangos neregistruotos',
      manage: 'Tvarkyti padangas',
      edit: 'Redaguoti padangą',
      noTireInfo: 'Padangų informacija nerasta',
      lastChanged: 'Paskutinis pakeitimas',
      currentTires: 'Sumontuotos padangos',
      tireChangeSection: 'Padangų informacija (registruojama keičiant)',
      newTires: 'Naujos padangos',
      newTiresHint: 'Pažymėkite naujas padangas. Protektoriaus gylis ir odometras išsaugomi kaip pradžia, o padangos sumontuojamos.',
      allFour: 'Visos keturios',
      frontAxle: 'Priekinė ašis',
      rearAxle: 'Galinė ašis',
      clearNew: 'Nėra naujų',
      mountTread: 'Protektoriaus gylis montuojant',
      mountTreadRequired: 'Įveskite protektoriaus gylį (0–20 mm) kiekvienai naujai padangai',
      newBadgeAll: 'Naujos padangos',
      newBadgeFront: 'Naujos: priekinė ašis',
      newBadgeRear: 'Naujos: galinė ašis',
      newBadgePositions: 'Naujos: {{positions}}',
      minTread: 'Mažiausias protektoriaus gylis',
      changeHistory: 'Pakeitimų istorija',
      noHistory: 'Padangų pakeitimų dar neregistruota',
      removed: 'Nuimta',
      installedNew: 'Sumontuota',
      kmDriven: 'Nuvažiuoti km ant nuimtų padangų',
      odometerAtChange: 'Odometro rodmuo keičiant',
      treadWorn: 'Susidėvėjimas pagal ratą (mm)',
      treadWornAvg: 'Vidutinis susidėvėjimas',
      treadDepthVf: 'KP (Kairė Priekis)',
      treadDepthHf: 'DP (Dešinė Priekis)',
      treadDepthVb: 'KG (Kairė Galas)',
      treadDepthHb: 'DG (Dešinė Galas)',
      treadDepthMm: 'mm',
      treadDepthSection: 'Protektoriaus gylis pagal rato padėtį',
      treadDepthAutoMin: 'Mažiausia vertė automatiškai išsaugoma kaip blogiausias rašto gylis',
      treadDepthLabel: 'Rašto gylis',
      storageHotel: 'Tyre viešbutis',
      storageStorage: 'Sandėlis',
      storageVehicle: 'Ant transporto priemonės',
      storageOther: 'Kita',
    },
    viewList: 'Sąrašas',
    viewCalendar: 'Kalendorius',
    viewCosts: 'Išlaidos',
    internal: 'Vidinis',
    responsible: 'Atsakingas už techninę priežiūrą',
    selectResponsible: 'Pasirinkite atsakingą asmenį...',
    category: {
      all: 'Visos kategorijos',
      tire: 'Padangų keitimas',
      maintenance: 'Techninė priežiūra',
      inspection: 'Apžiūra',
      custom: 'Kita',
    },
    filter: {
      allStatuses: 'Visos būsenos',
    },
    bulk: {
      selected: 'pažymėta',
      action: 'Atlikti su pažymėtais',
      title: 'Atlikti techninės priežiūros taškus',
      points: 'taškai',
      book: 'Rezervuoti',
      complete: 'Pažymėti kaip atliktus',
      bookingDate: 'Rezervavimo data',
      performedDate: 'Atlikimo data',
      totalCost: 'Bendra kaina',
      costNote: 'taikoma visai grupei',
      confirmBook: 'Patvirtinti rezervaciją',
      confirmComplete: 'Pažymėti kaip atliktus',
    },
    calendar: {
      title: 'Techninės priežiūros kalendorius',
      regNr: 'Valst. numeris',
      type: 'Tipas',
      station: 'Stotis',
      place: 'Vieta',
      time: 'Laikas',
      workshop: 'Dirbtuvė',
      due: 'Terminas',
      note: 'Pastaba',
    },
    workshop: {
      create: 'Sukurti dirbtuvę',
      edit: 'Redaguoti dirbtuvę',
      name: 'Pavadinimas',
      type: 'Tipas',
      extern: 'Išorinė',
      intern: 'Vidinė',
      internalPerson: 'Vidinis asmuo (techninės priežiūros personalas)',
      selectPersonnel: '-- Pasirinkite techninės priežiūros personalą --',
      noPersonnelHint: 'Techninės priežiūros personalo nerasta. Pridėkite vaidmenį per Kontaktų vaidmenis.',
      contactPerson: 'Kontaktinis asmuo',
      address: 'Adresas',
      city: 'Miestas',
      phone: 'Telefonas',
      email: 'El. paštas',
      listTitle: 'Dirbtuvės',
      listDescription: 'Tvarkykite dirbtuves ir techninės priežiūros personalą',
      searchPlaceholder: 'Ieškoti pavadinimo, miesto ar kontakto',
      empty: 'Dirbtuvių dar nėra',
      loadError: 'Nepavyko įkelti dirbtuvių',
    },
    invoice: {
      upload: 'Įkelti sąskaitą faktūrą (PDF/vaizdas) AI interpretavimui',
      uploadShort: 'Įkelti',
      parsed: 'AI interpretavo sąskaitą faktūrą',
      supplier: 'Tiekėjas',
      number: 'Sąskaitos nr.',
      total: 'Iš viso',
      vat: 'PVM',
    },
    costs: {
      month: 'Mėnesis',
      category: 'Kategorija',
      categoryName: 'Kategorijos pavadinimas',
      totalSek: 'Kaina (kr)',
      serviceCount: 'Kiekis',
      grandTotal: 'Bendra kaina',
      monthlyChart: 'Kaina per mėnesį',
      exportExcel: 'Eksportuoti Excel',
      noData: 'Nėra išlaidų duomenų pasirinktam laikotarpiui',
      reportPageTitle: 'Paslaugų kainos',
      reportSubtitle: 'Išlaidos pagal kategoriją ir laikotarpį',
    },
    autoTire: {
      title: 'Automatinis padangų servisas',
      description: 'Automatiškai kurkite techninės priežiūros taškus žieminėms ir vasarinėms padangoms pagal švediškas taisykles.',
      enable: 'Įjungti automatinį padangų servisą',
      enableHint: 'Sukuria techninės priežiūros taškus visiems transporto priemonėms nurodytą dienų skaičių prieš terminą.',
      winterDeadline: 'Žieminės padangos – sumontuoti ne vėliau kaip',
      summerDeadline: 'Dygliuotos/žieminės – nuimti ne vėliau kaip',
      winterHint: 'Iki šios datos žieminės padangos turi būti sumontuotos (pagal Susisiekimo inspekciją: gruodžio 1 d.)',
      summerHint: 'Iki šios datos dygliuotos ir žieminės padangos turi būti nuimtos (pagal Susisiekimo inspekciją: balandžio 15 d.)',
      advanceDays: 'Dienų iš anksto',
      advanceDaysUnit: 'dienų',
      advanceDaysHint: 'Dienų skaičius prieš terminą, kai sukuriamas techninės priežiūros užsakymas. Numatytasis: 60 dienų (2 mėnesiai).',
    },
    allPointsHint: 'Rodo visus techninės priežiūros taškus transporto priemonėje ir kada jie turi būti atlikti.',
    intervalHint: 'Įveskite bent vieną diapazoną – km, laiką (mėnesį) arba abu.',
  },
  vehicleEconomy: {
    leasing: 'Lizingas',
    ownershipType: 'Nuosava ar lizingas',
    ownershipHint: 'Paimama iš Car.info (lizingas pradėtas/baigtas). Statusą galite pakeisti čia.',
    insurance: 'Draudimas',
    disposal: 'Nurašymas',
    disposalType: 'Tipas',
    disposalTypeSale: 'Pardavimas',
    disposalTypeReturn: 'Grąžinimas',
    disposalNotes: 'Pastaba',
    saveSuccess: 'Ekonomika išsaugota',
    agreementNo: 'Sutartis Nr',
    contractNo: 'Sutartis Nr',
    leasingCompany: 'Lizingo kompanija',
    insuranceCompany: 'Draudimo bendrovė',
    vehicleSupplier: 'Transporto priemonių tiekėjas',
    addVehicleSupplier: 'Pridėti tiekėją…',
    newVehicleSupplierPlaceholder: 'Tiekėjo pavadinimas',
    vehicleSupplierCustomerHint: 'Išsaugoma klientui ir galima pasirinkti kitoms transporto priemonėms.',
    supplierSaveFailed: 'Nepavyko išsaugoti tiekėjo',
    rentStart: 'Nuomos pradžia',
    rentEnd: 'Nuomos pabaiga',
    costMonthLeasing: 'Lizingas kas mėnesį',
    costMonthMaintenance: 'Priežiūros sutartis kas mėnesį',
    allowedDistance: 'Leidžiamas km',
    costPerExtraKm: 'Mokestis už papildomą km',
    costCenter: 'Išlaidų centras',
    costCenterLeasing: 'Išlaidų centras (lizingas)',
    costCenterInsurance: 'Išlaidų centras (draudimas)',
    costCenterTax: 'Išlaidų centras (mokestis)',
    costCenterTaxMalus: 'Išlaidų centras (malusas)',
    insuranceStartDate: 'Pradžios data',
    insuranceEndDate: 'Pabaigos data',
    insuranceAgreementNo: 'Sutartis',
    costMonthInsurance: 'Mėnesio išlaidų draudimas',
    costMonthTax: 'Mėnesio išlaidų mokestis',
    costMonthTaxMalus: 'Mėnesio išlaidų mokesčių malusas',
    insuranceImportHistory: 'Istorija (Protector importas)',
    insHistoryPeriod: 'Laikotarpis (pabaigos data)',
    insHistoryAgreement: 'Sutartis',
    insHistoryTrafficTotal: 'Eismo iš viso',
    insHistoryDelkasko: 'Dalinis kaskas',
    insHistoryVagnskada: 'Susidūrimas',
    insHistoryPremiumYear: 'Suma',
    insHistoryTotal: 'Iš viso',
    insHistoryCostMonth: 'Mėnesinė',
    disposalDate: 'Išmetimo data',
    disposalSaleAmount: 'Pardavimo suma',
    disposalExtraCosts: 'Papildomos išlaidos už šalinimą',
    exportTitle: 'Eksporto transporto priemonių ekonomika',
    exportDescription: 'Pasirinkite organizaciją ir laikotarpį. Eksportas naudoja importuotas sąnaudų eilutes ir sukuria Unit4 failą.',
    period: 'Laikotarpis (metai-mėnuo)',
    exportBokforing: 'Buhalterinės apskaitos pagrindai (Unit4)',
    exportBokforingDesc: 'CSV pagal Unit4 kodų planą, agreguota pagal sąskaitą ir atsakomybę.',
    exportFakturering: 'Sąskaitų faktūrų išrašymo pagrindas (Unit4)',
    exportFaktureringDesc: 'CSV su vidine sąskaita (debetas/kreditas) pagal transporto priemonę ir sąnaudų tipą.',
    exportSelectOrg: 'Pasirinkite organizaciją, kad sukurtumėte failą.',
    exportError: 'Nepavyko atsisiųsti eksportavimo.',
    costInvoiceLines: 'Importuotos sąskaitos eilutės',
    costInvoiceSummary: 'Importuotos išlaidos',
    costInvoiceSummaryMeta: '{{count}} eilutės · laikotarpis {{period}}',
    costInvoiceSummaryCount: 'Eilutės',
    costInvoiceSummaryTotal: 'Iš viso',
    costInvoiceDate: 'Sąskaitos data',
    costInvoiceNumber: 'Sąskaitos nr.',
    costInvoiceCategory: 'Išlaidų tipas',
    costInvoiceDescription: 'Aprašymas',
    costInvoiceAmount: 'Suma be PVM',
    termMonths: 'Sutarties laikotarpis (mėnesiais)',
    leasingProduct: 'Produktas',
    originalBasePrice: 'Ursp bazinė kaina',
    bookValue: 'Buhalterinė vertė',
    guaranteedResidualValue: 'Garantuota likutinė vertė',
    importHistory: 'Istorija (Nordea importas)',
    readOnlyDeque: 'Žiūrėjimo režimas – galite peržiūrėti importuotus nuomos duomenis, bet neturite leidimo redaguoti finansų.',
    historyPeriod: 'Laikotarpis (data iki)',
    historyInvoice: 'Sąskaita Nr',
    historyPer: 'Per',
  },
  costInvoice: {
    title: 'Išlaidų sąskaitų importas',
    cardDescription: 'Importuokite Ayvens sąskaitas ir susiekite išlaidų tipus',
    description: 'Importuokite mišrias transporto priemonių išlaidas iš lizingo bendrovių (pvz. Ayvens). Susiekite kodus ir įkelkite failus arba visą aplanką. Kiekvienas failas importuojamas tik vieną kartą.',
    uploadTitle: 'Įkelti failus',
    uploadHint: 'Pasirinkite Excel failus (.xlsx) arba aplanką. Tas pats turinys importuojamas tik vieną kartą organizacijoje. Kuro kortelių eilutės pagal nutylėjimą išjungtos.',
    selectFiles: 'Pasirinkti failus',
    selectFolder: 'Pasirinkti aplanką',
    mappingTitle: 'Išlaidų tipų susiejimas (Ayvens)',
    mappingHint: 'Tiekėjo kodas susiejamas su DQFleet išlaidų tipu. Nuimkite Inkluduoti, jei eilutės neturėtų būti saugomos.',
    saveMapping: 'Išsaugoti susiejimą',
    mappingSaved: 'Susiejimas išsaugotas',
    mappingSaveError: 'Nepavyko išsaugoti susiejimo',
    importHistory: 'Ankstesni importai',
    noImports: 'Importų dar nėra',
    colFilename: 'Failo vardas',
    colInvoiceDate: 'Sąskaitos data',
    colRows: 'Eilutės',
    colImported: 'Importuota',
    colSkipped: 'Praleista',
    colUnmapped: 'Nesusieta',
    colUnmatched: 'Nežinomi numeriai',
    colImportedAt: 'Importuota',
    colSourceCode: 'Kodas',
    colSourceLabel: 'Tiekėjo tipas',
    colCategory: 'DQFleet tipas',
    colInclude: 'Įtraukti',
    loadError: 'Nepavyko įkelti importo ar susiejimo',
    importError: 'Importas nepavyko',
    importTimeout: 'Importas užtruko per ilgai. Bandykite po vieną failą.',
    fileTooLarge: 'Failas per didelis serveriui (nginx). Paprašykite admin padidinti client_max_body_size.',
    importSuccess: 'Importas baigtas {{count}} failui(-ams)',
    duplicateFiles: '{{count}} failas(-ai) jau importuoti',
    noSpreadsheetFiles: 'Aplanke nebuvo .xls/.xlsx failų',
    unmappedCodesHint: 'Nesusieti kodai: {{codes}} — papildykite susiejimą ir importuokite dar kartą',
    autoMappedHint: 'Nauji kodai susieti automatiškai: {{codes}}. Patikrinkite lentelę, jei reikia pakeisti.',
    createdVehiclesHint: '{{count}} trūkstamos transporto priemonės sukurtos viršutinėje organizacijoje ir gautos iš car.info',
    carInfoFailedHint: '{{count}} transporto priemonės sukurtos, bet car.info nepavyko užpildyti',
  },
  ayvensFuel: {
    title: 'Ayvens kuro kortelės (rankinis importas)',
    description: 'Įkelkite Ayvens „Bränslekort, detaljer“. Operacijos saugomos kaip Ayvens. Jei tas pats pylimas jau yra Circle K, OKQ8 ar kitoje įmonėje, eilutė žymima kaip dublikatas — tai gali reikšti dvigubą sąskaitą.',
    selectFiles: 'Pasirinkti kuro failą',
    importSuccess: 'Importuota {{count}} kuro eilučių',
    duplicateHint: '{{count}} eilutės pažymėtos kaip kitos įmonės dublikatai',
    nothingImported: 'Naujų eilučių nėra (failas jau galėjo būti importuotas)',
    importError: 'Ayvens kuro importas nepavyko',
  },
  vehicleCostAnalysis: {
    title: 'Transporto priemonių ekonomika',
    cardDescription: 'Analizuokite importuotas išlaidas pagal organizaciją, grupę ir automobilį',
    description: 'Pasirinkite organizaciją arba grupę ir matykite visus automobilius suvestus. Pažymėkite vieną ar kelis automobilius, kad analizuotumėte išlaidų tipus ir sąskaitų eilutes.',
    totalCost: 'Bendra suma',
    vehiclesWithCost: 'Automobiliai su išlaidomis',
    lineCount: 'Eilutės',
    unmatched: 'Nesutapatinta (nežinomas numeris)',
    groupBreakdown: 'Išlaidų tipai grupėje',
    vehiclesTitle: 'Grupės automobiliai',
    onlyWithCosts: 'Rodyti tik automobilius su išlaidomis',
    clearSelection: 'Išvalyti pasirinkimą',
    noVehicles: 'Pasirinktoje grupėje nėra transporto priemonių',
    selectionTitle: '{{count}} pasirinkto(-ų) automobilio(-ių) analizė',
    selectedVehicles: 'Pasirinkti automobiliai',
    selectionBreakdown: 'Išlaidų tipai pasirinkimui',
    linesTitle: 'Sąskaitų eilutės',
    noLines: 'Pasirinkimui šiuo laikotarpiu nėra sąskaitų eilučių',
    colReg: 'Numeris',
    colVehicle: 'Transporto priemonė',
    colOrg: 'Organizacija',
    colLines: 'Eilutės',
    colTotal: 'Suma be PVM',
    colCategory: 'Išlaidų tipas',
    colInvoiceDate: 'Sąskaitos data',
    colInvoiceNumber: 'Sąskaitos nr.',
    colDescription: 'Aprašymas',
    colAmount: 'Suma be PVM',
    loadError: 'Nepavyko įkelti išlaidų suvestinės',
    tabs: {
      overview: 'Apžvalga',
      vehicles: 'Automobiliai',
      analysis: 'Analizė',
    },
    goToAnalysis: 'Analizuoti pasirinktus',
    selectVehiclesHint: 'Pažymėkite vieną ar kelis automobilius skiltyje Automobiliai, kad juos analizuotumėte.',
  },
  contractDocument: {
    title: 'Sutarčių patvirtinimai (PDF)',
    description: 'Įkelkite Ayvens patvirtinimus. DI nuskaito vairuotoją, sutartį ir lizingo laukus. PDF pridedamas prie automobilio, o reikšmės įrašomos į ekonomiką.',
    selectFiles: 'Pasirinkti PDF failus',
    selectFolder: 'Pasirinkti aplanką',
    noPdfFiles: 'Aplanke nebuvo PDF failų',
    noImports: 'Sutarčių dokumentų dar nėra',
    loadError: 'Nepavyko įkelti sutarčių dokumentų',
    importError: 'Sutarčių importas nepavyko',
    importSuccess: 'Importuota {{count}} sutarties dokumentas(-ai)',
    unmatchedHint: '{{count}} failas(-ai) nesutapatinti su transporto priemone',
    attachedHint: '{{count}} PDF pridėtas(-i) prie transporto priemonių',
    aiSkipped: 'DI serveris neatsakė — numeris ir pagrindiniai laukai vis tiek nuskaityti iš failo',
    duplicateFile: '{{name}} jau importuotas',
    colFilename: 'Failo vardas',
    colReg: 'Numeris',
    colDriver: 'Vairuotojas',
    colContract: 'Sutartis',
    colStart: 'Pradžia',
    colEnd: 'Pabaiga',
    colAi: 'DI',
  },
  booking: {
    title: 'Užsakymas',
    pickupLocations: 'Paėmimo vietos',
    pickupLocationsTitle: 'Paėmimo vietos',
    pickupLocationsDescription: 'Po Rezervacijomis: transporto priemonių paėmimo ir grąžinimo vietos',
    pickupLocationMapShow: 'Rodyti atsiėmimo vietą žemėlapyje',
    pickupLocationMapTitle: 'Atsiėmimo vieta žemėlapyje',
    pickupLocationMapNoAddress: 'Adresas nenurodytas.',
    pickupLocationMapNoCoords: 'Šiai vietai nėra žemėlapio.',
    addPickupLocation: 'Pridėti paėmimo vietą',
    editPickupLocation: 'Redaguoti atsiėmimo vietą',
    noPickupLocations: 'Nėra paėmimo vietų. Pridėkite vieną, kad pradėtumėte.',
    pickupTopNodeFilter: 'Aukščiausias mazgas',
    pickupTopNodePlaceholder: 'Pasirinkite aukščiausią mazgą',
    pickupTopNodeAll: 'Visi klientai',
    pickupChooseTopNode: 'Pasirinkite aukščiausią mazgą, kad matytumėte to kliento paėmimo vietas.',
    noPickupLocationsCalendar: 'Paėmimo vietų nesukurta. Atverkite Rezervacijas ir pasirinkite paėmimo vietas, kad sukurtumėte baseinus ir pridėtumėte transporto priemonių.',
    goToPickupLocations: 'Atverti rezervacijas',
    pickupLocationActiveLabel: 'Aktyvi (rodoma rezervacijose ir baseinuose)',
    pickupLocationActiveHelp: 'Nuėmus žymėjimą vieta bus deaktyvuota. Ateities užsakymai su būsena Užsakyta, vis dar turintys transportą iš šio baseino, praras priskyrimą ir bus rodomi skyriuje Susidūrimų rezervacijos.',
    pickupBookingsLockedLabel: 'Matoma, bet užrakinta',
    pickupBookingsLockedHelp: 'Baseinas matomas kalendoriuje ir naudotojai mato savo rezervacijas, bet niekas negali kurti, keisti ar atšaukti, kol spyna nebus nuimta.',
    pickupBookingsLockedBadge: 'Užrakinta',
    poolBookingsLockedHint: 'Baseinas užrakintas. Galite matyti rezervacijas, bet negalite kurti, keisti ar atšaukti, kol spyna nebus nuimta.',
    pickupLocationOpens: 'atsidaro {{date}}',
    pickupLocationNotYetOpenHint: 'Atsiėmimo vieta atsidaro {{date}}. Galite ją matyti sąraše, bet rezervuoti galėsite tik tada, kai ji bus galiojanti.',
    pickupValidFrom: 'Galioja nuo',
    pickupValidTo: 'Galioja iki',
    pickupValidDatesHelp: 'Nustato, kada vieta rodoma ir ją galima rezervuoti. Palikite tuščią be apribojimų (galioja iškart). Už laikotarpio ribų vieta paslepiama rezervacijoje ir jos negalima rezervuoti. Administratoriai ją vis tiek mato čia.',
    pickupInactiveBadge: 'Neaktyvi',
    pickupDeactivateConfirm: 'Deaktyvuoti „{{name}}“? Vieta bus deaktyvuota. Visi būsimi užsakymai (Užsakyta, neišduoti), vis dar turintys transportą iš šio baseino, praras transportą ir bus rodomi skyriuje Susidūrimų rezervacijos. Tęsti?',
    pickupDeactivateStripped: '{{count}} rezervacija (-os) perkelta į susidūrimų apdorojimą.',
    pickupLocationSaveError: 'Nepavyko išsaugoti paėmimo vietos.',
    createUnderOrganization: 'Sukurti pagal organizaciją',
    loadingOrganizations: 'Įkeliamos organizacijos...',
    noTopNodesFound: 'Viršutinių mazgų nerasta. Patikrinkite leidimus arba bandykite dar kartą.',
    drawGeofenceArea: 'Nubrėžkite sritį žemėlapyje',
    startDrawing: 'Pradėkite piešti',
    finishArea: 'Atlikta – išsaugoti plotą',
    geofenceAreaHelp: 'Spustelėkite žemėlapį, kad nustatytumėte taškus. Reikalingi bent 3 balai. Sritis naudojama įėjimo/išėjimo aptikimui ir patvirtinimui, kad užsakymas baigiasi tinkamoje vietoje.',
    selectOrgGroup: 'Pasirinkite grupę (organizaciją)',
    vehiclesInPool: 'Transporto priemonės baseine',
    vehiclesInGroup: 'Transporto priemonės grupėje',
    pickupLinkedTotal: '{{count}} transporto priemonių susietos su šia paėmimo vieta',
    pickupLinkedInList: 'iš {{total}} transporto priemonių susietos',
    pickupLinkedOtherOrgsTitle: '{{count}} susietų transporto priemonių nėra sąraše (kita organizacija nei pasirinkta grupė)',
    pickupLinkedOtherOrgsHint: '{{count}} susietos transporto priemonės priklauso kitai organizacijai nei pasirinkta grupė (pažymėta sąraše).',
    pickupLinkedOtherOrgBadge: 'Kita org.',
    pickupVehicleSearch: 'Ieškoti transporto priemonių',
    pickupVehicleSearchPlaceholder: 'Valst. Nr., markė arba modelis…',
    pickupVehicleSearchResults: 'Rodoma {{shown}} iš {{total}} transporto priemonių',
    pickupVehicleSearchNoHits: 'Nė viena transporto priemonė neatitinka paieškos.',
    pickupLinkedBadge: 'Susietas',
    pickupPoolResourceTypeHeading: 'Rezervuojamas išteklių tipas (kiekvienam baseino transportui)',
    pickupPoolResourceTypeHelp: 'Tuščia = laikoma automobiliu paieškoje. Pasirinkite pvz. Dviratis dviračiams.',
    pickupPoolResourceTypeDefault: 'Numatyta (automobilis)',
    addVehiclesToPool: 'Pridėti pasirinktus į baseiną',
    name: 'Vardas',
    address: 'Adresas',
    postalCode: 'Pašto kodas',
    city: 'Miestas',
    displayOrder: 'Rodyti tvarką',
    suppliers: 'Tiekėjai',
    suppliersTitle: 'Tiekėjai',
    suppliersDescription: 'Tiekėjai pvz. automobilių nuomos įmonės',
    addSupplier: 'Pridėti tiekėją',
    addCarRentalFromCrm: 'Pridėkite automobilio nuomą iš CRM',
    selectCarRental: 'Pasirinkite automobilių nuomos įmonę',
    noCarRentalCustomers: 'Nėra klientų, turinčių automobilių nuomos tipą CRM. Sukurkite klientą su tipu Automobilių nuoma skiltyje CRM → Pirmiausia klientai.',
    deliversToAllPools: 'Pristatome į visus baseinus',
    editSupplier: 'Redaguoti tiekėją',
    noSuppliers: 'Nėra tiekėjų. Pridėkite vieną, kad pradėtumėte.',
    supplierType: 'Tipas',
    supplierTypeCarRental: 'Automobilių nuoma',
    supplierTypeOther: 'Kita',
    destinations: 'Paskirties vietos',
    destinationsTitle: 'Paskirties vietos',
    destinationsDescription: 'Iš anksto nustatytos paskirties vietos užsakymams',
    addDestination: 'Pridėti kelionės tikslą',
    editDestination: 'Redaguoti paskirties vietą',
    noDestinations: 'Nėra paskirties vietų. Pridėkite vieną, kad pradėtumėte.',
    vehiclesAtLocation: 'Transporto priemonės vietoje',
    addVehicle: 'Pridėti transporto priemonę',
    calendarTitle: 'Užsakymų kalendorius',
    calendarDescription: 'Ganto vaizdas į baseino užimtumą – peržiūrėkite laisvus laiko tarpsnius ir kurkite rezervacijas',
    weekTitle: '{{week}} savaitė ({{start}} - {{end}})',
    calendarViewAll: 'Visos dienos',
    calendarViewWorkdays: 'Tik darbo dienomis',
    viewWeek: 'Savaitė',
    viewDay: 'Diena',
    today: 'Šiandien',
    prevDay: 'Ankstesnė diena',
    nextDay: 'Kita diena',
    openDayView: 'Atidaryti dienos rodinį',
    vehicleColumn: 'Transporto priemonė',
    redDay: 'Raudona diena (valstybinė šventė)',
    statusBooked: 'Užsakyta',
    statusCheckedOut: 'Išsiregistravo',
    statusReturned: 'Sugrįžo',
    statusCancelled: 'Atšaukta',
    statusCancelledBySystem: 'Atšaukta sistemos',
    statusNoShow: 'Neatvyko (nepaimta)',
    statusOverdue: 'Pavėluota',
    checkoutDialogTitle: 'Išregistruoti užsakymą',
    checkoutTimeLabel: 'Išregistravimo laikas',
    changeResource: 'Keisti išteklių',
    changeResourceTitle: 'Keisti išteklių',
    changeResourceCurrent: 'Dabartinis išteklius',
    changeResourceNew: 'Naujas išteklius',
    changeResourceSearchPlaceholder: 'Ieškoti transporto (pvz. 197, GNB563, Manual)…',
    changeResourceSelected: 'Pasirinkta',
    changeResourceNoneAvailable: 'Šiuo laikotarpiu fonde nėra laisvų transporto priemonių',
    changeResourceSave: 'Keisti išteklių',
    changeResourceSuccess: 'Išteklius pakeistas.',
    changeResourceError: 'Nepavyko pakeisti ištekliaus.',
    vehicleMapShow: 'Rodyti žemėlapyje',
    vehicleMapTitle: 'Transporto priemonės vieta',
    vehicleMapSourceLive: 'Dabartinė vieta',
    vehicleMapSourceStored: 'Paskutinė išsaugota vieta',
    vehicleMapUpdatedAt: 'Atnaujinta',
    vehicleMapNoPosition: 'Šiai transporto priemonei nėra išsaugota vieta.',
    vehicleMapLoadError: 'Nepavyko gauti transporto priemonės vietos.',
    legendVehicleBlock: 'Transporto blokavimas (admin)',
    legendImportedBooking: 'Importuota rezervacija (JSON)',
    legendQuickBooking: 'Greita rezervacija',
    vehicleBlockShort: 'Blokas',
    noVehicleAssigned: 'Nepriskirta transporto priemonė',
    ownCar: {
      formTitle: 'Sukurti kelionę nuosavu automobiliu',
      listTitle: 'Kelionės nuosavu automobiliu',
      listIntro: 'Jūsų kelionės ir tos, kurias turite teisę peržiūrėti.',
      listEmpty: 'Nėra kelionių.',
      listLoadError: 'Nepavyko įkelti kelionių.',
      loadError: 'Nepavyko įkelti formos.',
      toList: 'Rodyti visas keliones',
      newTrip: 'Nauja kelionė',
      bookedFor: 'Užsakyta',
      phone: 'Telefono numeris',
      car: 'Automobilis',
      selectCar: 'Pasirinkite automobilį',
      newCar: 'Naujas automobilis…',
      lookupCar: 'Ieškoti car.info',
      regRequired: 'Pirmiausia įveskite valstybinį numerį',
      carInfoSuccess: 'Duomenys gauti iš car.info',
      carInfoError: 'Nepavyko gauti automobilio iš car.info',
      model: 'Modelis',
      year: 'Metai',
      color: 'Spalva',
      fuel: 'Kuro tipas',
      co2PerKm: 'CO₂',
      reimbursement: 'Kompensacija už kilometrą',
      odometerStart: 'Odometras – kelionės pradžia',
      odometerEnd: 'Odometras – kelionės pabaiga',
      directKm: 'Arba įveskite atstumą visais km',
      totalReimbursement: 'Bendra kompensacija',
      from: 'Rezervacija nuo',
      to: 'Rezervacija iki',
      costCenter: 'Kaštų centras',
      selectCostCenter: 'Pasirinkite kaštų centrą',
      project: 'Projekto numeris',
      emission: 'Emisija',
      km: 'Km',
      total: 'Iš viso',
      co2: 'CO₂',
      travelFrom: 'Kelionė – Iš',
      travelTo: 'Kelionė – Į',
      purpose: 'Tikslas',
      ownCarReason: 'Priežastis rinktis nuosavą automobilį',
      save: 'Išsaugoti',
      saveAndSubmit: 'Išsaugoti ir pateikti',
      saveSuccess: 'Kelionė išsaugota ir vis dar redaguojama.',
      submitSuccess: 'Kelionė pateikta peržiūrai.',
      saveError: 'Nepavyko išsaugoti kelionės.',
      approve: 'Patvirtinti',
      reject: 'Atmesti',
      approveSuccess: 'Kelionė patvirtinta.',
      rejectSuccess: 'Kelionė atmesta.',
      reviewError: 'Nepavyko peržiūrėti kelionės.',
      sendPayroll: 'Siųsti į darbo užmokestį',
      payrollSuccess: 'Kelionė pažymėta kaip išsiųsta.',
      payrollError: 'Nepavyko išsiųsti.',
      export: 'Eksportuoti CSV',
      exportError: 'Nepavyko eksportuoti.',
      searchPlaceholder: 'Ieškoti vardo, numerio, iš/į…',
      allStatuses: 'Visos būsenos',
      statusLabel: 'Būsena',
      status: {
        draft: 'Juodraštis',
        submitted: 'Pateikta',
        approved: 'Patvirtinta',
        rejected: 'Atmesta',
        sent_to_payroll: 'Išsiųsta į DU',
      },
    },
    collisionTitle: 'Susidūrimų rezervacijos',
    collisionIntro: 'Rezervacijos be priskirtos transporto priemonės, kurios prasideda šiandien arba vėliau (pvz. po transporto blokavimo). Ankstesnis baseinas ir automobilis išsaugomi, kad galėtumėte priskirti kitą arba atšaukti.',
    collisionBack: 'Atgal į rezervacijas',
    collisionEmpty: 'Nėra aktualių susidūrimų rezervacijų.',
    collisionLoadError: 'Nepavyko įkelti susidūrimų rezervacijų.',
    collisionDetailLoadError: 'Nepavyko atidaryti rezervacijos.',
    collisionColPool: 'Baseinas',
    collisionColCustomer: 'Užsakyta',
    collisionColTime: 'Laikas',
    collisionColPriorVehicle: 'Ankstesnė TP',
    collisionColAvailableResource: 'Laisvas resursas',
    collisionAssignVehicle: 'Priskirti',
    collisionAssignSuccess: 'Transporto priemonė priskirta.',
    collisionAssignError: 'Nepavyko priskirti transporto priemonės.',
    collisionCancelBySystem: 'Atšaukti',
    collisionCancelConfirm: 'Nėra laisvo resurso. Atšaukti rezervaciją? El. laiškai bus išsiųsti užsakovui ir keleiviams.',
    collisionCancelSuccess: 'Rezervacija atšaukta sistemos.',
    collisionCancelError: 'Nepavyko atšaukti rezervacijos.',
    collisionColStatus: 'Būsena',
    collisionColAction: 'Veiksmas',
    collisionOpenBooking: 'Atidaryti rezervaciją',
    assignVehicleTitle: 'Priskirti baseino transportą',
    assignVehicleHint: 'Pasirinkite laisvą transporto priemonę šiam laikui. Taip pat galite pašalinti rezervaciją arba nusiųsti klientui atšaukimo nuorodą žemiau.',
    assignVehicleSelectPlaceholder: 'Pasirinkite transportą…',
    assignVehicleButton: 'Priskirti',
    assignVehicleSuccess: 'Transportas priskirtas.',
    assignVehicleError: 'Nepavyko priskirti transporto.',
    assignVehicleNoneAvailable: 'Šiuo metu nėra laisvų transporto priemonių baseine (patikrinkite blokavimus ir kitas rezervacijas).',
    staffCancelLinkHint: 'Kliento savitarnos atšaukimas (naujas skirtukas):',
    staffCancelLinkOpen: 'Atšaukimo puslapis',
    newBooking: 'Naujas užsakymas',
    newBookingSubtitle: 'Užpildykite transporto priemonės užsakymą nurodydami tikslą, tikslą ir pasikartojančias parinktis.',
    newBookingButton: 'Sukurti naują užsakymą',
    newBookingSelectPoolFirst: 'Pirmiausia pasirinkite baseiną, kad sukurtumėte naują užsakymą.',
    guideButton: 'Gidas',
    guideMenuTitle: 'Paleisti gidą',
    guideSearch: 'Paieška ir filtrai',
    guideList: 'Sąrašo rodinys',
    guideTimeline: 'Laiko juosta',
    editBookingMembers: 'Papildomi dalyviai',
    editBookingAddMember: 'Pridėti dalyvį (ieškokite vardo arba darbuotojo nr.)…',
    editBookingMembersHint: 'Pridėkite daugiau žmonių, kad užsakymas taptų grupiniu. Pažymėjus „Raktas" leidžiama paimti/grąžinti.',
    editBookingGroupBadge: 'Grupinis užsakymas',
    editBookingStaffSubtitle: 'Redaguokite užsakymą – laiką, paėmimo vietą, transporto priemonę, tikslą ir dalyvius.',
    editBookingLoadError: 'Nepavyko atidaryti užsakymo redagavimui',
    organization: 'Organizacija',
    pool: 'Baseinas',
    date: 'Data',
    vehicle: 'Transporto priemonė',
    selectPoolAndDate: 'Pasirinkite baseiną ir datą, kad pamatytumėte užimtumą.',
    noVehiclesInPool: 'Šiame baseine nėra transporto priemonių. Pridėkite transporto priemones: Rezervacijos → Paėmimo vietos.',
    start: 'Pradėti',
    end: 'Pabaiga',
    customerName: 'Užsakė / už',
    bookerRsid: 'RSID',
    bookerPhone: 'Telefono numeris',
    customerNamePlaceholder: 'Pavadinimas arba vienetas',
    bookedFor: 'Užsakyta už',
    primaryBooker: 'Pagrindinis užsakovas',
    createdBy: 'Užsakė',
    cancelledBy: 'Atšaukė',
    cancelledBySystem: 'Sistema',
    actorUnknown: 'Nežinoma',
    createdChannel: 'Užsakyta iš',
    createdChannelApp: 'Programėlė',
    createdChannelWeb: 'Kompiuteris',
    bookingTypeSingle: 'Vienkartinis užsakymas',
    bookingTypeGroup: 'Grupinis užsakymas',
    bookingTypePool: 'Transporto priemonių baseinas',
    tripPurpose: 'Kelionės tikslas',
    tripPurposePlaceholder: 'pvz. Kliento apsilankymas',
    estimatedKm: 'Numatomas atstumas (km)',
    filterByEquipment: 'Filtruoti pagal įrangą',
    filterAutomaticTransmission: 'Tik automatinė pavarų dėžė',
    filterAutomaticTransmissionHelp: 'Pažymėjus rodomos tik transporto priemonės su automatinėmis pavaromis.',
    noAutomaticTransmissionVehicles: 'Pasirinktu laikotarpiu nėra laisvų automatinės pavarų dėžės transporto priemonių. Nuimkite filtrą arba pasirinkite kitą laiką.',
    destination: 'Paskirties vieta',
    destinationPlaceholder: 'Pasirinkite arba įveskite vietą',
    destinationTypeFree: 'Jei nėra atitikties, įveskite laisvą tekstą',
    driverLicenseConfirmed: 'Turiu galiojantį vairuotojo pažymėjimą',
    bookingPolicyCheckbox: 'Perskaičiau ir sutinku su užsakymo politika',
    bookingPolicyCheckboxHelp: 'Pažymėkite laukelį, kad atidarytumėte politiką. Patvirtinkite apačioje, kai perskaitėte.',
    isServiceBooking: 'Paslauga / aptarnavimas',
    isServiceBookingHelp: 'Pažymėkite, jei užsakymas susijęs su transporto priemonės aptarnavimu. Tokie užsakymai nepatenka po „no-show“ taisykle, kuri kitaip atlaisvina vietą po nustatyto laiko.',
    bookingPolicyTitle: 'Užsakymo politika',
    bookingPolicyReadConfirm: 'Perskaičiau politiką',
    approvedBy: 'Patvirtino (atestacija)',
    approvedByPlaceholder: '– neprivaloma –',
    noAvailableVehicles: 'Pasirinktu laikotarpiu nėra laisvų transporto priemonių',
    recurrence: 'Pasikartojantis',
    recurrenceWeekly: 'Kas savaitę',
    recurrenceMonthly: 'Kas mėnesį',
    recurrenceCount: 'Įvykių skaičius',
    loadingAvailableVehicles: 'Įkeliamos laisvos transporto priemonės...',
    noVehicleCreateRental: 'Nėra laisvos transporto priemonės – sukurkite nuomą iš tiekėjo',
    createRentalAndBooking: 'Sukurkite nuomą ir užsakymą',
    externalDisplayName: 'Rodomas vardas (pvz., automobilio nuoma)',
    externalDisplayNamePlaceholder: 'pvz. Automobilio nuoma A',
    selectSupplier: 'Pasirinkite tiekėją',
    costCenter: 'Išlaidų centras',
    costCenterPlaceholder: '— Pasirinkite išlaidų centrą —',
    costCenterFreeTextPlaceholder: 'Arba įveskite savo išlaidų centrą',
    tabTripPurposes: 'Kelionės tikslai',
    tripPurposesTitle: 'Kelionės tikslai',
    tripPurposesDescription: 'Tvarkykite iš anksto nustatytus kelionės tikslus pagal organizacijos viršutinį mazgą.',
    purposeSetsService: 'Budėjimas/Servisas',
    purposeSetsServiceHelp: 'Pažymėkite tikslus, kurie automatiškai įjungia budėjimą/servisą pasirinkus tikslą.',
    newTripPurposePlaceholder: 'Naujas kelionės tikslas',
    noTripPurposes: 'Kelionės tikslų dar nepridėta.',
    formSettingsListOnly: 'Tik iš sąrašo',
    formSettingsListOnlyForced: 'Šis laukas visada nuskaitomas tik iš sąrašo.',
    costCentersTitle: 'Išlaidų centrai',
    costCentersDescription: 'Organizacijos kaštų centrai – pasirenkami rezervuojant. Galima išjungti, bet niekada neištrinti.',
    addCostCenter: 'Pridėti išlaidų centrą',
    editCostCenter: 'Redaguoti išlaidų centrą',
    noCostCenters: 'Jokių išlaidų centrų. Pridėkite vieną, kad pradėtumėte.',
    costCenterCode: 'Kodas (maks. 15 simbolių)',
    costCenterDescription: 'Aprašymas (maks. 50 simbolių)',
    costCenterValidFrom: 'Galioja nuo',
    costCenterActive: 'Aktyvus',
    costCenterInactive: 'Neaktyvus',
    saveError: 'Nepavyko išsaugoti užsakymo',
    resourceTypesTitle: 'Išteklių tipai vienam klientui',
    resourceTypesDescription: 'Išteklių tipai (automobilis, dviratis, konferencijų salė ir kt.) apibrėžiami sistemos lygiu. Čia pažymite, kokius tipus kiekvienas klientas (organizacija) gali naudoti rezervuodamas.',
    resourceTypesOrganization: 'Organizacija (klientas)',
    resourceTypesSelectOrg: 'Pasirinkite organizaciją',
    resourceTypesSelectOrgFirst: 'Pasirinkite organizaciją, kad nustatytumėte, kuriuos išteklių tipus galima naudoti.',
    resourceTypesMyOrg: 'Mano organizacija',
    resourceTypesForOrg: 'Aktyvūs išteklių tipai',
    resourceTypeLabel: 'Ištekliaus tipas',
    resourceTypeEnabled: 'Įgalinta šiam klientui',
    resourceTypeDisabled: 'Išjungta šiam klientui',
    resourceTypesSaved: 'Išsaugoti išteklių tipai',
    resourceTypesSaveError: 'Nepavyko išsaugoti išteklių tipų',
    bookingCreated: 'Užsakymas sukurtas',
    sendCalendarInvitePrompt: 'Ar norite nusiųsti klientui kalendoriaus kvietimą? Kliento adresu bus išsiųstas el. laiškas su kalendoriaus priedu.',
    noEmailForCalendarInvite: 'Klientas neturi el. pašto adreso – kalendoriaus kvietimo išsiųsti negalima.',
    sendCalendarInvite: 'Siųsti kalendoriaus kvietimą',
    done: 'Atlikta',
    calendarInviteSent: 'Kalendoriaus kvietimas išsiųstas kliento el. paštu.',
    calendarInviteError: 'Nepavyko išsiųsti kalendoriaus kvietimo.',
    bookingDetailsTitle: 'Užsakymo informacija',
    cancelBookingTitle: 'Atšaukti užsakymą',
    cancelBookingConfirm: 'Ar norite atšaukti šį užsakymą? Jis nebus ištrintas, tik pažymėtas kaip neaktyvus.',
    cancelBookingSuccess: 'Užsakymas atšauktas (neaktyvus).',
    cancelBookingInvalid: 'Netinkama arba jau naudojama atšaukimo nuoroda.',
    cancelBookingError: 'Nepavyko atšaukti užsakymo.',
    cancelBookingButton: 'Atšaukti užsakymą',
    cancelBookingHelp: 'Atšaukimas pažymi užsakymą kaip neaktyvų (jis neištrinamas) ir atlaisvina laiką. „Uždaryti“ uždaro šį langą.',
    noShowReleasePoolOverride: 'Išleidimas be pasirodymo (baseinas)',
    noShowReleasePoolOverridePlaceholder: 'Tuščia = paveldėti iš organizacijos, 0 = išjungta, pvz. 30 = minutės',
    noShowReleasePoolOverrideHelp: 'Nepaisyti šio telkinio organizavimo taisyklės. Tuščias = naudoti org (viršutinis mazgas). 0 = taisyklė čia išjungta. Kitu atveju = minutės po pradžios.',
    requestsTitle: 'Užsakymo prašymai',
    requestsDescription: 'Užsakymai, kuriems bokavimo metu nebuvo priskirtas automobilis.',
    requestsBack: 'Atgal į rezervacijas',
    requestsEmpty: 'Šiuo metu nėra užsakymo prašymų.',
    requestsLoadError: 'Nepavyko įkelti užsakymo prašymų.',
    requestsDetailLoadError: 'Nepavyko atidaryti rezervacijos.',
    requestsColPool: 'Baseinas',
    requestsColCustomer: 'Užsakyta',
    requestsColTime: 'Laikas',
    requestsColCarClass: 'Automobilio klasė',
    requestsColSuppliers: 'Tiekėjai',
    requestsColStatus: 'Būsena',
    requestsColAction: 'Veiksmas',
    requestsOpenBooking: 'Atidaryti rezervaciją',
    requestsSearchPlaceholder: 'Paieškos pavadinimas, tikslas...',
    requestsCount: 'užsakymai',
    requestsNoResults: 'Užsakymų nerasta',
    requestsBookedBy: 'Užsakė',
    resourceManagerTitle: 'Išteklių valdytojas',
    resourceManagerDescription: 'Kasdieninė transporto priemonės apžvalga – žr. visų baseine esančių automobilių užimtumą ir užsakymo būseną',
    resourceManagerStatus: 'Būsena',
    resourceManagerToday: 'Šiandien',
    resourceManagerNowLine: 'Dabartinis laikas',
    resourceManagerSearchOrg: 'Ieškoti organizacijos...',
    bookingSearchTitle: 'Užsakymai',
    bookingSearchDescription: 'Ieškoti ir rodyti užsakymus pagal filtrus (nuoroda, baseinas, datos, vairuotojas, transportas, išteklių tipas).',
    bookingSearchPrompt: 'Pasirinkite filtrus ir spustelėkite Ieškoti.',
    bookingSearchReference: 'Nuoroda (užsakymo id)',
    bookingSearchReferencePlaceholder: 'UUID arba jo dalis',
    bookingSearchAllPools: 'Visi baseinai',
    bookingSearchDateFrom: 'Užsakymas nuo',
    bookingSearchDateTo: 'Užsakymas iki',
    timelineSpan: 'Laiko intervalas',
    timelineSpan1Day: '1 diena',
    timelineSpan2Days: '2 dienos',
    timelineSpan14Days: '14 dienų',
    timelineSpan40Days: '40 dienų',
    bookingSearchBookedFor: 'Užsakyta (vairuotojas / vardas)',
    bookingSearchBookedForPlaceholder: 'Vardas arba el. paštas',
    bookingSearchBookedForHelp: 'Ieško kliento vardo ir vartotojo, kuris sukūrė užsakymą.',
    bookingSearchVehicle: 'Išteklius (transportas)',
    bookingSearchVehiclePlaceholder: 'Vidinis nr., valst. nr. arba eilutės tekstas',
    bookingSearchVehicleHelp: 'Ieško vidinio numerio ir teksto, kuris rodomas pirmas transporto eilutėje, pvz. 195 arba EPP03P.',
    bookingSearchResourceTypeAll: 'Visi išteklių tipai',
    bookingSearchResourceTypeHint: 'Išteklių tipas nustatomas kiekvienam transportui baseine. Tuščias tipas = laikomas automobiliu filtre „Automobilis“. Dviračiui ir kt. reikia pažymėti tipą ant baseino transporto.',
    bookingSearchStatusAll: 'Visos būsenos',
    bookingSearchRun: 'Ieškoti',
    bookingSearchResults: 'Paieškos rezultatai',
    bookingSearchNoHits: 'Užsakymų pagal filtrus nerasta.',
    bookingSearchColReference: 'Nuoroda',
    bookingSearchColPickupLocation: 'Paėmimo vieta',
    bookingSearchColBookingFrom: 'Užsakymas nuo',
    bookingSearchColBookingTo: 'Užsakymas iki',
    bookingSearchColResource: 'Išteklius',
    bookingSearchColTripCount: 'Kelionių sk.',
    bookingSearchColBookedBy: 'Užsakė',
    viewList: 'Sąrašas',
    viewTimeline: 'Laiko juosta',
    timelineDragHint: 'Vilkite rezervaciją, kad ją perkeltumėte, vilkite dešinįjį kraštą, kad pakeistumėte pabaigos laiką, arba vilkite tuščioje vietoje, kad sukurtumėte naują rezervaciją.',
    timelineResizeHint: 'Vilkite, kad pakeistumėte pabaigos laiką',
    timelineMoveFailed: 'Nepavyko perkelti rezervacijos.',
    timelineMoveConfirmTitle: 'Patvirtinkite rezervacijos perkėlimą',
    timelineMoveConfirmQuestion: 'Ar norite perkelti rezervaciją? Patvirtinkite, kad išsaugotumėte pakeitimą.',
    timelineMoveFrom: 'Nuo',
    timelineMoveTo: 'Iki',
    timelineMoveNewTime: 'Naujas laikas',
    timelineMoveNewVehicle: 'Naujas automobilis',
    timelineMoveConfirmButton: 'Patvirtinti perkėlimą',
    timelineParticipants: 'Dalyviai',
    userConflictWarningTitle: 'Naudotojas jau turi rezervaciją šiuo metu:',
    passengerCount: 'Keleivių skaičius',
    fellowTravelers: 'Keleiviai',
    groupMembers: 'Grupės nariai',
    canCheckoutKey: 'Galima pasiimti raktą',
    addMemberPlaceholder: 'Pridėti narį (vardas, el. paštas arba RSID)...',
    maxExtraMembersHint: 'Galima pridėti ne daugiau kaip 4 papildomus asmenis.',
    memberAlreadyAdded: 'Šis asmuo jau pridėtas prie rezervacijos.',
    acceptTerms: 'Sutinku su užsakymo sąlygomis',
    checkedOutAt: 'Išsiregistravo',
    returnedAt: 'Sugrįžo',
    status_BOOKED: 'Užsakyta',
    status_CHECKED_OUT: 'Išsiregistravo',
    status_RETURNED: 'Sugrįžo',
    owner: 'Savininkas',
    checkedOut: 'Išsiregistravo',
    returned: 'Sugrįžo',
    checkoutButton: 'Patikrinkite',
    returnButton: 'Grįžti',
    checkedOutSuccess: 'Užsakymas buvo patikrintas',
    returnedSuccess: 'Užsakymas grąžintas',
    checkoutError: 'Nepavyko patikrinti užsakymo',
    returnError: 'Nepavyko grąžinti užsakymo',
    returnOffsiteButton: 'Grąžinimas kitoje vietoje',
    returnOffsiteHint: 'Leisti užbaigti užsakymą, net jei GPS nerodo automobilio aikštelėje (vėluojantis signalas).',
    returnOffsiteTitle: 'Grąžinimas kitoje vietoje',
    returnOffsiteDescription: 'Naudotojas gali užbaigti užsakymą, net jei GPS rodo, kad automobilis nėra zonoje. Nurodykite priežastį (registruojama).',
    returnOffsiteReasonPlaceholder: 'Pvz. GPS vėlavimas, automobilis yra vietoje...',
    returnOffsiteConfirm: 'Leisti kitą vietą',
    returnOffsiteSuccess: 'Grąžinimas kitoje vietoje leistinas šiam užsakymui',
    returnOffsiteError: 'Nepavyko leisti grąžinimo kitoje vietoje',
    status: 'Būsena',
    termsTitle: 'Užsakymo sąlygos',
    termsDescription: 'Tvarkykite užsakymų sąlygas',
    addTerms: 'Nauja versija',
    termsVersionPlaceholder: 'Versija (pvz., 1.0)',
    termsTitlePlaceholder: 'Pavadinimas',
    termsContentPlaceholder: 'Turinys (HTML arba tekstas)',
    termsActivate: 'Suaktyvinti',
    termsDeactivate: 'Išjungti',
    termsActive: 'Aktyvus',
    vehiclePoolTitle: 'Transporto priemonių baseinas',
    vehiclePoolDescription: 'Tvarkykite transporto priemonių baseinus naudodami automatinį raktų rezervavimą',
    createPool: 'Sukurti baseiną',
    poolName: 'Baseino pavadinimas',
    poolNamePlaceholder: 'Transporto priemonių baseino pavadinimas...',
    pickupLocation: 'Atsiėmimo vieta',
    maxHoursPerCheckout: 'Maksimalios valandos per kasą',
    poolMembers: 'nariai',
    addMember: 'Pridėti narį',
    removeMember: 'Pašalinti',
    activeCheckouts: 'Aktyvios kasos',
    noPoolsYet: 'Transporto priemonių baseinų dar nesukurta',
    noMembersYet: 'Šiame telkinyje nėra narių',
    editPool: 'Redaguoti baseiną',
    validFrom: 'Galioja nuo',
    validTo: 'Galioja iki',
    poolWatchTitle: 'Trūkstami duomenys',
    poolWatchDescription: 'Baseino paėmimai, kuriuose nėra tikslo ar kitų privalomų laukų.',
    poolWatchEmpty: 'Nėra užsakymų, laukiančių papildymo.',
    poolWatchComplete: 'Papildyti',
    poolWatchCompleteTitle: 'Papildyti užsakymą',
    poolWatchCompleteHint: 'Užpildykite kelionės tikslą ir pastabas paėmus raktą.',
    poolWatchSaved: 'Duomenys išsaugoti.',
    poolWatchLoadError: 'Nepavyko įkelti stebėjimo sąrašo.',
    poolWatchSaveError: 'Nepavyko išsaugoti duomenų.',
    needsPurposeFilter: 'Tik trūkstami duomenys',
    needsPurposeBadge: 'Trūksta duomenų',
    quickTitle: 'Greitas rezervavimas',
    quickDescription: 'Rezervuokite laisvą raktinės arba Flinkey automobilį svečiui. PIN siunčiamas SMS. Bent vardas, telefonas arba el. paštas.',
    quickCabinet: 'Raktinė',
    quickAccessCabinet: 'Raktinės automobilis',
    quickAccessFlinkey: 'Flinkey box',
    quickGuestName: 'Svečio vardas',
    quickGuestPhone: 'Mobilusis',
    quickGuestEmail: 'El. paštas',
    quickSubmit: 'Rezervuoti ir siųsti',
    quickBookOnly: 'Rezervuoti',
    quickSmsCost: 'SMS {{price}}',
    quickSaved: 'Rezervacija sukurta',
    quickGuestReusedHint: 'Išsaugota svečio paskyra rasta — ji bus naudojama pakartotinai.',
    quickSavedReused: 'Greita rezervacija sukurta, svečio paskyra panaudota pakartotinai',
    quickLoadError: 'Nepavyko įkelti laisvų automobilių.',
    quickSaveError: 'Nepavyko sukurti rezervacijos.',
    quickMissingFields: 'Užpildykite automobilį ir raktinę (jei tai raktinės automobilis).',
    quickMissingIdentity: 'Įveskite bent vardą, telefoną arba el. paštą.',
    quickIdentityHint: 'Reikalingas bent vardas, telefonas arba el. paštas.',
    quickPhoneHint: 'Šalies kodas, pvz. +47 arba +1',
    quickSaveCustomer: 'Išsaugoti klientą',
    quickPinLabel: 'PIN',
    quickSmsPreview: 'SMS kopijavimui',
    quickSmsCopy: 'Kopijuoti',
    quickSmsCopied: 'SMS nukopijuota',
    quickSmsSent: 'PIN išsiųstas SMS.',
    quickSmsFailed: 'Rezervacija sukurta, bet SMS nepavyko. Parodykite PIN svečiui.',
    quickTabNew: 'Nauja rezervacija',
    quickNew: 'Nauja',
    quickCloseForm: 'Uždaryti formą',
    quickCreated: 'Sukurta',
    quickRegistration: 'Valst. nr.',
    quickPeriod: 'Laikotarpis',
    quickChannel: 'Siuntimas',
    quickChannelSms: 'Išsiųsta SMS',
    quickChannelEmail: 'Išsiųsta el. paštu',
    quickChannelBooked: 'Tik rezervuota',
    quickTabCurrent: 'Dabartinės',
    quickTabPrevious: 'Ankstesnės',
    quickEmptyCurrent: 'Nėra dabartinių greitųjų rezervacijų.',
    quickEmptySent: 'Greitųjų rezervacijų dar nėra.',
    quickEmptyPrevious: 'Nėra ankstesnių greitųjų rezervacijų.',
    quickListError: 'Nepavyko įkelti rezervacijų.',
    quickCancel: 'Atšaukti',
    quickCancelConfirm: 'Atšaukti šią rezervaciją?',
    quickCancelled: 'Rezervacija atšaukta.',
    quickCancelError: 'Nepavyko atšaukti.',
    quickNoCreateAccess: 'Neturite teisės kurti greitosios rezervacijos.',
    quickNoVehicles: 'Pasirinktu laiku nėra laisvų raktinės ar Flinkey automobilių.',
    managedBySupplier: 'Tvarko automobilių nuomos įmonės',
    managedBySupplierNone: 'Nuosavas baseinas (be automobilio nuomos)',
    managedBySupplierHelp: 'Pasirinkite automobilių nuomos įmonę, kuri leis jai valdyti baseiną ir priskirti automobilius pagal užklausas. Baseine esantys automobiliai priklauso automobilių nuomos bendrovei.',
    managedBySupplierNoLinks: 'Šiai organizacijai nėra automobilių nuomos ryšių. Pirmiausia sukurkite ryšį skiltyje „Automobilių nuoma“.',
    pickupAllowedCarClasses: 'Automobilių klasės (galima užsisakyti / pateikti užklausą)',
    pickupAllowedCarClassesHelp: 'Įveskite automobilių klases, kurias galima užsakyti arba paprašyti šioje vietoje. Jei sąrašas paliekamas tuščias, automobilių nuomos jungties automobilių klasės yra paveldimos, o jei jis taip pat tuščias, užsakovas gali laisvai patekti į automobilių klasę.',
    pickupLocationResponsibles: 'Atsakomieji',
    pickupLocationResponsiblesHelp: 'Asmenys, atsakingi už išleidimo vietą. Jie gali tvarkyti Flinkey telkinio transporto priemonių dėžutes mobiliojoje programėlėje (FlinkyDėžutės), jei turi leidimą.',
    pickupLocationResponsiblesSearch: 'Ieškoti vartotojo',
    pickupLocationResponsiblesSearchPlaceholder: 'Vardas arba el. pašto adresas...',
    pickupLocationResponsiblesNone: 'Nepasirinktas atsakingas',
    showBookerNameInResourceManager: 'Išteklių tvarkyklėje rodyti asmens, kuris užsisakė, vardą.',
    showBookerNameInResourceManagerHelp: 'Jei bus pažymėta, bus rodomas keliautojo vardas (ir bendradarbio vardas) rezervavimo blokai išteklių tvarkyklėje. Pagal numatytuosius nustatymus pavadinimas nerodomas.',
    pickupDeactivate: 'Išjungti',
    pickupActivate: 'Suaktyvinti',
    pickupDelete: 'Ištrinti',
    pickupExportPools: 'Atsisiųsti telkinio sąrašą',
    pickupExportPoolsLoading: 'Eksportuojama...',
    pickupActivateConfirm: 'Vėl įgalinti „{{name}}“?',
    pickupDeleteConfirm: 'Ištrinti „{{name}}“ visam laikui? To negalima anuliuoti.',
    pickupDeleteHasBookings: 'Vietos istorijoje yra {{count}} užsakymas (-ai) ir jos negalima ištrinti. Vietoj to išjunkite.',
    pickupDeactivateSuccess: 'Išleidimo vieta išaktyvinta',
    pickupActivateSuccess: 'Išleidimo vieta suaktyvinta',
    pickupDeleteSuccess: 'Išmetimo vieta ištrinta',
    geofenceEnforceOnReturn: 'Reikalauti, kad automobilis būtų zonoje registruojantis',
    geofenceEnforceOnReturnHelp: 'Jei suaktyvinta, automobilis turi būti patikrinimo žemėlapio zonoje, kai užsakymas atliekamas. Priešingu atveju išėjimas užblokuotas. Klientų aptarnavimo tarnyba su grąžinimo į kitą vietą institucija gali leisti išimtis (pvz., uždelstas GPS). Reikalingas nubrėžtas plotas.',
    nearbyPoolSearchRadiusM: 'Ieškoti laisvų automobilių netoliese esančiuose baseinuose (metrais)',
    nearbyPoolSearchRadiusMHelp: 'Jei norite užsisakyti naują, taip pat rodomi laisvi automobiliai iš kitų baseinų, kurių stovėjimo aikštelė yra tokiu atstumu nuo šio baseino stovėjimo zonos. Numatytasis 2000 m. Nustatykite 0, kad būtų rodomas tik šis telkinys.',
    nearbyPoolSearchRadiusMPlaceholder: '2000',
    pickupHasGeofenceArea: 'Yra žemėlapio sritis',
    pickupShowAreasOnMap: 'Rodyti žemėlapio sritis',
    pickupAreasMapTitle: 'Pristatymo vietų žemėlapis',
    pickupAreasMapNoAreas: 'Jokiose perdavimo vietose nėra nubrėžtos žemėlapio sritys.',
    pickupAreasMapListHint: 'Spustelėkite pavadinimą, kad padidintumėte sritį.',
    pickupAreasMapListCount: '{{count}} vietos su žemėlapio sritimi',
    pickupAreasMapShowAll: 'Rodyti visas sritis',
    bookingResourcesInPool: 'Ištekliai baseine',
    bookingResourcesInPoolHelp: 'Dviračiai, priekabos ir kiti klientų ištekliai. Išteklių tipas paveldimas iš išteklių registro.',
    addBookingResourceToPool: 'Pridėti išteklių',
    selectBookingResource: 'Pasirinkite šaltinį',
    noUnassignedResources: 'Jokių nepaskirstytų išteklių. Sukurkite išteklius skiltyje Rezervavimo ištekliai.',
    bookingResourceAdded: 'Išteklius pridėtas prie baseino',
    bookingResourceRemoved: 'Išteklius pašalintas iš baseino',
    pickupVehicleOrgLimit: 'Čia galima susieti tik transporto priemones, priklausančias {{org}} arba jai žemiau esančiai grupei.',
    pickupVehiclesApplyOnSave: 'Įsiregistruokite arba išlipkite iš transporto priemonės čia. Pakeitimas įsigalios tik spustelėjus Išsaugoti. Atšaukti palieka sąrašą, koks buvo.',
    pickupRemoveVehiclesConfirm: 'Pašalinti {{count}} transporto priemonę iš išdavimo vietos? Būsimi šių automobilių užsakymai perskirstomi arba tampa susidūrimais.',
    pickupBookingInfo: 'Informacija rezervacijai',
    pickupBookingInfoHelp: 'Šis tekstas siunčiamas kartu su užsakymo patvirtinimu asmeniui, kuris rezervavo automobilį iš baseino.',
    pickupTabSettings: 'Nustatymai',
    pickupTabBooking: 'Rezervacija',
    pickupTabVehicles: 'Transporto priemonės',
    pickupTabResources: 'Ištekliai',
    pickupTabKeyCabinet: 'Raktų spintelė',
    pickupTabKeyCabinetPlaceholder: 'Čia raktų spintelės yra prijungtos prie pristatymo vietos. Funkcija netrukus bus išplėsta.',
    pickupTabKeyCabinetHelp: 'Čia matomos sujungtos spintelės. Taip pat galite prijungti spinteles, kurios priklauso tai pačiai organizacijai, bet nėra sujungtos su jokia pristatymo vieta.',
    pickupKeyCabinetsConnected: 'Sujungiamos spintos',
    pickupKeyCabinetsNone: 'Su šia išleidimo vieta nesusietos jokios rakinamos spintelės.',
    pickupKeyCabinetsAvailable: 'Turimos spintelės organizacijoje',
    pickupKeyCabinetsNoneAvailable: 'Organizacijoje nėra atjungtų spintelių.',
    pickupKeyCabinetSelect: 'Pasirinkite spintelę',
    pickupKeyCabinetConnect: 'Prijunkite spinteles',
    pickupKeyCabinetDisconnect: 'Nuimkite sankabą',
    pickupKeyCabinetConnectSuccess: 'Spintelė buvo prijungta prie pristatymo vietos.',
    pickupKeyCabinetDisconnectSuccess: 'Spintos mova buvo nuimta.',
    pickupKeyCabinetConnectError: 'Nepavyko prijungti spintelės.',
    pickupKeyCabinetDisconnectError: 'Nepavyko išimti spintelės jungties.',
    pickupKeyCabinetLoadError: 'Nepavyko gauti raktų spintelės.',
    pickupTabResponsibles: 'Atsakomieji',
    pickupMappedVehicleCount: 'Transporto priemonės',
    nearbyPoolSearchRadiusMeters: 'Ieškoti netoliese esančių baseinų (metrais)',
    nearbyPoolSearchRadiusPlaceholder: 'pvz. 5000',
    nearbyPoolSearchRadiusHelp: 'Užsakant laisvų transporto priemonių ieškoma ir kitose pristatymo vietose šiuo atstumu (matuojant nuo žemėlapio srities centro). Jei norite naudoti tik šį telkinį, palikite tuščią arba 0. Reikia nupiešti žemėlapio plotą.',
    supplierEmail: 'paštas',
    supplierPhone: 'Telefono numeris',
    supplierEmailPlaceholder: 'pvz. bokning@avis.se',
    supplierPhonePlaceholder: 'pvz. 011-123 45 67',
    supplierCarClasses: 'Automobilių grupės',
    supplierCarClassesHelp: 'Jūsų automobilių grupių pavadinimai pas tiekėją, pvz. Mažas arba vidutinis automobilis. Naudojama rezervavimo užklausoms.',
    supplierCarClassPlaceholder: 'pvz. Mažas automobilis',
    supplierCarClassAdd: 'Pridėti',
    supplierCarClassRemove: 'Pašalinti {{name}}',
    rentalManagementTitle: 'Automobilių nuomos įmonė',
    rentalManagementDescription: 'Susiekite klientų organizacijas su automobilių nuomos bendrove ir paprašykite nuomos. Prieigos lygis valdo, ar klientas užsisako pats, ar mato tik statistiką.',
    addRentalLink: 'Pridėti ryšį',
    editRentalLink: 'Redaguoti ryšį',
    noRentalLinks: 'Dar nėra automobilių nuomos ryšių. Pridėkite vieną, kad pradėtumėte.',
    rentalCompany: 'Automobilių nuomos įmonė',
    rentalCustomer: 'Klientų organizavimas',
    rentalSelectCompany: 'Pasirinkite automobilių nuomos įmonę',
    rentalSelectCustomer: 'Pasirinkite klientų organizaciją',
    rentalAccessLevel: 'Prieigos lygis',
    rentalAccessFullBooking: 'Visas užsakymas (užsakyti / sukurti užklausą)',
    rentalAccessStatsOnly: 'Tik statistika',
    rentalAccessFullBookingHelp: 'The customer\'s users book existing pool cars or create requests. Automobilių nuomos įmonė paskiria automobilį. Klientas negali valdyti transporto priemonių.',
    rentalAccessStatsOnlyHelp: 'Kliento darbuotojai gali rezervuoti/sukurti užklausas, tačiau klientas transporto priemonių nevaldo. Kliento administratorius mato užsakymo statistiką ir aplinkos ataskaitą.',
    rentalLinkSelectBoth: 'Pasirinkite tiek automobilių nuomos įmonę, tiek klientų organizaciją.',
    rentalLinkSaveError: 'Nepavyko išsaugoti ryšio.',
    rentalLinkDeleteConfirm: 'Ar norite pašalinti šią automobilių nuomos asociaciją?',
    requestedCarClass: 'Norima automobilių grupė',
    requestedCarClassPlaceholder: 'Pasirinkite automobilių grupę',
    requestedCarClassFreePlaceholder: 'Įveskite norimą automobilių grupę',
    requestedCarClassNoOptionsHint: 'Su tiekėjais nesukonfigūruota jokių automobilių grupių – įveskite rankiniu būdu arba pridėkite skiltyje Tiekėjai.',
    requestedCarClassRequired: 'Pasirinkite arba įveskite norimą automobilių grupę',
    supplierCrmCustomer: 'Klientas (automobilių nuomos įmonė CRM sistemoje)',
    supplierCrmNone: 'Nėra ryšio – nepriklausomas tiekėjas',
    supplierCrmCustomerHelp: 'Pasirenkamas ryšys su automobilių nuomos įmonėmis CRM. Tą patį CRM įrašą gali naudoti keli klientai – konfigūruojate savo automobilių grupes ir kontaktinius duomenis kiekvienam klientui.',
    supplierNameFromCrm: 'Pavadinimas imamas iš CRM kliento.',
    ksMarkPickedUp: 'Pažymėti kaip gautą',
    ksMarkPickedUpTitle: 'Pažymėti kaip gautą',
    ksMarkPickedUpConfirm: 'Ar norite pažymėti užsakymą kaip surinktą?',
    ksReturnTitle: 'Užsakymas atgal',
    ksReturnConfirm: 'Ar norite grąžinti užsakymą?',
    searchUserPlaceholder: 'Ieškoti vardo, el. pašto arba RSID...',
    notes: 'Pastabos',
    recurrenceDaily: 'Diena',
    filterByResourceType: 'Ištekliaus tipas',
    resourceTypeFilterAll: 'Visų tipų',
    resourceTypeFilterCar: 'Automobilis',
    resource: 'Išteklius',
    loadingAvailableResources: 'Įkeliami galimi ištekliai…',
    noAvailableResources: 'Pasirinktu laiku nėra išteklių',
    project: 'Projektas',
    notesShow: 'Rodyti užrašus',
    notesHide: 'Slėpti užrašus',
    cancelBookingPast: 'Užsakymas jau praėjo ir jo negalima atšaukti.',
    cancelBookingAlready: 'Užsakymas jau atšauktas.',
    importLockedHint: 'Importuotas užsakymas užrakinamas transporto priemonėje, kol susiejamas su asmeniu. Tada jis tvarkomas kaip įprastas užsakymas.',
    keyCabinetAccessActive: 'Prieiga prie raktų spintelės aktyvi užsakymo laikotarpiu.',
    poolBookingRulesHeading: 'Užsakymo taisyklės (nepaisyti organizacijos)',
    poolOverrideInheritHelp: 'Plot = paveldėti iš organizacijos (viršutinis mazgas). 0 = nėra apribojimų.',
    poolClosuresHeading: 'Uždarymo laikotarpiai',
    poolClosuresEmpty: 'Nėra uždarymo laikotarpių.',
    closureFrom: 'Uždaryta nuo',
    closureToOptional: 'Uždaryta (neprivaloma)',
    closureOpenEnded: 'Iki tolesnio pranešimo',
    closureReasonPlaceholder: 'Priežastis (neprivaloma)',
    closureAdd: 'Pridėti uždarymą',
    closureDeleteConfirm: 'Pašalinti uždarymo laikotarpį?',
    closureStripped: '{{count}} būsimas užsakymas (-ai) perkeltas (-i) į susidūrimo užsakymus.',
    fallbackSuppliersHeading: 'Tiekėjai, esant automobilio trūkumui',
    allowExternalBookingWhenNoCars: 'Leiskite užsisakyti per tiekėją, kai nėra laisvų automobilių',
    fallbackSuppliersHelp: 'Visi atrinkti tiekėjai yra informuojami, kai užsakymas sudaromas be laisvo automobilio.',
    noSuppliersInOrg: 'Organizacijoje nėra tiekėjų.',
    supplierFallbackPrompt: 'Nėra automobilio – siųskite užsakymą sukonfigūruotiems tiekėjams.',
    createSupplierFallbackBooking: 'Sukurkite užsakymą per tiekėjus',
    managedRequestPrompt: 'Automobilio nėra – siųskite užklausą automobilį skiriančiai automobilių nuomos įmonei.',
    createManagedRequest: 'Sukurkite užklausą automobilių nuomos įmonei',
    requestsRow: 'Prašymai',
    requestShort: 'Užklausa',
    pastBookingNotDeletable: 'Praeitų užsakymų atšaukti negalima.',
    bookingHistoryLimitHint: 'Matote paskutinių 3 mėnesių užsakymus.',
    vehicleReplacementTitle: 'Transporto priemonės keitimas',
    replaceWithVehicle: 'Pakeiskite automobiliu',
    replaceVehicle: 'Keisti transporto priemonę',
    takeOutOfService: 'Išimti iš tarnybos',
    returnToService: 'Vėl eksploatuoti',
    removeFromPool: 'Išimkite iš baseino',
    outOfService: 'Neveikia',
    futureBookingsCount: '{{count}} būsimas / dabartinis (-i) transporto priemonės užsakymas (-ai).',
    vehicleReplaceConfirm: 'Keisti transporto priemonę ir perkelti {{count}} užsakymą (-us)?',
    vehicleReplaceDone: '{{count}} užsakymas (-ai) perkeltas (-i) į naują transporto priemonę.',
    vehicleOutOfServiceConfirm: 'Pažymėti nenaudojamą ir iš naujo priskirti {{count}} užsakymą (-us)?',
    vehicleOutOfServiceDone: '{{reassigned}} perskirstyta, {{collisions}} susidūrimo užsakymuose.',
    vehicleReturnToServiceDone: 'Transporto priemonė vėl eksploatuojama.',
    vehicleRemoveFromPoolConfirm: 'Pašalinti transporto priemonę ir iš naujo priskirti {{count}} užsakymą (-us)?',
    vehicleRemoveFromPoolDone: '{{reassigned}} perskirstyta, {{collisions}} susidūrimo užsakymuose.',
    requestsColOrganization: 'Klientas/grupė',
    bookingOrganization: 'Klientas/grupė',
    fleetAssignTitle: 'Priskirti automobilį iš parko',
    fleetAssignHint: 'Automobilių nuomos įmonė gali priskirti savo automobilį šiai išleidimo vietai. Klientas gali pridėti tik savo automobilius.',
    fleetAssignEmpty: 'Šiuo metu parke nėra laisvų automobilių.',
    fleetAssignPlaceholder: 'Pasirinkite automobilį iš parko',
    fleetAssignButton: 'Priskirti',
    fleetAssignSuccess: 'Automobilis paskirtas.',
    fleetAssignError: 'Nepavyko priskirti automobilio.',
    fleetAssignFromRequestHint: 'Arba priskirkite nemokamą automobilį iš parko šiam konkrečiam užsakymui.',
    basisTitle: 'Užsakymo dokumentai',
    basisBack: 'Atgal į užsakymą',
    basisBackToList: 'Atgal į sąrašą',
    basisDescriptionOwn: 'Ieškokite grąžintų užsakymų ir atidarykite dokumentą.',
    basisDescriptionAll: 'Ieškokite organizacijoje grąžintų užsakymų ir atidarykite dokumentą.',
    basisSearch: 'Ieškoti',
    basisSearchPlaceholder: 'Pavadinimas, mokesčių kodas, pristatymo vieta...',
    basisEmpty: 'Grąžintų užsakymų nerasta.',
    basisLoadError: 'Nepavyko įkelti užsakymo dokumentų.',
    basisDetailLoadError: 'Nepavyko atidaryti dokumento.',
    basisOpen: 'Atviras substratas',
    basisColVehicle: 'Transporto priemonės',
    basisColPeriod: 'Laikotarpis',
    basisDownloadPdf: 'Spausdinti / PDF',
    basisPdfError: 'Nepavyko sukurti PDF.',
    basisBookedFor: 'Užsakyta',
    basisLoanHint: 'Automobilis laikinai buvo priskirtas iš automobilių nuomos įmonės parko.',
    basisKpiDistance: 'Vairavimo atstumas',
    basisKpiOdometer: 'Skaitiklio nustatymas',
    basisKpiWarnings: 'Įspėjimai',
    basisKpiCo2: 'CO₂',
    basisSectionTrips: 'Kelionės',
    basisSectionGeofences: 'Geotvoros',
    basisSectionWarnings: 'Įspėjimai',
    basisSectionEnvironment: 'Aplinka',
    basisNoTrips: 'Jokių kelionių per laikotarpį.',
    basisNoWarnings: 'Jokių įspėjimų.',
    basisGeofenceCost: 'Kaina',
    basisPassages: 'ištraukas',
    basisFuel: 'Kuro',
    resourceManagerShowAllPools: 'Rodyti visus baseinus',
    oldBookingTitle: 'Senas užsakymas',
    oldBookingDescription: 'Dienos transporto priemonės apžvalga – istoriniai užsakymo duomenys (laikinas modulis)',
    oldBookingTemporaryNotice: 'Laikinas modulis su istoriniu eksportu. Pašalinta, kai perkėlimas baigtas.',
    oldBookingDateRange: 'Duomenys: {{from}} – {{to}}',
    bookingSearchLoadError: 'Nepavyko atnaujinti paieškos rezultato. Rodomas ankstesnis sąrašas.',
    editBooking: 'Keisti rezervaciją',
    editButton: 'Redaguoti',
    editBookingTitle: 'Keisti rezervaciją',
    editBookingSelfSubtitle: 'Pakeiskite rezervaciją – laiką, tikslą ir dalyvius. Turėdami leidimą, prieš startą galite pakeisti išlaipinimo vietą ir nemokamą automobilį.',
    extendConflictTitle: 'Laikas nesutampa su kitu užsakymu tame pačiame automobilyje.',
    extendConflictMax: 'Galite išplėsti iki {{time}}.',
    extendConflictUseMax: 'Išnaudokite tą laiką',
    extendConflictContactCs: 'Jei jums reikia daugiau laiko, susisiekite su klientų aptarnavimo tarnyba.',
    deleteBooking: 'Ištrinti užsakymą',
    deleteBookingConfirm: 'Ar norite ištrinti užsakymą? Jis išjungtas, bet nepašalintas.',
    deleteBookingSuccess: 'Užsakymas buvo išjungtas',
    deleteBookingError: 'Nepavyko ištrinti užsakymo',
    startTooFarInPast: 'Pradžios laikas turi būti ne anksčiau kaip 5 minutės anksčiau.',
    assignedVehicleLocked: 'Paskirta transporto priemonė (negalima keisti pratęsimo metu)',
    bookedForRequired: 'Pasirinkite, kam priklausys automobilis',
    startLockedHint: 'Užsakymas jau prasidėjo – pradžios laikas keisti negalima.',
    editBookingStartAt: 'Užsakymas nuo',
    editBookingEndAt: 'Užsakymas iki',
    editBookingCustomerName: 'Kliento vardas',
    editBookingNotes: 'komentuoti',
    editBookingSaveSuccess: 'Užsakymas buvo atnaujintas',
    editBookingSaveError: 'Nepavyko atnaujinti užsakymo',
    expiredEndOnlyHint: 'Užsakymo laikas praėjo. Tik pabaigos laikas gali būti perkeltas, o naujas laikas turi būti ateityje ir laisvas.',
    expiredEndMustBeFuture: 'Naujas pabaigos laikas turi būti ateityje',
    expiredEndNoAccess: 'Įveiktų užsakymų negalima redaguoti pagal jūsų vaidmenį',
    editBookingInvalidRange: 'Pabaigos laikas turi būti po pradžios laiko',
    editBookingPersonSearch: 'Ieškokite asmens (vardas, el. pašto adresas arba RSID)…',
    editBookingNoMatches: 'Jokių hitų',
    editBookingFreeTextHint: 'Pasirinkite asmenį iš sąrašo arba parašykite laisvą vardą.',
    blockButton: 'Blokuoti',
    blockButtonHint: 'Užblokuokite transporto priemonę ir sukurkite pretenziją',
    blockNoVehicle: 'Užsakymui nėra priskirtos transporto priemonės, kurią būtų galima blokuoti',
    blockTitle: 'Blokuoti transporto priemones',
    blockVehicleLabel: 'Transporto priemonės',
    blockDamageType: 'Žalos tipas',
    blockDamageType_collision: 'Susidūrimas',
    blockDamageType_theft: 'Vagystė',
    blockDamageType_fire: 'Ugnis',
    blockDamageType_vandalism: 'Vandalizmas',
    blockDamageType_other: 'Įvairūs',
    blockDamageTypeRequired: 'Pasirinkite žalos tipą',
    blockDescription: 'Aprašymas',
    blockLocation: 'Vieta (neprivaloma)',
    blockDuration: 'Užblokuokite išteklius',
    blockHours_12: '12 valandų',
    blockHours_24: '24 valandos',
    blockHours_120: '120 valandų',
    blockUntilPreview: 'Blokavimas taikomas',
    blockConfirm: 'Blokuoti',
    blockSaveSuccess: 'Transporto priemonė buvo užblokuota. Iš naujo užsakyta į turimą automobilį: {{reassigned}}. Laukiama apdorojimo: {{collisions}}',
    blockSaveSuccessReassigned: 'Transporto priemonė buvo užblokuota. {{reassigned}} rezervacija (-os) perkelta (-os) į laisvą automobilį. Kitų užsakymų automobiliai nebuvo liesti.',
    blockSaveSuccessWaiting: 'Transporto priemonė buvo užblokuota. Nėra laisvo automobilio – {{collisions}} rezervacija (-os) laukia apdorojimo.',
    blockSaveSuccessNone: 'Transporto priemonė buvo užblokuota.',
    blockSaveSuccessEnded: 'Užsakymas buvo nutrauktas, nes transporto priemonė netinkama naudoti. Pabaigos laikas buvo nustatytas dabar.',
    blockSaveError: 'Nepavyko užblokuoti transporto priemonės',
    blockedListButton: 'Užblokuoti automobiliai',
    blockedListButtonHint: 'Peržiūrėkite užblokuotą kliento transporto priemonę',
    collisionListButtonHint: 'Rodyti rezervacijas be automobilio, kurios prasideda šiandien arba vėliau',
    blockedListTitle: 'Užblokuotos transporto priemonės',
    blockedListEmpty: 'Nėra aktyvių blokų',
    blockedListLoadError: 'Nepavyko gauti užblokuotų transporto priemonių',
    blockedListVehicle: 'Transporto priemonės',
    blockedListStart: 'Pradėti',
    blockedListEnd: 'Sustok',
    blockedListDamage: 'Pretenzijos ataskaita',
    blockedListDamageLink: 'Pretenzija Nr. {{id}}',
    blockedListDamageInline: 'Pretenzija Nr. {{id}}',
    blockedListNoDamage: 'Pranešimo apie žalą nėra',
    blockedListRelease: 'Paleisk',
    blockedListReleaseConfirm: 'Atleisti bloką, kad transporto priemonę būtų galima vėl rezervuoti?',
    blockedListReleased: 'Blokas buvo paleistas',
    blockedListReleaseError: 'Nepavyko atleisti bloko',
    blockedListUpdated: 'Blokavimas buvo atnaujintas',
    blockedListUpdateError: 'Nepavyko atnaujinti bloko',
    fuelPinTooltipTitle: 'Bako kortelė (PIN kodas)',
    fuelPinLoading: 'Gaunama degalų kortelė…',
    fuelPinNone: 'Nėra tanko kortelių',
    fuelPinError: 'Nepavyko gauti bako kortelės',
    fuelPinNoPin: '(be PIN kodo)',
    fuelCardsTitle: 'Degalų kortelės',
    optimizationTitle: 'Užsakymo optimizavimas',
    optimizationDescription: 'Peržiūrėkite šiandienos užimtumą kiekviename baseine ir optimizuokite transporto priemonių naudojimą naudodami AI.',
    optimizationDate: 'Data',
    optimizationAllPools: 'Visi baseinai',
    optimizationCurrentTitle: 'Dabartinė būsena',
    optimizationProposedTitle: 'Taip ir bus',
    optimizationKpiBookings: 'Rezervacijos',
    optimizationKpiUsedVehicles: 'Naudoti automobiliai',
    optimizationKpiTotalVehicles: 'Bendras automobilių skaičius',
    optimizationKpiUtilization: 'Panaudojimo rodiklis',
    optimizationRun: 'Optimizuoti',
    optimizationRunning: 'Optimizuojama…',
    optimizationResultTitle: 'Rezultatai (prieš/po)',
    optimizationBefore: 'Prieš',
    optimizationAfter: 'Po to',
    optimizationFreedVehicles: 'Išlaisvinti automobiliai',
    optimizationSuggestions: 'Pasiūlymas',
    optimizationNoSuggestions: 'Pasirinktą dieną nėra jokių patobulinimų pasiūlymų.',
    optimizationSuggestionMove: '{{booking}}: {{from}} → {{to}}',
    optimizationNoData: 'Nėra rezervacijų pasirinktai dienai.',
    optimizationAiUnavailable: 'AI paslauga šiuo metu nepasiekiama. Dabartinė būsena vis tiek rodoma – bandykite optimizuoti dar kartą vėliau.',
    optimizationError: 'Nepavyko paleisti optimizavimo',
    optimizationLoadError: 'Nepavyko atkurti užimtumo',
    optimizationApply: 'Atlikite optimizavimą',
    optimizationApplying: 'Atlikti…',
    optimizationApplyConfirm: 'Taip užsakymai perkeliami pagal pasiūlymą atlaisvinti transporto priemones. Ar norite tęsti?',
    optimizationApplied: 'Optimizavimas baigtas: {{moves}} užsakymas (-ai) perkeltas (-ai), {{freed}} transporto priemonė išleista.',
    optimizationApplyError: 'Nepavyko užbaigti optimizavimo',
    optimizationApplyNeedsPool: 'Pasirinkite aukščiau esantį baseiną, kad atliktumėte optimizavimą.',
    fitTitle: 'Padarykite vietos rezervacijai',
    fitDescription: 'Įveskite norimą laiką ir reikalavimus. Sistema patikrina, ar rezervacija gali būti apgyvendinta perkeliant esamas rezervacijas tarp baseino transporto priemonių (nekeičiant jų laiko).',
    fitStart: 'Norima pradžia',
    fitEnd: 'Norima pabaiga',
    fitCustomerName: 'Pavadinimas/nuoroda',
    fitCustomerNamePlaceholder: 'Neprivalomas pavadinimas arba nuoroda',
    fitBookedFor: 'Užsakyta (asmeniui)',
    fitSelectPerson: 'Pasirinkite asmenį',
    fitSelectPersonRequired: 'Pasirinkite asmenį, kuriam turėtų būti taikomas užsakymas.',
    fitResourceType: 'Ištekliaus tipas',
    fitAnyResourceType: 'Bet koks išteklių tipas',
    fitAutomaticOnly: 'Tik automatinė pavarų dėžė',
    fitEquipment: 'Reikalavimai įrangai',
    fitCheck: 'Patikrinkite tinkamumą',
    fitChecking: 'Tikrinama…',
    fitCheckError: 'Nepavyko patikrinti tinkamumo',
    fitFeasible: 'Užsakymas vyks adresu {{vehicle}}.',
    fitInfeasible: 'Užsakymas negali būti apgyvendintas net persikėlus.',
    fitNoMoves: 'Esamų užsakymų perkelti nereikia.',
    fitMovesTitle: 'Šis {{count}} užsakymas (-ai) perkeltas (-i):',
    fitApply: 'Sukurkite užsakymą ir perkelkite',
    fitApplying: 'Taikoma…',
    fitApplyConfirm: 'Taip sukuriamas naujas užsakymas ir esami užsakymai perkeliami į kitas transporto priemones. Ar norite tęsti?',
    fitApplyError: 'Nepavyko pritaikyti tinkamumo',
    groupMemberCount: '{{count}} žmonės',
    groupOrganizerRole: 'Atsakingas · visada gali pasiimti raktą',
    groupDriverLicenseConfirmed: 'Bent vienas grupės narys turi galiojantį vairuotojo pažymėjimą',
    groupFooterStatus: '{{members}} grupės nariai · {{keys}} su rakto leidimu',
    newGroupBookingSubtitle: 'Užpildykite transporto priemonės rezervaciją keliems kartu keliaujantiems žmonėms.',
    settingsTitle: 'Užsakymo nustatymai',
    settingsDescription: 'Konfigūruokite rezervavimo formas, projektus, paskirties vietas, išlaidų centrus, tikslus ir užsakymo sąlygas kiekviename organizacijos viršutiniame mazge.',
    settingsTopNode: 'Organizacija (viršutinis mazgas)',
    settingsSaved: 'Nustatymai išsaugoti',
    settingsSaveError: 'Nepavyko išsaugoti nustatymų',
    tabFormFields: 'Užsakymo forma',
    tabQuickGuest: 'Greitasis užsakymas',
    quickGuestSettingsHelp: 'Pagal numatytuosius nustatymus svečio paskyra ištrinta praėjus 60 minučių po užsakymo užbaigimo. Vardas, telefonas ir el. pašto adresas lieka užsakyme.',
    quickGuestReuseLabel: 'Išsaugoti svečių paskyras pakartotiniam naudojimui',
    quickGuestReuseHint: 'Jei laukelis pažymėtas, paskyra nebus ištrinta. Tame pačiame el. laiške įrašomas vardas ir telefono numeris, o paskyra pakartotinai naudojama kito greito užsakymo metu.',
    tabProjectImport: 'Importavimo projektas',
    tabDestinations: 'Paskirties vietos',
    tabCostCenters: 'Išlaidų centrai',
    tabCostSettings: 'Užsakymo mokesčiai',
    costSettings: {
      orgHelp: 'Bendra vidinė kliento atsiskaitymo pagal išteklių tipą. Taikoma visoms pristatymo vietoms, jei vietai nenurodyta sava vertė.',
      pickupHeading: 'Rezervavimo išlaidos (vieta)',
      pickupHelp: 'Tuščias laukas = paveldi bendrą išteklių tipo nustatymą. Įveskite vertę, kurią norite nepaisyti šioje vietoje.',
      noResourceTypes: 'Klientui neįjungti jokie išteklių tipai. Aktyvuokite sistemos tipus arba kurkite klientų tipus skiltyje Rezervavimo ištekliai.',
      inheritPlaceholder: 'Paveldėti',
      inheritedValue: 'Bendra',
      legacyCancellationNote: 'Atšaukimo taisyklė organizacijos lygiu (administravimas) yra atskira; čia valdomas atsiskaitymas pagal išteklių tipą.',
      baseCostPerBooking: 'Pagrindinė kaina (SEK/užsakymas)',
      hourlyCost: 'Bendra valandos kaina (SEK/valanda)',
      kmCost: 'Kilometro kaina (SEK/km)',
      cancellationFee: 'Atšaukimo pard. (SEK/užsakymas)',
      cancellationHours: 'Atšaukta per (valandomis)',
      maxDailyCost: 'Didžiausia dienos kaina (SEK)',
      monthlyCost30d: 'Mėnesio mokestis už 30 dienų (SEK)',
      billingTimeFrom: 'Valandinis atsiskaitymas nuo laikrodžio',
      billingTimeTo: 'Valandinis atsiskaitymas pagal laikrodį',
      offHoursHourlyCost: 'Valandinis atsiskaitymas kitu laiku (SEK/val.)',
    },
    tabTerms: 'Užsakymo sąlygos',
    formSettingsHelp: 'Nustatymai taikomi visiems naudotojams, esantiems pasirinktos organizacijos viršutiniame mazge.',
    formSettingsField: 'Laukas',
    formSettingsVisible: 'Matoma',
    formSettingsRequired: 'Privalomas',
    formSettingsLocked: 'užrakinta',
    projectImportDescription: 'Atsisiųskite šabloną, užpildykite projektą ir įkelkite failą. Esamų projektų numeriai atnaujinami.',
    downloadProjectTemplate: 'Parsisiųsti projekto šabloną',
    importProjects: 'Importo projektas',
    importProjectsSuccess: 'Importavimas baigtas: {{created}} naujas, {{updated}} atnaujintas',
    importProjectsError: 'Importuoti nepavyko',
    importProjectsResult: 'Sukurta {{created}}, atnaujinta {{updated}}',
    importRowError: '{{row}} eilutė: {{message}}',
    projectSearchPlaceholder: 'Ieškoti projekto...',
    projectCode: 'Projekto Nr',
    projectDescription: 'Projekto aprašymas',
    projectAccountString: 'Paskyros eilutė',
    projectValidFrom: 'Galioja nuo',
    projectNumber: 'Projekto numeris',
    projectPlaceholder: 'Ieškoti projekto...',
    noProjects: 'Jokių projektų. Norėdami pradėti, importuokite iš šablono.',
    downloadTemplateError: 'Nepavyko atsisiųsti šablono',
    footerRequiredHint: 'Laukai, pažymėti *, yra privalomi',
    saveBlockedTitle: 'Dar nepavyko išsaugoti:',
    saveBlockedPolicy: 'Sutikite su užsakymo politika (slinkite formą žemyn)',
    saveBlockedTerms: 'Sutikite su užsakymo sąlygomis (formoje slinkite žemyn)',
    saveBlockedDriverLicense: 'Patvirtinkite, kad turite galiojantį vairuotojo pažymėjimą',
    saveBlockedNoVehicle: 'Pasirinktu laiku nėra transporto priemonės',
    saveBlockedProject: 'Iš sąrašo pasirinkite projekto numerį (po paieškos spustelėkite mygtuką)',
    section: {
      booking: 'Rezervacija',
      group: 'Grupės nariai',
      vehicle: 'Transporto priemonės',
      resource: 'Išteklius',
      trip: 'Kelionė',
      admin: 'Administracine tvarka',
    },
    formField: {
      booking_type: 'Tipas (užsakymas / grupinis užsakymas)',
      booked_for: 'Užsakė / už',
      start_end: 'Pradžia ir pabaiga',
      recurrence: 'Pasikartojantis užsakymas',
      group_members: 'Grupės nariai',
      vehicle: 'Transporto priemonės',
      automatic_transmission_filter: 'Tik automatinė pavarų dėžė',
      equipment_filter: 'Filtruoti pagal įrangą',
      trip_purpose: 'Kelionės tikslas',
      destination: 'Paskirties vieta',
      estimated_km: 'Numatomas atstumas',
      passenger_count: 'Keleivių skaičius',
      driver_license: 'Patvirtintas vairuotojo pažymėjimas',
      service_booking: 'Paslauga / pareiga',
      approved_by: 'Patvirtino (atestacija)',
      cost_center: 'Išlaidų centras',
      project: 'Projekto numeris',
      notes: 'Pastabos',
      booking_policy: 'Užsakymo politika',
      terms: 'Užsakymo sąlygos',
    },
    returnOverrideButton: 'Leisti grąžinti be rakto',
    returnOverrideHint: 'Leiskite užbaigti užsakymą, net jei dėžutėje nėra rakto / kortelės.',
    returnOverrideTitle: 'Leisti grąžinti be rakto',
    returnOverrideDescription: 'Vartotojas gali baigti užsakymą, net jei trūksta rakto / kortelės arba durys nėra užrakintos. Įveskite priežastį (log dujų).',
    returnOverrideReasonLabel: 'Priežastis',
    returnOverrideReasonPlaceholder: 'Pvz. pamestas raktas, trūksta kortelės...',
    returnOverrideConfirm: 'Leisti grąžinti',
    returnOverrideSuccess: 'Leidžiamas grąžinimas be rakto užsakant',
    returnOverrideError: 'Nepavyko leisti grąžinti be rakto',
    postReturnAccessButton: 'Suteikite 15 min. prieigą',
    postReturnAccessHint: 'Suteikite klientui vėl prieiti prie automobilio 15 minučių (pvz., pamirštas krepšys). Tik per 60 minučių po grįžimo.',
    postReturnAccessConfirm: 'Suteikti klientui 15 minučių vėl prieiti prie automobilio? Tai taip pat veikia, jei transporto priemonę užsakė kas nors kitas.',
    postReturnAccessSuccess: 'Klientui vėl suteikta 15 minučių prieiga',
    postReturnAccessError: 'Nepavyko suteikti naujos prieigos',
    postReturnAccessTooLate: 'Nauja prieiga gali būti suteikta tik per 60 minučių po grįžimo',
    postReturnAccessReturnedHint: 'Užsakymas grąžintas. Pamirštam bagažui naudokite „Suteikti 15 min. prieigą“ – nekeiskite tik pabaigos laiko.',
    noTerms: 'Užsakymo sąlygos dar nesukurtos.',
    termsVersion: 'Versija',
    termsVersionTitle: 'Pavadinimas',
    termsContent: 'Turinys',
    vehiclePoolsTitle: 'Automobilių baseinai',
    vehiclePoolsDescription: 'Transporto priemonių baseinas yra atskira išlaipinimo vieta, kurios negalima rezervuoti. Spintelę galima bendrinti su rezervuojamomis vietomis. Užsakymai raktų paėmimo vietoje matomi kaip įprasta.',
    addPool: 'Sukurti automobilių baseiną',
    noPools: 'Kol kas nėra automobilių baseinų',
    cabinetViaPickupLocation: 'Spintelė per pristatymo punktą',
    cabinetViaPickupLocationHint: 'Pasirinkite rezervuojamą vietą, kurios raktų spintelė bus bendrinama su baseinu.',
    selectOrgFirstForUsers: 'Pirmiausia pasirinkite organizaciją, kad pamatytumėte naudotojus',
    selectKeysHint: 'Tik raktai, kurių dar nėra rezervuojamoje pristatymo vietoje.',
    noCandidateKeys: 'Nėra nemokamų baseino raktų pasirinktai spintelei ir organizacijai',
    maxHours: 'Maksimalios valandos',
    members: 'nariai',
    selectUser: 'Pasirinkite vartotoją',
    noMembers: 'Dar nėra narių',
    memberName: 'Vardas',
    memberEmail: 'paštas',
    pinCode: 'PIN kodas',
    linkedCabinet: 'Sujungta spintelė',
    noCabinet: 'Neprijungta spintelė – priskirkite raktų tvarkyme',
    selectKeys: 'Kokie raktai?',
    selectUsers: 'Vartotojas',
    noCabinetAtLocation: 'Prie šios pristatymo vietos neprijungta nė viena spintelė',
    confirmDeletePool: 'Ar norite ištrinti šį automobilių fondą? Taip pat pašalintas „KeyWin“ raktų krepšelis.',
    cannotDeleteActiveCheckouts: 'Negalima ištrinti – yra aktyvių paskolų',
  },
  workOrders: {
    title: 'Darbo užsakymai',
    pageTitle: 'Darbo užsakymų valdymas',
    description: 'Tvarkykite darbo užsakymus, pristatymus ir namų priežiūros užduotis',
    create: 'Sukurti darbo užsakymą',
    edit: 'Redaguoti',
    delete: 'Ištrinti',
    deleteConfirm: 'Ištrinti darbo užsakymą? Veiksmo atšaukti negalima.',
    deleteBlocked: 'Pradėto darbo užsakymo ištrinti negalima.',
    deleteError: 'Nepavyko ištrinti darbo užsakymo.',
    assign: 'Priskirti',
    unassign: 'Atšaukti priskyrimą',
    start: 'Pradėti',
    pause: 'Pristabdyti',
    resume: 'Tęsti',
    complete: 'Užbaigti',
    cancel: 'Atšaukti',
    optimize: 'Optimizuokite maršrutą',
    types: {
      SERVICE: 'Aptarnavimo darbas',
      DELIVERY: 'Pristatymas',
      HOMECARE: 'Namų priežiūra',
      INSPECTION: 'Apžiūra',
      INSTALLATION: 'Montavimas',
    },
    status: {
      DRAFT: 'Juodraštis',
      PENDING: 'Laukiama',
      ASSIGNED: 'Paskirta',
      OPTIMIZED: 'Optimizuotas',
      IN_PROGRESS: 'Vykdoma',
      ARRIVED: 'Atvyko',
      PAUSED: 'Pristabdyta',
      COMPLETED: 'Užbaigta',
      CANCELLED: 'Atšaukta',
      FAILED: 'Nepavyko',
    },
    priority: {
      LOW: 'Žemas',
      NORMAL: 'Normalus',
      HIGH: 'Aukštas',
      URGENT: 'Skubiai',
    },
    orderNumber: 'Užsakymo numeris',
    customer: 'Klientas',
    customerName: 'Kliento vardas',
    customerPhone: 'Telefonas',
    customerEmail: 'El. paštas',
    jobTitle: 'Pavadinimas',
    jobDescription: 'Aprašymas',
    notes: 'Pastabos',
    plannedDate: 'Planuojama data',
    timeWindow: 'Laiko langas',
    estimatedDuration: 'Numatoma trukmė',
    assignedVehicle: 'Paskirta transporto priemonė',
    assignedDriver: 'Paskirtas vairuotojas',
    stops: 'Sustoja',
    addStop: 'Pridėti stotelę',
    stopAddress: 'Adresas',
    stopContact: 'Kontaktinis asmuo',
    stopTimeWindow: 'Laiko langas',
    stopDuration: 'Numatomas laikas',
    routes: 'Maršrutai',
    route: 'Maršrutas',
    routeDate: 'Data',
    routeVehicle: 'Transporto priemonė',
    routeDriver: 'Vairuotojas',
    routeStatus: 'Būsena',
    routeDistance: 'Atstumas',
    routeDuration: 'Trukmė',
    optimizeRoute: 'Optimizuokite maršrutą',
    routeOptimized: 'Maršrutas optimizuotas',
    routeNotOptimized: 'Maršrutas neoptimizuotas',
    optimization: {
      title: 'Maršruto optimizavimas',
      optimize: 'Optimizuoti',
      optimizing: 'Optimizuojama...',
      freedTime: 'Išlaisvintas laikas',
      reducedDistance: 'Sumažintas atstumas',
      newOrder: 'Nauja tvarka',
      originalOrder: 'Originalus uzsakymas',
      vroomAvailable: 'Yra VROOM',
      vroomUnavailable: 'VROOM nepasiekiamas',
    },
    stats: {
      total: 'Iš viso',
      today: 'Šiandien',
      completed: 'Užbaigta',
      pending: 'Laukiama',
      overdue: 'Pavėluota',
      avgTime: 'Vidutinis laikas',
    },
    noOrders: 'Darbo užsakymų nerasta',
    selectVehicle: 'Pasirinkite transporto priemonę',
    selectDriver: 'Pasirinkite vairuotoją',
    confirmDelete: 'Ar tikrai norite ištrinti šį darbo užsakymą?',
    deleteSuccess: 'Darbo užsakymas ištrintas',
    createSuccess: 'Sukurtas darbo užsakymas',
    updateSuccess: 'Darbo užsakymas atnaujintas',
    assignSuccess: 'Paskirtas darbo užsakymas',
    completeSuccess: 'Darbo užsakymas baigtas',
    cancelSuccess: 'Darbo užsakymas atšauktas',
    optimizeSuccess: 'Maršrutas optimizuotas',
    delivery: {
      title: 'Paketo pristatymas',
      subtitle: 'Darbo užsakymai dėl pakuočių ir pristatymų',
      recipient: 'Gavėjas',
      address: 'Adresas',
      stop: 'Sustok',
      searchPlaceholder: 'Ieškoti užsakymo numerio, gavėjo, adreso...',
      newDelivery: 'Naujas pristatymas',
      noDeliveries: 'Pristatymų nerasta',
    },
    craftsman: {
      title: 'Amatininkas',
      subtitle: 'Darbo užsakymai meistrams ir servisas',
      customer: 'Klientas',
      address: 'Adresas',
      time: 'Laikas',
      searchPlaceholder: 'Ieškokite užsakymo numerio, kliento, adreso...',
      newWorkOrder: 'Nauja darbo tvarka',
      noWorkOrders: 'Darbo užsakymų nerasta',
      assigned: 'Paskirta',
      unassigned: 'Nepriskirta',
      assignPlaceholder: 'Ieškokite asmens...',
      assignSuccess: 'Paskirtas darbo užsakymas',
      assignError: 'Nepavyko priskirti',
      edit: 'Redaguoti',
      detail: 'Detalės / vykdymas',
      viewList: 'Sąrašas',
      viewGantt: 'Gantas',
      viewCalendar: 'Kalendorius',
      ordersShort: 'įsakymus',
    },
    detail: {
      assignment: 'Priskyrimas',
      person: 'Asmuo',
      vehicleOptional: 'Transporto priemonė (neprivaloma)',
      noVehicle: 'Nėra transporto priemonės',
      assign: 'Priskirti',
      gpsHint: 'Su priskirta transporto priemone kelionės laikas ir km registruojami automatiškai. Be jos laikas žymimas rankiniu būdu.',
      start: 'Pradėti',
      pause: 'Pristabdyti',
      resume: 'Tęsti',
      complete: 'Užbaigti',
      accounting: 'Apskaita',
      actualStart: 'Faktinė pradžia',
      actualEnd: 'Faktinė pabaiga',
      timeline: 'Pradžia ir pabaiga',
      historyStarted: 'Pradėta',
      historyPaused: 'Pristabdyta',
      historyResumed: 'Tęsta',
      historyCompleted: 'Užbaigta',
      totalTime: 'Visas laikas',
      travelTime: 'Kelionės laikas',
      workTime: 'Darbo laikas',
      distance: 'Atstumas',
      manualTime: 'Rankinis laiko žymėjimas',
      segmentType: 'Tipas',
      minutes: 'Minutės',
      segments: 'Laiko intervalai',
      completionNotes: 'Užbaigimo pastaba',
    },
    colType: 'Tipas',
    colStatus: 'Būsena',
    colStops: 'Sustok',
    allStatuses: 'Visos būsenos',
    allTypes: 'Visų tipų',
    searchPlaceholder: 'Ieškokite užsakymo numerio, pavadinimo, kliento...',
    form: {
      newTitle: 'Nauja darbo tvarka',
      editTitle: 'Redaguoti darbo užsakymą',
      title: 'Pavadinimas',
      titleRequired: 'Reikalingas pavadinimas',
      organization: 'Organizacija',
      orgRequired: 'Pasirinkite organizaciją',
      serviceType: 'Paslaugos tipas',
      serviceTypeRequired: 'Pasirinkite arba pridėkite paslaugos tipą',
      serviceTypeEmpty: 'Dar nėra tipų – pasirinkite Pridėti…',
      serviceTypeAdd: 'Pridėti…',
      serviceTypeSelectOrgFirst: 'Pirmiausia pasirinkite organizaciją',
      serviceTypeNamePlaceholder: 'Paslaugos tipo pavadinimas',
      serviceTypeNameRequired: 'Įveskite paslaugos tipo pavadinimą',
      serviceTypeCreateError: 'Nepavyko sukurti paslaugos tipo',
      customerName: 'Kliento vardas',
      customerPhone: 'Telefonas',
      address: 'Adresas',
      postalCode: 'Pašto kodas',
      city: 'Vieta',
      plannedDate: 'Planuojama data',
      timeWindowStart: 'Laiko langas nuo',
      timeWindowEnd: 'Laiko langas iki',
      description: 'Aprašymas',
    },
    import: {
      title: 'Importuoti',
      selectFile: 'Pasirinkite failą (Excel/CSV)',
      dropHint: 'Spustelėkite, kad pasirinktumėte Excel arba CSV failą',
      emptyFile: 'Faile nėra eilučių',
      parseError: 'Nepavyko perskaityti failo',
      mapping: 'Stulpelių atvaizdavimas',
      rows: 'linijos',
      row: 'Eilutė',
      ignore: 'Ignoruoti',
      import: 'Importuoti',
      importing: 'Importuojama...',
      created: 'Sukurta',
      failed: 'Nepavyko',
      titleMappingRequired: 'Susiekite stulpelį Pavadinimas',
      field: {
        title: 'Pavadinimas',
        customerName: 'Kliento vardas',
        customerPhone: 'Telefonas',
        customerEmail: 'paštas',
        address: 'Adresas',
        postalCode: 'Pašto kodas',
        city: 'Vieta',
        plannedDate: 'Planuojama data',
        timeWindowStart: 'Laikas nuo',
        timeWindowEnd: 'Daugiau laiko',
        estimatedDurationMinutes: 'Numatomas laikas (min.)',
        notes: 'Pastaba',
      },
    },
  },
  homecare: {
    title: 'Priežiūra namuose',
    subtitle: 'Priežiūros namuose maršrutų planavimas ir planavimas',
    date: 'Data',
    tabs: {
      planning: 'Planavimas',
      gantt: 'Ganto diagrama',
      map: 'Žemėlapis',
      roster: 'Darbo sąrašas',
      clients: 'Klientai',
      staff: 'Personalas',
    },
    planning: {
      visits: 'Apsilankymai',
      requiresMultiStaff: 'Reikalingi 2+ darbuotojai',
      teams: 'Komandos',
      pairTeams: 'porines komandas',
      soloTeams: 'solo komandos',
      pairTeam: 'Suporuota komanda',
      vehicles: 'Transporto priemonės',
      vehicleShortage: 'trūksta',
      vehiclesOk: 'Pakankamai',
      distance: 'Atstumas',
      suggestTeams: 'Pasiūlykite komandas',
      optimizeRoutes: 'Optimizuokite maršrutus',
      suggestedTeams: 'Siūlomos komandos',
      optimizationResult: 'Optimizavimo rezultatas',
      unassignedVisits: 'Nepriskirti apsilankymai',
      teamError: 'Nepavyko pasiūlyti komandų',
      optimizeError: 'Nepavyko optimizuoti maršrutų',
      timeWindow: 'Laiko langas',
      duration: 'Trukmė',
      staff: 'Personalas',
      priority: 'Pirmenybė',
      strategy: 'strategija',
      strategyBalanced: 'Subalansuota',
      strategyBalancedDesc: 'Optimizuoja pagal kompetencijos reikalavimus. Kai kurie apsilankymai gali būti nepriskirti.',
      strategyCoverAll: 'Aprėpti visus apsilankymus',
      strategyCoverAllDesc: 'Visi vizitai skirti nepriklausomai nuo kompetencijos. Rodomi įspėjimai.',
      strategyCalculateExtra: 'Apskaičiuokite išteklių poreikius',
      strategyCalculateExtraDesc: 'Rodo, kiek papildomų komandų reikia pilnai aprėpčiai.',
      optimizationRuns: 'Optimizavimo istorija',
      noRuns: 'Nėra išsaugotų optimizacijų',
      selectRun: 'Pasirinkite šį planą',
      deleteRun: 'Ištrinti',
      selectedRun: 'Aktyvus',
      archivedRun: 'Suarchyvuota',
      draftRun: 'Juodraštis',
      runStrategy: 'strategija',
      runCreated: 'Sukurta',
      extraTeamsNeeded: 'Reikalingos papildomos komandos',
      competenceWarnings: 'Įspėjimai dėl kompetencijos',
      competenceWarningDetail: 'trūksta kompetencijos',
      missingCompetences: 'Trūksta kompetencijos',
      reassignVisit: 'Perkelti į',
      reassignSuccess: 'Apsilankymas paskirtas iš naujo',
      reassignError: 'Nepavyko iš naujo priskirti apsilankymo',
      reoptimize: 'Iš naujo optimizuokite',
      manualChanges: 'Pakeitimai atlikti rankiniu būdu',
    },
    vehicleSource: 'Gaukite transporto priemones iš',
    selectVehicleSource: 'Pasirinkite transporto priemonės organizaciją',
    gantt: {
      team: 'Komanda',
      summary: 'Santrauka',
      noData: 'Nėra Ganto diagramos',
      noDataHint: 'Pirmiausia paleiskite optimizavimą planavimo skirtuke',
      travel: 'Kelionės',
      visit: 'Pas klientą',
      break: 'Pertrauka',
      unplanned: 'Neplanuota',
      totalTeams: 'Komandos',
      totalVisits: 'Apsilankymai',
      totalTravel: 'Atstumas',
      visitsLabel: 'apsilankymus',
      planned: 'suplanuotas laikas',
    },
    roster: {
      staff: 'Personalas',
      week: 'Savaitė',
      copyWeek: 'Kopijuoti į kitą savaitę',
      weekCopied: 'Savaitės tvarkaraštis nukopijuotas',
      confirmCopyWeek: 'Nukopijuoti tvarkaraštį į kitą savaitę? Esamiems tikslinės savaitės įrašams tai neturės įtakos.',
      nothingToCopy: 'Nėra ko kopijuoti – šios savaitės tvarkaraštis tuščias arba kitos savaitės jau yra tokie patys įrašai.',
      copyFailed: 'Nepavyko nukopijuoti tvarkaraščio',
    },
    clients: {
      searchPlaceholder: 'Ieškoti klientų...',
      add: 'Naujas Klientas',
      newClient: 'Naujas Klientas',
      editClient: 'Redaguoti klientą',
      name: 'Vardas',
      firstName: 'Vardas',
      lastName: 'Pavardė',
      personalNumber: 'Asmeninis numeris',
      address: 'Adresas',
      postalCode: 'Pašto kodas',
      city: 'Miestas',
      phone: 'Telefonas',
      doorCode: 'Durų kodas',
      floor: 'Grindys',
      specialInstructions: 'Specialios instrukcijos',
      emergencyContact: 'Avarinis kontaktas',
      emergencyPhone: 'Pagalbos telefonas',
      competences: 'Kompetencijos reikalavimai',
      noClients: 'Klientų nerasta',
      saved: 'Klientas išsaugotas',
      coordinates: 'Koordinatės',
      allocatedHours: 'Skirtas priežiūros laikas',
      hoursPerWeek: 'valandos/sav',
    },
    careNeeds: {
      title: 'Priežiūros poreikiai',
      add: 'Pridėkite priežiūros poreikį',
      edit: 'Redaguoti priežiūros poreikį',
      name: 'Vardas',
      duration: 'Trukmė (min.)',
      timeWindowStart: 'Laiko lango pradžia',
      timeWindowEnd: 'Laiko lango pabaiga',
      frequency: 'Dažnis',
      weekdays: 'Darbo dienomis',
      requiredStaff: 'Reikalingi darbuotojai',
      priority: 'Pirmenybė',
      description: 'Aprašymas',
      competences: 'Kompetencijos reikalavimai',
      mandatory: 'Privaloma',
      noNeeds: 'Priežiūros nereikia pridėti',
      saved: 'Išsaugotas priežiūros poreikis',
      deleted: 'Priežiūra išbraukta',
      confirmDelete: 'Ar norite ištrinti šį priežiūros poreikį?',
      generateVisits: 'Generuokite apsilankymus',
      generateVisitsDesc: 'Sukurkite apsilankymus iš priežiūros poreikių tam tikram laikotarpiui',
      fromDate: 'Nuo datos',
      toDate: 'Iki šiol',
      generated: 'sugeneruotų apsilankymų',
      noVisitsGenerated: 'Nereikia generuoti naujų apsilankymų',
      frequencies: {
        DAILY: 'Kasdien',
        WEEKDAYS: 'Darbo dienomis',
        WEEKLY: 'Kas savaitę',
        BIWEEKLY: 'Kas dvi savaites',
        MONTHLY: 'Kas mėnesį',
        CUSTOM: 'Pasirinktinis',
      },
      priorities: {
        LOW: 'Žemas',
        NORMAL: 'Normalus',
        HIGH: 'Aukštas',
        URGENT: 'Skubiai',
      },
      weekdayNames: {
        '1': 'Pirm',
        '2': 'antradienis',
        '3': 'trečia',
        '4': 'Ketvirtadienis',
        '5': 'penk',
        '6': 'Šešt',
        '7': 'Saulė',
      },
    },
    staff: {
      searchPlaceholder: 'Ieškokite darbuotojų...',
      startsFromHome: 'Prasideda nuo namų',
      startsFromOffice: 'Prasideda nuo biuro',
      startType: 'Pradinė padėtis',
      homeAddress: 'Namų adresas',
      homeLat: 'Platuma (namai)',
      homeLng: 'Ilguma (namai)',
      shiftStart: 'Pamainos pradžia',
      shiftEnd: 'Pamainos pabaiga',
      workHours: 'Darbo valandos',
      competences: 'Kompetencijos',
      editStaff: 'Redaguoti personalą',
      noCompetences: 'Jokių kompetencijų',
      noStaff: 'Darbuotojų nerasta',
      saved: 'Personalas išgelbėtas',
    },
  },
  fuel: {
    title: 'Kuro valdymas',
    description: 'Sąskaitos faktūros, degalų kortelės ir kortelės-transporto priemonės ryšys',
    invoices: {
      tab: 'Sąskaitos faktūros',
      invoiceNumber: 'Sąskaitos numeris',
      invoiceDate: 'Sąskaitos faktūros data',
      transactionCount: 'Suskaičiuoti',
      totalExclVat: 'Išskyrus PVM',
      vat: 'VAT',
      total: 'Iš viso',
      noInvoices: 'Sąskaitų faktūrų nerasta',
      loadError: 'Nepavyko įkelti sąskaitų faktūrų',
      date: 'Data',
      station: 'Stotis',
      product: 'Produktas',
      quantity: 'Litrų',
      priceExclVat: 'Kaina be PVM',
      vatAmount: 'VAT',
      company: 'Įmonė',
    },
    duplicate: {
      badge: 'Dublikatas',
      tooltip: 'Tas pats pylimas jau yra iš kitos įmonės — galima dviguba sąskaita',
      tooltipCompany: 'Tas pats pylimas jau yra {{company}} — galima dviguba sąskaita',
    },
    cards: {
      tab: 'Kuro kortelės',
      cardNumber: 'Kortelės numeris',
      pinCode: 'PIN kodas',
      fuelCompany: 'Kuro įmonė',
      linkedVehicle: 'Susieta transporto priemonė',
      linkedSince: 'Susieta nuo',
      notLinked: 'Nesusieti',
      link: 'Nuoroda',
      unlink: 'Atsieti',
      noCards: 'Degalų kortelių nerasta',
      loadError: 'Nepavyko įkelti kortelių',
      confirmUnlink: 'Ar tikrai norite atsieti šią kortelę?',
      unlinkSuccess: 'Kortelė atsieta',
      unlinkError: 'Nepavyko atsieti kortelės',
      linkModal: {
        title: 'Susieti kortelę su transporto priemone',
        vehicle: 'Transporto priemonė',
        validFrom: 'Susieta iš',
        selectVehicle: 'Pasirinkite transporto priemonę...',
        pinCode: 'PIN kodas',
        pinCodePlaceholder: 'PIN kodas',
        save: 'Nuoroda',
        success: 'Kortelė susieta su transporto priemone',
        error: 'Nepavyko susieti kortelės',
      },
      history: {
        title: 'Ryšio istorija',
        vehicle: 'Transporto priemonė',
        from: 'Nuo',
        to: 'Į',
        active: 'Aktyvus',
        inactive: 'Baigėsi',
        noHistory: 'Jokios istorijos',
        loadError: 'Nepavyko įkelti istorijos',
      },
      invoiceNumber: 'Sąskaitos numeris',
      embossedNumber: 'Reljefinis numeris',
      cardName: 'Trumpas vardas',
    },
    vehicleCard: {
      noCards: 'Su šia transporto priemone nebuvo susietos jokios degalų kortelės',
      noTransactions: 'Pasirinktu laikotarpiu kuro operacijų nerasta',
      outsidePeriod: 'Pasirinktu laikotarpiu operacijų nėra. Yra {{count}} operacijų už periodo ribų — praplėskite datas.',
      loadTxError: 'Nepavyko įkelti kuro operacijų',
      totalLiters: 'Iš viso litrų',
      totalCost: 'Bendra kaina',
      addCard: 'Pridėti kortelę',
      cardNumber: 'Kortelės numeris',
      validFrom: 'Galioja nuo',
      linkSuccess: 'Susieta degalų kortelė',
      linkError: 'Nepavyko susieti degalų kortelės',
      unlinkSuccess: 'Degalų kortelė atsieta',
      unlinkError: 'Nepavyko atsieti degalų kortelės',
      confirmUnlink: 'Ar tikrai norite atsieti šią kortelę?',
      unlink: 'Atsieti',
      loadError: 'Nepavyko gauti degalų kortelės',
      invoiceNumber: 'Sąskaitos numeris',
      embossedNumber: 'Reljefinis numeris',
      okq8BothRequired: 'OKQ8 reikalingas ir sąskaitos faktūros numeris, ir įspaustas numeris',
    },
  },
  modules: {
    addFavorite: 'Pridėti prie mėgstamiausių',
    removeFavorite: 'Pašalinti iš mėgstamiausių',
    roles: {
      title: 'Vaidmenys',
      description: 'Vaidmenys ir leidimai',
    },
    organizations: {
      title: 'Organizacijos',
      description: 'Tvarkyti organizacijas',
    },
    users: {
      title: 'Vartotojai',
      description: 'Vartotojų valdymas',
    },
    translations: {
      title: 'Vertimai',
      description: 'Vertimai ir kalba',
    },
    imports: {
      title: 'Importuoti',
      description: 'Importuoti duomenis iš failų',
    },
    packages: {
      title: 'Paketai',
      description: 'Tvarkykite paketus ir prenumeratas',
    },
    devices: {
      title: 'Prietaisai',
      description: 'Tvarkyti įrenginius',
    },
    'device-management': {
      title: 'Įrenginių valdymas',
      description: 'Išplėstinis įrenginio valdymas',
    },
    'sim-cards': {
      title: 'SIM kortelės',
      description: 'Tvarkykite SIM korteles, peržiūrėkite naudojimą ir kurkite ataskaitas naudodami Jasper API',
    },
    geofences: {
      title: 'Geotvoros',
      description: 'Tvarkyti geotvoras',
    },
    'geofence-events': {
      title: 'Geofence Renginiai',
      description: 'Peržiūrėkite geotvoros įvykius',
    },
    support: {
      title: 'Palaikymas',
      description: 'Pagalbinės funkcijos',
    },
    'service-workshops': {
      title: 'Dirbtuvės',
      description: 'Tvarkykite dirbtuves ir techninės priežiūros personalą',
    },
    'ai-log': {
      title: 'AI žurnalas',
      description: 'Peržiūrėkite AI žurnalus',
    },
    'data-migration': {
      title: 'Duomenų perkėlimas',
      description: 'Perkelkite duomenis tarp sistemų',
    },
    'device-commands': {
      title: 'Įrenginio komandos',
      description: 'Siųsti komandas į įrenginius',
    },
    'audit-log': {
      title: 'Audito žurnalas',
      description: 'Peržiūrėkite audito žurnalus',
    },
    'general-audit-log': {
      title: 'Pakeitimų žurnalas',
      description: 'Peržiūrėkite pakeitimų žurnalą',
    },
    'error-log': {
      title: 'Klaidų žurnalas',
      description: 'Peržiūrėkite klaidų žurnalus',
    },
    'eco-settings': {
      title: 'ECO nustatymai',
      description: 'Konfigūruokite ECO nustatymus',
    },
    'system-monitor': {
      title: 'Sistemos monitorius',
      description: 'Stebėti sistemos būseną',
    },
    'slow-queries': {
      title: 'Lėti užklausos',
      description: 'Peržiūrėkite lėtas duomenų bazės užklausas',
    },
    'data-replay': {
      title: 'Duomenų atkūrimas',
      description: 'Pakartokite GPS duomenis',
    },
    'trip-validation': {
      title: 'Kelionės patvirtinimas',
      description: 'Patvirtinti keliones',
    },
    'import-sources': {
      title: 'Importuoti šaltinius',
      description: 'Tvarkyti importo šaltinius',
    },
    'sso-log': {
      title: 'SSO žurnalas',
      description: 'Nepavykę ir nutraukti SSO bandymai pagal klientą ir įrenginį',
    },
    'gps-data-lag': {
      title: 'GPS dump eilė',
      description: 'Įrenginiai, siunčiantys atsiliekančius GPS duomenis; flush per SMS',
    },
    'api-metrics': {
      title: 'Našumas',
      description: 'Vartotojų augimas, rezervacijos ir API vėlinimas prieš sistemos apkrovą',
    },
    trips: {
      title: 'Kelionės',
      description: 'Peržiūrėkite ir analizuokite savo transporto priemonių keliones',
    },
    'eco-driving': {
      title: 'EKO vairavimas',
      description: 'Analizuoti vairavimo įpročius ir poveikį aplinkai',
    },
    'speed-compliance': {
      title: 'Greičio laikymasis',
      description: 'Išanalizuoti greičio atitiktį pagal organizaciją ir transporto priemonę',
    },
    'energy-consumption': {
      title: 'Energijos suvartojimas',
      description: 'Išanalizuoti degalų sąnaudas pagal organizaciją ir transporto priemonę',
    },
    'vehicle-wear': {
      title: 'Transporto priemonių susidėvėjimas',
      description: 'Išanalizuokite, kaip vairavimo elgsena veikia transporto priemonės nusidėvėjimą',
    },
    underutilized: {
      title: 'Nepakankamai eksploatuojamos transporto priemonės',
      description: 'Identifikuokite mažo naudojimo transporto priemones',
    },
    co2: {
      title: 'CO2 emisija',
      description: 'Apskaičiuokite ir analizuokite CO2 emisiją',
    },
    'geofence-zones': {
      title: 'Geotvoros zonos ataskaita',
      description: 'Išanalizuokite, kaip dažnai transporto priemonės yra zonose',
    },
    'driving-log': {
      title: 'Vairavimo žurnalas',
      description: 'Vairavimo žurnalas pagal mokesčių institucijos nurodymus',
    },
    'work-trips': {
      title: 'Darbo kelionės',
      description: 'Kelionės bendrais įmonės automobiliais',
    },
    odometer: {
      title: 'Odometro ataskaita',
      description: 'Peržiūrėkite transporto priemonės odometro rodmenis tam tikrą dieną',
    },
    rental: {
      title: 'Nuomos ataskaita',
      description: 'Pilna nuomos ataskaita su kelionėmis, išlaidomis ir būsena',
    },
    'rental-report': {
      title: 'Nuomos ataskaita',
      description: 'Nuomos statistika ir ataskaitos',
    },
    'stop-time': {
      title: 'Sustabdymo laiko analizė',
      description: 'Išanalizuoti transporto priemonės sustojimo laiką',
    },
    'route-analysis': {
      title: 'Maršruto analizė',
      description: 'Maršruto optimizavimas ir analizė',
    },
    'vehicle-kpi': {
      title: 'Transporto priemonės KPI',
      description: 'Pagrindiniai kiekvienos transporto priemonės veikimo rodikliai',
    },
    dtc: {
      title: 'DTC ataskaita',
      description: 'Peržiūrėkite ir analizuokite kiekvienos transporto priemonės diagnostikos gedimų kodus (DTC).',
    },
    'dtc-report': {
      title: 'DTC ataskaita',
      description: 'Diagnostikos gedimų kodai',
    },
    customers: {
      title: 'Klientai',
      description: 'Tvarkyti klientus',
    },
    projects: {
      title: 'Projektai',
      description: 'Tvarkyti projektus',
    },
    procurements: {
      title: 'Pirkimai',
      description: 'Tvarkyti pirkimus',
    },
    pipeline: {
      title: 'Dujotiekis',
      description: 'Pardavimo vamzdynas',
    },
    economy: {
      title: 'Ekonomika',
      description: 'Ekonomikos apžvalga',
    },
    invoices: {
      title: 'Sąskaitos faktūros',
      description: 'Tvarkyti sąskaitas faktūras',
    },
    pricelist: {
      title: 'Kainoraštis',
      description: 'Tvarkyti kainoraštį',
    },
    organization: {
      title: 'Organizacija',
      description: 'Tvarkyti organizacijos struktūrą',
    },
    fleet: {
      title: 'Laivynas',
      description: 'Transporto priemonių apžvalga ir valdymas',
    },
    drivers: {
      title: 'Vairuotojai',
      description: 'Vairuotojo valdymas',
    },
    'fleet-overview': {
      title: 'Automobilių parkas',
      description: 'Transporto priemonių apžvalga ir valdymas',
    },
    'live-tracking': {
      title: 'Tiesioginis žemėlapis',
      description: 'Transporto priemonių sekimas realiu laiku',
    },
    'track-playback': {
      title: 'Takelio atkūrimas',
      description: 'Peržiūrėkite istorinius maršrutus',
    },
    'map-services': {
      title: 'Žemėlapių paslaugos',
      description: 'Žemėlapis, sekimas, geotvora ir šilumos žemėlapis',
    },
    'fuel-management': {
      title: 'Kuro valdymas',
      description: 'Sąskaitos faktūros, degalų kortelės ir kortelės-transporto priemonės ryšys',
    },
    assignments: {
      title: 'Užduotys',
      description: 'Tvarkykite užduotis žmonėms',
    },
    'fuel-cards': {
      title: 'Degalų kortelės',
      description: 'Degalų kortelių ir transporto priemonių sąsajų registras',
    },
    'vehicle-categories': {
      title: 'Transporto priemonių kategorijos',
      description: 'Tvarkykite pasirenkamas transporto priemonių kategorijas',
    },
    'replacement-chain': {
      title: 'Pakeitimo grandinė',
      description: 'Kurios transporto priemonės buvo pakeistos grandinėje',
    },
    'alternative-fuels': {
      title: 'Alternatyvūs degalai',
      description: 'Tvarkykite pasirenkamus alternatyvius degalus aukščiausiame mazge',
    },
    'usage-statuses': {
      title: 'Transporto priemonės būsena',
      description: 'Tvarkykite pasirenkamas būsenas aukščiausiame mazge',
    },
    'vehicle-economy': {
      title: 'Transporto priemonės sąnaudos',
      description: 'Analizuokite importuotas sąnaudas pagal organizaciją, grupę ir transporto priemonę',
    },
    'vehicle-procurement': {
      title: 'Įsigijimas ir nurašymas',
      description: 'Sprendimas pakeisti ar nurašyti transporto priemones, su pagrindimu ir dokumentais',
    },
    'license-check': {
      title: 'Pažymėjimo patikra',
      description: 'Vairuotojo teisės patikra per BKY',
    },
    charging: {
      title: 'Įkrovimas',
      description: 'Elektromobilių įkrovimo seansai per laikotarpį',
    },
    'vehicle-log': {
      title: 'Transporto priemonės žurnalas',
      description: 'Įvykiai, pavyzdžiui perkėlimai, pakeitimai ir žurnalo laikotarpiai',
    },
    'nordea-leasing': {
      title: 'Nordea lizingas',
      description: 'Lizingo failo importas iš Nordea',
    },
    'personal-trackers': {
      title: 'Asmeniniai sekikliai',
      description: 'Asmeninių sekiklių žemėlapis',
    },
    'protector-insurance': {
      title: 'Protector draudimas',
      description: 'Draudimo failo importas iš Protector',
    },
    'unplug-events': {
      title: 'Atjungimo istorija',
      description: 'GPS įrenginio prijungimas ir atjungimas su laiku ir vieta',
    },
    'service-overview': {
      title: 'Aptarnavimas',
      description: 'Paslaugų apžvalga ir valdymas',
    },
    heatmap: {
      title: 'Šilumos žemėlapis',
      description: 'Transporto priemonių pozicijų šilumos žemėlapis',
    },
    'heatmap-import': {
      title: 'Šilumos žemėlapio importavimas',
      description: 'Importuokite CSV duomenis šilumos žemėlapio analizei',
    },
    'crash-detection': {
      title: 'Avarijų aptikimas',
      description: 'Strigčių įvykiai iš įrenginių su „Crash Trace“ (AVL 257)',
    },
    'ai-analysis': {
      title: 'AI analizė',
      description: 'Išanalizuokite transporto priemones ir parką naudodami AI',
    },
    eco: {
      title: 'EKO vairavimas',
      description: 'Aplinka ir vairavimo elgesys',
    },
    fuel: {
      title: 'Kuro',
      description: 'Degalų ataskaitos',
    },
    activity: {
      title: 'Veikla',
      description: 'Veiklos žurnalai',
    },
    statistics: {
      title: 'Statistika',
      description: 'Statistinė apžvalga',
    },
    trends: {
      title: 'Tendencijos',
      description: 'Tendencijų analizė ir rida pagal lizingo sutartis',
    },
    benchmarks: {
      title: 'Etalonai',
      description: 'Lyginamoji analizė',
    },
    overview: {
      title: 'Apžvalga',
      description: 'Sistemos būsena',
    },
    replay: {
      title: 'Duomenų atkūrimas',
      description: 'Pakartokite GPS duomenis',
    },
    logs: {
      title: 'Rąstai',
      description: 'Sistemos žurnalai',
    },
    'pickup-locations': {
      title: 'Paėmimo vietos',
      description: 'Po Rezervacijomis: vietos, kur paimamos ir grąžinamos transporto priemonės',
    },
    suppliers: {
      title: 'Tiekėjai',
      description: 'Tiekėjai pvz. automobilių nuomos įmonės',
    },
    destinations: {
      title: 'Paskirties vietos',
      description: 'Iš anksto nustatytos paskirties vietos užsakymams',
    },
    calendar: {
      title: 'Kalendorius',
      description: 'Užsakymų kalendorius',
    },
    'booking-optimization': {
      title: 'Užsakymų optimizavimas',
      description: 'Dienos užsakymų optimizavimas pagal telkinį su DI',
    },
    'bookings-search': {
      title: 'Klientų aptarnavimas',
      description: 'Administruoti ir palaikyti užsakymus',
    },
    'unbooked-trips': {
      title: 'Kelionės be užsakymo',
      description: 'Susieti keliones be užsakymo su vairuotoju ir tikslu',
    },
    requests: {
      title: 'Užsakymo prašymai',
      description: 'Tvarkykite užsakymo užklausas',
    },
    service: {
      title: 'Aptarnavimas',
      description: 'Aptarnavimo intervalai ir priminimai',
    },
    repairs: {
      title: 'Remontas',
      description: 'Remonto istorija ir išlaidos',
    },
    inspections: {
      title: 'Patikrinimai',
      description: 'Patikrinimo būsena ir priminimai',
    },
    'key-cabinet': {
      title: 'Raktų spintelė',
      description: 'Raktų spintelių ir raktų apžvalga',
    },
    'key-log': {
      title: 'Raktų istorija',
      description: 'Raktų kasų ir grąžinimų žurnalas',
    },
    'homecare-planning': {
      title: 'Maršruto planavimas',
      description: 'Priežiūros namuose maršruto optimizavimas',
    },
    'homecare-clients': {
      title: 'Klientai',
      description: 'Namų priežiūros klientai',
    },
    'homecare-staff': {
      title: 'Personalas',
      description: 'Namų priežiūros darbuotojai',
    },
    dashboard: {
      title: 'Prietaisų skydelis',
      description: 'Pradinis vaizdas',
    },
    realtime: {
      title: 'Tiesioginis žemėlapis',
      description: 'Transporto priemonių stebėjimas realiu laiku',
    },
    'temperature-monitoring': {
      title: 'Temperatūros stebėsena',
      description: 'Temperatūra ir šalčio grandinė',
      reports: {
        title: 'Šaldymo grandinės ataskaitos',
        description: 'Temperatūros ir šaldymo grandinės ataskaitos',
      },
    },
    administration: {
      title: 'Administravimas',
      description: 'Sistemos administravimas',
    },
    sysadmin: {
      title: 'Sistemos administravimas',
      description: 'Išplėstiniai sistemos nustatymai',
    },
    reports: {
      title: 'Ataskaitos',
      description: 'Ataskaitos ir statistika',
    },
    crm: {
      title: 'CRM',
      description: 'Ryšių su klientais valdymas',
    },
    deque: {
      title: 'Transporto valdymas',
      description: 'Laivyno valdymas',
    },
    booking: {
      title: 'Užsakymas',
      description: 'Transporto priemonių užsakymas',
    },
    homecare: {
      title: 'Priežiūra namuose',
      description: 'Namų priežiūros planavimas',
    },
    workshop: {
      title: 'Dirbtuvės',
      description: 'Dirbtuvės ir techninė priežiūra',
    },
    keymanagement: {
      title: 'Raktų valdymas',
      description: 'Raktų spintelės valdymas',
    },
    'cabinet-sync': {
      title: 'Spintelių sinchronizacija',
      description: 'Ką KeyWin siunčia į spinteles (globalus administratorius)',
    },
    workorder: {
      title: 'Darbo užsakymai',
      description: 'Darbo užsakymai ir pavedimai',
    },
    analysis: {
      title: 'Analizė',
      description: 'Statistika ir analizė',
    },
    'cost-centers': {
      title: 'Išlaidų centrai',
      description: 'Valdykite išlaidų centrus',
    },
    'carinfo-filter': {
      title: 'Car.info filtras',
      description: 'Automobilio duomenų filtro konfigūracija',
    },
    'travel-planner': {
      title: 'Kelionių planuotojas',
      description: 'Maršruto planavimas automobiliu, dviračiu, pėsčiomis ir viešuoju transportu',
    },
    'own-car-trip': {
      title: 'Kelionė nuosavu automobiliu',
      description: 'Registruokite ir tvarkykite tarnybines keliones nuosavu automobiliu',
    },
    'own-car-trips': {
      title: 'Kelionė nuosavu automobiliu',
      description: 'Registruokite ir tvarkykite tarnybines keliones nuosavu automobiliu',
    },
    resource_manager: {
      title: 'Išteklių valdytojas',
      description: 'Savaitinė transporto priemonės apžvalga',
    },
    'equipment-tags': {
      title: 'Transporto priemonių įranga',
      description: 'Tvarkykite transporto priemonių įrangos žymes (vaikų kėdutę, alkobloką ir kt.)',
    },
    purposes: {
      title: 'Kelionės tikslai',
      description: 'Tvarkykite iš anksto nustatytus kelionės tikslus užsakymams',
    },
    terms: {
      title: 'Užsakymo sąlygos',
      description: 'Tvarkykite užsakymų sąlygas',
    },
    'vehicle-pools': {
      title: 'Transporto priemonių baseinas',
      description: 'Tvarkykite transporto priemonių baseinus naudodami automatinį raktų rezervavimą',
    },
    'resource-types': {
      title: 'Išteklių tipai',
      description: 'Tvarkykite visos sistemos išteklių tipus',
    },
    'carinfo-org-sync': {
      title: 'Car.info Transporto priemonių importas',
      description: 'Importuokite transporto priemones iš Car.info pagal organizacijos numerį',
    },
    tidbok: {
      title: 'Skaitmeninis žurnalas',
      description: 'Vairavimo ir poilsio laikas pagal ES 561/2006 ir TSFS 2013:3',
    },
    'customer-keys': {
      title: 'Raktų tvarkymas',
      description: 'Susiekite transporto priemones su raktais savo spintelėse',
    },
    'key-management': {
      title: 'Spintelių administravimas',
      description: 'Spintelės, klientai, ryšys ir sinchronizavimas',
    },
    craftsman: {
      title: 'Amatininkas',
      description: 'Darbo užsakymai meistrams ir servisas',
    },
    delivery: {
      title: 'Paketo pristatymas',
      description: 'Darbo užsakymai dėl pakuočių ir pristatymų',
    },
    'widget-vehicle-count': {
      title: 'Transporto priemonių apžvalga',
      description: 'Transporto priemonių skaičius ir būsena: prisijungusios arba ne',
    },
    'widget-inspection': {
      title: 'Artėjančios techninės apžiūros',
      description: 'Transporto priemonės, kurias reikia apžiūrėti per 40 dienų',
    },
    'widget-leasing-expiring': {
      title: 'Lizingas baigiasi',
      description: 'Transporto priemonės, kurių lizingas baigiasi per 3 mėnesius',
    },
    'widget-unplugged': {
      title: 'Atjungti įrenginiai',
      description: 'Transporto priemonės su atjungtu GPS įrenginiu',
    },
    'widget-low-battery': {
      title: 'Žema akumuliatoriaus įtampa',
      description: 'Transporto priemonės, kurių įtampa žemesnė nei 12 V',
    },
    'widget-vehicle-status': {
      title: 'Transporto priemonės būsena',
      description: 'Suvestinė pagal būseną',
    },
    'widget-tax-due': {
      title: 'Artėjantis transporto mokestis',
      description: 'Mokestis per artimiausias 45 dienas',
    },
    'widget-service': {
      title: 'Artėjanti techninė priežiūra',
      description: 'Priežiūros intervalai, kurių terminas baigiasi',
    },
    'widget-assignments': {
      title: 'Mano priskyrimai',
      description: 'Atviri prisijungusio naudotojo priskyrimai',
    },
    'widget-bookings': {
      title: 'Mano rezervacijos',
      description: 'Būsimos prisijungusio naudotojo rezervacijos',
    },
    'service-agreements': {
      title: 'Paslaugų įsipareigojimai',
      description: 'Pasikartojančios priežiūros užduotys su intervalu',
    },
    collision_bookings: {
      title: 'Kolizijų rezervacijos',
      description: 'Rezervacijos be priskirtos transporto priemonės',
    },
    vehicle_replacement: {
      title: 'Transporto priemonės pakeitimas',
      description: 'Pakeisti transporto priemonę ir pažymėti ją kaip neveikiančią',
    },
    'booking-settings': {
      title: 'Rezervavimo nustatymai',
      description: 'Formos, projektai, kelionės tikslai, išlaidų centrai ir sąlygos',
    },
    'booking-resources': {
      title: 'Rezervavimo ištekliai',
      description: 'Ištekliai ir jų tipai kiekvienam klientui',
    },
    'rental-management': {
      title: 'Automobilių nuoma',
      description: 'Susieti klientus su nuomos įmonėmis',
    },
    'booking-basis': {
      title: 'Rezervavimo pagrindas',
      description: 'Duomenys apie grąžintas rezervacijas: kilometrai, kelionės ir aplinka',
    },
    'quick-booking': {
      title: 'Greita rezervacija',
      description: 'Rezervuoti laisvą automobilį skambinančiam, PIN kodas SMS žinute',
    },
    'pool-watch': {
      title: 'Trūkstami duomenys',
      description: 'Stebėjimas, kai paėmime iš baseino trūksta privalomų laukų',
    },
    'booking-stats': {
      title: 'Rezervacijų statistika',
      description: 'Suminė rezervacijų statistika',
    },
    'service-costs': {
      title: 'Priežiūros išlaidos',
      description: 'Priežiūros išlaidos pagal kategoriją ir laikotarpį',
    },
    'fuel-analysis': {
      title: 'Degalų analizė',
      description: 'Degalų sąnaudos ir suvartojimas iš importuotų operacijų',
    },
    'fleet-tco': {
      title: 'Parko bendra kaina',
      description: 'Bendra nuosavybės kaina: degalai, priežiūra, lizingas ir draudimas',
    },
    executive: {
      title: 'Vadovybės ataskaita',
      description: 'Parko pagrindiniai rodikliai',
    },
    'report-generator': {
      title: 'Ataskaitų generatorius',
      description: 'Savos ataskaitos iš duomenų modelių',
    },
    sensors: {
      title: 'Jutikliai',
      description: 'Registruoti EYE ir susieti su FMM003',
    },
    config: {
      title: 'BLE/EYE konfigūracija',
      description: 'Vidinė nuotolinė BLE ir EYE konfigūracija',
    },
    recipients: {
      title: 'Pavojaus gavėjai',
      description: 'Išoriniai el. pašto ir SMS gavėjai',
    },
    schedules: {
      title: 'Ataskaitų tvarkaraščiai',
      description: 'Savaitės ir mėnesio ataskaitos',
    },
    'tire-analysis': {
      title: 'Padangų analizė',
      description: 'Dėvėjimasis, sezonų planavimas ir pirkimo poreikis',
    },
    'module-catalog': {
      title: 'Modulių katalogas',
      description: 'Modulių ir funkcijų apžvalga',
    },
    'fota-migration': {
      title: 'FOTA perkėlimas',
      description: 'Siųsti konfigūraciją įrenginiams per FOTA Web',
    },
    'dev-projects': {
      title: 'Produkto kūrimas',
      description: 'Vidinis projektų valdymas',
    },
    'flinkey-boxes': {
      title: 'Flinkey dėžutės',
      description: 'Skaitmeninės raktų dėžutės ir priskyrimai',
    },
    'guide-management': {
      title: 'Gidų administravimas',
      description: 'Įvedimo gidai ir turai',
    },
    'theme-settings': {
      title: 'Tema ir prekės ženklas',
      description: 'Spalvų tema ir partnerio profilis',
    },
    'jam-detection': {
      title: 'Trikdžių aptikimas',
      description: 'Kur aptiktas GSM trikdymas',
    },
    'trip-analysis': {
      title: 'Kelionių analizė',
      description: 'Palyginti registruotas keliones su transporto priemonės bin failu',
    },
    'device-baseline': {
      title: 'Numatytieji įrenginių failai',
      description: 'Standartinė programinės įrangos ir konfigūracijos byla pagal modelį',
    },
    'obd-vehicles': {
      title: 'OBD transporto priemonės',
      description: 'OBD palaikymas pagal markę ir modelį',
    },
    'obd-knowledge': {
      title: 'OBD žinios',
      description: 'Paieškai skirta OBD žinių bazė',
    },
    'damage-reports': {
      title: 'Žalos ataskaitos',
      description: 'Gautų žalos ataskaitų tvarkymas',
    },
    'econ-kodverk': {
      title: 'Kodų žodynas',
      description: 'Regiono Skåne Raindance kodų žodynas',
    },
    'eye-inventory': {
      title: 'EYE sandėlis',
      description: 'Importuoti EYE jutiklius ir GPS sekiklius iš pakuočių sąrašo',
    },
    'cost-invoices': {
      title: 'Išlaidų sąskaitos',
      description: 'Transporto priemonių išlaidų importas iš lizingo bendrovės',
    },
    'device-queues': {
      title: 'Įrenginių eilės',
      description: 'Laukiantys siunčiami įrenginių darbai',
    },
    moten: {
      title: 'Susitikimas',
      description: 'Vidinis susitikimo įrašas ir pastabos',
    },
    'vehicle-carinfo-sync': {
      title: 'Sinchronizuoti iš Car.info',
      description: 'Markė, modelis, metai ir degalų tipas',
    },
    'mobile-access': {
      title: 'Mobilioji prieiga',
      description: 'Prisijungimas mobiliojoje programėlėje',
    },
    'support-chat': {
      title: 'Palaikymo pokalbis',
      description: 'Palaikymo pokalbiai žiniatinklyje ir programėlėje',
    },
    flinky: {
      title: 'Mano rezervacijos',
      description: 'Rezervacijos programėlėje',
    },
    dqbooking: {
      title: 'Rezervuoti automobilį',
      description: 'Rezervuoti transporto priemonę programėlėje',
    },
    'driving-log-mobile': {
      title: 'Vairavimo žurnalas',
      description: 'Skaitmeninis vairavimo žurnalas programėlėje',
    },
    'damage-report': {
      title: 'Žalos ataskaita',
      description: 'Pranešti apie žalą programėlėje',
    },
    'find-vehicle-mobile': {
      title: 'Rasti transporto priemonę',
      description: 'Ieškoti transporto priemonės programėlėje',
    },
    arbetsorder: {
      title: 'Darbo užsakymas',
      description: 'Priskirti darbai, laiko žymėjimas ir užbaigimas programėlėje',
    },
    flinkyboxes: {
      title: 'Flinkey dėžutės',
      description: 'Spyna, baterija ir NFC kortelės paėmimo vietoje',
    },
    'delad-bil': {
      title: 'Bendras automobilis',
      description: 'Kelionės bendru įmonės automobiliu',
    },
    'vehicle-replacement': {
      title: 'Transporto priemonės keitimas',
      description: 'Pakeiskite transporto priemones baseine, pažymėkite nenaudojamas ir perskirkite rezervacijas',
    },
    'collision-bookings': {
      title: 'Susidūrimo užsakymai',
      description: 'Užsakymai be priskirtos transporto priemonės po baseino ar transporto priemonės pakeitimo',
    },
    'old-booking': {
      title: 'Ankstesnis užsakymas',
      description: 'Istoriniai užsakymo duomenys (laikinai)',
    },
  },
  systemPage: {
    loading: 'Įkeliama sistema...',
    errorTitle: 'Klaida įkeliant sistemą',
    tryAgain: 'Bandykite dar kartą',
    systemNotFound: 'Sistema nerasta',
    systemNotFoundDescription: 'Sistemos „{name}“ duomenų bazėje nepavyko rasti.',
    backToStart: 'Atgal į pradžios puslapį',
    noModules: 'Šiai sistemai modulių nerasta.',
    comingSoon: 'Netrukus',
    plannedFeatures: 'Planuojamos funkcijos',
    underDevelopment: 'Šis modulis aktyviai kuriamas.',
    notFoundOrNoAccess: 'Sistema „{name}“ nerasta arba jūs neturite leidimo.',
    notLoggedIn: 'Jūs nesate prisijungęs arba jūsų sesija baigėsi. Būsite nukreipti į prisijungimą.',
    noPermission: 'Neturite leidimo peržiūrėti šios informacijos.',
    serverError: 'Serverio klaida. Bandykite dar kartą vėliau.',
    unexpectedError: 'Įkeliant sistemos duomenis įvyko netikėta klaida',
    noSystemName: 'Sistemos pavadinimas nenurodytas',
    apiError: 'API grąžino klaidą',
    functionCountOne: '{count} funkcija',
    functionCount: '{count} funkcijos',
    searchFunctions: 'Ieškoti funkcijos sistemoje {name}...',
    noSearchHits: 'Nė viena funkcija neatitinka paieškos.',
    groups: {
      daily: 'Kasdienė veikla',
      planning: 'Planavimas ir optimizavimas',
      resources: 'Ištekliai ir tiekėjai',
      history: 'Duomenys ir istorija',
      settings: 'Nustatymai',
      vehicles: 'Transportas',
      devices: 'Įrenginiai ir pozicija',
      economy: 'Ekonomika',
      compliance: 'Atitiktis',
      driving: 'Vairavimas',
      environment: 'Aplinka ir energija',
      fleet: 'Parkas',
      analysis: 'Analizė',
      customers: 'Klientai',
      catalog: 'Katalogas',
      people: 'Vartotojai ir rolės',
      data: 'Duomenys ir importas',
      monitor: 'Stebėsena',
      overview: 'Apžvalga',
      map: 'Žemėlapis',
      events: 'Įvykiai',
      functions: 'Funkcijos',
      other: 'Kita',
    },
    comingSoonBooking: {
      feature1: 'Užsakymų kalendoriaus vaizdas',
      feature2: 'Prašymai ir patvirtinimai',
      feature3: 'Konfliktų valdymas',
      feature4: 'Vairuotojo pranešimai',
      feature5: 'Integracija su transporto priemonių parku',
    },
    comingSoonWorkshop: {
      feature1: 'Aptarnavimo intervalai ir priminimai',
      feature2: 'Remonto istorija',
      feature3: 'Patikrinimo būsena',
      feature4: 'Išlaidų sekimas',
      feature5: 'Seminaro užsakymas',
    },
    comingSoonKeymanagement: {
      feature1: 'Raktų spintelės apžvalga',
      feature2: 'Prisijungimas / išregistravimas',
      feature3: 'Prieigos valdymas',
      feature4: 'Signalizacijos funkcijos',
      feature5: 'Integracija su rezervavimo sistema',
    },
    comingSoonWorkorder: {
      feature1: 'Kurti darbo užsakymus',
      feature2: 'Priskirti vairuotojui/transporto priemonei',
      feature3: 'Būsenos sekimas',
      feature4: 'Prioritetas ir terminas',
      feature5: 'Dokumentacija ir priedai',
    },
    comingSoonAnalysis: {
      feature1: 'Statistinė apžvalga',
      feature2: 'Tendencijos analizė laikui bėgant',
      feature3: 'Transporto priemonių palyginimai',
      feature4: 'Eksportuoti ataskaitas',
      feature5: 'Individualūs prietaisų skydeliai',
    },
  },
  vehicleAttachments: {
    attachments: 'Priedai',
    uploadButton: 'Įkelti',
    category: 'Kategorija',
    insurance: 'Draudimas',
    inspection: 'Apžiūra',
    damage: 'Žala',
    invoice: 'Sąskaita faktūra',
    contract: 'Sutartis',
    service: 'Aptarnavimas',
    other: 'Kita',
    addCategory: 'Pridėti savo kategoriją…',
    newCategoryPlaceholder: 'Kategorijos pavadinimas',
    categoryCustomerHint: 'Matoma tik šiam klientui.',
    categorySaveFailed: 'Nepavyko išsaugoti kategorijos',
    edit: 'Redaguoti',
    description: 'Tekstas',
    descriptionPlaceholder: 'Neprivalomas tekstas apie failą',
    saveFailed: 'Nepavyko išsaugoti pakeitimo',
    clickToPreview: 'Spustelėkite norėdami peržiūrėti',
    download: 'Atsisiųsti',
    deleteFile: 'Ištrinti',
    preview: 'Peržiūra',
    closePreview: 'Uždaryti',
  },
  ecoSettings: {
    couldNotSave: 'Nepavyko išsaugoti nustatymų',
    confirmDelete: 'Ar tikrai norite ištrinti šiuos konkrečios organizacijos nustatymus?',
    couldNotDelete: 'Nepavyko ištrinti nustatymų',
    globalDefaults: 'Pasauliniai numatytieji nustatymai',
    globalDefaultsOption: 'Pasauliniai numatytieji nustatymai',
    hasOwnSettings: 'Turi savo nustatymus',
    usesGlobal: 'Naudoja globaliai',
    orgsWithOwnSettings: 'Organizacijos su savo nustatymais:',
    removeOrgSettings: 'Pašalinkite konkrečios organizacijos nustatymus',
    hardAccelDescription: 'Stipraus pagreičio aptikimo slenksčiai...',
    defaultSpeedOverLimit: 'Numatytasis: 10 % viršijamas greitis',
    smoothDrivingDescription: 'Ekonomiško ir ekologiško vairavimo slenksčiai.',
    defaultSmoothAccel: 'Numatytasis: 1,5 m/s² sklandžiam važiavimui',
    defaultSmoothBrake: 'Numatytasis: 2,0 m/s², kad stabdymas būtų sklandus',
    defaultMinSpeed: 'Numatytasis: 10 km/h (stovintis neįskaičiuojamas)',
    defaultIdleTime: 'Numatytasis: 120 sekundžių (2 minutės) nepertraukiamai',
  },
  geofencesPage: {
    exportToCsv: 'Eksportuoti į CSV',
    clearSelection: 'Išvalyti pasirinkimą',
    noGeofences: 'Jokių geotvorų nesukurta',
    hide: 'Slėpti',
    show: 'Rodyti',
    editGeofence: 'Redaguoti',
    deleteGeofence: 'Ištrinti',
    clickMapToAddPoints: 'Spustelėkite žemėlapį, kad pridėtumėte taškų',
    minPointsRequired: 'Daugiakampiui reikia mažiausiai 3 taškų',
    globalAllOrgs: 'Pasaulinis (visos organizacijos)',
    specificOrg: 'Konkreti organizacija',
    selectOrg: 'Pasirinkite organizaciją',
    hideCoordinatesInArea: 'Slėpti koordinates srityje',
    tollArea: 'Mokama sritis',
    defaultPricePlaceholder: 'Numatytoji kaina, jei neatitinka jokia laiko taisyklė',
  },
  widgets: {
    remove: 'Pašalinti',
    addWidget: 'Pridėti valdiklį',
    selectColumn: 'Pasirinkite stulpelį:',
    available: 'Yra',
    lowBattery: 'Senka baterija',
    openVehicleCard: 'Atidaryti transporto priemonės kortelę',
    serviceDue: 'Aptarnavimo terminas',
    overdue: 'pavėluota',
    noServiceDue: 'Jokių paslaugų nereikia',
    servicePointsNeedAction: 'aptarnavimo punktuose reikia imtis veiksmų',
    overdueLabel: 'Pavėluota',
    soonLabel: 'Netrukus',
    bookedLabel: 'Užsakyta',
    allBatteriesOk: 'Visos baterijos OK',
    move: 'Judėti',
    alreadyAdded: 'Jau pridėta',
    comingSoon: 'Netrukus',
    columns: {
      left: 'Kairė',
      center: 'centras',
      right: 'Teisingai',
    },
    vehicleStatus: 'Transporto priemonės būsena',
    vehicleStatusSubtitle: 'Transporto priemonės pagal statusą',
    vehicleUnit: 'tr. priemonės',
    noUsageStatus: 'Nėra statuso',
    noVehicles: 'Nėra transporto priemonių',
    alreadyAddedHint: 'Uždarykite šį dialogo langą ir pažiūrėkite į savo prietaisų skydelį – valdiklis jau rodomas. Pašalinkite jį skiltyje Redaguoti, jei norite įtraukti jį į kitą stulpelį.',
    alreadyAddedOnPage: 'Valdiklis jau yra puslapyje. Pašalinkite jį skiltyje Redaguoti, jei norite pridėti iš naujo.',
    sectionAvailable: 'Galima pridėti',
    sectionOnDashboard: 'Jau jūsų prietaisų skydelyje',
    notInPackage: 'Neaktyvinta jūsų organizacijoje Paslaugose',
  },
  usersManagement: {
    title: 'Vartotojų valdymas',
    usersCount: 'vartotojų',
    driversLicense: 'Vairuotojo pažymėjimas:',
    employeeId: 'Darbuotojo ID:',
    costCenter: 'Išlaidų centras:',
    createUser: 'Sukurti vartotoją',
    editUser: 'Redaguoti naudotoją',
    notVerified: 'Nepatvirtinta',
    neverLoggedIn: 'Niekada neprisijungė',
    noPassword: 'Nėra slaptažodžio',
    lastLoginAt: 'Paskutinis prisijungimas: {{date}}',
    downloadTemplate: 'Parsisiųsti šabloną',
    importUsers: 'Importuoti vartotojus',
    importTitle: 'Importuokite naudotojus iš Excel',
    importDescription: 'Įkelkite užpildytą Excel šabloną, kad vienu veiksmu sukurtumėte vartotojo, vairuotojo ir transporto priemonės priskyrimus.',
    importSelectOrg: 'Pasirinkite organizaciją, į kurią norite importuoti',
    importUploadLabel: 'Pasirinkite Excel failą (.xlsx)',
    importUploadHint: 'Atsisiųskite šabloną, užpildykite ir įkelkite čia.',
    importPreviewTitle: 'Peržiūra',
    importPreviewRows: 'rastos eilutės',
    importRun: 'Vykdyti importavimą',
    importRunning: 'Importuojama...',
    importResultTitle: 'Importuoti rezultatus',
    importResultSuccess: 'buvo sukurtas vartotojas',
    importResultFailed: 'eilutės nepavyko',
    importErrorsTitle: 'Nepavykusios eilutės',
    importPasswordsTitle: 'Sugeneruoti slaptažodžiai',
    importPasswordsHint: 'Nukopijuokite ir bendrinkite šiuos slaptažodžius su atitinkamais vartotojais.',
    importPasswordsCopied: 'Nukopijuota!',
    importDone: 'Uždaryti',
    importNoFile: 'Prieš tęsdami pasirinkite failą.',
    importNoOrg: 'Prieš tęsdami pasirinkite organizaciją.',
    importVehicleNotFound: 'Registracijos numeris nerastas',
    sendWelcomeEmail: 'Siųsti sveikinimo el. laišką su slaptažodžio nustatymu iš naujo',
    sendWelcomeEmailDesc: 'Naudotojas gauna el. laišką su nuoroda, leidžiančia suaktyvinti paskyrą ir pasirinkti slaptažodį. Nuoroda galioja 72 valandas.',
    sendWelcomeEmailSent: 'Pasveikinimo el. laiškas išsiųstas',
    sendWelcomeEmailSentTo: 'Pasveikinimo el. laiškas išsiųstas šiuo adresu: {{email}}',
    sendWelcomeEmailButton: 'Siųsti pasisveikinimo el. laišką',
    sendWelcomeEmailSending: 'Siunčiama...',
    sendWelcomeEmailError: 'Nepavyko išsiųsti pasisveikinimo el. laiško.',
    sendWelcomeEmailBulk: 'Siųsti sveikinimo el. laišką į sąrašą',
    sendWelcomeEmailBulkHint: 'Siunčiama visų naudotojų sąrašo nuoroda. Naudotojai, neturintys el. pašto, SSO prisijungę arba neaktyvūs / užrakinti, praleidžiami.',
    sendWelcomeEmailBulkConfirm: 'Siųsti sveikinimo el. laišką su aktyvinimo nuoroda {{count}} sąraše esantiems naudotojams?',
    sendWelcomeEmailBulkDone: 'Sveikinimo el. laiškas išsiųstas {{sent}} vartotojui',
    sendWelcomeEmailBulkPartial: '{{skipped}} praleistas, {{failed}} nepavyko',
    sendWelcomeEmailBulkNone: 'Sąraše nėra vartotojų, kuriems būtų galima siųsti',
    welcomeSkipNoEmail: 'trūksta el. pašto',
    welcomeSkipSso: 'SSO prisijungimas',
    welcomeSkipInactive: 'neaktyvus/užrakintas',
    welcomeSkipNotFound: 'nebuvo rastas',
    welcomeSkipEmailOff: 'el. paštas klientui išjungtas',
    searchPlaceholder: 'Ieškokite vardo, el. pašto adreso ar reg...',
    department: 'Skyrius',
    editUserTitle: 'Redaguoti',
    deleteUserTitle: 'Pašalinti',
    hardDeleteButton: 'Visiškai ištrinti',
    hardDeleteTitle: 'Visiškai ištrinti naudotoją (SSO testas)',
    hardDeleteConfirm: 'Tai visiškai pašalina {{name}} ({{email}}) iš sistemos, kad SSO galėtų iš naujo sukurti paskyrą. Negalima anuliuoti.',
    emailRequiredForWelcome: 'Norint išsiųsti sveikinimo laišką, būtinas el.',
    downloadTemplateError: 'Nepavyko atsisiųsti šablono',
    driverInformation: 'Vairuotojo informacija',
    connectedVehicle: 'Prijungta transporto priemonė: {{reg}}',
  },
  userFormFields: {
    password: 'Slaptažodis',
    twoFactorAuth: 'Dviejų veiksnių autentifikavimas',
    selectOrg: 'Pasirinkite organizaciją...',
    selectOrgForRoles: 'Pirmiausia pasirinkite organizaciją',
    noRolesForOrg: 'Nėra rolių šiai organizacijai',
    rolesFromOrganization: 'Rodomos organizacijos viršūnės rolės.',
    keepCurrentPassword: 'Palikite tuščią, kad išliktų srovė',
    mobileLoginOptional: 'Neprivaloma – mobiliosios programėlės prisijungimui',
    driverInfo: 'Vairuotojo informacija',
    ongoing: '– vykstantis',
    roleViewer: 'Žiūrovas',
    roleDriver: 'Vairuotojas',
    roleAdmin: 'Administratorius',
    tabSchedule: 'Tvarkaraštis',
    tabVehicle: 'Transporto priemonės',
    tabHistory: 'Istorija',
    driverDraftHint: 'Tvarkaraštis ir transporto priemonė išsaugomi spustelėjus Sukurti vartotoją – pirmiausia nereikia įrašyti vartotojo.',
    vehicleDraftSaved: 'Užduotis išsaugota juodraštyje – sukurta kartu su vartotoju.',
    isAlsoDriver: 'Taip pat Vairuotojas',
    globalAdminRolesHint: 'Kai kuriuos vidinius vaidmenis (pvz., „Deviaq Management“) gali priskirti tik visuotinis administratorius.',
  },
  rolePermissions: {
    selectFunctions: 'Pasirinkite, kurios funkcijos turėtų būti pasiekiamos',
    moduleNotEnabled: 'Modulis neįjungtas',
    selectModuleLeft: 'Kairėje pasirinkite modulį, kad pamatytumėte funkcijas',
  },
  dataTable: {
    searchPlaceholder: 'Ieškoti...',
    filterPlaceholder: 'Filtruoti…',
    filterColumn: 'Filtruoti {{column}}',
    selectAll: 'Pažymėti visus',
    selectRow: 'Pažymėti eilutę',
  },
  customerDetail: {
    privateCompany: 'Privati ​​įmonė',
    companyName: 'Įmonės pavadinimas:',
    employees: 'Darbuotojai:',
    yearsInBusiness: 'Verslo metai:',
    perBrand: 'Pagal prekės ženklą',
    perFuelType: 'Pagal kuro rūšį',
    usersLabel: 'Vartotojai',
    keyCabinet: 'Raktų spintelė',
    devicesPerType: 'Įrenginiai pagal tipą',
    firstName: 'Vardas',
    primaryContact: 'Pirminis kontaktas',
    devices: 'Vienetai (GPS)',
    flinkeyBoxes: 'Flinkey dėžės',
    registeredCables: 'Kabeliai (registruoti)',
  },
  customerWizard: {
    namePlaceholder: 'Pvz. Linköping savivaldybė',
    privateCompany: 'Privati ​​įmonė',
    cityPlaceholder: 'Linköpingas',
    fixedMonthly: 'Fiksuotas mėnesinis mokestis',
    perUser: 'Vienam vartotojui',
    otherInfoPlaceholder: 'Kita informacija...',
  },
  customerPackages: {
    allPackagesSelected: 'Parenkami visi galimi paketai',
  },
  customerApiConfig: {
    lastUsed: 'Paskutinį kartą naudota:',
    noEndpoints: 'Galinių taškų nėra',
  },
  customerFederationConfig: {
    autoGenerate: 'Palikite tuščią automatiniam generavimui pagal organizacijos ID.',
    redirectUri: 'Peradresuoti URI (skirta IDP konfigūracijai)',
    clientAuthMethod: 'Kliento autentifikavimas',
    certificate: 'Sertifikatas (private_key_jwt)',
    certHelp: 'Mes (klientas) turime privatų raktą. Viešasis sertifikatas įkeliamas į „Entra“ (Sertifikatai ir paslaptys → Sertifikatai). Laukai priima tiesioginį PEM arba failo kelią serveryje (rekomenduojama: failas su 0600).',
    certificatePem: 'Viešasis sertifikatas (PEM arba failo kelias)',
    privateKeyPem: 'Privatus raktas (PEM arba failo kelias)',
    privateKeyHint: 'Stored secretly by us and never returned by the API. Pageidautina naudoti failo kelią serveryje.',
    defaultRole: 'Numatytasis naujų SSO vartotojų vaidmuo',
    defaultRoleFallback: 'Numatytasis (vartotojas / VIEWER)',
    defaultRoleHelp: 'Vaidmuo priskiriamas automatiškai, kai naujas vartotojas prisijungia per SSO. Esamos paskyros išlaiko savo vaidmenį.',
    claimMapping: 'Pretenzijos atvaizdavimas',
    claimMappingHelp: 'Įveskite paraiškų pavadinimus, kuriuos siunčia IDP. Palikite tuščią, jei norite naudoti numatytuosius vardus (el. paštas, pavardė, šeimos_vardas, rsid, telefono numeris).',
    claimRsid: 'RSID',
    claimEmail: 'paštas',
    claimFirstName: 'Vardas',
    claimLastName: 'Pavardė',
    claimPhone: 'Telefonas',
    mustActivate: 'Klientas turi būti suaktyvintas, kad galėtų konfigūruoti susijungimą.',
    mustActivateSso: 'Leiskite klientui sukurti organizaciją ir sukonfigūruoti SSO.',
    configured: 'Sukonfigūruotas, bet neaktyvus',
    notConfigured: 'Nesukonfigūruotas',
    enabled: 'Suaktyvinta',
    activateSaml: 'Įgalinti SAML 2.0',
    activateOidc: 'Suaktyvinkite „OpenID Connect“.',
    activateAdSync: 'Įgalinti AD vartotojo sinchronizavimą',
    updateSaml: 'Atnaujinkite SAML',
    saveSaml: 'Išsaugoti SAML',
    updateOidc: 'Atnaujinkite OIDC',
    saveOidc: 'Išsaugokite OIDC',
    update: 'Atnaujinti',
    save: 'Išsaugoti',
    delete: 'Pašalinti',
    adSyncTab: 'AD vartotojo sinchronizavimas',
    adSyncTitle: 'Ką klientas turi pateikti (Entra ID)',
    adSyncStep1: '1 veiksmas – programos registracija Entra ID',
    adSyncStep2: '2 veiksmas – API leidimai (reikalingas visuotinis administratorius)',
    adSyncStep3: '3 veiksmas – kliento paslaptis',
    adSyncSyncMode: 'Sinchronizavimo režimas',
    adSyncModeManual: 'Rankinis (per mygtuką)',
    adSyncModeNightly: 'Automatinis kiekvieną vakarą',
    adSyncLastSync: 'Paskutinis sinchronizavimas',
    adSyncNone: 'Sinchronizavimas dar neatliktas',
    adSyncSyncChanges: 'Sinchronizuoti pakeitimus',
    adSyncSyncAll: 'Sinchronizuoti viską',
    adSyncFullSync: 'Pilnas sinchronizavimas',
    adSyncTestConnection: 'Išbandyti ryšį (peržiūra)',
    adSyncLogTitle: 'Naujausi sinchronizavimas',
    adSyncPreviewOk: 'Ryšys gerai – ~{{count}} vartotojas AD ({{disabled}} išjungtas)',
    adSyncPreviewMore: 'Rodoma 10 atsisiųstų {{count}} (peržiūra)',
    adSyncIncremental: '(prieauginis)',
    adSyncFull: '(pilnas)',
    adSyncFetched: 'pakėlė',
    adSyncCreated: 'naujas',
    adSyncUpdated: 'atnaujinta',
    adSyncDeactivated: 'išjungtas',
    copyUrl: 'Kopijuoti URL',
    copyUrlShort: 'Kopijuoti',
    giveUrlToIt: 'Suteikite šį URL kliento IT skyriui, kad jis sukonfigūruotų savo IDP.',
    tableColName: 'Vardas',
    tableColEmail: 'paštas',
    tableColDepartment: 'Skyrius',
    tableColStatus: 'Būsena',
    userActive: 'Aktyvus',
    userInactive: 'Neaktyvus',
  },
  federation: {
    minLoa: 'Minimalus užtikrinimo lygis (LoA)',
    minLoaHelp: 'Reikalauti minimalaus pasitikėjimo lygio SITHS/Inera prisijungimui. LoA3 rekomenduojamas sveikatos priežiūrai.',
    sithsInfo: 'SITHS autentifikavimas („Inera“)',
    sithsInfoClaims: 'Pretenzijos: asmens kodas, HSA-ID, vardas iš SITHS sertifikato',
    sithsInfoEnv: 'QA: https://idp.ineraqa.org/oidc | Gamyba: https://idp.inera.se/oidc',
    sithsInfoReg: 'Klientų registracija atliekama rankiniu būdu naudojant Ineros išankstinio studijų formą',
  },
  customerSmsConfig: {
    enableSmsService: 'Įjungti SMS paslaugą',
    useCases: 'Naudojimo atvejai:',
    monthlyTitle: 'SMS pagal mėnesį',
    monthlyEmpty: 'SMS dar neišsiųsta.',
    monthlyMonth: 'Mėnuo',
    monthlyCount: 'SMS skaičius',
    monthlyAmount: 'Suma',
    title: 'SMS konfigūracija',
    subtitle: 'Konfigūruokite SMS siuntimą pranešimams ir aliarmui',
    statusActive: 'Aktyvus',
    statusInactive: 'Neaktyvus',
    provider: 'SMS teikėjas',
    senderId: 'Siuntėjo ID (maks. 11 simbolių)',
    apiKey: 'API raktas',
    apiKeyUnchanged: '(nepakeista)',
    apiKeyPlaceholder: 'Įveskite API raktą',
    apiKeyConfigured: 'API raktas jau sukonfigūruotas. Palikite lauką tuščią, kad jis liktų.',
    apiUrl: 'API URL (pasirenkama)',
    apiUrlPlaceholder: 'Palikite tuščią numatytajam URL',
    saveSettings: 'Išsaugokite nustatymus',
    saving: 'Išsaugoma...',
    saveSuccess: 'SMS nustatymai išsaugoti',
    saveError: 'Nepavyko išsaugoti SMS nustatymų',
    testSection: 'Išbandykite SMS konfigūraciją',
    testPhonePlaceholder: '07XXXXXXXXX arba +46...',
    testSend: 'Siųsti testą',
    testSending: 'Siunčiama...',
    testSuccess: 'Bandomasis SMS išsiųstas!',
    testFailed: 'Bandymas nepavyko',
    testError: 'Nepavyko išsiųsti bandomosios SMS',
    noOrgId: 'Organizacijai trūksta organization_id',
    noPhoneNumber: 'Įveskite telefono numerį testui',
    noOrgActivated: 'Šis klientas neturi susietos organizacijos. Pirmiausia suaktyvinkite organizaciją.',
    useCaseGeofence: 'Geofence signalizacija vairuotojams',
    useCaseVehicleEvents: 'Pranešimai apie transporto priemonių įvykius',
    useCaseService: 'Aptarnavimo ir apžiūros priminimai',
    providerNone: 'Nėra (išjungta)',
  },
  systemPackagesManager: {
    featuresPlaceholder: 'Pagalba telefonu\nSLA 99,9 %\nAPI prieiga',
  },
  importsManagement: {
    namePlaceholder: 'Pvz. Transporto priemonių importas iš Excel',
    selectTable: 'Pasirinkite lentelę...',
    firstRowIsHeader: 'Pirmoji eilutė yra antraštė',
    dragFileHere: 'Nuvilkite failą čia arba spustelėkite, kad pasirinktumėte',
    skipKeepExisting: 'Praleisti (palikti esamą)',
    replaceRow: 'PAKEISTI (pakeisti eilutę)',
    runImport: 'Vykdyti importavimą',
    filesFromSource: 'Failai iš šaltinio',
    runImportFromFtp: 'Vykdykite importavimą iš FTP',
  },
  tripValidation: {
    needsReview: 'Reikia peržiūros',
    manage: 'Tvarkyti',
    resolve: 'Išspręsti',
    deleteReasonPlaceholder: 'Aprašykite, kodėl ši kelionė ištrinama (mažiausiai 5 simboliai)...',
    minCharsRequired: 'Reikalingi bent 5 simboliai',
  },
  systemMonitor: {
    title: 'Sistemos monitorius',
    queue: 'Eilė',
    queueLength: 'Eilės ilgis',
    serverNumbers: 'Skaičiai iš serverio:',
    running: 'Bėgimas',
    runNow: 'Bėk dabar',
    latestRuns: 'Naujausi bėgimai',
    importSources: {
      title: 'Importo šaltiniai (priėmimas)',
      total: 'Šaltiniai',
      active: 'Aktyvūs',
      failed: 'Klaidos',
      pendingFiles: 'Failai kataloguose',
      none: 'Nėra sukonfigūruotų importo šaltinių',
      name: 'Pavadinimas',
      type: 'Tipas',
      lastFetch: 'Paskutinis gavimas',
      filesInDir: 'Failai kataloge',
      newestFile: 'Naujausias failas',
      inactive: 'Neaktyvus',
      never: 'Niekada',
      dirMissing: 'Katalogo nėra / neperskaitomas',
    },
    speedLimitBackfill: 'Greičio apribojimo užpildymas',
    speedLimitQueue: 'Eilė (trip_speed_limit_backfill)',
    speedLimitConsumers: 'Vartotojai',
    speedLimitDlq: 'DLQ pranešimai',
    speedLimitRate: 'Kelionės per minutę (vidutiniškai 5 min.)',
    speedLimitProcessedTotal: 'Iš viso apdorota',
    speedLimitWorkers: 'Darbuotojai internete',
    speedLimitAlerts: 'Įspėjimai',
    noAlerts: 'Jokių įspėjimų',
  },
  dataReplay: {
    clearAllDescription: 'Išvalykite visus kelionės / GPS / ekologinius / statistikos duomenis ir eiles. Transporto priemonės ir įrenginiai saugomi.',
    searchPlaceholder: 'Ieškoti IMEI arba registracijos numerio...',
    verifyDataStatus: 'Patikrinkite duomenų būseną',
    fullReset: 'Visiškas atstatymas',
    replayAllFiles: 'Pakartoti visus failus (kuriamasis)',
    fullResetInProgress: 'Visiškas nustatymas iš naujo... Tai gali užtrukti kelias minutes. Palauk.',
    allDbEmpty: 'Visos duomenų bazės tuščios (visas atstatymas patvirtintas)',
    someTablesHaveData: 'Kai kuriose lentelėse / rinkiniuose vis dar yra duomenų',
    startReplay: 'Pradėti pakartojimą',
    startReplaySection: 'Pradėti pakartojimą',
    fromDate: 'Nuo datos',
    toDate: 'Iki šiol',
    organization: 'Organizacija',
    vehicleImei: 'Transporto priemonės (IMEI)',
    selectOrgFirst: 'Pirmiausia pasirinkite organizaciją',
    allVehiclesInOrg: 'Visos organizacijos transporto priemonės',
    allVehiclesInOrgHint: 'Tuščias IMEI – visi organizacijos vienetai (pagal duomenų bazės apimtį)',
    noVehiclesFound: 'Šioje dienų sekoje nėra transporto priemonių (arba nė viena neatitinka jūsų paieškos)',
    replayNote: 'PASTABA: Pakartotinai pirmiausia išvalomi esami pasirinktos organizacijos ir dienų sekos duomenys. Su pasirinkta transporto priemone (IMEI) naudojamas paketinis pakartojimas, kuris akimirksniu sukuria ir išsaugo keliones (rekomenduojama). Nepasirinkus IMEI, paketai yra į eilę per darbuotojus visiems įrenginiams, esantiems organizacinėje srityje.',
    availableDates: 'Galimos datos',
    noBinFiles: 'Nerasta šiukšliadėžės failų',
    clickDateHint: 'Spustelėkite datą, kad nustatytumėte Nuo/Iki. Taip pat aukščiau esančiuose laukuose galite įrašyti bet kurią datą (sąraše rodoma daugiausia 90 dienų).',
    files: 'failus',
    showingDates: 'Rodoma 90 iš {{total}} datų. Senesnėms datoms naudokite laukus Nuo/Iki.',
    replayJobs: 'Pakartoti darbą',
    noActiveJobs: 'Nėra aktyvių darbų',
    orgLabel: 'Organizacija {{id}}',
    allDevicesInOrg: 'visi vienetai org',
    allVehiclesGlobal: 'Visos transporto priemonės (pasaulinis)',
    filesProgress: '{{processed}}/{{total}} failus',
    tripsDeleted: '{{count}} kelionės ištrintos',
    queued: '{{count}} yra eilėje',
    stopReplay: 'Sustabdykite atkūrimą',
    stepLog: 'Žingsnių žurnalas:',
    selectOrgPlaceholder: 'Pasirinkite organizaciją…',
  },
  speedComplianceReport: {
    selectOrgAndDateRange: 'Pasirinkite organizaciją ir dienų seką',
    violationPercent: 'Pažeidimas (%)',
    violations: 'Pažeidimai',
    timeOverLimit: 'Laikas viršijo limitą',
    segmentsHint: 'Rodo matavimo taškus pagal greičio apribojimą (NVDB, kitu atveju OSM ženklas). Didžiausias pažeidimo metu yra didžiausias GPS greitis, kai transporto priemonė viršijo ribą daugiau nei 10 %. Pavienės sekundės, priskirtos šoniniam keliui, neįskaičiuojamos. Filtruojami tik GPS šuoliai virš 250 km/h.',
  },
  vehicleWearReport: {
    wearScore: 'Dėvėjimo balas',
    wear: 'Nešioti',
    noVehicleData: 'Nėra transporto priemonės duomenų',
  },
  co2Report: {
    noVehicleData: 'Nėra transporto priemonės duomenų',
  },
  odometerReport: {
    searchPlaceholder: 'Paieškos registracijos Nr., prekės ženklo...',
  },
  drivingLog: {
    searchVehiclePlaceholder: 'Ieškokite arba pasirinkite transporto priemonę...',
  },
  rentalReport: {
    recipientNamePlaceholder: 'Gavėjo vardas',
  },
  geofenceEvents: {
    searchVehiclePlaceholder: 'Ieškoti transporto priemonių...',
  },
  signup: {
    title: 'Sukurti DQFleet paskyrą',
    subtitle: 'Po registracijos turite patvirtinti el. paštą prieš prisijungdami.',
    firstNameLabel: 'Vardas',
    lastNameLabel: 'Pavardė',
    emailLabel: 'El. paštas',
    passwordLabel: 'Slaptažodis',
    confirmPasswordLabel: 'Patvirtinkite slaptažodį',
    firstNamePlaceholder: 'Vardas',
    lastNamePlaceholder: 'Pavardė',
    emailPlaceholder: 'jus@imone.lt',
    passwordPlaceholder: 'Mažiausiai 8 simboliai',
    confirmPasswordPlaceholder: 'Patvirtinkite slaptažodį',
    passwordRulesHint: 'Mažiausiai 8 simboliai, didžioji ir mažoji raidė, skaitmuo ir specialus simbolis.',
    infoBoxTitle: 'Organizacija ir prieiga',
    infoBoxBody: 'Naudokite darbo el. paštą. Jei organizacija užregistravo domeną, po patvirtinimo būsite automatiškai susieti su Viewer role.',
    infoBoxManual: 'Jei domenas neužregistruotas, administratorius vėliau gali susieti paskyrą.',
    tosPrefix: 'Sutinku su',
    tosTerms: 'naudojimo sąlygomis',
    tosAnd: 'ir',
    tosPrivacy: 'privatumo politika',
    submit: 'Sukurti paskyrą',
    creating: 'Kuriama paskyra...',
    hasAccount: 'Jau turite paskyrą?',
    loginLink: 'Prisijungti',
    toastSuccessOrgLinked: 'Paskyra sukurta. Domenas susietas su organizacija — patvirtinkite el. paštą.',
    toastSuccessManual: 'Paskyra sukurta. Patvirtinkite el. paštą. Jei domenas neatpažintas, gali prireikti administratoriaus.',
    createError: 'Nepavyko sukurti paskyros. Bandykite dar kartą.',
  },
  packagesManagement: {
    unlimitedPlaceholder: 'Neribota',
    phoneSupportPlaceholder: 'Pagalba telefonu...',
  },
  serviceOverview: {
    statusOverdue: 'Pavėluota',
    statusDueSoon: 'Greitai',
    statusCompleted: 'Užbaigta',
    allStatuses: 'Visos būsenos',
    overdueFilter: 'Pavėluota',
    dueSoonFilter: 'Greitai',
    bookedFilter: 'Užsakyta',
    nextKm: 'Kitas km',
  },
  deviceAssignModal: {
    title: 'Priskirkite organizacijai IMEI',
    pasteImeiAndSelectOrg: 'Įklijuokite IMEI numerius ir pasirinkite organizaciją',
    assignmentComplete: 'Užduotis baigta',
    devicesAssigned: 'priskirtus įrenginius',
    assigned: 'Paskirta',
    skippedMounted: 'Praleista (primontuota)',
    notFound: 'Nerasta',
    invalidFormat: 'Netinkamas formatas',
    notFoundImeis: 'Nerasta IMEI:',
    errors: 'Klaidos:',
    selectOrg: 'Pasirinkite organizaciją...',
    imeiLabel: 'IMEI numeriai (įklijuoti, po vieną eilutėje, atskirti kableliu arba kabliataškiu)',
    pasteImeiHere: 'Įklijuokite IMEI čia...',
    validateImei: 'Patvirtinkite IMEI',
    validImeiFound: 'Rasta tinkamų IMEI numerių: {count}',
    clear: 'Aišku',
    assignDevices: 'Priskirkite {count} įrenginius',
    xlsxSection: 'Excel importuoti (.xlsx)',
    xlsxHint: 'Spustelėkite, kad pasirinktumėte failą – A stulpelis = IMEI, langelis B2 = kabelių skaičius',
    xlsxOnly: 'Palaikomi tik .xlsx failai.',
    xlsxNoImei: 'A stulpelyje nerasta tinkamo IMEI.',
    xlsxReadError: 'Nepavyko perskaityti failo.',
    xlsxImeiNote: 'Patarimas: formatuokite IMEI kaip tekstą Excel, kad skaičiai nebūtų suapvalinti.',
    orPaste: 'arba',
    cablesFromFile: 'Kabeliai iš failo (B2): {n} (išsaugomi CRM klientui, kai jis priskirtas)',
  },
  commonUi: {
    closeModal: 'Uždaryti',
    previousMonth: 'Ankstesnis mėnuo',
    nextMonth: 'Kitą mėnesį',
    noLanguages: 'Nėra galimų kalbų',
    noRouteData: 'Nėra maršruto duomenų',
    highPriority: 'Aukštas',
  },
  customerDevicesTab: {
    inVehicle: 'Transporto priemonėje',
    customerStock: 'Klientų atsargos',
    centralStock: 'Centrinės atsargos',
    allOrganizations: 'Visos organizacijos',
    deviceCount: 'prietaisai',
  },
  vehicleListWidget: {
    totalVehicles: 'Iš viso transporto priemonių',
    fleetNow: 'Parkas dabar',
    withDevice: 'su įrenginiu',
    online: 'online',
    offline: 'offline',
  },
  inspectionWidget: {
    title: 'Patikrinimai',
    titleWithDays: 'Apžiūra per 40d',
    noVehicles: 'Nėra transporto priemonių',
    overdue: 'pavėluota',
    daysAgo: 'Prieš {days} d',
    today: 'Šiandien',
  },
  taxWidget: {
    title: 'Transporto priemonės mokestis',
    titleWithDays: 'Mokestis per 45d',
    noVehicles: 'Nėra transporto priemonių su mokesčiu per 45 dienas',
    overdue: 'pavėluota',
    daysAgo: 'Prieš {days} d',
    today: 'Šiandien',
  },
  unpluggedWidget: {
    title: 'Atjungtas',
    subtitle: 'Atjungtas',
    warning: 'Įspėjimas',
    allConnected: 'Visi įrenginiai prijungti',
  },
  unplugEvents: {
    title: 'Atjungimo istorija',
    subtitle: 'GPS įrenginio prijungimas ir atjungimas su laiku ir artimiausia vieta.',
    backToDashboard: 'Atgal į valdymo skydelį',
    openHistory: 'Rodyti prijungimo ir atjungimo istoriją',
    eventType: 'Įvykis',
    allTypes: 'Visi',
    unplugged: 'Atjungta',
    plugged: 'Prijungta',
    occurredAt: 'Laikas',
    address: 'Vieta',
    email: 'El. paštas',
    emailSent: 'Išsiųsta',
    emailNotSent: 'Neišsiųsta',
    searchPlaceholder: 'Ieškoti numerio',
    registrationNumber: 'Numeris',
    empty: 'Pasirinktu laikotarpiu įvykių nėra.',
    showing: 'Rodoma {{from}}–{{to}} iš {{total}}',
    pageOf: 'Puslapis {{page}} iš {{pages}}',
    loadError: 'Nepavyko įkelti atjungimo istorijos.',
    mapSource: 'Artimiausias GPS taškas',
  },
  appRoutes: {
    salesPipeline: 'Pardavimo vamzdynas',
    salesPipelineDesc: 'Pardavimo piltuvas ir potencialūs klientai',
    economicOverview: 'Ekonominė apžvalga',
    economicOverviewDesc: 'Slenkantis 12, tendencijos ir pajamos',
  },
  deviceImportModal: {
    pasteImeiAndSelectOrg: 'Įklijuokite IMEI numerius ir pasirinkite organizaciją',
  },
  tireManagement: {
    partnerPlaceholder: 'Padangų partneris Sundsvalis',
  },
  companySearch: {
    title: 'Įmonės paieška',
    lookupButton: 'Ieškoti įmonės',
    whoLabel: 'Įmonės pavadinimas/tel',
    whoPlaceholder: 'Pvz. Volvo arba 08-123',
    whereLabel: 'Vieta (neprivaloma)',
    wherePlaceholder: 'Pvz. Stokholmas',
    search: 'Ieškoti',
    searching: 'Ieškoma...',
    minChars: 'Įveskite bent 2 simbolius',
    searchError: 'Nepavyko ieškoti įmonių',
    noResults: 'Nerasta įmonių. Išbandykite kitą paieškos terminą.',
    startSearching: 'Ieškokite pagal įmonės pavadinimą, telefono numerį arba adresą.',
    resultsCount: '{{count}} rezultatai',
    showingOfTotal: 'Rodoma {{showing}} iš {{total}} rezultatų',
    refineSearch: 'Patikslinkite paiešką, kad gautumėte daugiau rezultatų',
    wildcardHint: 'Pakaitos simbolis (*) pridedamas automatiškai. Naudoti? vienam simboliui.',
    page: 'Puslapis',
  },
  poolcarDemo: {
    myBookings: 'Mano užsakymai',
    bookingDetails: 'Užsakymo informacija',
    digitalKey: 'Skaitmeninis raktas',
    returnVehicle: 'Grąžinti transporto priemonę',
    receipt: 'Kvitas',
    noBookings: 'Jokių užsakymų',
    noBookingsHint: 'Neturite būsimų užsakymų.',
    upcoming: 'Būsimi užsakymai',
    active: 'Aktyvus',
    vehicle: 'Transporto priemonė',
    pool: 'Baseinas',
    period: 'Laikotarpis',
    destination: 'Paskirties vieta',
    licenseConfirm: 'Patvirtinu, kad turiu galiojantį vairuotojo pažymėjimą ir galiu vairuoti transporto priemonę.',
    startsIn: 'Užsakymas prasideda',
    checkoutVehicle: 'Patikrinkite transporto priemonę',
    vehicleUnlocked: 'Transporto priemonė atrakinta',
    vehicleLocked: 'Transporto priemonė užrakinta',
    communicating: 'Bendraujame...',
    bookingEnded: 'Užsakymas baigėsi',
    cannotUnlock: 'Pasibaigus rezervavimui transporto priemonės atrakinti negalima.',
    tapToToggle: 'Bakstelėkite, kad užrakintumėte/atrakintumėte',
    bookingTime: 'Užsakymo laikas',
    returnTitle: 'Grąžinti transporto priemonę',
    checkParked: 'Transporto priemonė pastatyta tinkamoje vietoje',
    checkLocked: 'Transporto priemonė užrakinta',
    reportDamage: 'Praneškite apie žalą ar problemą',
    damageDescription: 'Apibūdinkite žalą...',
    confirmReturn: 'Patvirtinkite grąžinimą',
    thankYou: 'Ačiū!',
    vehicleReturned: 'Automobilis grąžintas ir įregistruotas.',
    backToBookings: 'Atgal į užsakymus',
    demoTitle: 'Berakčių automobilių baseinas – demonstracinė versija',
    demoDescription: 'Ši demonstracija parodo visą naudotojo srautą darbuotojui, naudojančiam baseino transporto priemonę, įskaitant rezervavimą, paėmimą, skaitmeninio rakto sprendimą ir grąžinimą.',
    step1: 'Pasirinkite rezervaciją',
    step2: 'Patikrinkite transporto priemonę',
    step3: 'Atrakinti / užrakinti (skaitmeninis raktas)',
    step4: 'Grąžinti transporto priemonę',
    step5: 'Kvitas',
  },
  tidbok: {
    title: 'Skaitmeninis žurnalas',
    subtitle: 'Vairavimo ir poilsio laikas pagal ES 561/2006 ir TSFS 2013:3',
    registerActivity: 'Registruoti veiklą',
    selectDriver: 'Vairuotojas',
    selectDriverPlaceholder: 'Pasirinkite vairuotoją...',
    selectDriverToStart: 'Norėdami peržiūrėti žurnalą, pasirinkite vairuotoją',
    driverCard: 'Vairuotojo kortelė',
    previousWeek: 'Ankstesnis',
    nextWeek: 'Kitas',
    weekLabel: 'Savaitė {{week}}, {{year}}',
    noActivities: 'Šią savaitę veiklos neužregistruota',
    registerFirstActivity: 'Užregistruokite pirmąją veiklą',
    activitySaved: 'Veikla išsaugota',
    errorLoadingDrivers: 'Nepavyko įkelti tvarkyklių',
    errorLoadingEntries: 'Nepavyko įkelti žurnalo įrašų',
    errorSaving: 'Nepavyko išsaugoti veiklos',
    weekDriving: 'Savaitinis vairavimas',
    weekWork: 'Savaitinis darbas',
    weekRest: 'Savaitinis poilsis',
    driving: 'Vairavimas',
    continuous: 'Nuolatinis',
    activityType: 'Veiklos tipas',
    vehicle: 'Transporto priemonė',
    selectVehiclePlaceholder: 'Pasirinkite transporto priemonę...',
    date: 'Data',
    startTime: 'Pradžios laikas',
    endTime: 'Pabaigos laikas',
    noteOptional: 'Pastaba (neprivaloma)',
    notePlaceholder: 'pvz. Stokholmas → Geteborgas',
    saving: 'Išsaugoma...',
    saveActivity: 'Išsaugoti veiklą',
    rulesTitle: 'Taisyklės – taikomi limitai',
    activity: {
      driving: 'Vairavimas',
      otherWork: 'Kiti darbai',
      available: 'Yra',
      rest: 'Poilsis',
    },
    rule: {
      maxDailyDriving: 'Maksimalus kasdieninis vairavimas',
      maxContinuousDriving: 'Maksimalus nuolatinis važiavimas',
      mandatoryBreak: 'Privaloma pertrauka',
      minDailyRest: 'Minimalus dienos poilsis',
      maxWeeklyDriving: 'Maksimalus savaitinis vairavimas',
      maxBiweeklyDriving: 'Maksimalus važiavimas dvi savaites',
    },
    validation: {
      selectVehicle: 'Pasirinkite transporto priemonę',
      enterDate: 'Įveskite datą',
      enterStartTime: 'Įveskite pradžios laiką',
      enterEndTime: 'Įveskite pabaigos laiką',
      endAfterStart: 'Pabaigos laikas turi būti po pradžios laiko',
    },
    searchDriverPlaceholder: 'Ieškoti vairuotojo (vardas arba vairuotojo pažymėjimo numeris)…',
    errorLoadingVehicles: 'Negalima pasiimti transporto priemonės',
  },
  customerKeyHandling: {
    title: 'Raktų tvarkymas',
    summary: {
      cabinets: 'Spintelių skaičius',
      places: 'Vietų skaičius',
      linked: 'Susietos transporto priemonės',
    },
    columns: {
      name: 'Spintelės pavadinimas',
      lists: 'Juostos',
      places: 'Vietos',
    },
    empty: 'Šiam klientui nėra susietų spintelių.',
    noLayout: 'Spintelės juostų nepavyko nuskaityti.',
    pickCustomer: 'Pasirinkite klientą',
    loadError: 'Nepavyko įkelti spintelių.',
    backToList: 'Atgal į spinteles',
    switchCabinet: 'Keisti spintelę',
    historyTitle: 'KeyId {{keyId}}',
    historyEmpty: 'Šiam raktui nėra išsaugotos sąsajos.',
    vehicleHistory: 'Transporto priemonės raktai',
    historyOpen: 'Vyksta',
    nameLabel: 'Spintelės pavadinimas',
    saveName: 'Išsaugoti pavadinimą',
    nameSaved: 'Spintelės pavadinimas išsaugotas.',
    nameError: 'Nepavyko išsaugoti spintelės pavadinimo.',
    selectSlot: 'Pasirinkite laisvą žalią raktą ir suraskite transporto priemonę. Susiejimas išsaugomas iš karto.',
    searchVehicle: 'Ieškoti transporto priemonės',
    searchPlaceholder: 'Valstybinis numeris, markė arba modelis',
    searching: 'Ieškoma…',
    noVehicles: 'Laisvų transporto priemonių nerasta.',
    linking: 'Susiejama…',
    linked: 'Transporto priemonė susieta ir padėta į {{location}}.',
    linkError: 'Nepavyko susieti transporto priemonės.',
    readOnly: 'Galite matyti spinteles. Raktui susieti reikia teisės Susieti raktą.',
    fleetCount: '{{count}} transporto priemonės be lizdo ir Flinkey dėžės',
    fleetEmpty: 'Nėra transporto priemonių, kurioms trūktų ir lizdo, ir Flinkey dėžės.',
    kindVehicle: 'Transporto priemonė',
    kindResource: 'Išteklius',
    linkedResource: 'Rezervacijos išteklius susietas.',
    unlink: 'Atjungti',
    unlinkConfirm: 'Atjungti {{registration}}? Raktas spintelėje taps laisvas.',
    unlinking: 'Atjungiama…',
    unlinked: 'Raktas atjungtas.',
    unlinkError: 'Nepavyko atjungti.',
  },
  keyManagement: {
    title: 'Spintelių administravimas',
    tabs: {
      cabinets: 'Spintelės',
      keys: 'Raktai',
      onpremConnect: 'Ryšys',
      cabinetSync: 'Spintelių sinchronizacija',
    },
    onpremConnect: {
      title: 'OpenVPN OnPrem spintelėms',
      subtitle: 'Sukurkite kliento sertifikatą ir atsisiųskite .ovpn. CA lieka creone. Esamų sertifikatų pakartotinai atsisiųsti negalima.',
      cn: 'Common Name',
      location: 'Vieta',
      organization: 'Organizacija',
      proto: 'Protokolas',
      validTo: 'Galioja iki',
      cnHint: 'Naudokite mažąsias raides, skaičius ir brūkšnelius. Rekomenduojama: skap-vieta-miestas.',
      create: 'Sukurti ir atsisiųsti .ovpn',
      creating: 'Kuriamas sertifikatas…',
      loadError: 'Nepavyko gauti OpenVPN klientų',
      createError: 'Nepavyko sukurti OpenVPN sertifikato',
      empty: 'Spintelių sertifikatų dar nėra.',
    },
    cabinetSync: {
      title: 'Spintelių sinchronizacija (Creone Rabbit)',
      subtitle: 'Ką KeyWin siunčia į kiekvieną spintelę. Tik globalus administratorius. PIN ir asmens duomenys užmaskuoti.',
      spyConnected: 'Stebėtojas prijungtas',
      spyDisconnected: 'Stebėtojas atjungtas',
      traceOn: 'Firehose įjungtas',
      traceOff: 'Firehose išjungtas',
      eventsLastMinute: 'Įvykiai / min',
      eventsLastHour: 'Įvykiai / val',
      bytesLastHour: 'Baitai / val',
      storedEvents: 'Išsaugoti įvykiai',
      queues: 'Eilės',
      events: 'Įvykiai',
      queue: 'Eilė',
      kind: 'Tipas',
      backlog: 'Laukiama',
      consumers: 'Consumers',
      publishRate: 'Publish / s',
      deliverRate: 'Deliver / s',
      online: 'Spintelė veikia',
      offline: 'Spintelė neveikia',
      time: 'Laikas',
      type: 'Tipas',
      size: 'Dydis',
      summary: 'Turinys',
      payload: 'Duomenys',
      noEvents: 'Dar nėra pranešimų. Sukurkite rezervaciją arba palaukite kitos sinchronizacijos.',
      loadError: 'Nepavyko įkelti sinchronizacijos',
      filterQueue: 'Filtruoti eilę',
      allQueues: 'Visos eilės',
      cabinet: 'Spintelė',
      keywin: 'KeyWin debesis',
      other: 'Kita',
      source: 'Šaltinis',
      sourceAll: 'Visi šaltiniai',
      sourceRabbit: 'Rabbit',
      sourceLocker: 'Mūsų API',
      sourceCabinetHttp: 'Spintelės HTTP',
    },
    cabinet: {
      name: 'Vardas',
      location: 'Vieta',
      status: 'Būsena',
      capacity: 'Talpa',
      occupiedSlots: 'Užimti laiko tarpsniai',
      availableSlots: 'Galimi laiko tarpsniai',
      assignedGroup: 'Priskirta grupė',
      noGroup: 'Nepriskirta',
      assignGroup: 'Priskirti grupę',
      changeGroup: 'Keisti grupę',
      removeGroup: 'Pašalinti grupės priskyrimą',
      linkedToCustomer: 'Susieta su klientu',
      notLinkedToCustomer: 'Nesusieta su klientu',
      linkCustomer: 'Susieti su klientu',
      unlinkCustomer: 'Pašalinti kliento nuorodą',
      linkCustomerConfirm: 'Susieti spintelę su klientu? SuperAdmin ir LocalAdmin bus sukurti kaip KeyWin naudotojai su spintelės raktais (be internetinės prieigos).',
      unlinkCustomerConfirm: 'Pašalinti kliento nuorodą? Paėmimo vieta ir LocalAdmin bus pašalinti.',
      linkCustomerFirst: 'Pirmiausia susiekite su klientu',
      localAdminPin: 'LocalAdmin PIN',
      syncTags: 'Sinchronizuoti raktus',
      syncTagsHelp: 'Prijungia tik šioje spintelėje esančius raktus prie SuperAdmin ir LocalAdmin. Grupė nekuriama.',
      keysInCabinet: 'Raktai spintelėje',
      showKeys: 'Rodyti raktus',
      hideKeys: 'Slėpti raktus',
      lists: 'Sąrašai',
      listsShort: 'sąrašus',
      keysShort: 'raktai',
      keysIn: 'Raktai viduje',
      keysOut: 'Raktai ištraukti',
      inShort: 'viduje',
      emptyShort: 'tuščias',
      unusedSlots: 'Nenaudojami kranai',
      slotsPerList: 'čiaupai / strategija',
      empty: 'tuščias',
      emptySlot: 'Tuščias čiaupas',
      backToOverview: 'Grįžti į kabineto apžvalgą',
      changeShort: 'Keisti',
      assignShort: 'Priskirti',
    },
    key: {
      name: 'Vardas',
      keyId: 'KeyId',
      cabinet: 'kabinetas',
      slot: 'Lizdas',
      status: 'Būsena',
      available: 'Yra',
      vehicle: 'Transporto priemonė',
      noVehicle: 'Nesusieti',
      assignVehicle: 'Susieti transporto priemonę',
      removeVehicle: 'Pašalinti nuorodą',
      history: 'Istorija',
      historyOpen: 'Vyksta',
      externalId: 'Išorinis ID',
      keyInfo: 'Pagrindinė informacija',
      linkedVehicle: 'Prijungta transporto priemonė',
    },
    status: {
      online: 'Prisijungę',
      offline: 'Neprisijungus',
      error: 'Klaida',
      maintenance: 'Priežiūra',
      in_cabinet: 'Kabinete',
      taken: 'Paimta',
      lost: 'Prarasta',
    },
    assignment: {
      assignedAt: 'Paskirta',
      assignedBy: 'Paskyrė',
      unassignedAt: 'Pašalinta',
      note: 'Pastaba',
      notePlaceholder: 'Neprivaloma pastaba...',
      noAssignments: 'Nėra aktyvių užduočių',
    },
    messages: {
      assignSuccess: 'Užduotis sukurta',
      unassignSuccess: 'Užduotis pašalinta',
      assignError: 'Nepavyko sukurti užduoties',
      unassignError: 'Nepavyko pašalinti užduoties',
      customerAssignSuccess: 'Spintelė susieta su klientu',
      customerUnassignSuccess: 'Kliento nuoroda pašalinta',
      customerAssignError: 'Nepavyko susieti spintelės su klientu',
      customerUnassignError: 'Nepavyko pašalinti kliento nuorodos',
      syncTagsSuccess: '{{count}} raktai prijungti prie SuperAdmin ir LocalAdmin',
      syncTagsEmpty: 'Spintelėje dar nėra raktų. Atidarykite su įmontuotu SuperAdmin, įdėkite raktus ir sinchronizuokite dar kartą.',
      syncTagsError: 'Nepavyko sinchronizuoti raktų',
      missingKeyId: 'Raktas neturi KeyId ir negali būti susietas su transporto priemone.',
      renameWarning: 'Transporto priemonė susieta, bet rakto pavadinimo spintelėje nepavyko pakeisti į registracijos numerį.',
      unassignRenameWarning: 'Nuoroda pašalinta, bet senas registracijos numeris liko rakto pavadinime spintelėje.',
      loadError: 'Nepavyko įkelti duomenų',
      confirmRemove: 'Ar tikrai norite pašalinti šią užduotį?',
      alarmAcknowledged: 'Signalizacija patvirtinta',
      allAlarmsAcknowledged: 'Visi pavojaus signalai patvirtinti',
      alarmError: 'Nepavyko patvirtinti aliarmo',
    },
    filters: {
      allCabinets: 'Visos spintos',
      allStatuses: 'Visos būsenos',
      searchPlaceholder: 'Ieškoti pagal rakto pavadinimą...',
    },
    modal: {
      selectGroup: 'Pasirinkite klientų grupę',
      selectVehicle: 'Pasirinkite transporto priemonę',
      registrationNumber: 'Registracijos numeris',
      searchVehicle: 'Ieškoti reg. number or model...',
      searchRegistration: 'Įveskite registracijos numerį, pvz. ABC123',
      typeRegistrationHint: 'Įveskite bent du simbolius. Rodomi tik automobiliai be rakto arba Flinkey dėžutės.',
      orgVehiclesWithoutKey: 'Organizacijos transportas be priskirto rakto lizdo. Ieškokite, kad filtruotumėte.',
      noOrgVehiclesWithoutKey: 'Šioje organizacijoje nėra transporto be rakto lizdo.',
      clickToSelect: 'Spustelėkite transporto priemonę sąraše',
      noVehicleMatch: 'Laisvų automobilių nerasta',
      currentAssignment: 'Dabartinė užduotis',
      noGroupSelected: 'Nepasirinkta jokia grupė',
      selectCustomer: 'Pasirinkite viršutinę organizaciją',
      searchCustomer: 'Ieškoti viršutinės organizacijos',
      noCustomerSelected: 'Viršutinė organizacija nepasirinkta',
      noEligibleCustomers: 'Viršutinių organizacijų nerasta.',
      linkCustomerHelp: 'Pasirinkite viršutinę organizaciją, kuriai priklausys spintelė. Globalus administratorius mato visas. SuperAdmin ir LocalAdmin tampa KeyWin naudotojais su spintelės raktais, be internetinės prieigos.',
    },
    summary: {
      totalCabinets: 'Iš viso spintos',
      keysIn: 'Raktai viduje',
      keysOut: 'Raktai ištraukti',
      unusedSlots: 'Nenaudojami kranai',
    },
    logs: {
      activityLog: 'Veiklos žurnalas',
      keyHistory: 'Išėjęs/į istoriją',
      noEvents: 'Jokių įvykių',
      taken: 'Atšauktas',
      returned: 'Sugrįžo',
      alarm: 'Signalizacija',
      alarmsExist: 'Nepatvirtinti aliarmai',
      linked: 'Prisijungta prie',
      unlinked: 'Atsijungta nuo',
      cabinetEvents: 'Spintos renginiai',
      last24h: 'Paskutines 24 valandas',
      unacknowledgedAlarms: 'nepatvirtinti pavojaus signalai',
      acknowledgeAll: 'Pripažinkite visus',
      filterAll: 'Visi',
      filterAlarms: 'Signalizacija',
      filterKeys: 'Raktai',
      filterSystem: 'Sistema',
      noEventsToShow: 'Nėra įvykių, kuriuos būtų galima rodyti',
    },
  },
  assignments: {
    title: 'Užduotys',
    description: 'Tvarkykite užduotis žmonėms',
    myAssignments: 'Mano užduotys',
    myAssignmentsHint: 'Jums priskirtos užduotys',
    assigneeFilterMine: 'Priskirta man',
    assigneeFilterAll: 'Visos užduotys',
    create: 'Sukurti užduotį',
    category: 'Kategorija',
    whatToDo: 'Ką daryti',
    titlePlaceholder: 'Trumpai apibūdinkite užduotį...',
    descriptionLabel: 'Aprašymas',
    assignedTo: 'Priskirta',
    assignedBy: 'Paskyrė',
    assignedAt: 'Paskirta',
    selectUser: 'Pasirinkite vartotoją...',
    priorityLabel: 'Pirmenybė',
    priorityLow: 'Žemas',
    priorityNormal: 'Normalus',
    priorityHigh: 'Aukštas',
    priorityUrgent: 'Skubiai',
    vehicle: 'Transporto priemonė',
    vehicleIdPlaceholder: 'Transporto priemonės ID (neprivaloma)',
    dueDate: 'Terminas',
    startWork: 'Pradėti',
    complete: 'Pažymėti kaip užbaigtą',
    cancel: 'Atšaukti',
    completionNotes: 'Pastabos',
    completionNotesPlaceholder: 'Aprašykite, kas buvo padaryta...',
    startedAt: 'Prasidėjo',
    completedAt: 'Užbaigta',
    allStatuses: 'Visos būsenos',
    allCategories: 'Visos kategorijos',
    noCategories: 'Kategorijų nėra (patikrinkite API arba seed)',
    statusPending: 'Laukiama',
    statusInProgress: 'Vykdoma',
    statusCompleted: 'Užbaigta',
    statusCancelled: 'Atšaukta',
    noAssignments: 'Užduočių nerasta',
    noOpenAssignments: 'Nėra atvirų užduočių',
    open: 'atviras',
    viewAll: 'Peržiūrėkite visas užduotis',
    fillRequired: 'Užpildykite visus privalomus laukus',
    created: 'Užduotis sukurta',
    started: 'Užduotis pradėta',
    completed: 'Užduotis baigta',
    cancelled: 'Užduotis atšaukta',
    confirmCancel: 'Ar tikrai norite atšaukti šią užduotį?',
    assigned: 'paskirtas',
    assign: 'Priskirti',
    selectAll: 'Pasirinkite viską',
    assignSelected: 'Priskirti pasirinktą',
    vehiclesSelected: 'pasirinktos transporto priemonės',
    assignmentsCreated: 'sukurtos užduotys',
  },
  mine: {
    title: 'Mano',
    bookings: 'rezervacijos',
    assignments: 'priskyrimai',
    nothingToday: 'Šiandien nieko neužsakyta. Reikia automobilio?',
    bookedToday: '{count} rezervacija šiandien',
    bookedTodayMany: '{count} rezervacijos šiandien',
  },
  bookingWidget: {
    title: 'Mano užsakymai',
    noBookings: 'Jokių būsimų užsakymų',
    upcoming: 'būsimas',
    booked: 'Užsakyta',
    checkedOut: 'Išsiregistravo',
    awaiting: 'Laukiama',
    awaitingHandling: 'Laukiama tvarkymo',
    noVehicleAssigned: 'Transporto priemonė nepriskirta',
    previousVehicle: 'anksčiau',
    nextBooking: 'Kitas užsakymas',
    inProgress: 'Vyksta',
    startsIn: 'Po {{hours}} val. {{minutes}} min.',
    newBooking: 'Naujas užsakymas',
    edit: 'Keisti',
    today: 'Šiandien',
    returned: 'Baigta',
    history: 'Istorija',
    current: 'Aktualūs',
    sort: 'Rūšiuoti',
    sortStartAsc: 'Pradžios data, artimiausi pirmi',
    sortStartDesc: 'Pradžios data, tolimiausi pirmi',
    noHistory: 'Istorijos nėra',
    lastSixMonths: 'Paskutiniai 6 mėnesiai',
    bookingsCount: 'užsakymai',
    cars: 'automobiliai',
    resources: 'ištekliai',
    mixCarsAndResources: '{{cars}} automobiliai ir {{resources}} ištekliai',
    mixCars: '{{cars}} automobiliai',
    mixResources: '{{resources}} ištekliai',
    periodKm: 'km',
    periodEstimatedKm: 'numatomi km',
    periodCost: 'kr',
    electricShare: 'elektra',
    openCalendar: 'Atidaryti rezervavimo kalendorių',
    perMonth: 'Užsakymai per mėnesį',
    sixMonths: '6 mėn.',
    completedSeries: 'Įvykdyti',
    upcomingSeries: 'Būsimi',
    noMoreBookings: 'Daugiau užsakymų nėra',
  },
  carinfoOrgSync: {
    title: 'Carinfo transporto priemonių importas',
    dashboardDescription: 'Importuokite transporto priemones iš Car.info pagal organizacijos numerį',
    orgNumber: 'Org. Nr.',
    customer: 'Klientas',
    lastSync: 'Paskutinis sinchronizavimas',
    syncCount: 'Sinchronizuoja',
    vehicleCount: 'Suskaičiuoti',
    active: 'Aktyvus',
    inactive: 'Neaktyvus',
    source: 'Šaltinis',
    actions: 'Veiksmai',
    sync: 'Sinchronizuoti',
    log: 'Žurnalas',
    syncResult: 'Sinchronizavimo rezultatas',
    resultFor: 'Rezultatas už',
    added: 'Pridėta',
    updated: 'Atnaujinta',
    unchanged: 'Nepakitęs',
    inactivated: 'Neaktyvuota',
    failed: 'Nepavyko',
    total: 'Iš viso',
    vehicles: 'transporto priemonių',
    filialNumbersTitle: 'Aptikti filialų numeriai',
    addFilialsAndSync: 'Pridėkite pasirinktas transporto priemones ir gaukite',
    syncLog: 'Sinchronizavimo istorija',
    noLogEntries: 'Nėra sinchronizavimo istorijos',
    noOrgNumbers: 'Organizacijos numeriai nesukonfigūruoti. Pridėti org. numeriai per CRM klientų skirtuką „Org. Nr. Transporto priemonės“.',
    date: 'Data',
  },
  travelPlanner: {
    title: 'Kelionių planuotojas',
    from: 'Nuo',
    to: 'Į',
    fromPlaceholder: 'Paieškos pradžios adresas...',
    toPlaceholder: 'Ieškoti paskirties...',
    search: 'Paieškos maršrutas',
    swap: 'Sukeisti pradžią ir tikslą',
    clickOnMap: 'Spustelėkite žemėlapį',
    modeCar: 'Automobilis',
    modeBicycle: 'Dviratis',
    modeFoot: 'Vaikščiojimas',
    modeTransit: 'Viešasis transportas',
    timeNow: 'Išeik dabar',
    timeDeparture: 'Išvykimo laikas',
    timeArrival: 'Atvykimo laikas',
    showAlternatives: 'Rodyti alternatyvius maršrutus',
    routeAlternatives: 'Maršruto alternatyvos',
    transitAlternatives: 'Kelionės pasiūlymai',
    route: 'Maršrutas',
    transfers: 'pervedimai',
    tripDetails: 'Kelionės detalės',
    noRouteFound: 'Maršrutas nerastas',
    noTripsFound: 'Kelionės pasiūlymų nerasta',
    searchError: 'Paieška nepavyko',
    selectBothPoints: 'Pasirinkite pradžią ir tikslą',
    sendEmail: 'Siųsti nurodymus',
    emailPlaceholder: 'El. pašto adresas',
    send: 'Siųsti',
    emailSent: 'Nurodymai išsiųsti',
    emailError: 'Nepavyko išsiųsti el',
    transitNotConfigured: 'Viešasis transportas nesukonfigūruotas (serveryje trūksta ResRobot API rakto)',
  },
  resourceTypesAdmin: {
    title: 'Išteklių tipai (sistema)',
    description: 'Tvarkykite visos sistemos išteklių tipus, kuriuos galima priskirti organizacijoms',
    code: 'Kodas',
    nameSv: 'Vardas (švedų k.)',
    nameEn: 'Vardas (anglų k.)',
    displayOrder: 'Rūšiavimo tvarka',
    addNew: 'Pridėti naują išteklių tipą',
    codePlaceholder: 'Pvz. MOTOROLERIS',
    nameSvPlaceholder: 'Pvz. E-paspirtukas',
    nameEnPlaceholder: 'Pvz. E-paspirtukas',
    created: 'Sukurtas ištekliaus tipas',
    updated: 'Ištekliaus tipas atnaujintas',
    codeRequired: 'Būtinas kodas ir vardas',
  },
  equipment: {
    title: 'Įrangos etiketės',
    description: 'Tvarkykite įrangos žymes, kurias galima priskirti transporto priemonėms',
    tagName: 'Žymės pavadinimas',
    icon: 'Piktograma',
    newTagPlaceholder: 'Naujos įrangos etiketė...',
    iconPlaceholder: 'Piktograma (neprivaloma)',
    noTags: 'Nėra įrangos etikečių. Pridėkite vieną, kad pradėtumėte.',
    vehicleEquipment: 'Įranga',
    noEquipment: 'Šiai transporto priemonei nepriskirta jokia įranga.',
    selectTag: 'Pasirinkite įrangą...',
    notesPlaceholder: 'Pastaba (neprivaloma)',
    removed: 'Įranga pašalinta',
    organization: 'Organizacija',
    createUnderOrganization: 'Organizacija',
  },
  dequeVehicleLog: {
    title: 'Deque — Vehicle log',
    description: 'In-customer org moves, replacements, top-node transfers, and vehicle status (active/inactive).',
    scopeNote: 'Activation/deactivation appears under «Status» or «All» (from audit). Superadmins see more in the change log. Device history (device_change_log) requires a mounted GPS device.',
    scopeNoteUpdated: 'Activation/deactivation (status changes) appear under the «Status» tab or in «All». Superadmins see the same events with more context in the change log.',
    auditLogLink: 'Open change log',
    tabAll: 'All',
    tabOrgMove: 'Org move',
    tabReplacement: 'Replacement',
    tabCrossTop: 'Top-node transfer',
    tabVehicleStatus: 'Status',
    vehicleActivated: 'Aktyvuota',
    vehicleInactivated: 'Išaktyvuota',
    vehicleId: 'Vehicle ID',
    dateFrom: 'From date',
    dateTo: 'To date',
    colWhen: 'Time',
    colType: 'Type',
    colVehicle: 'Vehicle',
    colDetail: 'Detail',
    colUser: 'Performed by',
    empty: 'No events for the selected filters.',
    loadError: 'Could not load log',
    showing: 'Showing {{from}}–{{to}} of {{total}}',
    replaces: 'Replaces',
    replacedReg: 'Replaced reg.',
    registrationNumber: 'Reg numeris',
    registrationNumberPlaceholder: 'ABC123',
  },
  flinkeyBoxes: {
    title: 'Flinkey dėžutės',
    dashboardDescription: 'Valdykite Flinkey skaitmenines raktų dėžutes ir individualius priskyrimus',
    addBox: 'Pridėti dėžutę',
    search: 'Ieškoti produkto ID, serijos numerio...',
    productId: 'Produkto ID',
    serialNumber: 'Serijos numeris',
    boxType: 'Tipas',
    carName: 'Transporto priemonė',
    licensePlate: 'Valstybinis numeris',
    contractStart: 'Sutarties pradžia',
    contractState: 'Sutarties būsena',
    notes: 'Pastabos',
    organization: 'Organizacija',
    individuals: 'Asmenys',
    noBoxes: 'Dėžučių nerasta',
    scopeAll: 'Visos dėžutės',
    scopeResponsible: 'Aš atsakingas',
    noOrg: 'Nėra organizacijos',
    editBox: 'Redaguoti dėžutę',
    linkVehicleTitle: 'Susieti transporto priemonę',
    searchVehicle: 'Ieškoti transporto priemonės...',
    individualsDescription: 'Asmenys, turintys prieigą prie šios dėžutės',
    searchUser: 'Ieškoti vartotojo...',
    addUser: 'Pridėti',
    noUsers: 'Asmenų nepridėta',
    vehicleLinked: 'Transporto priemonė susieta',
    vehicleLinkError: 'Klaida susiejant transporto priemonę',
    linkVehicle: 'Susieti transporto priemonę',
    unlinkVehicle: 'Atsieti transporto priemonę',
    linkedVehicle: 'Susieta transporto priemonė',
    fetchError: 'Nepavyko įkelti dėžučių',
    confirmDelete: 'Ar tikrai norite ištrinti dėžutę {{id}}?',
    userAddError: 'Klaida pridedant asmenį',
    removeUser: 'Pašalinti asmenį',
    confirmRemoveUser: 'Ar tikrai norite pašalinti {{name}}?',
    firmwareVersion: 'Firmware',
    importDeviaq: 'Import Deviaq (Excel)',
    importDeviaqSuccess: 'Import complete: {{inserted}} new, {{updated}} updated',
    importDeviaqError: 'Import failed',
    deviaqDetailsTitle: 'Deviaq row',
    deviaqNoDetails: 'No Deviaq payload stored for this box.',
    vehicleUnlinked: 'Transporto priemonė atjungta',
    selectedBoxes: 'pasirinktas (-i) langelis (-iai).',
    assignOrg: 'Priskirti organizaciją',
    assignOrgTitle: 'Priskirti organizaciją',
    assignOrgTopNode: 'Organizacija (viršutinis mazgas)',
    searchOrg: 'Ieškoti organizacijos...',
    noOrgMatches: 'Jokių hitų',
    battery: 'Baterija',
    batteryUnknown: 'Nežinoma',
    batteryCharging: 'Įkeliama',
    chargerDisconnected: 'Įkroviklis atjungtas',
    nfcTestMode: 'Bandomasis režimas (grąžinus nereikia rakto / kortelės)',
    nfcTestModeHint: 'Kai bandymo režimas išjungtas, raktas visada turi būti dėžutėje. Perbraukta: negalima valdyti rakto ar kortelės.',
    nfcCardCheck: 'Grąžinus čekio kortelę',
    nfcCardCheckHint: 'Pasirinktinai. Suaktyvinkite, jei klientas taip pat turėtų grąžinti registruotą kortelę. Kortelė turi būti užregistruota dėžutėje.',
    nfcDetectMode: 'Aptikti korteles dėžutėje',
    nfcDetectModeHint: 'Grąžinant/atidarant: jei randama nežinoma NFC kortelė, įgalioti darbuotojai gali ją užregistruoti ant dėžutės.',
    permanentPower: 'Nuolatinio įkrovimo laidas',
    permanentPowerHint: 'Įspėkite, jei pranešama, kad įkroviklis atjungtas.',
    nfcTagsTitle: 'Registruotos NFC žymos (raktas / bako kortelė)',
    nfcTagsHint: 'Registracija vyksta mobiliojoje programėlėje (šalia dėžutės). Žymos gali būti rodomos ir pašalinamos čia.',
    noNfcTags: 'Nėra užregistruotų NFC žymų.',
    nfcRequired: 'Privaloma',
    nfcLabelKey: 'Raktas',
    nfcLabelCard: 'Degalų kortelės',
    nfcTagDeleted: 'NFC žyma pašalinta',
    nfcTagDeleteError: 'Nepavyko pašalinti NFC žymos',
  },
  guide: {
    admin: {
      title: 'Gidų administravimas',
      description: 'Valdykite prisijungimo gidus ir turus',
      newTour: 'Naujas turas',
      noTours: 'Turų nesukurta',
      inactive: 'Neaktyvus',
      steps: 'Žingsniai',
      preview: 'Peržiūra',
      deactivate: 'Deaktyvuoti',
      activate: 'Aktyvuoti',
      noSteps: 'Nėra žingsnių',
      noTitle: '(Nėra pavadinimo)',
      addStep: 'Pridėti žingsnį',
      stepTitle: 'Žingsnio pavadinimas',
      stepTitlePlaceholder: 'Pvz. Sveiki atvykę į flotės apžvalgą',
      stepOrder: 'Eilė',
      content: 'Turinys',
      contentPlaceholder: 'Apibūdinkite, ką vartotojas turėtų daryti šiame žingsnyje...',
      targetSelector: 'CSS selektorius (tikslas)',
      targetSelectorHint: 'Pvz. #fleet-map arba .vehicle-list. Palikite tuščią centruotam dialogui.',
      placement: 'Išdėstymas',
      tourKey: 'Turo raktas',
      tourName: 'Turo pavadinimas',
      tourNamePlaceholder: 'Pvz. Įvadas į flotės apžvalgą',
      tourDescription: 'Aprašymas',
      sortOrder: 'Rūšiavimo tvarka',
      confirmDeleteTour: 'Ar tikrai norite ištrinti šį turą?',
      confirmDeleteStep: 'Ar tikrai norite ištrinti šį žingsnį?',
    },
    showGuide: 'Rodyti vadovą',
  },
  fotaMigration: {
    title: 'FOTA konfigūravimas',
    description: 'Įkelkite .cfg failą ir išsiųskite jį įrenginiams per Teltonika FOTA Web. Įrenginiai gaus konfigūraciją kitą kartą prisijungę prie FOTA Web.',
    wakeupInfo: 'Pastaba: Be SMS "web_connect" įrenginys gaus konfigūraciją kitą suplanuotą FOTA prisijungimą (paprastai per 1–24 val.). Spustelėkite Atnaujinti būseną, kad pamatytumėte, kada baigta.',
    tabSend: 'Siųsti konfigūraciją',
    tabStatus: 'Būsena',
    uploadFile: 'Įkelti konfigūracijos failą (.cfg)',
    dropCfgHere: 'Vilkite ir numeskite .cfg failą čia arba spustelėkite, kad pasirinktumėte',
    onlyCfgAllowed: 'Leidžiami tik .cfg failai',
    uploading: 'Įkeliama...',
    uploadSuccess: 'Failas "{name}" įkeltas į FOTA Web',
    uploadError: 'Nepavyko įkelti failo',
    errorLoadingFiles: 'Nepavyko gauti konfigūracijos failų iš FOTA Web',
    selectConfigFile: 'Pasirinkite konfigūracijos failą siuntimui',
    configFilePlaceholder: 'Pasirinkite konfigūracijos failą...',
    deliveryType: 'Ką norite siųsti?',
    selectFirmwareFile: 'Pasirinkite programinės įrangos failą',
    firmwareFilePlaceholder: 'Pasirinkite programinės įrangos failą...',
    firmwareWarning: 'Programinės įrangos atnaujinimas keičia įrenginio programinę įrangą. Siųskite tik patikrintą, įrenginio modeliui tinkamą programinę įrangą.',
    noFilesFound: 'FOTA Web nerasta failų',
    selectFilFirst: 'Pirmiausia pasirinkite konfigūracijos failą',
    filterAll: 'Visi',
    kindConfig: 'Konfigūracija',
    kindFirmware: 'Programinė įranga',
    kindLog: 'Žurnalas',
    kindOther: 'Kita',
    selectOrganization: 'Pasirinkite organizaciją',
    organizationPlaceholder: 'Ieškoti ir pasirinkti organizaciją...',
    selectOrgFirst: 'Pirmiausia pasirinkite organizaciją',
    previewBtn: 'Peržiūrėti įrenginius',
    previewing: 'Gaunami įrenginiai...',
    vehiclesFound: 'transporto priemonių rasta su IMEI',
    vehiclesSelected: 'pasirinktos transporto priemonės',
    sendToAll: 'Visos',
    sendToSelected: 'Pasirinktos',
    selectAll: 'Pažymėti visus',
    noVehiclesSelected: 'Nepasirinkta transporto priemonių',
    noVehicles: 'Pasirinktoje organizacijoje nerasta transporto priemonių su IMEI',
    errorLoading: 'Nepavyko gauti įrenginių',
    sendBtn: 'Siųsti per FOTA',
    sending: 'Siunčiama...',
    errorSending: 'Nepavyko išsiųsti konfigūracijos',
    successMessage: '{succeeded} iš {total} užduočių įtraukta į FOTA Web eilę',
    confirmTitle: 'Patvirtinti FOTA siuntimą',
    confirmMessage: 'Jūs ketinate išsiųsti "{file}" {count} įrenginiams per FOTA Web.',
    confirmWakeupNote: 'Įrenginys gaus konfigūraciją kitą FOTA prisijungimą. Naudojant SMS "web_connect" tai įvyks iš karto.',
    resultTitle: 'Rezultatas',
    succeeded: 'Įtraukta į eilę',
    failed: 'Nepavyko',
    total: 'Iš viso',
    taskQueued: 'Eilėje',
    taskDownloading: 'Atsisiunčiama',
    taskApplied: 'Įdiegta',
    taskFailed: 'Klaida',
    taskStatusTitle: 'FOTA užduočių būsena pagal įrenginį',
    refreshStatus: 'Atnaujinti būseną',
    lastUpdated: 'Paskutinis atnaujinimas',
    selectOrgForStatus: 'Pasirinkite organizaciją skirtuke "Siųsti konfigūraciją", kad matytumėte būseną',
    clickRefreshToLoad: 'Spustelėkite "Atnaujinti būseną", kad gautumėte užduotis',
    noTasksFound: 'Pasirinktoje organizacijoje užduočių nerasta',
    errorLoadingStatus: 'Nepavyko gauti užduočių būsenos',
    registrationNumber: 'Reg. nr.',
    vehicleName: 'Transporto priemonės pavadinimas',
    imei: 'IMEI',
    status: 'Būsena',
    taskId: 'Užduoties ID',
    errorMsg: 'Klaidos pranešimas',
    configFile: 'Konfigūracijos failas',
    columnSuccess: 'Įtraukta į eilę',
    columnFailed: 'Klaida',
    tabFiles: 'Failai',
    fileListTitle: 'Įkelti konfigūracijos failai FOTA Web',
    deleteFile: 'Ištrinti failą',
    confirmDelete: 'Tikrai?',
    fileDeleted: 'Failas "{name}" ištrintas',
    fileDeleteError: 'Nepavyko ištrinti failo',
    downloadFile: 'Atsisiųsti failą',
    fileDownloadError: 'Nepavyko atsisiųsti failo',
    noImei: 'IMEI trūksta',
    apiKeyMissing: 'FOTA Web API raktas serveryje trūksta',
    offlineInfo: 'Neprisijungę įrenginiai (neprisijungę prie DQFleet) nepasiekiami be SMS',
    responseLabel: 'Įrenginio atsakymas',
  },
  damageReports: {
    title: 'Žalos ataskaitos',
    subtitle: 'Gautos žalos ataskaitos iš mobiliosios programėlės',
    filterStatus: 'Būsena',
    filterSeverity: 'Sunkumas',
    filterFromDate: 'Nuo datos',
    filterToDate: 'Iki datos',
    filterRegistration: 'Valstybinis numeris',
    filterRegistrationPlaceholder: 'pvz. EEM51Z',
    clearFilter: 'Išvalyti filtrus',
    noReports: 'Žalos ataskaitų nerasta',
    loading: 'Įkeliama...',
    vehicle: 'Transporto priemonė',
    reporter: 'Pranešėjas',
    severity: 'Sunkumas',
    status: 'Būsena',
    date: 'Data',
    images: 'Nuotraukos',
    description: 'Aprašymas',
    adminNotes: 'Pastabos (vidinės)',
    adminNotesPlaceholder: 'Pridėti vidines pastabas...',
    save: 'Išsaugoti pakeitimus',
    saving: 'Išsaugoma...',
    saved: 'Ataskaita atnaujinta',
    saveError: 'Nepavyko išsaugoti',
    loadDetailError: 'Nepavyko įkelti ataskaitos',
    location: 'Vieta',
    resolvedAt: 'Išspręsta',
    handling: 'Tvarkymas',
    statusPending: 'Laukiama',
    statusInProgress: 'Vykdoma',
    statusResolved: 'Išspręsta',
    statusClosed: 'Uždaryta',
    severityLow: 'Žemas',
    severityMedium: 'Vidutinis',
    severityHigh: 'Aukštas',
    severityCritical: 'Kritinis',
    statTotal: 'Iš viso',
    statPending: 'Laukiama',
    statInProgress: 'Vykdoma',
    statResolved: 'Išspręsta',
    statCritical: 'Kritiniai',
    allStatuses: 'Visos būsenos',
    allSeverities: 'Visi',
    totalCount: '{{total}} ataskaitų iš viso',
    prev: 'Ankstesnis',
    next: 'Kitas',
    fetchError: 'Nepavyko gauti žalos ataskaitų',
    damageImage: 'Žalos nuotrauka',
    reportTitle: 'Ataskaita #{{id}}',
    myList: 'Mano sąrašas',
    listBecomesAssignment: 'Asmuo mato bylą skiltyje Mano užduotys.',
    noMyList: 'Jūsų sąraše nėra bylų',
    listColumn: 'Sąrašas',
    onMyList: 'jūsų sąrašas',
    addToMyList: 'Įtraukti į mano sąrašą',
    addToList: 'Priskirti asmeniui',
    assignPerson: 'Priskirti',
    listSearchPlaceholder: 'Ieškoti asmens (vardas arba el. paštas)',
    listSearchHint: 'Įveskite bent du simbolius',
    listEmpty: 'Niekas neturi šios bylos savo sąraše',
    listAdded: 'Įtraukta į sąrašą',
    listRemoved: 'Pašalinta iš sąrašo',
    listRemove: 'Pašalinti',
    listAlready: 'Jau sąraše',
    listAddError: 'Nepavyko įtraukti į sąrašą',
    listRemoveError: 'Nepavyko pašalinti iš sąrašo',
    logTitle: 'Žurnalas',
    logEmpty: 'Įvykių dar nėra',
    logPlaceholder: 'Parašykite, ką padarėte…',
    logSubmit: 'Įrašyti į žurnalą',
    logSaved: 'Išsaugota žurnale',
    logError: 'Nepavyko išsaugoti žurnale',
    logUnknown: 'Nežinoma',
    logCreated: 'Sukūrė bylą',
    logStatus: 'Pakeitė būseną iš {{from}} į {{to}}',
    logSeverity: 'Pakeitė sunkumą iš {{from}} į {{to}}',
    logAdminNote: 'Atnaujino vidines pastabas',
    logNote: 'Pastaba',
    logListAdd: 'Priskyrė {{name}}. Matoma skiltyje Mano užduotys',
    logListRemove: 'Pašalino {{name}} iš sąrašo',
    logBlockRelease: 'Atšaukė transporto blokavimą',
    releaseBlock: 'Atlaisvinkite bloką',
    releaseBlockUntil: 'Transporto priemonė užblokuota iki {{end}}',
    releaseBlockConfirm: 'Atleisti bloką, kad transporto priemonę būtų galima vėl rezervuoti?',
    releaseBlockSuccess: 'Blokas buvo paleistas',
    releaseBlockError: 'Nepavyko atleisti bloko',
  },
  tireAnalysis: {
    title: 'Padangų analizė',
    update: 'Atnaujinti',
    analysisDate: 'Analizė atlikta {{date}} · Kitas sezonas: {{season}}',
    loading: 'Analizuojami padangų duomenys...',
    loadError: 'Nepavyko įkelti padangų analizės',
    vehiclesWithData: 'Transporto priemonės su padangų duomenimis',
    ofTotal: 'iš {{total}} iš viso',
    criticalNow: 'Kritiniai dabar',
    belowMin: 'Žemiau rekomenduojamo minimumo',
    needsReplacement: 'Reikia keisti',
    nextSeasonLabel: 'Kitas: {{label}}',
    tiresToBuy: 'Padangų pirkti',
    totalPurchaseNeed: 'Bendras pirkimo poreikis',
    critical: 'Kritinis',
    warning: 'Įspėjimas',
    noCritical: 'Nėra padangų žemiau rekomenduojamo minimumo',
    noForecast: 'Tikimasi, kad kitą sezoną nereikės keisti padangų',
    noProcurement: 'Pirkimo poreikio nenustatyta',
    stored: '📦 Sandėliuojama',
    installed: '🔩 Sumontuota',
    currentTread: 'Esamas protektoriaus gylis',
    predictedTread: 'Apskaičiuota sezono pabaigoje',
    season: 'Sezonas',
    wearRate: 'Susidėvėjimas',
    threshold: 'Riba',
    type: 'Tipas',
    size: 'Dydis',
    count: 'Kiekis',
    level: 'Lygis',
    urgent: 'Skubu',
    planned: 'Planuojama',
    affectedVehicles: 'Susijusios transporto priemonės:',
    orderList: '📋 Užsakymų sąrašas (spustelėkite norėdami išplėsti)',
    copyToOrder: 'Kopijuoti į pirkimo užsakymą:',
    totalTires: 'IŠ VISO: {{count}} padangų',
    procurementSummary: 'Iš viso {{count}} padangų pirkti ({{groups}} unikalūs dydžiai)',
    tabCritical: 'Kritiniai dabar',
    tabForecast: 'Kito sezono prognozė',
    tabProcurement: 'Pirkimo planavimas',
    criticalTitle: 'Kritinės padangos – reikia skubiai imtis veiksmų',
    criticalDesc: 'Sumontuotos padangos žemiau rekomenduojamo minimumo savo tipui. Žieminės ≥ 4 mm, sniego ≥ 3 mm, vasarinės ≥ 3 mm. Teisinis minimumas visiems: 1,6 mm.',
    forecastTitle: 'Prognozė – kitas sezonas: {{season}}',
    forecastDesc: 'Padangos, kurių apskaičiuotas protektoriaus gylis sezono pabaigoje gali nesiekti rekomenduojamo minimumo. Apskaičiuota pagal istorinius transporto priemonės susidėvėjimo duomenis.',
    procurementTitle: 'Pirkimo planavimas – sugrupuota pagal dydį',
    procurementDesc: 'Visų padangų, kurias reikia nupirkti, suvestinė – tiek skubių (kritiniai dabar), tiek planuojamų (prognozė). Spustelėkite eilutę, kad pamatytumėte susijusias transporto priemones.',
    methodology: 'ℹ️ Kaip skaičiuojamos prognozės?',
    methodWear: 'Susidėvėjimo greitis: Apskaičiuotas iš istorinių padangų keitimų žurnale. Jei istorijos nėra, naudojama standartinė vertė: 1 mm per 18 000 km.',
    methodSeason: 'Sezono trukmė: Vidutinis km per sezoną iš keitimo žurnalo. Rezervas: 15 000 km per sezoną.',
    methodForecast: 'Prognozė: Esamas protektoriaus gylis minus (susidėvėjimo greitis × apskaičiuota sezono trukmė).',
    methodThresholds: 'Ribinės vertės: Žieminės padangos 4 mm (rekomenduojama), dygliautos 4 mm, sniego 3 mm, vasarinės 3 mm. Teisinis minimumas: 1,6 mm.',
    treadMin: 'Protektoriaus gylis (min)',
    thresholdLabel: 'Riba: {{mm}} mm',
    seasonKm: '🛣️ Sezonas: ~{{km}} km',
    wearRateLabel: '📉 Susidėvėjimas: {{rate}}',
    thresholdMm: '🎯 Riba: {{mm}} mm',
    wearRatePer10k: '{{rate}} mm/10 000 km',
  },
  moten: {
    title: 'Susitikimas',
    intro: 'Vidinis nuorašas ir santrauka. Palaikymo skambučiai eina pirmi.',
    titlePlaceholder: 'Susitikimo pavadinimas',
    upload: 'Įkelti garsą arba Teams failą',
    uploading: 'Įkeliama…',
    fileRequired: 'Pirmiausia pasirinkite failą.',
    uploadError: 'Nepavyko įkelti failo.',
    loadError: 'Nepavyko gauti susitikimų.',
    empty: 'Susitikimų dar nėra.',
    delete: 'Ištrinti',
    deleteConfirm: 'Ištrinti susitikimą ir failą?',
    deleteError: 'Nepavyko ištrinti susitikimo.',
    summary: 'Santrauka',
    decisions: 'Sprendimai',
    ideas: 'Naujos idėjos',
    followUps: 'Tolesni veiksmai',
    transcript: 'Nuorašas',
    waiting: 'Laukiama nuorašo.',
    statusQueued: 'Eilėje',
    statusUploading: 'Įkeliama',
    statusProcessing: 'Apdorojama',
    statusReady: 'Paruošta',
    statusFailed: 'Nepavyko',
    colTitle: 'Pavadinimas',
    colDate: 'Data',
    colTime: 'Laikas',
    colRecordedBy: 'Įrašė',
    colStatus: 'Būsena',
    meetingTitle: 'Pavadinimas',
    backToList: 'Atgal į sąrašą',
    formatBold: 'Paryškinti',
    formatHeading: 'Antraštė',
    formatList: 'Sąrašas',
    reformat: 'Performatuoti',
    reformatError: 'Nepavyko performatuoti teksto.',
    save: 'Išsaugoti',
    saveError: 'Nepavyko išsaugoti pastabų.',
    download: 'Išsaugoti failą',
    send: 'Siųsti',
    sendHint: 'Siųsti vienam ar keliems asmenims',
    sendError: 'Nepavyko išsiųsti el. laiško.',
    recipientPlaceholder: 'vardas@imone.lt',
    addRecipient: 'Pridėti',
    recipientsRequired: 'Įveskite bent vieną el. pašto adresą.',
  },
  econKodverk: {
    title: 'Kodai',
    description: 'Region Skåne Raindance kodų sąrašai.',
    snapshot: 'Ištrauka {date}',
    searchPlaceholder: 'Ieškoti kodo arba teksto',
    company: 'Įmonė',
    department: 'Departamentas',
    code: 'Kodas',
    text: 'Tekstas',
    passive: 'Pasyvus',
    validTo: 'Galioja iki',
    empty: 'Nėra eilučių, atitinkančių paiešką.',
    loadError: 'Nepavyko gauti kodų',
    prev: 'Ankstesnis',
    next: 'Kitas',
    page: 'Puslapis {page} iš {pages} ({total} eil.)',
    kind: {
      ansvar: 'Atsakomybė',
      konto: 'Sąskaita',
      motpart: 'Sandorio šalis',
    },
  },
  eyeInventory: {
    title: 'EYE sandėlis',
    description: 'Importuokite Teltonika pakavimo sąrašą. EYE jutikliai patenka į šį sandėlį ir gali būti priskirti klientui. GPS sekikliai, pavyzdžiui ATC700, patenka į įrenginių registrą kaip sandėlis. Jau priskirtas įrenginys lieka tam klientui.',
    import: 'Importuoti sąrašą',
    assign: 'Priskirti klientą',
    assignTitle: 'Pasirinkite klientą',
    assignHint: '{count} įrenginiai pateks į kliento viršutinį mazgą ir bus matomi temperatūros stebėjime.',
    search: 'Ieškoti MAC, serijos, pavadinimo ar kliento',
    searchCustomer: 'Ieškoti kliento',
    all: 'Visi',
    stock: 'Sandėlyje',
    assignedFilter: 'Priskirti',
    inStock: 'Sandėlyje',
    name: 'Pavadinimas',
    serial: 'Serijos numeris',
    box: 'Dėžė',
    firmware: 'Programinė įranga',
    customer: 'Klientas',
    tracker: 'Sekiklis',
    unassign: 'Grąžinti',
    selectAll: 'Pažymėti visus puslapyje',
    empty: 'Nėra įrenginių. Importuokite pakavimo sąrašą.',
    loadError: 'Nepavyko gauti EYE sandėlio',
    importError: 'Nepavyko importuoti failo',
    importDone: '{created} nauji EYE, {updated} atnaujinti',
    importTrackers: '{created} nauji asmeniniai sekikliai ({model}), {updated} atnaujinti',
    assigned: 'Priskirta įrenginių: {count}',
    unassigned: 'Grąžinta į sandėlį: {count}',
    assignError: 'Nepavyko pakeisti priskyrimo',
    prev: 'Ankstesnis',
    next: 'Kitas',
    page: 'Puslapis {page} iš {pages} ({total} eil.)',
    rowIssue: 'Eilutė {row}: {message}',
    errors: {
      INVALID_FILE: 'Failas nėra Teltonika pakavimo sąrašas',
      NO_ROWS: 'Faile nėra įrenginių',
      FILE_REQUIRED: 'Pasirinkite xlsx failą',
      INVALID_INPUT: 'Pasirinkite įrenginius ir klientą',
      ORG_NOT_FOUND: 'Klientas nerastas',
      INVALID_MAC: 'Neteisingas MAC adresas',
      MISSING_MAC: 'Trūksta MAC adreso',
      MISSING_IMEI: 'Trūksta IMEI',
      DEVICE_BLOCKED: 'Įrenginys išregistruotas ir nebuvo atnaujintas',
      SERIAL_CONFLICT: 'Serijos numeris jau priklauso kitam įrenginiui',
      ROW_FAILED: 'Eilutės išsaugoti nepavyko',
      NOT_FOUND: 'Įrenginio nėra sandėlyje',
      ALREADY_LINKED: 'Įrenginys prijungtas prie sekiklio ir negali būti perkeltas',
      AMBIGUOUS_MAC: 'MAC adresas yra keliuose jutikliuose',
      PRODUCT_UNKNOWN: 'Produkto tipo nėra kataloge',
    },
  },
  documentTitle: {
    testRunner: 'Testų vykdymas',
    emailVerification: 'El. pašto patvirtinimas',
    poolCar: 'Bendras automobilis',
  },
  copy: {
    reports: {
      aGrade: 'A įvertinimas',
      achievements: 'Pasiekimai',
      active: 'Aktyvu',
      allVehicles: 'Visos transporto priemonės',
      anticipation: 'Numatymas',
      avgCoasting: 'Vidutinis riedėjimas',
      avgScore: 'Vidutinis balas',
      avgSpeed: 'Vidutinis greitis',
      batteryCapacity: 'Baterijos talpa:',
      binDescription: 'aprašymas',
      binValue: 'reikšmė',
      brand: 'Markė',
      cancel: 'Atšaukti',
      chargeAtEnd: 'Įkrova pabaigoje:',
      chooseDate: 'Pasirinkite datą',
      chooseFilters: 'Pasirinkite filtrus',
      chooseFiltersAndFetch: 'Pasirinkite filtrus ir spustelėkite „Gauti ataskaitą“',
      chooseOrgVehiclePeriod: 'Pasirinkite organizaciją, transporto priemonę ir laikotarpį',
      chooseOrganization: 'Pasirinkite organizaciją',
      chooseVehicle: 'Pasirinkite transporto priemonę',
      clickFetchSpeed: 'Spustelėkite „Gauti duomenis“, kad pamatytumėte greičio viršijimus.',
      close: 'Uždaryti',
      co2Emissions: 'CO₂ išmetimas',
      coasting: 'Riedėjimas',
      coasting20: '20 % riedėjimo',
      coastingChartHint: 'Žalia = riedėjimas. Geltona linija: teigiama = naudoja energiją, neigiama = regeneruoja',
      coastingDistance: 'Riedėjimo atstumas',
      coastingPercent: 'Riedėjimas %',
      coastingSegments: 'Riedėjimo segmentai ({{count}})',
      coastingShare: 'Riedėjimo dalis',
      coastingTime: 'Riedėjimo laikas',
      comparedToWltp: 'Palyginti su WLTP:',
      consumptionPer100: 'Sąnaudos (l/100 km)',
      date: 'Data',
      dateRequired: 'Data *',
      details: 'Išsamiau',
      distance: 'Atstumas',
      distanceDrivenKm: 'Nuvažiuotas atstumas (km)',
      distanceKm: 'Atstumas (km)',
      distributionByType: 'Pasiskirstymas pagal tipą',
      downloadPdf: 'Atsisiųsti PDF',
      downloadPdfFailed: 'Nepavyko atsisiųsti PDF',
      driver: 'Vairuotojas',
      drivingLogFilePrefix: 'VairavimoZurnalas',
      drivingSplit: 'Važiavimo pasiskirstymas',
      dtcCount: 'Gedimų kodų skaičius:',
      durationTotal: '{{duration}} iš viso',
      electricVehicle: '⚡ Elektromobilis',
      emailPlaceholder: 'gavejas@pavyzdys.lt',
      emailRequired: 'El. pašto adresas *',
      emailSentTo: 'El. laiškas išsiųstas adresu {{email}}',
      endDateRequired: 'Pabaigos data *',
      endTime: 'Pabaigos laikas',
      enter: 'Įvažiavo',
      environment: 'Aplinka',
      evBattery: 'EV baterija',
      eventCount: '{{count}} įvykiai',
      eventTrend: 'Įvykių tendencija',
      events: 'Įvykiai',
      eventsPerDay: 'Įvykiai per dieną',
      excessiveIdling: 'Ilga tuščioji eiga',
      exit: 'Išvažiavo',
      exportCsv: 'Eksportuoti CSV',
      fetchData: 'Gauti duomenis',
      fetchReport: 'Gauti ataskaitą',
      fetchReportFailed: 'Nepavyko gauti ataskaitos',
      fetching: 'Gaunama...',
      firstB: 'Pirmas B',
      fiveDays: '5 dienos',
      fromAddress: 'Iš (adresas)',
      fuelDiesel: 'Dyzelinas',
      fuelElectric: 'Elektra',
      fuelHybrid: 'Hibridas',
      fuelLiters: 'Degalai (l)',
      fuelPetrol: 'Benzinas',
      fuelUnknown: 'Nežinoma',
      genericError: 'Įvyko klaida',
      geofenceCosts: 'Geozonų išlaidos',
      geofences: 'Geozonos',
      gradeBasedOnCoasting: 'Įvertinimas pagal riedėjimo rezultatą',
      gradePassed: '👌 Patenkinama',
      gradeWithValue: 'Įvertinimas {{grade}}',
      greatDriving: '👍 Puikus vairavimas!',
      harshAccShort: 'Staigus greit.',
      harshAcceleration: 'Staigus greitėjimas',
      harshBrakeShort: 'Staigus stabd.',
      harshBraking: 'Staigus stabdymas',
      harshCornering: 'Staigus posūkis',
      highestDuringViolation: 'Didžiausias viršijimo metu',
      history: 'Istorija',
      hoursAndMinutes: '{{hours}} val. {{minutes}} min.',
      idleMinutes: '{{count}} min tuščiosios eigos',
      improvementTips: 'Patarimai, kaip pagerinti',
      improver: 'Gerintojas',
      keepPracticing: '💪 Toliau treniruokitės',
      kmWithMil: 'Km su įjungtu MIL:',
      latestTrip: 'Paskutinė kelionė',
      loading: 'Kraunama...',
      loadingCoasting: 'Kraunama riedėjimo statistika...',
      maxKmh: 'Maks. km/h',
      maxOverLimit: 'Maks. virš ribos',
      maxSpeed: 'Maks. greitis',
      maxSpeedShort: 'Maks. greitis',
      measurementPoints: 'Matavimo taškai',
      messageOptional: 'Žinutė (neprivaloma)',
      milActiveTrips: '⚠ MIL įspėjimas buvo aktyvus {{count}} kelionėje (-ėse)',
      milAlarms: 'MIL įspėjimai (gedimų kodai)',
      minutesOnly: '{{minutes}} min.',
      missingLiters: '⚠ Trūksta apie {{liters}} litrų',
      missingOdometer: 'Nėra odometro',
      model: 'Modelis',
      monthApril: 'Balandis',
      monthAugust: 'Rugpjūtis',
      monthDecember: 'Gruodis',
      monthFebruary: 'Vasaris',
      monthJanuary: 'Sausis',
      monthJuly: 'Liepa',
      monthJune: 'Birželis',
      monthMarch: 'Kovas',
      monthMay: 'Gegužė',
      monthNovember: 'Lapkritis',
      monthOctober: 'Spalis',
      monthSeptember: 'Rugsėjis',
      mostViolations: 'Daugiausia pažeidimų (transporto priemonės)',
      noChartData: 'Grafikui duomenų nėra',
      noCoastingData: 'Pasirinktam laikotarpiui riedėjimo duomenų nėra',
      noComparisonData: 'Nėra palyginimo duomenų',
      noDataForRange: 'Pasirinktam datų intervalui duomenų nėra',
      noDataToExport: 'Nėra duomenų eksportui',
      noEventsInPeriod: 'Pasirinktu laikotarpiu įvykių nėra',
      noGeofencePassages: 'Geozonų kirtimų neužregistruota',
      noMilAlarms: '✓ Per laikotarpį MIL įspėjimų nebuvo',
      noTankData: 'Nėra duomenų apie bako lygį',
      noTripsInPeriod: 'Per laikotarpį kelionių neužregistruota',
      noVehicleData: 'Nėra transporto priemonės duomenų',
      noVehiclesFound: 'Transporto priemonių nerasta',
      noWarningsGoodDriving: 'Įspėjimų nėra! Per laikotarpį vairuota gerai.',
      odometer: 'Odometras',
      odometerEnd: 'Pabaiga: {{value}}',
      odometerEndKm: 'Odometras pabaigoje (km)',
      odometerFilePrefix: 'OdometroAtaskaita',
      odometerKm: 'Odometras (km)',
      odometerReportHint: 'Ataskaita rodo transporto priemonių odometro rodmenis pasirinktą dieną.',
      odometerReportTitle: 'Odometro ataskaita – {{date}}',
      odometerStart: 'Pradžia: {{value}}',
      odometerStartKm: 'Odometras pradžioje (km)',
      ofVehicles: 'iš {{count}} transporto priemonių',
      orgOrVehicle: 'Organizacija/transporto priemonė',
      organization: 'Organizacija',
      organizationRequired: 'Organizacija *',
      overspeed: 'Greičio viršijimas',
      overspeedByOrg: 'Greičio ribos viršijimas pagal organizaciją',
      overspeedTooltip: '{{count}} pažeidimai ({{rate}}%)',
      overview: 'Apžvalga',
      passageCount: '{{count}} kirtimai',
      perKmColon: 'Kilometrui:',
      perOrganization: 'Pagal organizaciją',
      perSpeedLimit: 'Pagal greičio ribą',
      perVehicle: 'Pagal transporto priemonę',
      personalMessagePlaceholder: 'Asmeninė žinutė...',
      pieceCount: '{{count}}',
      points: 'Taškai',
      recipientNameOptional: 'Gavėjo vardas (neprivaloma)',
      registrationNumber: 'Registracijos numeris',
      rentalPdfFileName: 'nuomos-ataskaita.pdf',
      reportExported: 'Ataskaita eksportuota',
      reportSent: 'Ataskaita išsiųsta!',
      roomToImprove: '📈 Yra kur tobulėti',
      route: 'Maršrutas',
      scoreImpact: 'Balų poveikis',
      scoreWeek: 'Balai (savaitė)',
      searchRegistration: 'Ieškoti registracijos numerio...',
      segmentCount: 'Segmentų skaičius',
      segmentLength: 'Segmento ilgis',
      send: 'Siųsti',
      sendByEmail: 'Siųsti el. paštu',
      sendEmailFailed: 'Nepavyko išsiųsti el. laiško',
      sendReportByEmail: 'Siųsti ataskaitą el. paštu',
      severity: 'Rimtumas',
      severityCritical: 'Kritinis',
      severityHigh: 'Aukštas',
      severityLow: 'Žemas',
      severityMedium: 'Vidutinis',
      severityOutOf: 'Rimtumas: {{severity}}/10',
      sharePercent: 'Dalis (%)',
      showMoreWithSearch: 'Rodyti dar {{count}} naudojant paiešką...',
      smoothness: 'Tolygumas',
      source: 'Šaltinis',
      sourceCalculated: 'Apskaičiuota',
      sourceInitial: 'Pradinė',
      sourceMissing: 'Nėra',
      speed: 'Greitis',
      speedAndEnergy: 'Greitis ir energijos srautas',
      speedFilePrefix: 'greicio-virsijimai',
      speedKmh: 'Greitis (km/h)',
      speedLimit: 'Greičio riba',
      speedViolations: 'Greičio viršijimai',
      startDateRequired: 'Pradžios data *',
      startTime: 'Pradžios laikas',
      status: 'Būsena',
      subScores: 'Daliniai balai',
      tankCapacity: 'Bako talpa:',
      tankFull: '✓ Bakas pilnas (≥98 %)',
      tankLevelEnd: 'Bako lygis pabaigoje:',
      tankLevelStart: 'Bako lygis pradžioje:',
      tankStatus: 'Bako būsena',
      time: 'Laikas',
      timestamp: 'Laikas',
      toAddress: 'Į (adresas)',
      tonnes: '{{value}} t',
      total: 'Iš viso',
      totalColon: 'Iš viso:',
      totalCost: 'Bendra kaina: {{amount}}',
      totalDistance: 'Bendras nuvažiuotas atstumas',
      totalMeasurementPoints: 'Iš viso matavimo taškų',
      totalVehicles: 'Iš viso transporto priemonių',
      totalVehiclesLine: 'Iš viso transporto priemonių: {{count}}',
      totalViolations: 'Iš viso pažeidimų',
      travelTimeMin: 'Kelionės trukmė (min.)',
      trend: 'Tendencija',
      tripCount: 'Kelionių skaičius',
      trips: 'Kelionės',
      type: 'Tipas',
      unknown: 'Nežinoma',
      vehicle: 'Transporto priemonė',
      vehicleFileToken: 'transporto-priemone',
      vehicleKpiFilePrefix: 'transporto_priemones_rodikliai',
      vehicleRequired: 'Transporto priemonė *',
      violationCount: 'Pažeidimų skaičius',
      violationPercent: 'Pažeidimas (%)',
      violationShare: 'Pažeidimų dalis',
      violations: 'Pažeidimai',
      violationsByLimit: 'Pažeidimai pagal greičio ribą',
      violationsCount: 'Pažeidimai (skaičius)',
      violationsLower: 'pažeidimai',
      violationsOverTime: 'Pažeidimai per laiką',
      violationsPercent: 'Pažeidimai %',
      warnings: 'Įspėjimai',
      weeklyDevelopment: 'Pokytis per pastarąją savaitę',
      withOdometer: 'Su odometru',
      withOdometerLine: 'Su odometru: {{count}}',
      withOem: 'Su OEM odometru',
      withOemLine: 'Su OEM odometru: {{count}}',
      wltpValue: 'WLTP reikšmė:',
    },
    sysadmin: {
      missingInMariadb: 'Trūksta MariaDB',
      missingInMongodb: 'Trūksta MongoDB',
      tooFewGpsPoints: 'Per mažai GPS taškų',
      invalidDistance: 'Netinkamas atstumas',
      invalidDuration: 'Netinkama trukmė',
      syncMismatch: 'Sinchronizacijos neatitikimas',
      loadPendingError: 'Nepavyko įkelti laukiančių tikrinimų',
      selectDate: 'Pasirinkite datą',
      validationDone: 'Tikrinimas baigtas {{date}}',
      validationAlreadyRunning: 'Šiai datai tikrinimas jau vyksta',
      validationRunFailedHint: 'Nepavyko paleisti tikrinimo. Žiūrėkite konsolę arba serverio žurnalą.',
      validationRunFailed: 'Nepavyko paleisti tikrinimo',
      validationGone: 'Tikrinimo įrašo nebėra (pavyzdžiui, jis pašalintas arba išspręstas). Uždarykite ir atnaujinkite sąrašą.',
      invalidReplayDate: 'Netinkama replay data',
      replayQueuedWaiting: 'Replay (per eilę) paleistas {{imei}} ({{date}}). Laukiama, kol replay bus baigtas…',
      replayDone: 'Replay baigtas {{imei}} ({{date}}).',
      replayFailedFor: 'Replay nepavyko {{imei}} ({{date}}).',
      replayStillRunning: 'Replay vis dar vyksta {{imei}}. Jei užtrunka, būseną patikrinkite rankiniu būdu.',
      replayStartedFor: 'Replay paleistas {{imei}} ({{date}}).',
      replayStartFailed: 'Nepavyko paleisti replay',
      noValidDates: 'Sąraše nėra tinkamų datų',
      replayStartedForDate: 'Replay paleistas {{date}} (per eilę).',
      replayStartFailedForDate: 'Nepavyko paleisti replay {{date}}',
      unknownError: 'Nežinoma klaida',
      replayDateError: 'Replay {{date}}: {{message}}',
      replayStartedForDates: 'Replay paleistas {{count}} datoms. Kai darbai bus baigti, galėsite išvalyti žurnalą.',
      noReplayStarted: 'Replay nepaleistas ({{count}} nepavyko).',
      markedResolved: 'Pažymėta kaip išspręsta',
      markResolvedFailed: 'Nepavyko pažymėti kaip išspręstos',
      deleteReasonMin: 'Įveskite priežastį, bent 5 simbolių',
      manualValidation: 'Rankinis tikrinimas',
      runValidation: 'Vykdyti tikrinimą',
      validationHint: 'Tikrina pasirinktos datos keliones ir lygina MongoDB su MariaDB',
      emptyPending: 'Nėra laukiančių tikrinimų',
      regNr: 'Valst. nr.',
      details: 'Išsami informacija',
      action: 'Veiksmas',
      manual: 'Rankinis',
      created: 'Sukurta',
      tripCount: '{{count}} kelionės',
      binFile: 'Bin failas:',
      segmentCount: '{{count}} segmentai',
      totalGpsInBin: 'Iš viso {{count}} GPS taškų bin faile',
      binSegmentsTitle: 'Kelionės segmentai bin faile:',
      segmentNumber: 'Segmentas {{n}}',
      noAvl250: 'Nėra AVL250',
      pointsAndKm: '{{points}} taškai • {{km}} km',
      noBinSegments: 'Bin faile kelionės segmentų nerasta',
      mongoTripsTitle: 'MongoDB kelionės:',
      tripNumber: 'Kelionė {{n}}',
      missingInMariadbMark: '✗ Trūksta MariaDB',
      mariaTripsTitle: 'MariaDB kelionės:',
      mariaOnly: 'Tik MariaDB (trūksta MongoDB)',
      segmentsFound: 'Bin faile rasta {{count}} segmentų.',
      mongoTripDiff: 'MongoDB turi {{count}} keliones – skirtumas gali būti dėl kelionės aptikimo taisyklių.',
      replayBinHint: 'Replay dar kartą apdoroja bin failą ir gali sukurti trūkstamas keliones MongoDB. Tikrinimas dabar lygina tą pačią UTC dieną abiejose duomenų bazėse.',
      avl250Window: 'AVL250 bin faile šiame laiko lange ({{from}} – {{to}})',
      avl250Legend: '{{count}} taškai. 1 = kelionė aktyvi, 0 = sustojimas, – = pakete nėra.',
      time: 'Laikas',
      speed: 'Greitis',
      avlTrip: '1 (kelionė)',
      avlStop: '0 (sustojimas)',
      statusLoadError: 'Nepavyko gauti būsenos',
      syncFailed: 'Sinchronizacija nepavyko',
      fromToDate: '{{from}} – {{to}}',
      tripsCreated: 'Sukurta kelionių: {{count}}',
      jobCompleted: '{{name}} baigta',
      jobFailed: '{{name}} nepavyko',
      runCompleted: 'Vykdymas baigtas',
      runFailed: 'Vykdymas nepavyko',
      dataStatusError: 'Nepavyko gauti duomenų būsenos',
      selectFromToDate: 'Pasirinkite pradžios ir pabaigos datą',
      selectOrganization: 'Pasirinkite organizaciją',
      stopReplayFailed: 'Nepavyko sustabdyti replay',
      fullResetConfirm: 'Visiškas atstatymas pašalina VISUS iš realaus laiko išvestus duomenis:\n• Kelionės, GPS dalys, eco įvykiai\n• vehicle_daily_stats, trip_state, dedup talpykla\n• Ištuština replay ir GPS eiles\n\nTransporto priemonės ir įrenginiai paliekami. Tęsti?',
      fullResetDone: 'Visiškas atstatymas atliktas. Visi iš realaus laiko išvesti duomenys išvalyti.',
      fullResetFailed: 'Visiškas atstatymas nepavyko',
      replayAllConfirm: 'Bus atlikta:\n1. Sustabdyti TCP gateway\n2. Išvalyti VISUS duomenis\n3. Iš naujo perskaityti visus bin failus\n4. Vėl paleisti TCP\n\nAr tikrai?',
      allVehiclesInSelectedOrg: 'Visos pasirinktos organizacijos transporto priemonės',
      syncComplete: 'Sinchronizacija baigta',
      syncFailedGeneric: 'Sinchronizacija nepavyko',
      carInfoSyncTitle: 'Sinchronizuoti transporto priemones iš Car.info',
      carInfoSyncDescription: 'Iš Car.info API gauna markę, modelį, metus, degalų tipą, bako talpą, CO₂ ir kita',
      missingData: 'Trūkstami duomenys',
      vehiclesInSystemBefore: 'Iš viso',
      vehiclesInSystemAfter: 'transporto priemonių sistemoje',
      missingVin: 'Trūksta VIN',
      missingBrand: 'Trūksta markės',
      missingModel: 'Trūksta modelio',
      missingYear: 'Trūksta modelio metų',
      missingFuelType: 'Trūksta degalų tipo',
      missingTank: 'Trūksta bako talpos',
      missingConsumption: 'Trūksta degalų sąnaudų',
      missingCo2: 'Trūksta CO₂/km',
      syncFromCache: 'Sinchronizuoti iš talpyklos',
      syncFromCacheHint: 'Atnaujina transporto priemones, kurioms trūksta duomenų, naudodama jau talpykloje esančius Car.info duomenis. Greita — be API užklausų.',
      syncing: 'Sinchronizuojama...',
      startCacheSync: 'Pradėti sinchronizaciją iš talpyklos',
      syncViaApi: 'Sinchronizuoti per Car.info API',
      syncViaApiHint: 'Tiesiogiai iš Car.info API gauna naujus duomenis transporto priemonėms, kurioms trūksta informacijos. Lėčiau, bet duomenys aktualūs.',
      fetchFromCarInfo: 'Gauti iš Car.info API',
      forceResync: 'Priverstinai sinchronizuoti iš naujo',
      forceResyncBefore: 'Gauna naujus duomenis ',
      forceResyncAll: 'visoms',
      forceResyncAfter: ' transporto priemonėms, nepriklausomai nuo esamų duomenų. Išvalo senas neteisingas reikšmes (pavyzdžiui, neteisingą degalų tipą).',
      forceResyncAllVehicles: 'Priverstinai sinchronizuoti iš naujo (visos transporto priemonės)',
      result: 'Rezultatas',
      total: 'Iš viso',
      updated: 'Atnaujinta',
      skipped: 'Praleista',
      updatedFields: 'Atnaujinti laukai:',
      vehiclesSyncFailed: '{{count}} transporto priemonių sinchronizuoti nepavyko. Išsamią informaciją rasite klaidų žurnale.',
      clearSlowLogConfirm: 'Ar tikrai norite išvalyti lėtų užklausų žurnalą?',
      slowLogCleared: 'Lėtų užklausų žurnalas išvalytas',
      settingsUpdated: 'Nustatymai atnaujinti',
      settingsUpdateFailed: 'Nepavyko atnaujinti nustatymų',
      slowQueryPermissionError: 'Teisių klaida: duomenų bazės naudotojas neturi teisės. Vykdykite: {{command}}',
      minutesShort: 'min.',
      lastHour: 'Paskutinė valanda',
      last6Hours: 'Paskutinės 6 valandos',
      last24Hours: 'Paskutinės 24 valandos',
      last48Hours: 'Paskutinės 48 valandos',
      lastWeek: 'Paskutinė savaitė',
      settingsGear: '⚙️ Nustatymai',
      clearLog: 'Valyti žurnalą',
      threshold: 'Slenkstis:',
      countLabel: 'Skaičius:',
      average: 'Vidurkis:',
      max: 'Maks.:',
      slowQuerySettings: 'Lėtų užklausų nustatymai',
      on: 'ĮJUNGTA',
      off: 'IŠJUNGTA',
      thresholdSeconds: 'Slenkstis (sekundės)',
      recommendedOneSecond: 'Rekomenduojama: bent 1 sekundė',
      logOutputTable: 'TABLE (sąsajai)',
      logOutputFile: 'FILE (į failą)',
      logOutputBoth: 'TABLE,FILE (abu)',
      tableRequiredHint: 'Norint čia matyti užklausas, reikia TABLE',
      saveSettings: 'Išsaugoti nustatymus',
      thresholdWarning: '⚠️ Įspėjimas: slenkstis mažesnis nei 1 sekundė gali sugeneruoti daug duomenų. Rekomenduojama: bent 1 sekundė.',
      noSlowQueries: 'Šiuo laikotarpiu lėtų užklausų nėra',
      slowQueryLoggedHint: 'Čia registruojamos užklausos, trunkančios ilgiau nei {{seconds}} s',
      queryTime: 'Užklausos laikas:',
      lockTime: 'Užrakto laikas:',
      rowsSent: 'Išsiųsta eilučių:',
      rowsExamined: 'Patikrinta eilučių:',
      user: 'Naudotojas:',
      copySql: 'Kopijuoti SQL',
      importSyncResult: 'Sinchronizacija baigta: {{imported}} nauji, {{skipped}} praleisti{{totalPart}}',
      loadingSystemData: 'Įkeliami sistemos duomenys...',
      lastUpdated: 'Paskutinį kartą atnaujinta: {{time}}',
      viewingHost: 'Žiūrite:',
      backendResponding: '→ Atsakantis backend:',
      overviewIntro: 'Bendra visų keturių DQFleet serverių peržiūra. Nuotoliniai duomenys atnaujinami kas 60 sekundžių — paskutinį kartą: {{time}}',
      diskPath: 'Diskas ({{path}})',
      cores: '{{count}} branduoliai',
      unreachableError: 'Nepasiekiama: {{error}}',
      noData: 'Nėra duomenų',
      fetchingData: 'Gaunami duomenys...',
      noDataRunAgent: 'Nėra duomenų – serveryje paleiskite stebėjimo agentą.',
      serverUnreachable: '{{name}} nepasiekiamas',
      checkAgentRuns: 'Patikrinkite, ar stebėjimo agentas veikia:',
      onTheServer: 'serveryje.',
      portLabel: 'Prievadas:',
      startCommand: 'Paleidimo komanda:',
      latestData: 'Naujausi duomenys',
      freeMemory: 'Laisva: {{value}}',
      allDisks: 'Visi diskai',
      geoServices: 'Geo paslaugos',
      dockerContainers: 'Docker konteineriai',
      name: 'Pavadinimas',
      running: 'Veikia',
      notRunning: 'Neveikia',
      loadedModels: 'Įkelti modeliai ({{count}})',
      allSystemsOk: 'Visos sistemos veikia normaliai',
      statusWarning: 'Įspėjimas: kai kurioms sistemoms reikia dėmesio',
      statusCritical: 'Kritinė būsena: reikia nedelsiant imtis veiksmų',
      functionalChecks: 'Funkciniai patikrinimai (prod)',
      dataVolumeRw: 'Duomenų tomas RW',
      checkFailed: '✗ Klaida',
      criticalPm2: 'Kritiniai PM2 procesai',
      pm2Online: '✓ {{count}} prisijungę',
      pm2Offline: '✗ neprisijungęs',
      criticalDocker: 'Kritiniai Docker konteineriai',
      memoryPercent: 'Atmintis {{percent}}%',
      diskPercent: 'Diskas {{percent}}%',
      diskMax: 'Disko maks. {{percent}}%',
      platform: 'Platforma',
      cpuCores: 'CPU ({{count}} branduoliai)',
      pm2Processes: 'Procesai (PM2)',
      stoppedOrError: 'Sustabdyta/klaida',
      notConnectedError: 'Neprisijungta: {{error}}',
      totalMessages: 'Iš viso pranešimų',
      messages: 'Pranešimai',
      totalShort: '({{count}} iš viso)',
      devicesOnline: 'Įrenginiai prisijungę',
      packetsPerMinute: 'Paketai/min.',
      latestPacket: 'Naujausias paketas',
      databases: 'Duomenų bazės',
      connected: 'Prisijungta',
      notConnected: 'Neprisijungta',
      dataSize: 'Duomenų dydis',
      indexSize: 'Indekso dydis',
      peakMemory: 'Didžiausia atmintis',
      fragmentation: 'Fragmentacija',
      keysTotal: 'Iš viso raktų',
      keysByPrefix: 'Raktai pagal priešdėlį:',
      dockerAllZero: 'Visi skaičiai yra 0.',
      dockerDataFrom: 'Duomenys gaunami iš {{host}}.',
      thisServer: 'šio serverio',
      dockerZeroBeforeGroup: 'Jei Docker tikrai veikia šiame serveryje, bet matote 0: pridėkite backend paleidžiantį naudotoją (pavyzdžiui, ubuntu) į grupę',
      dockerZeroRestart: 'ir paleiskite serverį iš naujo:',
      dockerZeroThen: 'tada',
      runningEllipsis: 'Vykdoma...',
      lastPrefix: 'Paskutinį kartą',
      scheduleTimezoneHint: 'Tvarkaraštis nurodytas serverio laiku (UTC). Kitas ir paskutinis vykdymas rodomi jūsų vietos laiku.',
      manualRunHint: 'Kai vykdymas baigiamas, rodomas pranešimas. Rankinis „Vykdyti“ paleidžia vieną darbą vienu metu (be eilės).',
      showLatest: 'Rodyti naujausius',
      dayCount: '{{count}} dienų',
    },
    admin: {
      comingSoonBookingDescription: 'Užsakykite ir planuokite transporto priemones įvairioms užduotims ir naudotojams.',
      comingSoonWorkshopTitle: 'Dirbtuvės',
      comingSoonWorkshopDescription: 'Tvarkykite techninės priežiūros intervalus, remontą ir priežiūrą.',
      comingSoonWorkorderTitle: 'Darbo užsakymai',
      comingSoonWorkorderDescription: 'Kurkite ir tvarkykite darbo užsakymus transporto priemonėms ir personalui.',
      comingSoonAnalysisTitle: 'Analizė',
      comingSoonAnalysisDescription: 'Analizuokite savo transporto parko tendencijas ir statistiką.',
      comingSoonDefaultDescription: 'Ši sistema yra kuriama.',
      comingSoonModuleInDevelopment: 'Šis modulis aktyviai kuriamas ir netrukus bus prieinamas.',
      emailRequired: 'El. paštas būtinas',
      invalidEmail: 'Neteisingas el. pašto adresas',
      firstNameMin: 'Vardas turi būti bent 2 simbolių',
      lastNameMin: 'Pavardė turi būti bent 2 simbolių',
      passwordMin: 'Slaptažodį turi sudaryti bent 8 simboliai',
      passwordUpper: 'Slaptažodyje turi būti bent viena didžioji raidė',
      passwordLower: 'Slaptažodyje turi būti bent viena mažoji raidė',
      passwordDigit: 'Slaptažodyje turi būti bent vienas skaitmuo',
      passwordSpecial: 'Slaptažodyje turi būti bent vienas specialusis simbolis',
      acceptTerms: 'Turite sutikti su sąlygomis',
      passwordsMismatch: 'Slaptažodžiai nesutampa',
      mustVerifyEmail: 'Prieš prisijungdami turite patvirtinti el. pašto adresą.',
      hidePassword: 'Slėpti slaptažodį',
      showPassword: 'Rodyti slaptažodį',
      resetEmailSentToast: 'Jei naudotojas su šiuo el. pašto adresu yra, bus išsiųstas slaptažodžio atkūrimo laiškas.',
      resetTokenMissing: 'Trūksta atkūrimo žetono',
      resetSuccess: 'Slaptažodis atkurtas. Dabar galite prisijungti nauju slaptažodžiu.',
      resetFailed: 'Nepavyko atkurti slaptažodžio',
      couldNotReadFile: 'Nepavyko perskaityti failo',
      fuelImportName: '{{supplier}} degalų importas',
      fuelImportFromCompany: 'Degalų operacijų importas iš {{company}}',
      fuelImportSt1PresetDescription: 'Degalų operacijų importas iš ST1 (fillings_customerview.xlsx ir panašūs failai)',
      fuelImportOkq8Description: 'OKQ8: vienas importas kiekvienam failo tipui (K02 / K05 / švedų), failo vardo filtras *K02*, *K05* arba ^\\d. card_number = Kliento numeris/Account Number + Kortelės serija/Card Serial (4 simboliai, užpildyta nuliais).',
      importProgressCounts: '{{imported}} imp. · {{updated}} atn. · {{skipped}} kita · {{failed}} kl.',
      importRunRowCounts: '{{total}} iš viso · {{imported}} importuota · {{updated}} atnaujinta · {{skipped}} kita · {{failed}} klaidų',
      skipRowsBeforeHeader: 'Praleisti eilutes (prieš antraštę)',
      skipRowsHint: 'Praleistos eilutės praleidžia, pavyzdžiui, sąskaitos antraštę prieš antraštės eilutę (Qstar: 6).',
      invalidCellAddress: 'Neteisingas langelio adresas: {{cell}}',
      headerSplitMismatch: 'Antraštė {{cell}} ("{{raw}}") neatitiko skaidymo šablono',
      headerCellReadError: 'Nepavyko perskaityti antraštės langelio {{cell}}',
      packageCount: '{{count}} paketai',
      packagesNoneYet: 'Paketų dar nėra',
      packagesCreateFirst: 'Sukurti pirmą paketą',
      packagesNoSystems: 'Sistemų su paketais nerasta',
      pricePerMonthSek: 'Kaina per mėnesį (SEK)',
      pricePerYearSek: 'Kaina per metus (SEK)',
      yearlyPriceAutoHint: 'Palikite 0 automatiniam skaičiavimui (10× mėnesio kaina)',
      orgChartSelectOrganization: 'Pasirinkite organizaciją...',
      orgChartAutoLayoutTitle: 'Išdėstyti mazgus automatiškai',
      orgChartAutoLayout: 'Automatinis išdėstymas',
      orgChartImportCsv: 'Importuoti CSV',
      orgChartAddUnder: 'Pridėti po "{{name}}"',
      orgChartInstructions: 'Instrukcijos:',
      orgChartMoveNode: 'Perkelti mazgą:',
      orgChartDragNode: 'Tempkite mazgą',
      orgChartNewLink: 'Nauja jungtis:',
      orgChartNewLinkHint: 'Tempkite nuo ● apačioje iki ● kito mazgo viršuje',
      orgChartSelectNode: 'Pasirinkti mazgą:',
      orgChartClickNode: 'Spustelėkite jį',
      orgChartAddUnderSelected: 'Pridėti po pasirinktu:',
      orgChartAddUnderSelectedHint: 'Pasirinkite mazgą ir spustelėkite "Pridėti"',
      orgChartAutoLayoutHint: 'Tvarkingai išdėsto visus mazgus',
      orgChartPickToShow: 'Pasirinkite organizaciją, kad būtų rodoma schema',
      orgChartUseDropdown: 'Naudokite išskleidžiamąjį meniu viršuje',
      orgChartAddOrganization: 'Pridėti organizaciją',
      orgChartParent: 'Tėvinė',
      orgChartNamePlaceholder: 'Organizacijos pavadinimas',
      orgChartDescriptionPlaceholder: 'Nebūtinas aprašymas',
      geofenceDrawModeActive: 'Piešimo režimas įjungtas',
      geofenceFinishPolygon: 'Užbaigti daugiakampį',
      geofenceCrossingsOnly: 'Tik sienos kirtimai',
      geofenceSkipInitialEntry: '(neaktyvuoti aliarmo pirmo įvažiavimo metu)',
      geofenceTimeRules: 'Laiku pagrįstos rinkliavos taisyklės ({{count}} taisyklės)',
      weekdayShortSun: 'Sk',
      weekdayShortMon: 'Pr',
      weekdayShortTue: 'An',
      weekdayShortWed: 'Tr',
      weekdayShortThu: 'Kt',
      weekdayShortFri: 'Pn',
      weekdayShortSat: 'Št',
      monthShortJan: 'Sau',
      monthShortFeb: 'Vas',
      monthShortMar: 'Kov',
      monthShortApr: 'Bal',
      monthShortMay: 'Geg',
      monthShortJun: 'Bir',
      monthShortJul: 'Lie',
      monthShortAug: 'Rgp',
      monthShortSep: 'Rgs',
      monthShortOct: 'Spa',
      monthShortNov: 'Lap',
      monthShortDec: 'Grd',
      geofenceAllDays: 'Visos dienos',
      geofenceAllMonths: 'Visi mėnesiai',
      geofenceAllDay: 'Visą dieną',
      geofenceRule: 'Taisyklė {{index}}',
      geofenceTimeRulesReadonly: 'Laiko taisyklių čia redaguoti negalima. Jos kuriamos serverio scenarijumi.',
      weekdayMonday: 'Pirmadienis',
      weekdayTuesday: 'Antradienis',
      weekdayWednesday: 'Trečiadienis',
      weekdayThursday: 'Ketvirtadienis',
      weekdayFriday: 'Penktadienis',
      weekdaySaturday: 'Šeštadienis',
      weekdaySunday: 'Sekmadienis',
      monthJanuary: 'Sausis',
      monthFebruary: 'Vasaris',
      monthMarch: 'Kovas',
      monthApril: 'Balandis',
      monthMay: 'Gegužė',
      monthJune: 'Birželis',
      monthJuly: 'Liepa',
      monthAugust: 'Rugpjūtis',
      monthSeptember: 'Rugsėjis',
      monthOctober: 'Spalis',
      monthNovember: 'Lapkritis',
      monthDecember: 'Gruodis',
      minutesAgo: 'prieš {{count}} min',
      hoursAgo: 'prieš {{count}} val.',
      yesterday: 'Vakar',
      deviceCsvOrganization: 'Organizacija',
      deviceCsvRegistration: 'Valst. nr.',
      deviceCsvMake: 'Markė',
      deviceCsvModel: 'Modelis',
      deviceCsvLastVin: 'Naujausias VIN',
      deviceCsvSimStatus: 'SIM būsena',
      deviceCsvCreated: 'Sukurta',
      deviceCsvUpdated: 'Atnaujinta',
      jamVehicleLabel: 'Transporto priemonė {{id}}',
      jamTripLabel: 'Kelionė #{{id}}',
      jamPoints: 'trukdžių taškai',
      pageLabel: 'Puslapis',
      totalLower: 'iš viso',
      adminUsersDescription: 'Tvarkykite naudotojus, vairuotojus ir SSO naudotojus',
      aiRequestTitle: 'DI užklausa #{{id}}',
      avlCapabilitiesLoadError: 'Nepavyko gauti AVL galimybių',
      guideElementMissing: '(Šiame puslapyje nėra elemento: `{{selector}}`)',
      broadcastReadCount: '{{count}} perskaityta',
      translationsExported: 'Eksportuoti į failus! Nukopijuokite turinį į tinkamus failus.',
      ssoLoginInfoError: 'Nepavyko gauti prisijungimo informacijos',
      or: 'arba',
      auditCannotDeleteAcknowledged: 'Patvirtintų komandų ištrinti negalima',
      auditDeleteCommandConfirm: 'Ar tikrai norite ištrinti šią komandą?',
      emailVerifyTokenMissing: 'URL nerastas patvirtinimo žetonas.',
      emailVerifiedToast: 'El. pašto adresas patvirtintas.',
      emailVerifyFailed: 'Patvirtinimas nepavyko',
      emailVerifyError: 'Nepavyko patvirtinti el. pašto adreso',
      emailVerifyingTitle: 'Tvirtinamas el. pašto adresas...',
      emailVerifyingBody: 'Palaukite, kol patvirtinsime jūsų el. pašto adresą.',
      emailVerifiedTitle: 'El. pašto adresas patvirtintas!',
      emailVerifiedBody: 'Jūsų el. pašto adresas patvirtintas. Dabar galite prisijungti.',
      emailVerifyRedirect: 'Automatiškai nukreipiama po 3 sekundžių...',
      emailVerifyExpiredHint: 'Jei patvirtinimo nuoroda nebegalioja, naują galite užsisakyti prisijungimo puslapyje.',
      testRunnerPatternRequired: 'Įveskite testų šabloną, testų failą arba pasirinkite "Vykdyti visus testus"',
      testRunnerStartFailed: 'Nepavyko paleisti testų: {{message}}',
      testRunnerDeleteOneConfirm: 'Ar tikrai norite ištrinti šį testo rezultatą?',
      testRunnerDeleteAllConfirm: 'Ar tikrai norite ištrinti visus testų rezultatus?',
      testRunnerResultHeading: 'Testo rezultatas - {{name}}',
      testRunnerAllTests: 'Visi testai',
      testRunnerStatus: 'Būsena',
      testRunnerTimestamp: 'Laikas',
      testRunnerSummary: 'Suvestinė',
      testRunnerTotal: 'Iš viso',
      testRunnerTests: 'testai',
      testRunnerPassed: 'Pavyko',
      testRunnerFailed: 'Nepavyko',
      testRunnerDuration: 'Trukmė',
      testRunnerTestDetails: 'Testo informacija',
      testRunnerError: 'Klaida',
      testRunnerCopyFallback: 'Nepavyko nukopijuoti automatiškai. Štai tekstas:\n\n{{text}}...',
      testRunnerClipboardFailed: 'Nepavyko nukopijuoti į iškarpinę.',
      testRunnerNoFailedToCopy: 'Nėra nepavykusių testų, kuriuos būtų galima kopijuoti.',
      testRunnerFailedTests: 'Nepavykę testai ({{count}})',
      testRunnerSuiteError: 'Testų rinkinio klaida',
      testRunnerDeleteAll: 'Ištrinti visus',
      testRunnerRunTests: 'Vykdyti testus',
      testRunnerRunAll: 'Vykdyti visus testus',
      testRunnerStarting: 'Paleidžiama...',
      testRunnerResults: 'Testų rezultatai',
      testRunnerNoResults: 'Testų rezultatų dar nėra. Paleiskite testus, kad pamatytumėte rezultatus.',
      testRunnerPassedFraction: '{{passed}}/{{total}} pavyko',
      testRunnerFailedCount: '{{count}} nepavyko',
      testRunnerDetails: 'Informacija',
      testRunnerCopyErrorsTitle: 'Kopijuoti tik nepavykusius testus ir klaidų informaciją',
      testRunnerCopied: '✓ Nukopijuota!',
      testRunnerCopyErrors: 'Kopijuoti klaidas',
      testRunnerCopyAllTitle: 'Kopijuoti visą testo rezultatą',
      testRunnerCopyAll: 'Kopijuoti viską',
    },
    ui: {
      activeLoansBlockDelete: 'Aktyvios paskolos neleidžia ištrinti',
      addPackage: 'Pridėti paketą',
      aiConnectError: 'Nepavyko prisijungti prie DI paslaugos',
      aiPromptBestVehicles: 'Kurios transporto priemonės veikia geriausiai?',
      aiPromptFleetOverview: 'Pateik parko apžvalgą',
      aiPromptReduceFuel: 'Kaip galime sumažinti degalų sąnaudas?',
      aiPromptSaveFuel: 'Kaip galime taupyti degalus?',
      aiPromptWarnings: 'Ar yra įspėjamųjų ženklų?',
      aiRequestFailed: 'DI užklausa nepavyko',
      aiVehicleContext: 'Naudotojas žiūri transporto priemonę: {{reg}} ({{make}} {{model}})',
      apiAccess: 'API prieiga',
      apiCreateFirstKey: 'Sukurti pirmą raktą',
      apiEndpointsHelp1: 'Pasirinkite, kuriuos API galinius taškus šis klientas gali naudoti. Galiniai taškai',
      apiEndpointsHelp2: 'kurie įjungti, gali būti naudojami su kliento API raktais.',
      apiError: 'API klaida',
      apiExpired: 'Pasibaigęs',
      apiExpiryOptional: 'Galiojimo data (neprivaloma)',
      apiKeyOnce: 'Raktas rodomas tik vieną kartą ir jo negalima atkurti.',
      apiNoKeys: 'API raktų nesukurta',
      apiScopesRequired: 'Leidimai (sritys) *',
      appPassword: 'Programos slaptažodis (mobiliajai programai)',
      areaPlace: 'Zona / vieta',
      autoYearlyPriceHint: 'Palikite 0 automatiniam skaičiavimui (10× mėnesio kaina)',
      calculated: 'apskaičiuota',
      change: 'keisti',
      changed: 'pakeista',
      chargingPriority: 'Įkrovimo infrastruktūros prioritetas',
      circleSizeHint: '(apskritimo dydis = stovėjimo laikas, skaičius = transporto priemonių kiekis)',
      companyEconomic: 'Ekonominė bendrija',
      companyFoundation: 'Fondas',
      companyNonprofit: 'Ne pelno siekianti asociacija',
      companySoleProp: 'Individuali įmonė',
      days: 'dienos',
      daysTotalStop: 'Dienos, bendras stovėjimo laikas',
      demoMode: 'Demonstracinis režimas',
      demoModeReadOnly: 'Naudojate demonstracinį režimą. Galimos tik skaitymo operacijos.',
      demoModeUpgrade: 'Susisiekite su mumis, jei norite atnaujinti į pilną versiją.',
      deviceImportAction: 'Importuoti',
      deviceImportDeactivateSim: 'Išjungti SIM korteles Jasper sistemoje',
      deviceImportDisconnect: 'Atjungti nuo transporto priemonės',
      deviceImportError: 'Importas nepavyko',
      deviceImportFailed: 'Nepavyko',
      deviceImportManual: 'Reikia rankiniu būdu',
      deviceImportNeedsAttention: 'Reikia dėmesio:',
      deviceImportNoImei: 'Nėra galiojančių IMEI numerių',
      deviceImportSetStock: 'Nustatyti būseną Į SANDĖLĮ',
      deviceImportSettings: 'Nustatymai:',
      deviceImportSubtitle: 'Įklijuokite IMEI numerius iš Excel (po vieną eilutėje)',
      deviceImportSuccess: 'Pavyko',
      deviceImportTitle: 'Importuoti grąžintus įrenginius',
      deviceImportValidCount: 'rasta galiojančių IMEI numerių',
      distanceCrow: 'tiesus atstumas',
      distanceOem: 'OEM odometras',
      distanceOsrm: 'OSRM įvertis',
      enterClientSecret: 'Įveskite kliento slaptą raktą',
      featureNotInPackage: 'Ši funkcija neįeina į jūsų dabartinį paketą.',
      featureUnavailable: 'Funkcija nepasiekiama',
      featureUpgradeContact: 'Susisiekite su mumis, jei norite atnaujinti ir gauti daugiau funkcijų.',
      federationIntro: 'Sukonfigūruokite SAML 2.0 arba OpenID Connect, kad kliento naudotojai galėtų prisijungti savo tapatybės sistema (pvz., Microsoft Entra ID, Google Workspace, Okta).',
      federationMinLoa: 'Mažiausias pasitikėjimo lygis (LoA)',
      federationMinLoaHelp: 'Reikalaukite pasitikėjimo lygio prisijungiant per SITHS/Inera. Sveikatos priežiūrai rekomenduojamas LoA3.',
      fetchDataError: 'Nepavyko gauti duomenų',
      graphAddPermission: 'Pridėti:',
      graphAppName: 'Pavadinimas:',
      graphChooseLifetime: 'Pasirinkite galiojimo laiką (rekomenduojama: 24 mėnesiai)',
      graphCopyValue: 'Nukopijuokite Value (rodoma tik vieną kartą)',
      graphGrantConsent: 'Spustelėkite „Grant admin consent“ – kitaip neveiks',
      graphNoteIds: 'Užsirašykite Application (client) ID ir Directory (tenant) ID',
      graphOptionalDirectory: 'Neprivaloma: pašalintoms paskyroms',
      graphSecretHint: 'Certificates & secrets → Client secrets → Value (nukopijuojama kuriant)',
      graphStep1: '1 veiksmas – programos registracija Entra ID',
      graphStep2: '2 veiksmas – API leidimai (reikia visuotinio administratoriaus)',
      graphStep3: '3 veiksmas – kliento slaptas raktas',
      highPriority: 'Aukštas prioritetas',
      hoursPerStop: 'Val. / sustojimas',
      inspectionAllSweden: 'Visa Švedija',
      inspectionHeavy: 'Sunkiosios transporto priemonės / pramonė',
      inspectionMachines: 'Mašinos / specialios transporto priemonės',
      levelNumber: 'Lygis {{level}}',
      licenseCategoriesExample: 'Vairuotojo pažymėjimo kategorijos (pvz., B, C, CE)',
      linkedFromDriverForm: 'Susieta iš naudotojo formos / vairuotojo priskyrimo',
      linkedFromVehicleList: 'Susieta iš transporto priemonių sąrašo, {{email}}',
      linkedOnDriverCreate: 'Susieta registruojant iš vairuotojo formos',
      logoAltCrop: 'Logotipas apkarpymui',
      logoBgDark: 'Tamsi',
      logoBgWhite: 'Balta',
      logoChooseOther: 'Pasirinkti kitą paveikslėlį',
      logoClickToChoose: 'arba spustelėkite ir pasirinkite failą',
      logoCropImage: 'Apkarpyti paveikslėlį',
      logoDarkPreview: 'Tamsi',
      logoDropImage: 'Nutempkite paveikslėlį čia',
      logoExportBackground: 'Eksportuojamo paveikslėlio fonas',
      logoExportHint: 'Eksportuojama kaip ne didesnis nei {{max}} px PNG, išlaikant proporcijas',
      logoLightPreview: 'Šviesi',
      logoPreview: 'Peržiūra',
      manualAuditLog: 'Audito žurnalas',
      manualAuditLogDesc: 'Peržiūrėkite visus sistemos pakeitimus',
      manualBookingStatsDesc: 'Apimtis, užimtumas, užklausų srautas ir rezervacijų tendencija',
      manualCertMonitor: 'Sertifikatų stebėsena',
      manualCertMonitorDesc: 'Stebėkite besibaigiančius sertifikatus (OIDC/SSO) ir kaip jie atnaujinami',
      manualCo2: 'CO2 išmetimas',
      manualCo2Desc: 'Skaičiuokite ir raportuokite anglies dioksido išmetimą',
      manualCrmDesc: 'Klientų valdymas ir CRM funkcijos',
      manualCustomersDesc: 'Klientų sąrašas su kontaktais, statistika ir kortelėmis',
      manualDataMigration: 'Duomenų migracija',
      manualDataMigrationDesc: 'Perkelkite duomenis tarp duomenų bazių ir formatų',
      manualDataReplay: 'Duomenų pakartojimas',
      manualDataReplayDesc: 'Pakartokite GPS duomenis, kad iš naujo sugeneruotumėte keliones',
      manualDeviceAdminDesc: 'Išplėstinis įrenginių administravimas ir konfigūracija',
      manualDeviceCommands: 'Įrenginių komandos',
      manualDeviceCommandsDesc: 'Siųskite SMS komandas GPS įrenginiams',
      manualDeviceQueuesDesc: 'Peržiūrėkite ir valdykite laukiančias komandas, OBD P&P ir ne OBD įrenginiams',
      manualDevicesDesc: 'Valdykite GPS įrenginius ir jų susiejimą su transporto priemonėmis',
      manualDrivingLogDesc: 'Važiavimo žurnalas pagal Švedijos mokesčių tarnybos reikalavimus, su odometru ir CSV eksportu',
      manualEcoDriving: 'Ekonomiškas vairavimas',
      manualEcoDrivingDesc: 'Analizuokite vairavimo stilių: greitėjimą, stabdymą, tuščiąją eigą, riedėjimą',
      manualEcoSettingsDesc: 'Konfigūruokite ekonomiško vairavimo analizės slenksčius',
      manualEnergyDesc: 'Degalų ir elektros sąnaudos pagal transporto priemonę ir laikotarpį',
      manualErrorLogs: 'Klaidų žurnalai',
      manualErrorLogsDesc: 'Peržiūrėkite ir analizuokite sistemos klaidas',
      manualExecutiveDesc: 'Bendri viso parko KPI: išlaidos, panaudojimas, CO₂ ir 5 didžiausi nukrypimai',
      manualFuelDesc: 'Analizuokite degalų išlaidas, sąnaudas ir kr/10 km iš importuotų operacijų',
      manualGeneralAudit: 'Bendras audito žurnalas',
      manualGeneralAuditDesc: 'Peržiūrėkite visus sistemos įvykius ir naudotojų veiklą',
      manualGeofenceEventsDesc: 'Peržiūrėkite visų geozonų aliarmų žurnalą',
      manualGeofenceReportDesc: 'Geozonų įvykių ir laiko zonose ataskaita',
      manualGeofenceZones: 'Geozonos',
      manualGeofenceZonesDesc: 'Kurkite geografines zonas įvažiavimo ir išvažiavimo aliarmams',
      manualHeatmapDesc: 'Šilumos žemėlapyje matykite, kur transporto priemonės važiuoja daugiausiai',
      manualImportDesc: 'Importuokite transporto priemones ir duomenis iš Excel/CSV',
      manualLiveTrackingDesc: 'Rodykite visas transporto priemones realiu laiku žemėlapyje su organizacijų medžiu',
      manualNewCustomer: 'Naujas klientas (vedlys)',
      manualNewCustomerDesc: '5 žingsnių vedlys naujiems klientams kurti (potencialus arba aktyvus)',
      manualOrgHierarchyDesc: 'Valdykite organizacijų hierarchiją ir klientų struktūras',
      manualPackagesDesc: 'Valdykite paslaugų paketus ir kainų planus',
      manualPipelineDesc: 'Pardavimo atvejai, reikalavimų analizė, verslo vertė ir ryšys su produkto kūrimu',
      manualPricelistDesc: 'Kategorijos, produktai ir kainodara',
      manualRolesDesc: 'Kurkite ir valdykite roles su konkrečiais leidimais',
      manualSectionCrm: 'CRM – klientų valdymas',
      manualSectionTools: 'Įrankiai ir analizė',
      manualSecurityDesc: 'Fail2ban blokavimai, apsaugos žurnalai, IP atlaisvinimas ir saugių sąrašas',
      manualSimCards: 'SIM kortelės',
      manualSimCardsDesc: 'Valdykite SIM korteles ir mobiliojo ryšio abonementus (Tele2/Jasper)',
      manualSlowQueries: 'Lėtos užklausos',
      manualSlowQueriesDesc: 'Nustatykite ir optimizuokite lėtas duomenų bazės užklausas',
      manualSpeedViolations: 'Greičio viršijimai',
      manualSpeedViolationsDesc: 'Rodykite, kur ir kada buvo viršytas greitis',
      manualSupportDesc: 'Palaikymo atvejai ir bendravimas su klientais',
      manualSystemMonitor: 'Sistemos monitorius',
      manualSystemMonitorDesc: 'Stebėkite sistemos būklę, duomenų bazes ir procesus',
      manualTcoDesc: 'Bendra nuosavybės kaina vienai transporto priemonei: degalai, servisas, lizingas, draudimas ir mokestis (kr/km)',
      manualTranslationsDesc: 'Valdykite švedų ir anglų kalbų vertimus',
      manualTripCompareDesc: 'Palyginkite registruotas keliones su transporto priemonės bin failu ir raskite nukrypimus',
      manualTripsDesc: 'Išvardykite visas keliones su pradžia ir pabaiga, atstumu ir laiku',
      manualUnderutilizedDesc: 'Nustatykite mažai naudojamas transporto priemones (pridėtinė vertė 100 000 kr)',
      manualUsersDesc: 'Valdykite naudotojus, teises ir slaptažodžius',
      manualWearDesc: 'Analizuokite vairavimą, kuris veikia transporto priemonės dėvėjimąsi (pridėtinė vertė 120 000 kr)',
      max50Hits: 'Rodoma ne daugiau kaip 50 rezultatų. Patikslinkite paiešką, jei norite daugiau.',
      maxValue: '{{label}} gali būti ne daugiau kaip {{max}}',
      minInteger: '{{label}} turi būti sveikasis skaičius, ne mažesnis nei {{min}}',
      mobileAppAccess: 'Prieiga prie mobiliosios programos',
      mobileAppAccessHint: 'Suteikia vairuotojui teisę prisijungti prie DQFleet programos.',
      modulesAvailable: '{{count}} prieinama',
      monthsCount: '{{count}} mėn.',
      motenCustomerWishes: 'Klientų pageidavimai',
      moveOrgToParent: 'Perkelti „{{name}}“ į naują viršutinę organizaciją.',
      noCustomersMatch: 'Jokie klientai neatitinka filtro',
      noCustomersYet: 'Klientų dar nėra',
      noGroupStructure: 'Koncerno struktūra neišsaugota. Spustelėkite „Gauti ir išsaugoti“, kad įkeltumėte iš Checkbiz/SCB.',
      noVehiclesAvailable: 'Nėra prieinamų transporto priemonių',
      noVehiclesMatch: 'Nėra transporto priemonių, atitinkančių „{{term}}“',
      notNegative: '{{label}} negali būti neigiamas',
      oidcCertPlaceholder: '-----BEGIN CERTIFICATE-----\n...\n-----END CERTIFICATE-----\n  arba  /opt/dqfleet/secrets/oidc-1555-cert.pem',
      oidcKeyPlaceholder: '-----BEGIN PRIVATE KEY-----\n...\n  arba  /opt/dqfleet/secrets/oidc-1555-private.pem',
      ownershipShare: 'Nuosavybės dalis: {{share}}',
      perMonthShort: '/mėn.',
      placesByStopTime: 'Vietos surikiuotos pagal stovėjimo laiką',
      priority: 'Prioritetas',
      priorityCritical: 'Kritinis',
      priorityHigh: 'Aukštas',
      priorityLow: 'Žemas',
      priorityMedium: 'Vidutinis',
      reconstructedDistance: 'Atkurta kelionė (trūko GPS) – atstumas: {{source}}',
      registeredSince: '{{value}}, nuo {{date}}',
      replaceTenantId: 'Pakeiskite {tenant-id} kliento Azure AD nuomininko ID.',
      resizeColumn: 'Keisti {{label}} plotį',
      roleDecisionMaker: 'Sprendimų priėmėjas',
      roleFinance: 'Finansai',
      roleFleetManager: 'Parko vadovas',
      roleOther: 'Kita',
      searchHits: '{{count}} rezultatai',
      searchOrSelectVehicle: 'Ieškokite arba pasirinkite transporto priemonę...',
      searchRegNumber: 'Ieškoti registracijos numerio...',
      searching: 'Ieškoma...',
      searchingVehicles: 'Ieškoma transporto priemonių...',
      secretUnchanged: '(nekeičiama, jei tuščia)',
      selectVehicleDash: '-- Pasirinkite transporto priemonę --',
      simActivated: 'Aktyvuota',
      simActivationReady: 'Paruošta aktyvinti',
      simCardJasper: 'SIM kortelė (Jasper)',
      simCommPlan: 'Ryšio planas',
      simDataLimit: 'Duomenų riba pasiekta!',
      simDeactivated: 'Išjungta',
      simFetching: 'Gaunama SIM būsena...',
      simInventory: 'Sandėlis',
      simNoIccid: 'ICCID nesukonfigūruotas',
      simPurged: 'Ištrinta',
      simRatePlan: 'Tarifų planas',
      simRetired: 'Užbaigta',
      simSessions: 'Seansai',
      simStatusChangeError: 'Nepavyko pakeisti būsenos',
      simStatusFetchError: 'Nepavyko gauti SIM būsenos',
      simTestReady: 'Testo režimas',
      simUsagePeriod: 'Naudojimas šiuo laikotarpiu',
      sithsAuthTitle: 'SITHS autentifikavimas (Inera)',
      sithsClaims: 'Teiginiai: asmens kodas, HSA ID, vardas per SITHS sertifikatą',
      sithsEnv: 'QA: https://idp.ineraqa.org/oidc | Prod: https://idp.inera.se/oidc',
      sithsRegistration: 'Kliento registracija atliekama rankiniu būdu pagal Inera bandomąjį šabloną',
      sortByHoursPerStop: 'Rikiuoti: valandos / sustojimas',
      sortByStopCount: 'Rikiuoti: sustojimų skaičius',
      sortByStopTime: 'Rikiuoti: stovėjimo laikas',
      sortByVehicleCount: 'Rikiuoti: transporto priemonių skaičius',
      ssoAppPasswordHint: 'SSO naudotojai gali nustatyti slaptažodį prisijungimui prie mobiliosios programos',
      stop: 'Sustojimas',
      stopCount: 'Sustojimų skaičius',
      stopTime: 'Stovėjimo laikas',
      stopTimeDays: 'Stovėjimo laikas (dienos)',
      storageLocationExample: 'BVS Linköping',
      supportMessagePlaceholder: 'Išsamiai aprašykite problemą...',
      supportReplyPlaceholder: 'Rašykite atsakymą...',
      supportSubjectPlaceholder: 'Trumpai aprašykite problemą',
      supportWaitingOnYou: 'Laukia jūsų',
      syncMode: 'Sinchronizavimo režimas',
      ticketResolved: 'Šis atvejis išspręstas',
      tireHistoryAuto: 'Istorija sukuriama automatiškai kito padangų keitimo metu',
      topStopAreas: 'Zonos su ilgiausiu stovėjimo laiku (spustelėkite išsamiau)',
      treadPerWheel: 'Protektoriaus gylis kiekvienam ratui',
      trialDaysLeft: 'Bandomajam laikotarpiui liko {{count}} d.',
      trialEndingSoon: 'Jūsų bandomasis laikotarpis greitai baigsis. Susisiekite su mumis dėl atnaujinimo.',
      trialExpiredBody: 'Jūsų bandomasis laikotarpis baigėsi. Susisiekite su mumis, jei norite toliau naudotis paslauga.',
      trialExpiredTitle: 'Bandomasis laikotarpis baigėsi',
      trialOneDayLeft: 'Bandomajam laikotarpiui liko 1 diena',
      typeTwoCharsToSearch: 'Įveskite bent 2 simbolius paieškai...',
      unknownError: 'Nežinoma klaida',
      userCount: '{{count}} naudotojai',
      weekdayFr: 'pn',
      weekdayMo: 'pr',
      weekdaySa: 'št',
      weekdaySu: 'sk',
      weekdayTh: 'kt',
      weekdayTu: 'an',
      weekdayWe: 'tr',
      xlsxReadError: 'Nepavyko perskaityti failo – patikrinkite, ar tai galiojantis xlsx failas',
      yearsCount: '{{count}} m.',
    },
    hooks: {
      userLoadError: 'Klaida įkeliant naudotojus: {{message}}',
      emailAndRoleRequired: 'El. paštas ir rolė yra privalomi',
      organizationRequired: 'Organizacija yra privaloma',
      userCreatedDriverMissing: 'Naudotojas sukurtas, bet vairuotojo įrašo nėra. Atidarykite naudotoją ir nustatykite grafiką bei transporto priemones.',
      userCreatedDriverSetupFailed: 'Naudotojas sukurtas, bet vairuotojo nustatymų nepavyko išsaugoti: {{message}}',
      userCreatedWelcomeSent: 'Naudotojas sukurtas – pasveikinimo laiškas išsiųstas',
      userCreated: 'Naudotojas sukurtas',
      welcomeEmailFailed: 'Pasveikinimo laiško išsiųsti nepavyko',
      welcomeEmailDisabled: 'Pasveikinimo laiškas šiam klientui išjungtas',
      userCreateError: 'Klaida kuriant naudotoją: {{message}}',
      userUpdated: 'Naudotojas atnaujintas',
      userUpdateError: 'Klaida atnaujinant naudotoją: {{message}}',
      driverCreated: 'Vairuotojas sukurtas',
      driverCreateError: 'Klaida kuriant vairuotoją: {{message}}',
      userDeleted: 'Naudotojas pašalintas',
      userDeleteError: 'Klaida šalinant naudotoją: {{message}}',
      userHardDeleted: 'Naudotojas visiškai pašalintas ir gali būti sukurtas iš naujo per SSO',
      userHardDeleteError: 'Klaida visiškai šalinant: {{message}}',
      vehicleFetchFailed: 'Nepavyko gauti transporto priemonės duomenų',
      genericError: 'Įvyko klaida',
      odometerSaveFailed: 'Nepavyko išsaugoti odometro rodmenų',
      saveFailed: 'Klaida saugant',
      flinkeyLinkFailed: 'Nepavyko susieti Flinkey',
      flinkeyUnlinkFailed: 'Nepavyko pašalinti Flinkey',
      boxLinkFailed: 'Nepavyko susieti dėžutės',
      boxUnlinkFailed: 'Nepavyko atsieti dėžutės',
      assignFailed: 'Nepavyko priskirti',
      transferError: 'Perkėlimo metu įvyko klaida',
      vehicleMissing: 'Trūksta transporto priemonės',
      vehicleTransferFailed: 'Nepavyko perkelti transporto priemonės',
      changeSaveFailed: 'Nepavyko išsaugoti pakeitimo',
      invalidOrganization: 'Netinkama organizacija',
      vehicleChangesSaveFailed: 'Nepavyko išsaugoti transporto priemonės pakeitimų',
      topNodeResolveFailed: 'Nepavyko nustatyti pasirinktos organizacijos viršutinio mazgo',
      saveGenericFailed: 'Saugant įvyko klaida',
      drawPolygonHint: 'Spustelėkite žemėlapį, kad nubrėžtumėte daugiakampį. Baigę spustelėkite „Baigti“.',
      polygonDrawnFillForm: 'Daugiakampis nubrėžtas! Užpildykite formą ir išsaugokite.',
      drawPolygonFirst: 'Pirmiausia nubrėžkite daugiakampį žemėlapyje (bent 3 taškai)',
      csvCostPerPassage: 'Kaina už pravažiavimą',
      csvCostPerMinute: 'Kaina už minutę',
      csvHideCoordinates: 'Slėpti koordinates',
      csvBorderOnly: 'Tik sienos kirtimai',
      scopeGlobalShort: 'Visuotinis',
      csvDownloaded: 'CSV failas atsisiųstas',
      selectAtLeastOneVehicle: 'Pasirinkite bent vieną transporto priemonę',
      enterStartAndEndTime: 'Įveskite pradžios ir pabaigos laiką',
      gpsPointsFetched: 'Gauta {{count}} GPS taškų',
      fetchDataFailed: 'Nepavyko gauti duomenų',
      fetchGpsFailed: 'Nepavyko gauti GPS duomenų',
      tenantAndClientRequired: 'Būtina nurodyti Tenant ID ir Client ID',
      clientSecretRequired: 'Naujai konfigūracijai būtinas Client Secret',
      graphConfigUpdated: 'Graph konfigūracija atnaujinta',
      graphConfigCreated: 'Graph konfigūracija sukurta',
      couldNotSave: 'Nepavyko išsaugoti',
      graphSaveFailed: 'Nepavyko išsaugoti Graph konfigūracijos',
      confirmDeleteGraph: 'Pašalinti Graph API konfigūraciją? Sinchronizavimo žurnalas bus išsaugotas.',
      graphConfigRemoved: 'Graph konfigūracija pašalinta',
      couldNotDelete: 'Nepavyko pašalinti',
      graphDeleteFailed: 'Nepavyko pašalinti Graph konfigūracijos',
      syncDone: 'Sinchronizavimas baigtas',
      syncFailed: 'Sinchronizavimas nepavyko',
      previewFailed: 'Nepavyko gauti peržiūros',
      samlUpdated: 'SAML konfigūracija atnaujinta',
      samlCreated: 'SAML konfigūracija sukurta',
      confirmDeleteSaml: 'Pašalinti SAML konfigūraciją?',
      oidcUpdated: 'OIDC konfigūracija atnaujinta',
      oidcCreated: 'OIDC konfigūracija sukurta',
      confirmDeleteOidc: 'Pašalinti OIDC konfigūraciją?',
      confirmDeactivate: 'Ar norite deaktyvuoti transporto priemonę {{reg}}?\n\nJi bus paslėpta sąraše, bet nebus visam laikui ištrinta.',
      vehicleDeactivated: '{{reg}} deaktyvuota',
      vehicleDeactivateFailed: 'Nepavyko deaktyvuoti {{reg}}',
      vehicleAlreadyActive: '{{reg}} jau aktyvi',
      vehicleReactivateFailed: 'Nepavyko iš naujo aktyvuoti {{reg}}',
      connectKey: 'Susieti raktą su {{reg}}...',
      subscribeVehicle: 'Prenumeruoti {{reg}}...',
      unknownOrg: 'Nežinoma',
      ticketUpdated: 'Užklausa atnaujinta',
      fillTitleAndMessage: 'Įveskite pavadinimą ir žinutę',
      selectOrganization: 'Pasirinkite organizaciją',
      broadcastSent: 'Pranešimas išsiųstas!',
      categoryNameRequired: 'Įveskite kategorijos pavadinimą',
      categoryCreated: 'Kategorija sukurta',
      categoryCreateFailed: 'Nepavyko sukurti kategorijos',
      broadcastDeleted: 'Pranešimas pašalintas',
      faqAdded: 'DUK įrašas pridėtas',
      faqUpdated: 'DUK įrašas atnaujintas',
      faqDeleted: 'DUK įrašas pašalintas',
      faqAddedFromTicket: 'DUK įrašas pridėtas iš užklausos',
      pricingHourly: 'Už valandą',
      pricingMonthly: 'Per mėnesį',
      pricingPerVehicle: 'Už transporto priemonę',
      pricingPerUser: 'Už naudotoją',
      pricingOneTime: 'Vienkartinis pirkimas',
      pricingCustom: 'Individuali',
      dailyDrivingExceeded: 'Vairavimo laikas {{hours}} val. viršija {{limit}} val. ribą',
      continuousDrivingExceeded: 'Nepertraukiamas vairavimas {{hours}} val. be pakankamos pertraukos',
      minimumBreakTooShort: 'Trumpiausia pertrauka {{minutes}} min. – reikia bent 45 min.',
      weeklyDrivingExceeded: 'Savaitės vairavimo laikas {{hours}} val. viršija 56 val. ribą',
      layoutUpdated: 'Išdėstymas atnaujintas',
      linkCreated: 'Ryšys sukurtas',
      showingHierarchy: 'Rodoma hierarchija nuo „{{name}}“',
      organizationNameRequired: 'Įveskite organizacijos pavadinimą',
      orgAddedUnder: '„{{name}}“ pridėta po „{{parent}}“',
      topNode: 'Viršutinis mazgas',
      cannotDeleteTopNode: 'Negalima pašalinti viršutinio mazgo',
      nodeDeleted: 'Mazgas pašalintas',
      structureSaved: 'Organizacijos struktūra išsaugota!',
      orgSaveFailed: 'Nepavyko išsaugoti: {{message}}',
      importedOrganizations: 'Importuota organizacijų: {{count}}. Nutempkite ryšius, kad sutvarkytumėte hierarchiją.',
      noOrganizationsInFile: 'Faile organizacijų nerasta',
      otherCategory: 'Kita',
      mobileModule: 'Mobilioji: {{name}}',
      wizardBasicInfo: 'Pagrindinė informacija',
      wizardAddress: 'Adresas',
      wizardContact: 'Kontaktinis asmuo',
      wizardPricing: 'Kainodara',
      wizardSummary: 'Suvestinė',
      pricePerMonth: '{{price}} kr/mėn.',
      pricePerVehicle: '{{price}} kr/transporto priemonei',
      pricePerUser: '{{price}} kr/naudotojui',
      packageAddedSyncFailed: 'Paketas pridėtas, bet modulių sinchronizuoti nepavyko.',
      confirmRemovePackage: 'Ar norite pašalinti paketą „{{name}}“ iš kliento?',
      packageRemoved: 'Paketas pašalintas',
      packageRemoveFailed: 'Nepavyko pašalinti paketo',
      mapViewSaved: 'Žemėlapio vaizdas išsaugotas!',
      simUsageFetchFailed: 'Nepavyko gauti naudojimo duomenų',
      simCardsFetchFailed: 'Nepavyko gauti SIM kortelių',
      reportCreated: 'Ataskaita sukurta',
      reportCreateFailed: 'Nepavyko sukurti ataskaitos',
      deviceStatusStock: 'Sandėlyje',
      deviceStatusCustomer: 'Pas klientą',
      deviceStatusVehicle: 'Transporto priemonėje',
      deviceStatusLost: 'Prarasta',
      deviceStatusDecommissioned: 'Nurašyta',
      deviceChangeStatus: 'Būsena pakeista',
      deviceChangeMounted: 'Sumontuota transporto priemonėje',
      deviceChangeUnmounted: 'Išmontuota',
      deviceChangeTransferred: 'Perkelta į kitą transporto priemonę',
      deviceChangeVin: 'VIN aptiktas',
      deviceChangeVehicleCreated: 'Transporto priemonė sukurta',
      deviceChangeSimActivated: 'SIM aktyvuota',
      deviceChangeSimSuspended: 'SIM sustabdyta',
      deviceChangeCreated: 'Įrenginys sukurtas',
      deviceChangeImported: 'Įrenginys importuotas',
      loaNone: 'Nėra (neprivaloma)',
      loa2: 'LoA2 - Tam tikras pasitikėjimas',
      loa3: 'LoA3 - Aukštas pasitikėjimas',
      loa4: 'LoA4 - Labai aukštas pasitikėjimas',
      nameIdEmail: 'El. paštas',
      nameIdPersistent: 'Nuolatinis',
      nameIdTransient: 'Laikinas',
      nameIdUnspecified: 'Nenurodytas',
      somethingWentWrong: 'Kažkas nepavyko',
      entityCreated: '{{entity}} sukurta',
      entityCreateFailed: 'Nepavyko sukurti {{entity}}',
      entityUpdated: '{{entity}} atnaujinta',
      entityUpdateFailed: 'Nepavyko atnaujinti {{entity}}',
      entityDeleted: '{{entity}} pašalinta',
      entityDeleteFailed: 'Nepavyko pašalinti {{entity}}',
      benchmarksFetchFailed: 'Nepavyko gauti palyginimų',
      ticketCreateFailed: 'Nepavyko sukurti užklausos',
      apiKeyCreated: 'API raktas sukurtas',
      confirmDeactivateApiKey: 'Ar tikrai norite deaktyvuoti šį API raktą?',
      apiKeyDeactivated: 'API raktas deaktyvuotas',
      endpointDeactivated: 'Endpoint deaktyvuotas',
      endpointActivated: 'Endpoint aktyvuotas',
      customerCreateFailed: 'Nepavyko sukurti kliento',
      networkError: 'Tinklo klaida',
      statusChangeFailed: 'Klaida keičiant būseną',
      unmountFailed: 'Klaida išmontuojant',
      orgAssignFailed: 'Klaida priskiriant organizaciją',
      fileReadFailed: 'Nepavyko perskaityti failo',
      uploadFailed: 'Įkėlimo klaida',
      importComplete: 'Importas baigtas: importuota {{imported}}, atnaujinta {{updated}}, nepavyko {{failed}}',
      importFailed: 'Importas nepavyko',
      importLoadFailed: 'Nepavyko įkelti importo',
      leasingMileageFetchFailed: 'Nepavyko gauti lizingo ridos',
      remoteServersFetchFailed: 'Nepavyko gauti duomenų iš nuotolinių serverių',
      tripsFetchFailed: 'Nepavyko gauti kelionių',
      analysisFailed: 'Analizė nepavyko',
      trendsFetchFailed: 'Nepavyko gauti tendencijų',
      registeredTripsFetchFailed: 'Nepavyko gauti registruotų kelionių',
      invalidCase: 'Netinkama byla',
      binDataFetchFailed: 'Nepavyko gauti bin duomenų',
      roleDashboard: 'Suvestinė',
      roleLiveMap: 'Žemėlapis realiuoju laiku',
      roleWorkOrders: 'Darbo užsakymai',
      roleBooking: 'Rezervacijos',
      roleWorkshop: 'Dirbtuvės',
      roleKeys: 'Raktų valdymas',
      roleTemperature: 'Temperatūros stebėsena',
      roleReports: 'Ataskaitos',
      roleAnalysis: 'Analizė',
      roleAdmin: 'Administravimas',
      roleMobile: 'Mobilioji programa',
      unknownVehicle: 'Nežinoma transporto priemonė',
      supportStatusOpen: 'Atvira',
      supportStatusInProgress: 'Vykdoma',
      supportStatusWaitingCustomer: 'Laukiama kliento',
      supportStatusResolved: 'Išspręsta',
      supportStatusClosed: 'Uždaryta',
      supportPriorityLow: 'Žema',
      supportPriorityMedium: 'Vidutinė',
      supportPriorityHigh: 'Aukšta',
      supportPriorityCritical: 'Kritinė',
      supportCategoryTechnical: 'Techninė',
      supportCategoryBilling: 'Atsiskaitymas',
      supportCategoryFeatureRequest: 'Pageidavimas',
      supportCategoryBugReport: 'Klaidos pranešimas',
      supportCategoryQuestion: 'Klausimas',
      supportCategoryTraining: 'Mokymai',
      supportCategoryIntegration: 'Integracija',
      unassigned: 'Nepriskirta',
      binAnalysisFailed: 'Nepavyko išanalizuoti bin failo',
    },
  },
  projects: {
    devTitle: 'Produkto kūrimas',
    newProject: 'Naujas projektas',
    projectName: 'Projekto pavadinimas',
    selectCustomer: 'Pasirinkite klientą',
    searchPlaceholder: 'Ieškoti projekto...',
    allStatuses: 'Visos būsenos',
    noProjects: 'Projektų nerasta',
    openTasks: 'atviri duomenys',
    addTask: 'Pridėti užduotį',
    editTask: 'Redaguoti užduotį',
    editProject: 'Redaguoti projektą',
    taskTitle: 'Užduotis',
    subtasks: 'Dalinės užduotys',
    subtaskPlaceholder: 'Nauja antrinė užduotis...',
    subtasksProgress: '{{done}} iš {{total}} atlikta',
    milestone: 'Gairės',
    milestones: 'Gairės',
    milestoneName: 'Gairės pavadinimas',
    priority: 'Pirmenybė',
    plannedStart: 'Suplanuota pradžia',
    plannedEnd: 'Planuojama pabaiga',
    budget: 'Biudžetas',
    actualCost: 'Faktinė kaina',
    billingType: 'Atsiskaitymas',
    hourlyRate: 'Valandinis tarifas',
    billingTypes: {
      fixed: 'Fiksuota kaina',
      hourly: 'Per valandą',
      milestone: 'Per etapą',
    },
    totalHours: 'Iš viso valandų',
    timeTracking: 'Laiko ataskaitos',
    hours: 'Valandos',
    logTime: 'Prisijungimo laikas',
    billable: 'Atsiskaitoma',
    noTask: 'Jokios užduoties',
    dependsOn: 'Priklauso nuo',
    projectType: 'Projekto tipas',
    manager: 'Projekto vadovas',
    primaryContact: 'Pagrindinis kontaktas',
    primaryContactHint: 'Vartotojai kliento organizacijoje (ne visuotiniai administratoriai).',
    owner: 'Savininkas',
    assignedTo: 'Priskirta',
    notAssigned: 'Nepriskirta',
    globalAdmin: 'Pasaulinis administratorius',
    managerCandidatesHint: 'Klientų administratoriai ir pasauliniai administratoriai.',
    ownerCandidatesHint: 'Tik pasauliniai administratoriai.',
    releaseTarget: 'Tikslinė versija',
    component: 'Komponentas',
    featureCode: 'Funkcijos kodas',
    tabs: {
      overview: 'Apžvalga',
      kanban: 'Kanbanas',
      gantt: 'Gantas',
      milestones: 'Gairės',
      time: 'Laikas',
    },
    stats: {
      total: 'Iš viso',
      active: 'Aktyvus',
      myTasks: 'Mano duomenys',
      overdue: 'Pavėluota',
      hoursWeek: 'Valandos šią savaitę',
    },
    status: {
      planned: 'Planuojama',
      active: 'Aktyvus',
      on_hold: 'Pristabdyta',
      completed: 'Baigta',
      cancelled: 'Pertraukė',
    },
    taskStatus: {
      backlog: 'Atsilikimas',
      todo: 'Padaryti',
      in_progress: 'Vykdoma',
      review: 'Apžiūra',
      done: 'Aišku',
      cancelled: 'Pertraukė',
    },
    priorityLevel: {
      low: 'Žemas',
      normal: 'Normalus',
      high: 'Aukštas',
      urgent: 'Ūmus',
    },
    types: {
      implementation: 'Įgyvendinimas',
      migration: 'Migracija',
      upgrade: 'Atnaujinti',
      integration: 'Integracija',
      consulting: 'Konsultavimas',
      other: 'Įvairūs',
    },
    components: {
      backend: 'Galinis galas',
      frontend: 'Priekinis galas',
      mobile: 'Mobilusis',
      gateway: 'Vartai',
      infra: 'Infrastruktūra',
      other: 'Įvairūs',
    },
    gantt: {
      task: 'Užduotis',
      noData: 'Nėra tvarkaraščio – pridėkite datas prie užduočių',
      unassignedTasks: 'Duomenys be etapo',
      holiday: 'Raudona diena',
      dependencies: 'Priklausomybės',
      criticalPath: 'Kritinis kelias',
      tasks: 'informacija',
    },
  },
  carInfoFilterConfig: {
    title: 'Car.info Filtro konfigūracija',
    subtitle: 'Pasirinkite, kurie Car.info laukai turi būti rodomi Transporto priemonių parko filtre.',
    activeFilters: 'Aktyvūs filtrai',
    totalFields: 'Bendras laukų skaičius',
    categories: 'Kategorijos',
    showActiveOnly: 'Rodyti tik aktyvų',
    expandAll: 'Išskleisti viską',
    collapseAll: 'Sutraukti viską',
    reload: 'Įkelti iš naujo',
    fieldsCount: 'lauke',
    noFieldsFound: 'Laukų nerasta',
    adjustSearch: 'Pabandykite pakeisti paiešką arba pašalinti filtrą',
    loadError: 'Nepavyko įkelti filtro konfigūracijos',
    errorToggle: 'Nepavyko atnaujinti lauko',
    activated: 'Suaktyvinta',
    deactivated: 'Išjungta',
    fields: 'lauke',
    uncategorized: 'Neįtraukta į kategorijas',
    examplePrefix: 'Pvz',
  },
  temperatureMonitoring: {
    overviewTitle: 'Temperatūros stebėjimas',
    overviewDescription: 'Klientui priskirtų ir su GPS stebėjimo priemone susietų EYE jutiklių būsena.',
    sensorsTitle: 'Jutikliai ir jungtys',
    sensorsDescription: 'Jutikliai priskiriami iš EYE sluoksnio. Pritvirtinkite jutiklį prie transporto priemonės (1–4 lizdai). Intervalai ir matavimai automatiškai siunčiami į sekiklį.',
    configTitle: 'BLE/EYE konfigūracija (vidinė)',
    configDescription: 'Trikčių šalinimas ir rankinis nepaisymas. Klientai turi naudoti jutiklius ir jungtis.',
    configInternalBannerTitle: 'Vidinis vaizdas – ne klientų savitarnai',
    configInternalBannerBody: 'Parametrai automatiškai nustatomi kode prisijungiant ir redaguojant. Šis puslapis skirtas tik „DeviaQ“ / palaikymui, kai reikia derinti automatinį aprūpinimą.',
    recipientsTitle: 'Signalinių signalų imtuvas',
    schedulesTitle: 'Ataskaitų tvarkaraščiai',
    schedulesComingSoon: 'Suplanuotos savaitės ir mėnesio ataskaitos bus pateiktos kitame veiksme.',
    reportsTitle: 'Šaltos grandinės ataskaitos',
    reportsDescription: 'Select transporto priemonė su prijungta „EYSelect“. Ataskaitoje rodoma pastarųjų 7 dienų temperatūra ir drėgmė.',
    selectSensorForReport: 'Pasirinkite reg. ne. / jutiklis',
    noLinkedSensorsForReport: 'Nėra transporto priemonių su prijungtais jutikliais. Prijunkite jutiklį skiltyje Jutikliai ir ryšys.',
    temperature: 'Temperatūra',
    humidity: 'Drėgmė',
    battery: 'Baterija',
    lowBatteryLabel: 'Senka baterija',
    tracker: 'Tracker (IMEI)',
    lastReading: 'Naujausias matavimas',
    noSensors: 'Dar nėra priskirtų jutiklių.',
    recentExcursions: 'Naujausi nukrypimai',
    noExcursions: 'Nėra registruotų nukrypimų.',
    sensor: 'Jutiklis',
    excursionType: 'Tipas',
    started: 'Pradėti',
    registerSensor: 'Užregistruokite jutiklį',
    organizationRequired: 'Prieš kurdami jutiklį pasirinkite klientą/organizaciją.',
    registeredSensors: 'Priskirti jutikliai',
    editName: 'Keisti vardą',
    sensorRenamed: 'Atnaujintas rodomas pavadinimas',
    noSerial: 'Nėra serijos numerio',
    sensorName: 'Pavadinimas (rodomas pavadinimas)',
    serialNumber: 'Serijos numeris (SN)',
    product: 'Produktas',
    macAddress: 'MAC adresas (nebūtina, dvitaškis nereikalingas)',
    invalidMac: 'MAC adresas turi būti . 7CD9F4142349',
    linkToTracker: 'Prisijungti prie stebėjimo priemonės',
    configuredSlot: 'Aktyvus lizdas DQFleet',
    slotChangeHint: 'Išsaugant pasirinktas lizdas sukonfigūruojamas sekimo įrenginyje. Jei pakeičiate lizdą, senasis automatiškai išjungiamas.',
    willConfigure: 'Išsiųsta į stebėjimo priemonę',
    scanInterval: 'Nuskaitymo intervalas',
    scanIntervalOptions: [
,
,
,
,
,
,
,
,
,
,
,
,
,
,
,
,
,
,
,
,
,
,
,
,
,
,
,
,
,
,
      '30 sekundžių',
,
,
,
,
,
,
,
,
,
,
,
,
,
,
,
,
,
,
,
,
,
,
,
,
,
,
,
,
,
      '1 minutę',
,
,
,
,
,
,
,
,
,
,
,
,
,
,
,
,
,
,
,
,
,
,
,
,
,
,
,
,
,
,
,
,
,
,
,
,
,
,
,
,
,
,
,
,
,
,
,
,
,
,
,
,
,
,
,
,
,
,
,
      '2 minutes',
,
,
,
,
,
,
,
,
,
,
,
,
,
,
,
,
,
,
,
,
,
,
,
,
,
,
,
,
,
,
,
,
,
,
,
,
,
,
,
,
,
,
,
,
,
,
,
,
,
,
,
,
,
,
,
,
,
,
,
,
,
,
,
,
,
,
,
,
,
,
,
,
,
,
,
,
,
,
,
,
,
,
,
,
,
,
,
,
,
,
,
,
,
,
,
,
,
,
,
,
,
,
,
,
,
,
,
,
,
,
,
,
,
,
,
,
,
,
,
,
,
,
,
,
,
,
,
,
,
,
,
,
,
,
,
,
,
,
,
,
,
,
,
,
,
,
,
,
,
,
,
,
,
,
,
,
,
,
,
,
,
,
,
,
,
,
,
,
,
,
,
,
,
,
,
,
,
,
,
      '5 minutes',
    ],
    measurements: 'Išmatavimai',
    measurement: {
      temperature: 'Temperatūra',
      humidity: 'Drėgmė',
      magnet: 'Magnetas (durys / liukas)',
    },
    editLinkTitle: 'Redaguoti ryšį',
    linkSettingsSaved: 'Nustatymai išsaugoti',
    saveAndSendConfig: 'Išsaugokite ir nusiųskite į sekiklį',
    saveWithoutSend: 'Išsaugokite nesiunčiant',
    saveOnlyHint: 'Pakeitimai siunčiami į sekiklį tik paspaudus „Išsaugoti ir išsiųsti į sekiklį“. Jei stebėjimo priemonė neprisijungusi, konfigūracija patenka į eilę ir siunčiama kito prisijungimo metu.',
    settingsSavedNotSent: 'Išsaugota DQFleet. Konfigūracija dar nenusiunčiama į sekiklį – paspauskite „Išsaugoti ir siųsti“ arba „Siųsti BLE-config“.',
    configSentQueuedBanner: 'Konfigūracija yra eilėje – stebėjimo priemonė neprisijungusi. Išsiųsta automatiškai kito prisijungimo metu. Žiūrėkite būsenos ir būklės žurnalą žemiau.',
    configSentAppliedBanner: 'Konfigūraciją gavo stebėjimo priemonė. Žemiau atnaujintas naujausias būsenos ir būklės žurnalas.',
    configSendLogEmpty: 'Dar nėra išsiųsta konfigūracija.',
    configSyncStatus: 'Konfigūracijos būsena',
    configLastSent: 'Paskutinį kartą išsiųstas',
    configSendLog: 'Būsenos žurnalas',
    linkSyncStatus: {
      applied: 'Gauta trackeris',
      pending: 'Eilėje (sekimo priemonė neprisijungus)',
      applying: 'Siunčiama…',
      failed: 'Nepavyko',
      unknown: 'Nežinoma',
    },
    syncLogStatus: {
      applied: 'Gauta',
      queued: 'Eilėje',
      failed: 'Nepavyko',
    },
    selectSensor: 'Select sensor',
    selectVehicle: 'Pasirinkite transporto priemonę',
    selectSensorFirst: 'Select sensor first',
    vehiclePlaceholder: 'Search reg.no, make or model…',
    imeiFromVehicle: 'Select vehicle to retrieve IMEI',
    noDeviceOnVehicle: 'Vehicle has no connected GPS device (IMEI)',
    deviceId: 'Device ID (devices.id)',
    slot: 'Slot',
    link: 'Prisijungti',
    activeLinks: 'Aktyvūs ryšiai',
    noLinks: 'Jokių ryšių.',
    loadError: 'Nepavyko įkelti duomenų',
    saveError: 'Nepavyko išsaugoti',
    saveForbidden: 'Neturite leidimo išsaugoti. Patikrinkite, ar esate prisijungę kaip klientas ir turite teisę kurti jutiklius.',
    sensorCreated: 'Sukurtas jutiklis',
    linkCreated: 'Ryšys sukurtas',
    linkAndConfigSent: 'Ryšys sukurtas ir BLE konfigūracija išsiųsta į sekiklį',
    sendTrackerConfig: 'Siųsti BLE-config',
    provisionError: 'Nepavyko išsiųsti BLE konfigūracijos į stebėjimo priemonę',
    configSaved: 'Konfigūracija išsaugota DQFleet',
    configApplied: 'Konfigūracija išsiųsta į įrenginį',
    configQueued: 'Įrenginys neprisijungęs – konfigūracija turi būti išsiųsta prisijungus',
    syncStatusLabel: 'Sinchronizavimo būsena',
    saveInCloud: 'Išsaugoti DQFleet',
    sendToDevice: 'Siųsti į įrenginį',
    imeiRequired: 'Įveskite IMEI, kad išsiųstumėte konfigūraciją',
    recipientName: 'Vardas',
    email: 'paštas',
    phone: 'Telefonas (SMS)',
    recipientCreated: 'Imtuvas sukurtas',
    noRecipients: 'Nėra imtuvų.',
    exportCsv: 'Eksportuoti CSV',
    eyeDeviceId: 'Jutiklio ID',
    showReport: 'Žiūrėti ataskaitą',
    reportLoadError: 'Nepavyko atsisiųsti ataskaitos',
    noReportReadings: 'Temperatūros matavimų pasirinktu laikotarpiu nėra.',
    reportPeriod: 'Laikotarpis: {{from}} – {{to}}',
    reportReadingCount: '{{count}} matavimai',
    status: {
      ok: 'Gerai',
      no_signal: 'Nėra signalo',
      out_of_range: 'Ne ribos',
      low_battery: 'Senka baterija',
      sensor_error: 'Jutiklio klaida',
      disconnected: 'Atjungtas',
    },
  },
  tripAnalysis: {
    title: 'Analizuoti keliones',
    description: 'Palyginkite įrašytas keliones su transporto priemonės šiukšliadėžės byla, kad nustatytumėte neatitikimus',
    analyze: 'Analizuoti',
    replay: 'Pakartoti',
    replayHint: 'Iš naujo paleiskite išjungimo aptikimą iš šiukšliadėžės failo (sukuria / atnaujina keliones)',
    replayStarted: 'Prasidėjo pakartojimas',
    replayFailed: 'Nepavyko pradėti kartoti',
    selectVehicleFirst: 'Norėdami pradėti, pasirinkite transporto priemonę',
    registered: 'Registruotas',
    fromBin: 'Iš bin failo',
    diff: 'Skirtumas',
    records: 'taškų',
    registeredTrips: 'Registruotos kelionės',
    binTrips: 'Kelionės iš šiukšliadėžės failo',
    noRegistered: 'Nėra registruotų kelionių',
    noBinTrips: 'Dėžės faile nėra kelionių (žr. įspėjimus aukščiau)',
    loadBinHint: 'Išanalizuoti, kad įkeltumėte bin failą',
    maxSpeed: 'maks',
    gpsPoints: 'GPS taškų',
    noAvl250: 'Ne AVL250',
    warnNoRecords: 'Dėžės faile nėra GPS elementų',
    warnNoSpeed: 'Greitis = 0 visuose taškuose (be vairavimo žurnalo)',
    warnNoAvl250: 'Visiškai trūksta AVL250 (išjungimo signalo).',
    warnNoGpsFix: 'GPS pataisos dažnai trūksta (sat=0)',
    warnSparse: 'Reti taškeliai – tik širdies plakimai',
    reconstructed: 'Rekonstruota',
    reconstructedHint: 'Rekonstruota kelionė (trūko GPS šalto užvedimo metu) – atstumas nuo OEM matuoklio arba OSRM įvertinimo',
    warnNoBinFile: 'Vartuose nėra transporto priemonės / datos šiukšliadėžės failo',
    underDetectedTitle: 'Mažiau šiukšlių dėžių nei užregistruota – tikėtina, kad aptikimo nepavyks',
    underDetectedBody: 'Dėžutės faile yra paleidimas (norma > 0), bet paketo / pakartojimo aptikimas aptiko mažiau kelionių nei įrašyta. Neapdoroti duomenys yra teisingi – tai išjungimo aptikimas (toks pat kaip ir atkūrimas), kuris suskirsto į segmentus, pvz. vienetams su retais AVL250. NENAUDOKITE šios transporto priemonės: tai pakeistų teisingas keliones mažiau.',
    replayDestructiveConfirm: 'Įspėjimas: šiukšliadėžės / pakartojimo aptikimas aptiko mažiau kelionių, nei buvo įrašyta, net jei šiukšliadėžės faile yra paleidimų. Pakartojimas tikriausiai pakeistų teisingas keliones mažiau. Ar vis dar norite tęsti?',
  },
  obdVehicles: {
    title: 'OBD transporto priemonių sąrašas',
    description: 'Ieškokite Teltonika OBD OĮG palaikymo pagal markę ir modelį. Sąrašas skirtas FMX001/FMM00A/FMX003, o ne FMM003 sertifikatui.',
    deviceFamilyNote: 'Šaltinis: Teltonika wiki, skirtas FMX001, FMM00A ir FMX003. DQFleet P&P veikia FMM003 – naudokite sąrašą kaip OĮG nuorodą.',
    checkNow: 'Patikrinkite dabar',
    import: 'Importuoti',
    checkFailed: 'Nepavyko patikrinti wiki',
    searchFailed: 'Nepavyko ieškoti',
    syncFailed: 'Nepavyko importuoti sąrašo',
    detailFailed: 'Nepavyko gauti išsamios informacijos',
    alreadyLatest: 'Jau naujausia versija',
    imported: 'Importuotos {{count}} eilutės',
    wikiDate: 'Wiki data',
    ourDate: 'Mūsų versija',
    none: 'Nr',
    rows: 'Linijos',
    newerAvailable: 'Yra naujas failas',
    allMakes: 'Visi prekiniai ženklai',
    allParameters: 'Visi parametrai',
    make: 'Padaryti',
    model: 'Modelis',
    year: 'Metai',
    fuelType: 'Kuro',
    resultCount: '{{count}} hitai',
    scrollHint: 'Slinkite į šoną, kad pamatytumėte visus parametrus',
    deviceFamily: 'Šaltinio vienetai',
    relatedKb: 'Susiję wiki puslapiai',
    fleetMatches: 'Automobilių parke',
    forceNonObd: 'priverstinis Ne-OBD',
  },
  obdKnowledge: {
    title: 'OBD Žinios',
    description: 'Ieškoma Teltonika OBD sprendimų kopija. Visada nuoroda atgal į wiki.',
    sources: 'Šaltiniai',
    sync: 'Sinchronizuoti dabar',
    loadFailed: 'Nepavyko gauti šaltinių',
    searchFailed: 'Nepavyko ieškoti',
    syncFailed: 'Nepavyko sinchronizuoti',
    pageMissing: 'Puslapis dar negautas – paleiskite sinchronizavimą',
    synced: 'Sinchronizavimas baigtas: {{updated}} atnaujino {{checked}}',
    notFetched: 'nepakėlė',
    openWiki: 'Atidaryti adresu Teltonika',
    searchPlaceholder: 'Ieškoti pvz. Ne OBD, EV, Kia…',
    vehicleHits: '{{count}} transporto priemonės sąraše',
    openVehicleList: 'Atidarykite transporto priemonių sąrašą',
    vehicleListPageNote: 'Wiki puslapis yra didelė lentelė. Norėdami ieškoti markės, modelio ir parametrų, naudokite OBD transporto priemonių sąrašą.',
    noVehicleHits: 'Importuotų transporto priemonių sąraše nėra eilučių. Importuokite xlsx iš OBD transporto priemonių sąrašo.',
    askAi: 'Paklauskite AI',
    askPlaceholder: 'Pavyzdžiui. Kokie OĮG parametrai palaikomi „Kia Niro“ ir kaip pašalinti triktis, jei jų trūksta?',
    ask: 'Klausimas',
    askFailed: 'AI negalėjo atsakyti',
  },
  replacementChain: {
    title: 'Atlyginimo grandinė',
    description: 'Ieškokite registracijos numerių ir parodykite, kurios transporto priemonės buvo pakeistos grandinėje.',
    searchPlaceholder: 'Reg numeris…',
    emptyState: 'Ieškokite registracijos numerio, kad būtų rodoma pakaitinė grandinė.',
    loadError: 'Nepavyko gauti pakaitinės grandinės',
    resultHint: 'Senesnės pakeistos transporto priemonės kairėje, vėliau pakeistos dešinėje.',
    noChain: 'Prie šios transporto priemonės nėra pritvirtintos pakaitinės grandinės.',
    legendLeft: 'Kairėje: transporto priemonė, kurią pakeičia ieškoma transporto priemonė (laukelis „Pakeičia transporto priemonę“).',
    legendRight: 'Dešinėje: transporto priemonė, kuri pakeitė ieškomą transporto priemonę.',
    legendCurrent: 'Pažymėta transporto priemonė',
    openVehicle: 'Atvira transporto priemonė',
    notInSystem: 'Sistemoje kaip transporto priemonė neprieinama',
    noAccess: 'Neturite leidimo peržiūrėti pakeitimo grandines.',
  },
  vehicleCategories: {
    title: 'Transporto priemonių kategorijos',
    description: 'Tvarkykite pasirenkamas transporto priemonių kategorijas savo viršutiniame mazge.',
    newCategoryPlaceholder: 'Naujos transporto priemonės kategorija',
    categoryName: 'Kategorijos pavadinimas',
    empty: 'Transporto priemonių kategorijų dar nėra.',
    saved: 'Transporto priemonės kategorija buvo išsaugota',
    loadError: 'Nepavyko gauti transporto priemonių kategorijų',
    saveError: 'Nepavyko išsaugoti transporto priemonės kategorijos',
  },
  alternativeFuels: {
    title: 'Alternatyvūs degalai',
    description: 'Tvarkykite pasirenkamus alternatyvius degalus savo viršutiniame mazge (pvz., Skåne regione).',
    newFuelPlaceholder: 'Nauji degalai, pvz., HVO',
    fuelName: 'Degalai',
    empty: 'Kol kas nėra alternatyvių degalų.',
    saved: 'Sutaupytas alternatyvus kuras',
    loadError: 'Nepavyko atsisiųsti alternatyvaus kuro',
    saveError: 'Nepavyko išsaugoti alternatyvių degalų',
  },
  nordeaLeasing: {
    title: 'Nordea lizingo importas',
    description: 'Import iš Nordea TX failo mėn. Atnaujina transporto priemonės finansus, išsaugo failą archyve ir mokėjimo istoriją per laikotarpį.',
    uploadTitle: 'Įkelti failą',
    uploadHint: 'Pasirinkite kabliataškiu atskirtą .txt failą (pvz., 2026-04.TXT). Tas pats failas importuojamas tik vieną kartą. Kitas nuomos mokestis yra padalintas iš stulpelio Per (sąskaitų faktūrų išrašymo laikotarpis mėnesiais) į mėnesio nuomos mokestį.',
    selectFile: 'Pasirinkite failą',
    importHistory: 'Ankstesnis importas',
    noImports: 'Importo dar nėra',
    colFilename: 'Failo pavadinimas',
    colPeriodEnd: 'Data Antradienis',
    colRows: 'Linijos',
    colUpdated: 'Atnaujinta',
    colSkipped: 'Praleistas',
    colImportedAt: 'Importuota',
    loadError: 'Nepavyko gauti importuojamo sąrašo',
    importError: 'Importuoti nepavyko',
    importSuccess: 'Importavimas baigtas: {{updated}} transporto priemonės atnaujintos, {{skipped}} praleista',
    duplicateFile: 'Failas jau importuotas – nėra naujo išsaugojimo ar istorijos',
    skippedRegistrations: 'Regnr be atitinkamos transporto priemonės',
  },
  protectorInsurance: {
    title: 'Protector draudimo importas',
    description: 'Importuokite draudimo failus (Excel) iš Protector. Suderina transporto priemones pagal regnr (F stulpelis), atnaujina transporto priemonės draudimą ir sukuria istoriją per laikotarpį.',
    uploadTitle: 'Įkelti failus',
    uploadHint: 'Pasirinkite vieną ar daugiau .xls/.xlsx failų. RegNo (F stulpelis) yra raktas. Mėnesio kaina = suma (V stulpelis) / 12. Tas pats failas importuojamas tik vieną kartą.',
    selectFiles: 'Pasirinkite failus',
    importHistory: 'Ankstesnis importas',
    noImports: 'Importo dar nėra',
    colFilename: 'Failo pavadinimas',
    colPeriodEnd: 'Iki šiol',
    colRows: 'Linijos',
    colUpdated: 'Atnaujinta',
    colSkipped: 'Praleistas',
    colImportedAt: 'Importuota',
    loadError: 'Nepavyko gauti importuojamo sąrašo',
    importError: 'Importuoti nepavyko',
    importSuccess: 'Importavimas baigtas: {{updated}} transporto priemonės atnaujintos, {{skipped}} praleista',
    duplicateFile: 'Failas jau importuotas – nėra naujo išsaugojimo ar istorijos',
    skippedRegistrations: 'Regnr be atitinkamos transporto priemonės',
  },
  vehicleUsageStatuses: {
    title: 'Transporto priemonės būsena',
    description: 'Tvarkykite pasirenkamas būsenas aukščiausiame mazge (lizingas, likvidavimas ir kt.).',
    newStatusPlaceholder: 'Nauja būsena. Apdorojama',
    statusName: 'Būsena',
    empty: 'Būsenų dar nėra.',
    saved: 'Transporto priemonės būsena išsaugota',
    loadError: 'Nepavyko gauti transporto priemonės būsenų',
    saveError: 'Nepavyko išsaugoti transporto priemonės būsenos',
  },
  personalTrackers: {
    title: 'Asmeniniai sekėjai',
    description: 'Asmeninių sekėjų registras. Įdėkite SIM kortelę ir priskirkite organizaciją.',
    orgDescription: 'Pažiūrėkite, kur yra organizacijos stebėjimo priemonės, prijunkite juos prie vartotojo ir valdykite mygtuką.',
    add: 'Pridėti sekiklį',
    save: 'Išsaugoti',
    cancel: 'Atšaukti',
    delete: 'Pašalinti',
    imei: 'IMEI',
    serial: 'Serijos numeris',
    iccid: 'SIM kortelė (ICCID)',
    organization: 'Organizacija',
    noOrganization: 'Jokios organizacijos',
    user: 'Vartotojas',
    noUser: 'Nėra vartotojo',
    searchUser: 'Ieškoti vartotojo',
    needsOrganization: 'Pasirinkite organizaciją aukščiau. Tada galima prijungti vartotoją toje organizacijoje.',
    model: 'Modelis',
    lastSeen: 'Paskutinį kartą matytas',
    battery: 'Baterija',
    charging: 'Įkeliama',
    empty: 'Registre nėra stebėjimo priemonių.',
    emptyOrg: 'Organizacijai nėra priskirtų stebėjimo priemonių.',
    saved: 'Išsaugota',
    deleted: 'Stebėtojas buvo pašalintas',
    loadError: 'Nepavyko atsisiųsti stebėjimo priemonių',
    saveError: 'Nepavyko išsaugoti',
    confirmDelete: 'Pašalinti stebėjimo priemonę iš registro?',
    mapEmpty: 'Jokia pozicija dar neįrašyta.',
    buttonTitle: 'Mygtukas',
    click1: '1 paspaudimas',
    click2: '2 paspaudimai',
    longPress: 'Ilgas paspaudimas (2–5 s)',
    powerOff: 'Išjungimas mygtuku (laikykite >5 s)',
    actionNone: 'Nr',
    actionAlarm: 'Signalizacija',
    priority: 'Pirmenybė',
    priorityOff: 'Iš',
    priorityLow: 'Žemas',
    priorityHigh: 'Aukštas',
    configStatus: 'Išsiųsta į įrenginį',
    configDelivered: 'Pristatyta',
    configQueued: 'Laukiama eilėje, kol įrenginys prisijungs',
    configFailed: 'Nepavyko išsiųsti',
    configPending: 'Laukia',
    alarm: 'Naujausias signalas',
    iccidHint: 'ICCID iš konfigūratoriaus. Atnaujinama, jei įrenginys praneša apie kitą SIM kortelę.',
    alarmType: {
      fall: 'CASE',
      button: 'Mygtukas',
      alarm: 'Signalizacija',
    },
    alarmClick1: '1 paspaudimas',
    alarmClick2: '2 paspaudimai',
    alarmLong: 'Ilgai paspauskite',
    alarmTitle: 'Asmeninis sekimo signalas',
    alarmEmpty: 'Nėra nepatvirtintų aliarmų.',
    alarmWho: 'Person',
    alarmPhone: 'Telefonas',
    alarmNoPhone: 'Nėra telefono numerio',
    alarmNoPosition: 'Jokia padėtis nelydėjo pavojaus signalo.',
    alarmAck: 'Pripažinti',
    alarmAcked: 'Pavojaus signalas patvirtintas',
    alarmBell: 'Nepatvirtinti aliarmai',
  },
  licenseCheck: {
    title: 'Vairuotojo pažymėjimo patikrinimas',
    description: 'Organizacijų, kurios turi patikrinti vairuotojo tinkamumą, patikrinimas per BKY.',
    apiWaiting: 'Skambučiai į BKY laukia paskyros ir pranešimų tvarkaraščio. Žmonės ir ryšys gali būti išsaugoti jau dabar.',
    organization: 'Organizacija',
    connection: 'BKY ryšys',
    questionUrl: 'Klausimo URL',
    answerUrl: 'Atsakymo URL',
    username: 'Vartotojo vardas',
    password: 'Slaptažodis',
    passwordKept: 'Palikite tuščią, kad išsaugotumėte slaptažodį',
    active: 'Aktyvus',
    saveConnection: 'Išsaugoti ryšį',
    saved: 'Išsaugota',
    subjects: 'Žmonės',
    name: 'Vardas',
    personnummer: 'Socialinio draudimo numeris',
    addSubject: 'Pridėti asmenį',
    competence: 'Kompetencija',
    tachograph: 'Tachografo kortelė (16 skaitmenų)',
    addCompetence: 'Pridėti leidimą',
    wouldAsk: 'Paklausė',
    inactive: 'Neaktyvus',
    activate: 'Suaktyvinti',
    deactivate: 'Išjungti',
    emptySubjects: 'Nėra užsiregistravusių žmonių.',
    previewCount: 'Siunčiamų klausimų skaičius: {{count}}',
    history: 'Istorija',
    emptyHistory: 'Kol kas klausimų neišsiųsta.',
    questions: 'Klausimai',
    answers: 'Atsakymas',
    yes: 'TAIP',
    no: 'NE',
    askedBy: 'Paklausė',
    when: 'Kada',
    run: 'Siųsti klausimus',
    purge: 'Ištrinti visus duomenis',
    purgeHelp: 'Pašalinamas šios organizacijos ryšys, žmonės, leidimai ir istorija. Įveskite organizacijos pavadinimą, kad patvirtintumėte.',
    purgeConfirm: 'Organizacijos pavadinimas',
    purged: 'Visi organizacijos vairuotojo pažymėjimų patikrinimai ištrinami',
    loadError: 'Nepavyko gauti vairuotojo pažymėjimo patikrinimo',
    saveError: 'Nepavyko išsaugoti',
    deleteConfirm: 'Pašalinti asmenį ir jo leidimus?',
  },
  serviceAgreements: {
    title: 'Paslaugų įsipareigojimas',
    subtitle: 'Periodiškai atliekamos aptarnavimo užduotys',
    new: 'Naujas įsipareigojimas teikti paslaugas',
    newTitle: 'Naujas įsipareigojimas teikti paslaugas',
    editTitle: 'Redaguoti įsipareigojimą teikti paslaugas',
    empty: 'Jokių paslaugų įsipareigojimų',
    titleField: 'Pavadinimas',
    titlePlaceholder: 'pavyzdžiui, išmetimo oro siurblio patikrinimas',
    customerSection: 'Kliento ir aptarnavimo adresas',
    serviceAddress: 'Paslaugos adresas',
    billingSection: 'Atsiskaitymo adresas',
    billingName: 'Atsiskaitymo vardas',
    billingAddress: 'Atsiskaitymo adresas',
    billingReference: 'Sąskaitos faktūros nuoroda',
    scheduleSection: 'Tvarkaraštis ir kaina',
    intervalMonths: 'Intervalas (mėnesiais)',
    monthsShort: 'Pirm',
    nextDueDate: 'Kitas terminas',
    pricingType: 'Kainodara',
    hourly: 'Valandinis tarifas',
    fixed: 'Fiksuota kaina',
    estimatedMinutes: 'Numatomas laikas (min.)',
    estimatedHours: 'Numatomas laikas (valandomis)',
    estimatedHoursHint: 'Kiek laiko turėtų užtrukti užduotis, pvz. 1.5',
    hourlyRate: 'Valandinis tarifas (SEK/val.)',
    fixedPrice: 'Fiksuota kaina (SEK)',
    dueWidgetTitle: 'Galiojimas baigiasi per 30 dienų',
    noneDue: 'Jokie įsipareigojimai nesibaigia per 30 dienų',
    dueInDays: 'Galiojimas baigiasi po {{days}} d',
    overdueBy: 'Vėluojama {{days}} dienų',
    assign: 'Priskirti asmenį',
    assignTitle: 'Priskirkite ir kurkite darbo užsakymus',
    createWorkOrder: 'Sukurti darbo užsakymą',
    personRequired: 'Pasirinkite žmogų',
    confirmDelete: 'Ar norite pašalinti šį įsipareigojimą teikti paslaugą?',
  },
  charging: {
    title: 'Įkrauti',
    description: 'EV įkrovimo seansų (kWh) ir vietos apskaita',
    tab: 'Įkrauti',
    month: 'Mėnuo',
    organization: 'Organizacija',
    allOrganizations: 'Visos organizacijos',
    selectVehicle: 'Transporto priemonės',
    vehiclePlaceholder: 'Visos transporto priemonės – ieškokite arba pasirinkite...',
    export: 'Eksportuoti',
    estimateNote: 'kWh apskaičiuojamas pagal akumuliatoriaus įkrovos būseną (SoC), o ne išmatuotą sienelės vertę. Norint tiksliai nustatyti mokesčių bazę, reikalinga matavimo įkrovimo dėžutė.',
    loadError: 'Nepavyko nuskaityti įkrovimo seansų',
    exportError: 'Nepavyko eksportuoti',
    noData: 'Per šį laikotarpį įkrovimo sesijų nėra',
    location: {
      label: 'Vieta',
      all: 'Visos vietos',
      home: 'Pradžia',
      work: 'Darbas',
      public: 'Publika',
      unknown: 'Nežinoma',
    },
    summary: {
      homeKwh: 'Įkrovimas namuose (kWh)',
      totalKwh: 'Bendra apmokestinta (kWh)',
      sessions: 'Seansų skaičius',
    },
    table: {
      vehicle: 'Transporto priemonės',
      start: 'Pradėti',
      end: 'Galutinis',
      soc: 'Įkrovimo lygis',
      wallKwh: 'kWh (siena)',
      location: 'Vieta',
    },
    config: {
      description: 'Konfigūruokite akumuliatoriaus talpą, įkrovimo praradimą ir namus bei darbo vietą, kad gautumėte tikslias įkrovos ataskaitas. Jei Car.info nėra reikšmės, kWh galite užpildyti rankiniu būdu – Car.info perrašo, kai yra duomenų.',
      batteryCapacity: 'Akumuliatoriaus talpa (kWh)',
      batteryFromCarInfo: 'Naudokite paieškos reikšmę iš Car.info: {{value}} kWh',
      batterySourceManual: 'Šaltinis: užpildytas rankiniu būdu (perrašomas, jei Car.info gauna kWh)',
      batterySourceCarInfo: 'Šaltinis: Car.info',
      efficiency: 'Įkrovimo praradimas (baterija / siena, 0–1)',
      homeLatitude: 'Namų įkrovimo vietos platuma',
      homeLongitude: 'Namų įkrovimo vietos ilguma',
      homeRadius: 'Namų įkrovimo stoties spindulys (m)',
      homeLocation: 'Namų įkrovimo stotelė',
      workLocation: 'Darbo vieta',
      pickOnMap: 'Pasirinkite žemėlapyje',
      changeOnMap: 'Keisti žemėlapyje',
      clear: 'Aišku',
      address: 'Adresas',
      addressPlaceholder: 'Spustelėkite žemėlapį, kad gautumėte adresą',
      radius: 'Spindulys',
      pickerHelp: 'Ieškokite adreso arba spustelėkite žemėlapį / vilkite, kad pasirinktumėte vietą. Adresas nuskaitomas automatiškai.',
      pickerNoPoint: 'Vieta nepasirinkta',
      searchPlaceholder: 'Ieškokite adreso arba vietos…',
      publicNote: 'Įkrovimas ne namuose ir darbo vietoje automatiškai klasifikuojamas kaip viešas.',
    },
  },
  fuelCards: {
    title: 'Degalų kortelės',
    description: 'Kuro kortelės, OKQ8 numerio ir transporto priemonės sukabinimo registras',
    create: 'Nauja kortelė',
    createTitle: 'Užregistruoti bako kortelę',
    editTitle: 'Redaguoti tanko kortelę',
    fuelCompany: 'Kuro įmonė',
    selectCompany: 'Pasirinkite kuro įmonę...',
    cardNumber: 'Kortelės numeris',
    invoiceNumber: 'Sąskaitos numeris',
    embossedNumber: 'Reljefinis numeris',
    cardName: 'Trumpas vardas',
    pinCode: 'Pin kodas',
    expiresAt: 'Galiojimo laikas',
    status: 'Būsena',
    statusActive: 'Aktyvus',
    statusBlocked: 'Užblokuota',
    statusCancelled: 'Susmulkinta',
    notes: 'Pastaba',
    vehicle: 'Transporto priemonės',
    selectVehicle: 'Pasirinkite transporto priemonę…',
    missingOrganization: 'Kortelėje trūksta organizuotumo, todėl transporto priemonių prijungti negalima.',
    notLinked: 'Neprisijungęs',
    link: 'Prisijungti',
    unlink: 'Atsijungti',
    linkTitle: 'Prijunkite kortelę prie transporto priemonės',
    cancel: 'Atšaukti',
    expiringFilter: 'Galiojimas baigiasi per 60 dienų',
    noCards: 'Tanko kortelių nerasta',
    loadError: 'Nepavyko gauti bako kortelės',
    createSuccess: 'Užregistruota kuro kortelė',
    saveSuccess: 'Atnaujinta bako kortelė',
    saveError: 'Nepavyko išsaugoti bako kortelės',
    linkSuccess: 'Kortelė prijungta prie automobilio',
    linkError: 'Nepavyko prijungti kortelės',
    unlinkSuccess: 'Kortelė atjungta',
    unlinkError: 'Nepavyko atjungti kortelės',
    confirmUnlink: 'Atjungti kortelę nuo transporto priemonės? Kortelė lieka registre.',
    cancelSuccess: 'Kortelė susmulkinta',
    cancelError: 'Nepavyko susmulkinti kortelės',
    confirmCancel: 'Susmulkinti šią degalų kortelę?',
    historyTitle: 'Ryšio istorija',
    historyVehicle: 'Transporto priemonės',
    historyFrom: 'Atjungtas',
    historyTo: 'Atjungtas',
    historyUnlinked: 'Atjungtas',
    historyOngoing: 'Vykdoma',
    historyCurrent: 'Dabartinė',
    historyPast: 'Baigta',
    historyEmpty: 'Nėra ryšio istorijos',
    historyLoadError: 'Nepavyko nuskaityti ryšio istorijos',
  },
  leasingWidget: {
    title: 'Lizingas',
    titleWithMonths: 'Lizingas per {months} mėn',
    noVehicles: 'Greitai nesibaigs jokia nuomos sutartis',
    overdue: 'pasibaigė',
    daysAgo: 'Prieš {days}d',
    today: 'Šiandien',
    openCase: 'Atlikta byla',
    toModule: 'Pirkimas',
  },
  procurement: {
    title: 'Pirkimas ir likvidavimas',
    cardDescription: 'Sprendimas pakeisti arba likviduoti transporto priemonę, kai baigiasi nuomos sutartis',
    tabCases: 'Byla',
    tabSettings: 'Nustatymai',
    newCase: 'Nauja byla',
    newCaseHelp: 'Pirmiausia pasirinkite transporto priemonę. Atvejis išsaugomas tik spustelėjus Išsaugoti.',
    selectVehicle: 'Viršutiniame mazge pasirinkite transporto priemonę',
    selectVehiclePlaceholder: 'Ieškoti registracijos numerio, markės arba modelio',
    noVehiclesFound: 'Paiešką neatitiko nė viena transporto priemonė',
    vehicleSearchError: 'Nepavyko ieškoti transporto priemonės',
    vehicleLoadError: 'Nepavyko gauti išsamios transporto priemonės informacijos',
    business: 'Operacija',
    unknownBusiness: 'Jokia veikla nenurodyta',
    organization: 'Organizacija',
    makeModel: 'Markė, modelis ir modelio metai',
    currentStatus: 'Dabartinė būsena',
    vehicleType: 'Transporto priemonės tipas',
    poolCar: 'Baseino automobilis',
    alreadyOpenCase: 'Jau yra nagrinėjama šios transporto priemonės byla.',
    openExisting: 'Atidarykite esamą bylą',
    existingCaseOpened: 'Atidaryta esama byla',
    caseCreated: 'Byla buvo išsaugota',
    firstDecisionHint: 'Toliau nurodytas naudojimas yra pagrindas priimant pirmąjį sprendimą: pakeisti transporto priemonę arba ją išjungti.',
    utilizationWindow: 'Pastarųjų {months} mėnesių analizė, apskaičiuota pagal turimus vairavimo duomenis.',
    insufficientHistory: 'Turime mažiau nei 12 mėnesių vairavimo duomenų ({months} mėnesių). Skaičiavimas atliekamas remiantis turimais duomenimis.',
    poolUtilization: 'Baseino automobilio naudojimo laipsnis',
    poolOccupancy: '{pct} užimtumas % (galima {booked} užsakytų valandų {capacity}).',
    poolUtilizationMissing: 'Nėra užsakymo duomenų, pagal kuriuos būtų galima apskaičiuoti užimtumą.',
    noCases: 'Jokių pavedimų',
    noVehicle: 'Be transporto priemonės',
    loadError: 'Nepavyko įkelti dėklų',
    createError: 'Nepavyko sukurti atvejo',
    saveError: 'Nepavyko išsaugoti',
    refreshError: 'Nepavyko atnaujinti duomenų bazės',
    uploadError: 'Nepavyko įkelti failo',
    settingsLoadError: 'Nepavyko įkelti nustatymų',
    settingsSaveError: 'Nepavyko išsaugoti nustatymų',
    settingsSaved: 'Nustatymai išsaugoti',
    colTitle: 'Reikalas',
    colVehicle: 'Transporto priemonės',
    colOrg: 'Organizacija',
    colStatus: 'Būsena',
    colOutcome: 'Rezultatas',
    colStep: 'Žingsnis',
    colRentEnd: 'Nuomos pabaiga',
    statusOpen: 'Atidaryti',
    statusDraft: 'Juodraštis',
    statusInProgress: 'Vykdoma',
    statusCompleted: 'Baigta',
    statusCancelled: 'Nutraukta',
    status_draft: 'Juodraštis',
    status_in_progress: 'Vykdoma',
    status_completed: 'Baigta',
    status_cancelled: 'Nutraukta',
    outcome_undecided: 'Neapsisprendęs',
    outcome_replace: 'Pakeiskite',
    outcome_decommission: 'Nusileiskite',
    decisionModel: 'Sprendimo modelis',
    decisionAuthority: 'Kas nusprendžia',
    authorityFleet: 'Flotilės vadovas',
    authorityOperations: 'Verslas',
    utilizationMonths: 'Naudojimo laikotarpis (mėnesiai)',
    utilizationMonthsHelp: 'Numatytasis 36. Galima keisti kiekvienam klientui (1–60).',
    steps: 'Žingsnis',
    processTitle: 'Kliento procesas',
    processHelp: 'Veiksmai taikomi viršutiniam mazgui ir nukopijuojami į kiekvieną naują atvejį. Esami atvejai išlaiko procesą, su kuriuo jie buvo sukurti. Pažymėkite Naudoti, kad nustatytumėte veiksmus, kurie bus įtraukti kuriant bylą.',
    stepOrder: 'Užsakyti',
    stepName: 'Žingsnio pavadinimas',
    stepNamePlaceholder: 'Pavyzdžiui, citata iš tiekėjo',
    stepApplies: 'Taikoma',
    stepUse: 'Naudota',
    stepRequired: 'Privaloma',
    stepAttachment: 'Priedas',
    addStep: 'Pridėkite žingsnių',
    moveUp: 'Judėti aukštyn',
    moveDown: 'Judėti žemyn',
    noProcessSteps: 'Dar jokių žingsnių. Pridėkite šiam klientui taikomus veiksmus.',
    stepNameRequired: 'Visi žingsniai turi turėti pavadinimą',
    processNeedsStep: 'Bent vienas veiksmas turi būti pažymėtas kaip Naudoti',
    grounds: 'Sprendimo motyvai',
    applies_always: 'Visada',
    applies_replace: 'Pakeiskite',
    applies_decommission: 'Nusileiskite',
    applies_both: 'Abu',
    utilization: 'Naudojimo pagrindas',
    refreshUtilization: 'Atnaujinti dokumentus',
    kpiDistance: 'Vairavimo atstumas',
    kpiTrips: 'Kelionės',
    kpiDaysDriven: 'Dienos bėga',
    kpiScore: 'Malonumo balas',
    recommend: 'Fleetmanager rekomendacija',
    fleetStatement: 'Fleetmanager pareiškimas',
    saveRecommend: 'Išsaugoti rekomendaciją',
    recommendSaved: 'Rekomendacija išsaugota',
    decide: 'Oficialus sprendimas',
    operationsStatement: 'Pareiškimas iš verslo',
    justification: 'Pateisinimas',
    saveDecision: 'Priimk sprendimus',
    decisionSaved: 'Sprendimas išsaugotas',
    markDone: 'Aišku',
    attach: 'Prikabinti',
    proposals: 'Pasiūlymas dėl kompensacijos',
    proposalTitle: 'Pasiūlymo pavadinimas',
    addProposal: 'Pridėti pasiūlymų',
    documents: 'dokumentas',
    complete: 'Uždaryti bylą',
    cancel: 'Atšaukti bylą',
    step_pending: 'Laukia',
    step_done: 'Aišku',
    step_skipped: 'Peršoko',
  },
  productionCost: {
    title: 'Gamyba ir kaina',
    kmTitle: 'Nuvažiuoti kilometrai per mėnesį',
    fuelTitle: 'Kuro kaina per mėnesį',
    inMonth: '{month}',
    vsPrevious: '{percent} prieš {month}',
    totalKm: 'Iš viso',
    periodCost: 'Kaina laikotarpiu',
    perKm: 'Vidurkis kr/km',
    perVehicle: 'Vidurkis vienai transporto priemonei per mėnesį',
    link: 'Bendra parko kaina →',
    noData: 'Nėra ridos ar kainos šiam laikotarpiui',
    span: { months: '12 mėn.', year: '1 metai', quarter: 'Pagal ketvirtį' },
  },

  actionRequired: {
    title: 'Reikia veiksmo',
    sortedByOverdue: 'Rikiuota pagal pradelstus',
    service: 'Aptarnavimas',
    serviceHint: 'per 300 km arba 60 dienų',
    inspection: 'Apžiūra',
    inspectionHint: 'per {days} dienas',
    leasing: 'Lizingas',
    leasingHint: 'baigiasi per {months} mėn.',
    tax: 'Transporto mokestis',
    taxHint: 'per {days} dienas',
    overdue: '{count} pradelsta',
    soon: '{count} greitai',
    assigned: '{count} priskirta',
    openDetail: 'Atidaryti {name}',
  },

  deviceHealth: {
    title: 'Įrenginių būklė',
    lowBattery: 'Žema akumuliatoriaus įtampa',
    lowBatteryHint: 'žemiau 12 V',
    unplugged: 'Atjungti įrenginiai',
    unpluggedAssigned: '{{count}} priskirta',
    dataLag: 'Duomenų vėlavimas',
    dataLagHint: 'išmetimo eilėje, virš 1 val.',
  },

  gpsLagWidget: {
    title: 'GPS atsilieka',
    subtitle: 'Gauta dėžė ir įrenginyje sukurti duomenys (> 1 val.)',
    noVehicles: 'Nėra transporto priemonių su uždelstais GPS duomenimis',
    dumpQueue: 'sąvartynų eilėje',
    dumpLagLabel: 'Diff priėmimo blokas',
    showDumpOnly: 'Rodyti tik iškelties eilę',
    showAllStale: 'Rodyti visus pasenusius',
    kind: {
      dumping_lag: 'Išmesti eilę',
      silent: 'Tyliai',
      parked_or_old: 'Suparkuotas',
      lost_while_driving: 'Važiavo - pasiklydo',
    },
  },
  themeSettings: {
    title: 'Tema ir prekės ženklas',
    description: 'Sureguliuokite šviesaus ir tamsaus režimo spalvas. Peržiūra atnaujinama akimirksniu – niekas neišsaugoma, kol nepaspaudžiate Išsaugoti.',
    tabGlobal: 'Pasaulinis standartas',
    tabPartner: 'Partnerio tema',
    selectPartner: 'Pasirinkite partnerį',
    editMode: 'Redagavimo režimas',
    editModeHint: 'Perjunkite iš šviesios ir tamsios – abu išsaugomi Išsaugoti',
    lightTitle: 'Ryškus režimas',
    darkTitle: 'Tamsus režimas',
    primary: 'Pirminė spalva',
    secondary: 'Antrinė spalva',
    sectionPrimary: 'Pirminės spalvos',
    sectionBackground: 'Fonai',
    sectionText: 'Teksto spalvos',
    bgPage: 'Puslapio fonas',
    bgContainer: 'Konteineris / šoninis skydelis',
    bgElevated: 'Kortelė / paviršius',
    textDefault: 'Teksto galvutė',
    textPrimary: 'Teksto akcentas',
    textSecondary: 'Tekstas nutildytas',
    textTertiary: 'Tekstas silpnas (tretinis)',
    textDisabled: 'Tekstas neaktyvus',
    textDanger: 'Tekstas pavojingas/raudonas',
    textLight: 'Šviesus tekstas (ant mygtukų)',
    previewTitle: 'Peržiūra',
    previewLight: 'Ryškus',
    previewDark: 'Tamsus',
    previewNavActive: 'Aktyvus meniu',
    previewNavItem: 'Meniu',
    previewHeader: 'Puslapio antraštė',
    previewCardTitle: 'Trumpas pavadinimas',
    previewBody: 'Turinio tekstas, kurį vartotojai skaito sąsajoje.',
    previewLink: 'Akcento nuoroda',
    previewMuted: 'Nutildytas pagalbos tekstas',
    previewPrimaryBtn: 'Pirminis',
    previewSecondaryBtn: 'Antrinis',
    previewFormTitle: 'Forma',
    previewTabsTitle: 'Skirtukai',
    previewTabOne: 'Apžvalga',
    previewTabTwo: 'Išsami informacija',
    previewTabThree: 'Istorija',
    previewTabContent: 'Aktyvaus skirtuko turinys – štai kaip turinys atrodo naršant skirtukus.',
    previewBadgesTitle: 'Ženkliukai',
    previewBadgePrimary: 'Pirminis',
    previewBadgeNeutral: 'Neutralus',
    previewBadgeOutline: 'Kontūras',
    previewBadgeSecondary: 'Antrinis',
    previewModalTitle: 'Modalinis',
    previewModalHeading: 'Patvirtinti veiksmą',
    previewModalBody: '? Tai yra dialogo lango peržiūra.',
    previewModalCancel: 'Atšaukti',
    previewModalConfirm: 'Patvirtinti',
    previewComboboxLabel: 'Sudėtinis laukelis',
    previewComboboxValue: 'Pasirinkite parinktį...',
    previewInputLabel: 'Teksto laukas',
    previewInputPlaceholder: 'Įveskite reikšmę...',
    previewGridTitle: 'Duomenų tinklelis',
    previewColName: 'Vardas',
    previewColStatus: 'Būsena',
    previewColDate: 'Data',
    previewRowA: 'Transporto priemonė ABC123',
    previewRowB: 'Automobilis XYZ789',
    previewRowC: 'Transporto priemonė DEF456',
    previewStatusActive: 'Aktyvus',
    previewStatusPending: 'Laukia',
    previewStatusDone: 'Aišku',
    contrastWarning: 'Įspėjimas: dėl mažo teksto ir fono kontrasto gali būti sunku skaityti turinį.',
    reset: 'Atkurti',
    saveSuccess: 'Tema išsaugota',
    saveSuccessActivated: 'Tema išsaugota ir suaktyvinta visoje žiniatinklio programoje',
    activate: 'Suaktyvinti temą',
    reapply: 'Pakartotinai kreiptis',
    saveError: 'Nepavyko išsaugoti temos',
    loadError: 'Nepavyko įkelti temos',
    unsavedConfirm: 'Turite neišsaugotų pakeitimų. Ar norite tęsti neišsaugoję?',
    disabledBannerTitle: 'Dinaminė tema dar neaktyvi',
    disabledBannerBody: 'Čia galite redaguoti ir peržiūrėti. Spustelėkite Suaktyvinti, kad suaktyvintumėte visuotinę temą visiems vartotojams (partneriai, turintys savo suaktyvintą temą, tai neturi įtakos).',
    disabledBannerBodyPartner: 'Čia galite redaguoti ir peržiūrėti. Spustelėkite Suaktyvinti, kad suaktyvintumėte temą tik šio partnerio naudotojams – tai neturės įtakos kitiems ir visuotinei temai.',
  },
  bookingResources: {
    title: 'Užsakymo ištekliai',
    description: 'Sukurkite savo išteklių tipus (pvz., dviratį, priekabą) ir užregistruokite rezervuojamus išteklius naudodami unikalų turto ID.',
    organization: 'Organizacija (klientas)',
    tabTypes: 'Išteklių tipai',
    tabResources: 'Ištekliai',
    addType: 'Pridėti išteklių tipą',
    editType: 'Redaguoti ištekliaus tipą',
    addResource: 'Pridėti išteklių',
    editResource: 'Redaguoti išteklius',
    noTypes: 'Dar nėra išteklių tipų. Prieš registruodami išteklius sukurkite bent vieną tipą.',
    noResources: 'Neregistruotų išteklių nėra. Pirmiausia sukurkite išteklių tipus, tada pridėkite išteklių.',
    createTypeFirst: 'Prieš pridėdami išteklių sukurkite bent vieną aktyvų išteklių tipą.',
    colCode: 'Kodas',
    colName: 'Vardas',
    colResourceCount: 'Išteklių skaičius',
    colIdentity: 'Tapatybė (ištekliaus ID)',
    colType: 'Ištekliaus tipas',
    colPool: 'Pristatymo vieta',
    nameEn: 'Pavadinimas (anglų k., neprivaloma)',
    confirmDeactivateType: 'Išjungti šį išteklių tipą? Neveikia, jei ištekliai arba užsakymai yra susieti.',
    confirmDeactivateResource: 'Išjungti šį šaltinį? Neveikia, jei yra aktyvus rezervavimas arba jis yra telkinyje.',
    connectKey: 'Susieti raktą',
    connectKeyTitle: 'Susieti raktą su {{name}}',
    connectKeyPick: 'Pasirinkite laisvą žalią lizdą',
    connectKeyPickCabinet: 'Pasirinkite spintą',
    connectKeySelected: 'Pasirinktas lizdas {{name}}',
    connectKeySaved: 'Raktas susietas su {{name}}.',
    connectKeyError: 'Nepavyko susieti rakto.',
    connectKeyNoCabinets: 'Klientas neturi raktų spintos.',
  },
  pipeline: {
    newCase: 'Naujas atvejis',
    caseType: 'Atvejo tipas',
    caseTitle: 'Pavadinimas',
    typeInquiry: 'Kontaktai / prospektas',
    typeProcurement: 'Pirkimas',
    filterAll: 'Visi',
    estimatedValue: 'Numatoma vertė',
    calculatedValue: 'Apskaičiuota vertė',
    contractMonths: 'Sutarties laikotarpis (mėnesiais)',
    referenceNumber: 'Nuorodos numeris',
    submissionDeadline: 'Konkurso terminas',
    procurementUrl: 'Pirkimo nuoroda',
    noCustomer: 'Nėra prisijungusių klientų',
    tabOverview: 'Apžvalga',
    tabDocuments: 'dokumentas',
    tabRequirements: 'Reikalavimų analizė',
    tabValue: 'Verslo vertė',
    contact: 'Susisiekite',
    analysisStatus: 'Analizės būsena',
    uploadDocument: 'Įkelti dokumentus',
    uploadSuccess: 'Dokumentas įkeltas',
    uploadSuccessCount: 'Įkelti {{count}} dokumentai',
    uploadPartial: '{{ok}} įkelta, {{failed}} nepavyko',
    uploadFailed: 'Įkelti nepavyko',
    uploadMultipleHint: 'Galite pasirinkti kelis failus vienu metu',
    noDocuments: 'Dar nėra dokumentų',
    runAnalysis: 'Vykdykite AI analizę',
    runAnalysisAll: 'Išanalizuokite reikalavimų specifikaciją',
    runAnalysisAllHint: 'Analizuoja pagrindinio failo Reikalavimų specifikaciją. Pasirinkite daugiau dokumentų ir naudokite Analizuoti pasirinktus kitiems priedams.',
    runAnalysisSelected: 'Analizuoti pasirinktus dokumentus',
    analyzeDocument: 'Analizuoti',
    analyzing: 'Analizuojama...',
    analyzeStarting: 'Pradedama analizė...',
    analyzeStartedBackground: 'Analizė pradėta fone. Galite išeiti iš puslapio – būseną atnaujiname automatiškai, kai grįžtate.',
    analyzeAlreadyRunning: 'Šio atvejo analizė jau vykdoma.',
    analyzeAlreadyRunningInfo: 'Analizė jau vykdoma fone. Palaukite, kol baigsis, arba spustelėkite Paleisti analizę iš naujo.',
    analyzeStuckHint: 'Atrodo, kad analizė įstrigo (pvz., po perkrovimo). Galite paleisti iš naujo.',
    forceRestartAnalysis: 'Iš naujo paleisti analizę',
    analysisRunningHint: 'AI analizė vykdoma fone. Galite nueiti – rezultatas bus rodomas čia, kai analizė bus baigta.',
    analysisStatusNone: 'Neanalizuojama',
    analyzeSlow: 'Vykdoma AI analizė – gali užtrukti kelias minutes, kol pateikiami dideli pirkimo dokumentai.',
    analyzeTimeout: 'Analizė užtruko per ilgai. Bandykite dar kartą arba vienu metu analizuokite mažiau priedų.',
    analyzeSuccess: 'Analizė baigta',
    analyzeFailed: 'Analizė nepavyko',
    requirementType: 'Tipas',
    requirement: 'Reikalauti',
    requirementText: 'Pilnas reikalavimo tekstas',
    matchStatus: 'Atitikimas',
    fulfilled: 'įvykdyta',
    skaCount: '{{count}} SKA reikalavimai',
    borCount: '{{count}} TURI būti reikalavimai',
    systemHandles: 'Ką tvarko sistema',
    whatIsMissing: 'Ko trūksta',
    noCatalogMatch: 'Neatitiko jokių galimybių',
    noCoverageNotes: 'Nėra įvertinimo – pakartokite analizę, kad gautumėte AI paaiškinimą',
    matchedCapability: 'Suderintas pajėgumas',
    noGapNotes: 'Nėra įvertinimo',
    nothingMissing: 'Nieko netrūksta – reikalavimas įvykdytas',
    confidence: 'Saugumas',
    noRequirements: 'Kol kas nėra išanalizuoti reikalavimai',
    createDevTask: 'Sukurkite plėtros užduotį',
    devTaskCreated: 'Sukurta kūrimo užduotis',
    handlingStatus: 'Tvarkymas',
    handlingNotSet: 'Nenustatyta',
    manualHandling: 'Rankinis apdorojimas',
    assessment: 'Įvertinimas',
    reuseInOtherCases: 'Naudokite atsakymą kituose pirkimuose',
    reuseInOtherCasesHint: 'Išsaugo įvertinimą, kad panašūs reikalavimai (pvz., gauti informaciją apie transporto priemonę) būtų automatiškai nustatyti į tą pačią būseną.',
    comment: 'komentuoti',
    commentPlaceholder: 'Rašyk komentarą, pvz. kad transporto priemonės informacija gaunama per Car.info...',
    handlingSaved: 'Apdorojimas išsaugotas',
    handlingSavedReuse: 'Įvertinimas išsaugomas ir pakartotinai naudojamas kituose pirkimuose',
    handling: {
      hanterat: 'Tvarkyti',
      utveckling: 'Plėtra',
      juridik: 'Teisė',
    },
    product: 'Produktas',
    selectProduct: 'Pasirinkite prekę',
    quantity: 'Skaičius',
    unitPrice: 'À kaina',
    lineTotal: 'Eilutės suma',
    addLine: 'Pridėti eilutę',
    monthlyTotal: 'Mėnesio vertė',
    caseNotFound: 'Atvejis nerastas',
    status: {
      fulfilled: 'Patenkintas',
      partial: 'Iš dalies',
      missing: 'Trūksta',
      unknown: 'Nežinoma',
      review: 'Apžiūra',
    },
    analysisStatusValues: {
      none: 'Neanalizuojama',
      pending: 'Laukia',
      analyzing: 'Analizuojama',
      completed: 'Analizė baigta',
      failed: 'Analizė nepavyko',
    },
  },
};
